require("discourse/loader-shims");
require("discourse-i18n");


I18n.translations = {"de":{"js":{"number":{"format":{"separator":",","delimiter":"."},"human":{"storage_units":{"format":"%n %u","units":{"byte":{"one":"Byte","other":"Bytes"},"gb":"GB","kb":"KB","mb":"MB","tb":"TB"}}},"percent":"%{count} %","short":{"thousands":"%{number} T.","millions":"%{number} M."}},"dates":{"time":"HH:mm","time_short":"HH:mm","time_with_zone":"HH:mm (z)","time_short_day":"dd, HH:mm","timeline_date":"MMM YYYY","long_no_year":"D. MMM, HH:mm","long_no_year_no_time":"D. MMM","full_no_year_no_time":"D. MMMM","long_with_year":"D. MMM YYYY [um] HH:mm","long_with_year_no_time":"D. MMM YYYY","full_with_year_no_time":"D. MMMM YYYY","long_date_with_year":"D. MMM YYYY [um] HH:mm","long_date_without_year":"D. MMM [um] HH:mm","long_date_with_year_without_time":"D. MMM YYYY","long_date_without_year_with_linebreak":"D. MMM\u003cbr/\u003eHH:mm","long_date_with_year_with_linebreak":"D. MMM YYYY\u003cbr/\u003eHH:mm","wrap_ago":"vor %{date}","wrap_on":"am %{date}","tiny":{"half_a_minute":"\u003c 1 Min.","less_than_x_seconds":{"one":"\u003c %{count} s","other":"\u003c %{count} s"},"x_seconds":{"one":"%{count} s","other":"%{count} s"},"less_than_x_minutes":{"one":"\u003c %{count} min","other":"\u003c %{count} min"},"x_minutes":{"one":"%{count} min","other":"%{count} min"},"about_x_hours":{"one":"%{count} h","other":"%{count} h"},"x_days":{"one":"%{count} d","other":"%{count} d"},"x_months":{"one":"%{count} m","other":"%{count} m"},"about_x_years":{"one":"%{count} a","other":"%{count} a"},"over_x_years":{"one":"\u003e %{count} a","other":"\u003e %{count} a"},"almost_x_years":{"one":"%{count} a","other":"%{count} a"},"date_month":"D. MMM","date_year":"MMM YYYY"},"medium":{"less_than_x_minutes":{"one":"weniger als %{count} Min.","other":"weniger als %{count} Min."},"x_minutes":{"one":"%{count} Minute","other":"%{count} Minuten"},"x_hours":{"one":"%{count} Stunde","other":"%{count} Stunden"},"about_x_hours":{"one":"ungefähr %{count} Stunde","other":"ungefähr %{count} Stunden"},"x_days":{"one":"%{count} Tag","other":"%{count} Tage"},"x_months":{"one":"%{count} Monat","other":"%{count} Monate"},"about_x_years":{"one":"ungefähr %{count} Jahr","other":"ungefähr %{count} Jahre"},"over_x_years":{"one":"über %{count} Jahr","other":"über %{count} Jahre"},"almost_x_years":{"one":"fast %{count} Jahr","other":"fast %{count} Jahre"},"date_year":"D. MMM YYYY"},"medium_with_ago":{"x_minutes":{"one":"vor %{count} Minute","other":"vor %{count} Minuten"},"x_hours":{"one":"vor %{count} Stunde","other":"vor %{count} Stunden"},"x_days":{"one":"vor %{count} Tag","other":"vor %{count} Tagen"},"x_months":{"one":"vor %{count} Monat","other":"vor %{count} Monaten"},"x_years":{"one":"vor %{count} Jahr","other":"vor %{count} Jahren"}},"later":{"x_days":{"one":"%{count} Tag später","other":"%{count} Tage später"},"x_months":{"one":"%{count} Monat später","other":"%{count} Monate später"},"x_years":{"one":"%{count} Jahr später","other":"%{count} Jahre später"}},"previous_month":"Vormonat","next_month":"Nächster Monat","placeholder":"Datum","from_placeholder":"ab Datum","to_placeholder":"bis Datum"},"share":{"topic_html":"Thema: \u003cspan class=\"topic-title\"\u003e%{topicTitle}\u003c/span\u003e","post":"Beitrag Nr. %{postNumber} von @%{username}","close":"Schließen","twitter":"Teilen auf X","facebook":"Auf Facebook teilen","email":"Per E-Mail senden","url":"URL kopieren und teilen"},"word_connector":{"comma":", ","last_item":"und"},"action_codes":{"public_topic":"Hat dieses Thema öffentlich gemacht, %{when}","open_topic":"Hat dies in ein Thema umgewandelt, %{when}","private_topic":"Hat dieses Thema in eine Nachricht umgewandelt, %{when}","split_topic":"Hat dieses Thema aufgeteilt, %{when}","invited_user":"Hat %{who} eingeladen, %{when}","invited_group":"Hat %{who} eingeladen, %{when}","user_left":"%{who} hat sich selbst von dieser Nachricht entfernt, %{when}","removed_user":"Hat %{who} entfernt, %{when}","removed_group":"Hat %{who} entfernt, %{when}","autobumped":"Thema wurde automatisch nach oben geschoben, %{when}","tags_changed":"Schlagwörter aktualisiert %{when}","category_changed":"Kategorie aktualisiert %{when}","autoclosed":{"enabled":"Geschlossen, %{when}","disabled":"Geöffnet, %{when}"},"closed":{"enabled":"Geschlossen, %{when}","disabled":"Geöffnet, %{when}"},"archived":{"enabled":"Archiviert, %{when}","disabled":"Aus dem Archiv geholt, %{when}"},"pinned":{"enabled":"Angeheftet, %{when}","disabled":"Losgelöst, %{when}"},"pinned_globally":{"enabled":"Global angeheftet, %{when}","disabled":"Losgelöst, %{when}"},"visible":{"enabled":"Sichtbar gemacht, %{when}","disabled":"Unsichtbar gemacht, %{when}"},"banner":{"enabled":"Hat dieses Banner erstellt, %{when}. Es wird oberhalb jeder Seite angezeigt, bis es vom Benutzer weggeklickt wird.","disabled":"Hat dieses Banner entfernt, %{when}. Es wird nicht mehr oberhalb jeder Seite angezeigt."},"forwarded":"Hat die obige E-Mail weitergeleitet","chat":{"enabled":"%{who} hat \u003cbutton class=\"btn-link open-chat\"\u003eChat\u003c/button\u003e aktiviert %{when}","disabled":"%{who} hat Chat geschlossen %{when}"}},"topic_admin_menu":"Themen-Administration","skip_to_main_content":"Zum Hauptinhalt springen","skip_user_nav":"Zum Profilinhalt springen","emails_are_disabled":"Die ausgehende E-Mail-Kommunikation wurde von einem Administrator global deaktiviert. Es werden keinerlei Benachrichtigungen per E-Mail verschickt.","emails_are_disabled_non_staff":"Ausgehende E-Mails wurden für Benutzer, die nicht zum Team gehören, deaktiviert.","software_update_prompt":{"message":"Wir haben diese Website aktualisiert. \u003cspan\u003eBitte aktualisiere\u003c/span\u003e, damit alles reibungslos funktioniert.","dismiss":"Verwerfen"},"bootstrap_mode":"Erste Schritte","back_button":"Zurück","themes":{"default_description":"Standard","broken_theme_alert":"Deine Website funktioniert vielleicht nicht, weil ein Theme/eine Komponente Fehler hat.","error_caused_by":"Verursacht durch „%{name}“. \u003ca target='blank' href='%{path}'\u003eKlicke hier\u003c/a\u003e , um die Funktion zu aktualisieren, neu zu konfigurieren oder zu deaktivieren.","only_admins":"(Diese Nachricht wird nur Website-Administratoren angezeigt)"},"broken_decorator_alert":"Beiträge werden möglicherweise nicht richtig angezeigt, weil einer der Beitragsausstatter auf deiner Website einen Fehler ausgelöst hat.","broken_page_change_alert":"Ein onPageChange-Handler hat einen Fehler ausgelöst. Überprüfe die Entwicklerwerkzeuge des Browsers für weitere Informationen.","broken_plugin_alert":"Verursacht durch das Plug-in „%{name}“","broken_transformer_alert":"Es ist ein Fehler aufgetreten. Deine Website funktioniert möglicherweise nicht richtig.","critical_deprecation":{"notice":"\u003cb\u003e[Hinweis für Administratoren]\u003c/b\u003e Eines deiner Themes oder Plug-ins muss aktualisiert werden, um die Kompatibilität mit den bevorstehenden Discourse-Kernänderungen zu gewährleisten.","id":"(id:\u003cem\u003e%{id}\u003c/em\u003e)","linked_id":"(id:\u003ca href='%{url}' target='_blank'\u003e\u003cem\u003e%{id}\u003c/em\u003e\u003c/a\u003e)","theme_source":"Identifiziertes Theme: \u003ca target='_blank' href='%{path}'\u003e'%{name}'\u003c/a\u003e.","plugin_source":"Identifiziertes Plug-in: „%{name}“"},"s3":{"regions":{"ap_northeast_1":"Asien-Pazifik (Tokio)","ap_northeast_2":"Asien-Pazifik (Seoul)","ap_east_1":"Asien-Pazifik (Hongkong)","ap_south_1":"Asien-Pazifik (Mumbai)","ap_southeast_1":"Asien-Pazifik (Singapur)","ap_southeast_2":"Asien-Pazifik (Sydney)","ca_central_1":"Kanada (Zentral)","cn_north_1":"China (Peking)","cn_northwest_1":"China (Ningxia)","eu_central_1":"EU (Frankfurt)","eu_north_1":"EU (Stockholm)","eu_south_1":"EU (Mailand)","eu_west_1":"EU (Irland)","eu_west_2":"EU (London)","eu_west_3":"EU (Paris)","sa_east_1":"Südamerika (São Paulo)","us_east_1":"USA Ost (Nord-Virginia)","us_east_2":"USA Ost (Ohio)","us_gov_east_1":"AWS GovCloud (US-Ost)","us_gov_west_1":"AWS GovCloud (US-West)","us_west_1":"USA West (Nordkalifornien)","us_west_2":"USA West (Oregon)"}},"clear_input":"Eingabe löschen","edit":"Bearbeiten","edit_topic":"Titel und Kategorie dieses Themas ändern","expand":"Aufklappen","not_implemented":"Entschuldige, diese Funktion wurde noch nicht implementiert!","no_value":"Nein","yes_value":"Ja","ok_value":"OK","cancel_value":"Abbrechen","submit":"Absenden","delete":"Löschen","generic_error":"Entschuldigung, ein Fehler ist aufgetreten.","generic_error_with_reason":"Ein Fehler ist aufgetreten: %{error}","multiple_errors":"Es sind mehrere Fehler aufgetreten: %{errors}","sign_up":"Registrieren","log_in":"Anmelden","age":"Alter","joined":"Beigetreten","admin_title":"Administration","show_more":"mehr anzeigen","show_help":"Erweiterte Suche","links":"Links","links_lowercase":{"one":"Link","other":"Links"},"faq":"FAQ","guidelines":"Richtlinien","privacy_policy":"Datenschutzerklärung","privacy":"Datenschutz","tos":"Nutzungsbedingungen","rules":"Regeln","conduct":"Verhaltenskodex","mobile_view":"Mobile Ansicht","desktop_view":"Desktop-Ansicht","now":"gerade eben","read_more":"weiterlesen","more":"Mehr","more_options":"Mehr Optionen","x_more":{"one":"%{count} weiterer","other":"%{count} weitere"},"never":"nie","every_30_minutes":"alle 30 Minuten","every_hour":"jede Stunde","daily":"täglich","weekly":"wöchentlich","every_month":"jeden Monat","every_six_months":"alle sechs Monate","max_of_count":{"one":"max. %{count}","other":"max. %{count}"},"character_count":{"one":"%{count} Zeichen","other":"%{count} Zeichen"},"period_chooser":{"aria_label":"Filtern nach Zeitraum"},"related_messages":{"title":"Verwandte Nachrichten","pill":"Verwandte Nachrichten","see_all":"\u003ca href=\"%{path}\"\u003eAlle Nachrichten\u003c/a\u003e von @%{username} anzeigen …"},"suggested_topics":{"title":"Neue und ungelesene Themen","pill":"Empfohlen","pm_title":"Vorgeschlagene Nachrichten"},"about":{"edit":"Diese Seite bearbeiten","simple_title":"Über uns","title":"Über %{title}","stats":"Website-Statistiken","our_admins":"Unsere Administratoren","our_moderators":"Unsere Moderatoren","moderators":"Moderatoren","stat":{"all_time":"Gesamt","last_day":"24 Stunden","last_7_days":"7 Tage","last_30_days":"30 Tage"},"like_count":"„Gefällt mir“","topic_count":"Themen","post_count":"Beiträge","user_count":"Registrierungen","active_user_count":"Aktive Benutzer","visitor_count":"Besucher","eu_visitor_count":"Besucher aus der Europäischen Union","contact":"Kontaktiere uns","contact_info":"Im Falle eines kritischen Problems oder einer dringenden Angelegenheit, die diese Website betrifft, wende dich bitte an %{contact_info}.","site_activity":"Aktivität auf der Website","view_more":"Mehr anzeigen","view_less":"Weniger anzeigen","activities":{"topics":{"one":"%{formatted_number} Thema","other":"%{formatted_number} Themen"},"posts":{"one":"%{formatted_number} Beitrag","other":"%{formatted_number} Beiträge"},"active_users":{"one":"%{formatted_number} aktiver Benutzer","other":"%{formatted_number} aktive Benutzer"},"sign_ups":{"one":"%{formatted_number} Registrierung","other":"%{formatted_number} Registrierungen"},"likes":{"one":"%{formatted_number} „Gefällt mir“","other":"%{formatted_number} „Gefällt mir“"},"periods":{"last_7_days":"in den letzten 7 Tagen","today":"heute","all_time":"gesamt"},"chat_messages":{"one":"%{formatted_number} Chat-Nachricht","other":"%{formatted_number} Chat-Nachrichten"}},"member_count":{"one":"%{formatted_number} Mitglied","other":"%{formatted_number} Mitglieder"},"admin_count":{"one":"%{formatted_number} Administrator","other":"%{formatted_number} Administratoren"},"moderator_count":{"one":"%{formatted_number} Moderator","other":"%{formatted_number} Moderatoren"},"report_inappropriate_content":"Wenn du auf unangemessene Inhalte stößt, zögere nicht, eine Unterhaltung mit unseren Moderatoren und Administratoren zu beginnen. Denke daran, dich anzumelden, bevor du Kontakt aufnimmst.","site_age":{"less_than_one_month":"Erstellt vor \u003c 1 Monat","month":{"one":"Vor %{count} Monat erstellt","other":"Vor %{count} Monaten erstellt"},"year":{"one":"Vor %{count} Jahr erstellt","other":"Vor %{count} Jahren erstellt"}},"chat_messages_count":"Chat-Nachrichten","chat_channels_count":"Chat-Kanäle","chat_users_count":"Chat-Benutzer"},"bookmarked":{"title":"Lesezeichen setzen","edit_bookmark":"Lesezeichen bearbeiten","clear_bookmarks":"Lesezeichen entfernen","help":{"bookmark":"Klicke, um dieses Thema mit einem Lesezeichen zu markieren","edit_bookmark":"Klicke, um das Lesezeichen für einen Beitrag in diesem Thema zu bearbeiten","edit_bookmark_for_topic":"Klicke, um das Lesezeichen für dieses Thema zu bearbeiten","unbookmark":"Klicke hier, um alle Lesezeichen in diesem Thema zu entfernen.","unbookmark_with_reminder":"Klicke, um alle Lesezeichen und Erinnerungen in diesem Thema zu entfernen"}},"bookmarks":{"also_set_reminder":"Erinnerung hinzufügen?","bookmarked_success":"Gespeichert!","deleted_bookmark_success":"Lesezeichen gelöscht!","reminder_set_success":"Erinnerung gesetzt!","created":"Du hast diesen Beitrag mit einem Lesezeichen versehen. %{name}","created_generic":"Du hast dies mit einem Lesezeichen versehen: %{name}","create":"Lesezeichen erstellen","edit":"Lesezeichen bearbeiten","not_bookmarked":"diesen Beitrag mit Lesezeichen versehen","remove_reminder_keep_bookmark":"Erinnerung entfernen und Lesezeichen behalten","created_with_reminder":"Du wirst %{date} an dieses Lesezeichen erinnert. %{name}","created_with_reminder_generic":"Du wirst am %{date} an dieses Lesezeichen erinnert. %{name}","delete":"Lesezeichen löschen","confirm_delete":"Möchtest du dieses Lesezeichen wirklich löschen? Die Erinnerung wird ebenfalls gelöscht.","confirm_clear":"Möchtest du wirklich alle deine Lesezeichen in diesem Thema löschen?","save":"Speichern","no_timezone":"Du hast noch keine Zeitzone ausgewählt und wirst deswegen keine Erinnerungen erstellen können. Wähle deine Zeitzone \u003ca href=\"%{basePath}/my/preferences/profile\"\u003ein deinem Profil\u003c/a\u003e aus.","invalid_custom_datetime":"Das angegebene Datum und die Uhrzeit sind ungültig. Bitte versuche es erneut.","list_permission_denied":"Du hast keine Berechtigung, die Lesezeichen dieses Benutzers anzuzeigen.","no_user_bookmarks":"Du hast noch keine Beiträge mit einem Lesezeichen versehen. Lesezeichen erlauben dir den schnellen Zugriff auf bestimmte Beiträge.","auto_delete_preference":{"label":"Nachdem du benachrichtigst wurdest","never":"Lesezeichen behalten","when_reminder_sent":"Lesezeichen löschen","on_owner_reply":"Lesezeichen löschen, sobald ich antworte","clear_reminder":"Lesezeichen behalten und Erinnerung löschen","after_reminder_label":"Nach Erinnerung …","after_reminder_checkbox":"Als Standard für alle zukünftigen Lesezeichen-Erinnerungen festlegen"},"search_placeholder":"Lesezeichen nach Namen, Thementitel oder Beitragsinhalt durchsuchen","search":"Suche","bookmark":"Lesezeichen","bulk":{"delete_completed":"Lesezeichen erfolgreich gelöscht.","reminders_cleared":"Lesezeichen-Erinnerungen erfolgreich gelöscht.","toggle":"Massenauswahl von Lesezeichen umschalten","select_all":"Alle auswählen","clear_all":"Alle löschen","selected_count":{"one":"%{count} ausgewählt","other":"%{count} ausgewählt"}},"reminders":{"today_with_time":"heute um %{time}","tomorrow_with_time":"morgen um %{time}","at_time":"am %{date_time}","existing_reminder":"Du wirst %{at_date_time} an dieses Lesezeichen erinnert."}},"bookmark_bulk_actions":{"clear_reminders":{"name":"Erinnerungen löschen","description":{"one":"Möchtest du die Erinnerung für dieses Lesezeichen wirklich löschen?","other":"Möchtest du die Erinnerungen für diese \u003cb\u003e%{count}\u003c/b\u003e Lesezeichen wirklich löschen?"}},"delete_bookmarks":{"name":"Lesezeichen löschen","description":{"one":"Möchtest du dieses Lesezeichen wirklich löschen?","other":"Möchtest du diese \u003cb\u003e%{count}\u003c/b\u003e Lesezeichen wirklich löschen?"}}},"copy_codeblock":{"copied":"Kopiert!","copy":"Code in die Zwischenablage kopieren","fullscreen":"Code im Vollbildmodus zeigen","view_code":"Code ansehen"},"drafts":{"label":"Entwürfe","label_with_count":"Entwürfe (%{count})","resume":"Fortsetzen","remove":"Entfernen","remove_confirmation":"Bist du sicher, dass du diesen Entwurf löschen möchtest?","new_topic":"Neuer Entwurf für Thema","new_private_message":"Neuer Entwurf für persönliche Nachricht","abandon":{"confirm":"Du hast bereits einen Entwurf in Arbeit. Was möchtest du damit machen?","yes_value":"Verwerfen","no_value":"Bearbeitung fortsetzen"},"dropdown":{"title":"Menü mit den neuesten Entwürfen öffnen","untitled":"Entwurf ohne Titel","view_all":"alle ansehen","other_drafts":{"one":"+%{count} anderer Entwurf","other":"+%{count} andere Entwürfe"}}},"topic_count_all":{"one":"Zeige %{count} neues Thema","other":"Zeige %{count} neue Themen"},"topic_count_categories":{"one":"Zeige %{count} neues oder aktualisiertes Thema","other":"Zeige %{count} neue oder aktualisierte Themen"},"topic_count_latest":{"one":"Zeige %{count} neues oder aktualisiertes Thema","other":"Zeige %{count} neue oder aktualisierte Themen"},"topic_count_unseen":{"one":"Zeige %{count} neues oder aktualisiertes Thema","other":"Zeige %{count} neue oder aktualisierte Themen"},"topic_count_unread":{"one":"Zeige %{count} ungelesenes Thema","other":"Zeige %{count} ungelesene Themen"},"topic_count_new":{"one":"Zeige %{count} neues Thema","other":"Zeige %{count} neue Themen"},"preview":"Vorschau","cancel":"Abbrechen","deleting":"Wird gelöscht …","save":"Änderungen speichern","saving":"Wird gespeichert …","saved":"Gespeichert!","upload":"Hochladen","uploading":"Wird hochgeladen …","processing":"Wird verarbeitet …","uploading_filename":"Wird hochgeladen: %{filename} …","processing_filename":"Wird verarbeitet: %{filename} …","clipboard":"Zwischenablage","uploaded":"Hochgeladen!","pasting":"Wird eingefügt …","enable":"Aktivieren","disable":"Deaktivieren","continue":"Weiter","switch_to_anon":"Anonymen Modus aktivieren","switch_from_anon":"Anonymen Modus deaktivieren","select_placeholder":"Auswählen …","none_placeholder":"Keiner","banner":{"close":"Dieses Banner ausblenden","edit":"Bearbeiten"},"pwa":{"install_banner":"Möchtest du \u003ca href\u003e%{title} auf diesem Gerät installieren?\u003c/a\u003e"},"choose_topic":{"none_found":"Keine Themen gefunden.","title":{"search":"Suche nach einem Thema","placeholder":"gib hier den Titel, die URL oder die ID des Themas ein"}},"choose_message":{"none_found":"Keine Nachrichten gefunden.","title":{"search":"Suche nach einer Nachricht","placeholder":"gib hier den Titel, die URL oder die ID der Nachricht ein"}},"review":{"show_more":"Mehr anzeigen","show_less":"Weniger anzeigen","order_by":"Sortieren nach","date_filter":"Gepostet zwischen","in_reply_to":"Antwort auf","filtered_flagged_by":"Gemeldet von","explain":{"why":"erkläre, warum dieses Element in der Warteschlange gelandet ist","title":"Überprüfbares Scoring","formula":"Formel","subtotal":"Zwischensumme","total":"Gesamt","min_score_visibility":"Minimaler Score für Sichtbarkeit","score_to_hide":"Score, um den Beitrag zu verbergen","take_action_bonus":{"name":"Maßnahme ergriffen","title":"Wenn ein Team-Mitglied entscheidet, eine Maßnahme zu ergreifen, erhält die Meldung einen Bonus."},"user_accuracy_bonus":{"name":"Benutzer-Genauigkeit","title":"Benutzer, deren Meldungen in der Vergangenheit zugestimmt wurde, erhalten einen Bonus."},"trust_level_bonus":{"name":"Vertrauensstufe","title":"Überprüfbare Elemente, die von Benutzern höherer Vertrauensstufen angelegt wurden, haben einen höheren Score."},"type_bonus":{"name":"Bonustyp","title":"Bestimmte überprüfbare Typen können vom Team mit einem Bonus ausgestattet werden, damit sie höher priorisiert sind."}},"revise_and_reject_post":{"title":"Überarbeiten","reason":"Grund","send_pm":"PN senden","feedback":"Feedback","custom_reason":"Gib eine klare Beschreibung des Grundes an","other_reason":"Sonstiges …","optional":"optional"},"stale_help":"Diese Überprüfung wurde von \u003cb\u003e%{username}\u003c/b\u003e gelöst.","claim_help":{"optional":"Du kannst dieses Element reservieren, damit andere es nicht überprüfen.","required":"Du musst Elemente reservieren, bevor du sie überprüfen kannst.","claimed_by_you":"Du hast dieses Element reserviert und kannst es überprüfen.","claimed_by_other":"Dieses Element kann nur von \u003cb\u003e%{username}\u003c/b\u003e überprüft werden."},"claim":{"title":"dieses Thema reservieren"},"unclaim":{"help":"diese Reservierung entfernen"},"awaiting_approval":"Wartet auf Genehmigung","delete":"Löschen","settings":{"saved":"Gespeichert","save_changes":"Änderungen speichern","title":"Einstellungen","priorities":{"title":"Prioritäten für überprüfbare Elemente"}},"moderation_history":"Moderationsverlauf","view_all":"Alle anzeigen","grouped_by_topic":"Gruppiert nach Thema","none":"Es sind keine Elemente zur Überprüfung vorhanden.","view_pending":"zeige verbleibende","topic_has_pending":{"one":"Dieses Thema hat \u003cb\u003e%{count}\u003c/b\u003e Beitrag, der auf Genehmigung wartet.","other":"Dieses Thema hat \u003cb\u003e%{count}\u003c/b\u003e Beiträge, die auf Genehmigung warten."},"title":"Überprüfen","topic":"Thema:","filtered_topic":"Du hast nach zu prüfenden Inhalten in einem einzelnen Thema gefiltert.","filtered_user":"Benutzer","filtered_reviewed_by":"Überprüft von","show_all_topics":"alle Themen zeigen","deleted_post":"(Beitrag gelöscht)","deleted_user":"(Benutzer gelöscht)","user":{"bio":"Bio","website":"Website","username":"Benutzername","email":"E-Mail","name":"Name","fields":"Felder","reject_reason":"Grund"},"user_percentage":{"summary":{"one":"%{agreed}, %{disagreed}, %{ignored} (der letzten Meldung)","other":"%{agreed}, %{disagreed}, %{ignored} (der letzten %{count} Meldungen)"},"agreed":{"one":"%{count} % zugestimmt","other":"%{count} % zugestimmt"},"disagreed":{"one":"%{count} % abgelehnt","other":"%{count} % abgelehnt"},"ignored":{"one":"%{count} % ignoriert","other":"%{count} % ignoriert"}},"topics":{"topic":"Thema","reviewable_count":"Anzahl","reported_by":"Gemeldet von","deleted":"[Thema gelöscht]","original":"(ursprüngliches Thema)","details":"Details","unique_users":{"one":"%{count} Benutzer","other":"%{count} Benutzer"}},"replies":{"one":"%{count} Antwort","other":"%{count} Antworten"},"edit":"Bearbeiten","save":"Speichern","cancel":"Abbrechen","new_topic":"Das Bestätigen dieses Elements wird ein neues Thema erstellen","filters":{"all_categories":"(alle Kategorien)","type":{"title":"Typ","all":"(alle Arten)"},"minimum_score":"Minimaler Score:","refresh":"Aktualisieren","status":"Status","category":"Kategorie","score_type":{"title":"Grund","all":"(alle Gründe)"},"orders":{"score":"Score","score_asc":"Score (umgekehrt)","created_at":"Erstellt am","created_at_asc":"Erstellt am (umgekehrt)"},"priority":{"title":"Minimale Priorität","any":"(beliebig)","low":"Niedrig","medium":"Mittel","high":"Hoch"}},"conversation":{"view_full":"zeige vollständige Unterhaltung"},"scores":{"about":"Dieser Score wird basierend auf der Vertrauensstufe des Meldenden, der Richtigkeit der vorhergehenden Meldungen sowie der Priorität des gemeldeten Elements berechnet.","score":"Score","date":"Datum der Meldung","type":"Grund","status":"Status","submitted_by":"Gemeldet von","reviewed_by":"Überprüft von","reviewed_timestamp":"Datum der Überprüfung"},"statuses":{"pending":{"title":"Ausstehend"},"approved":{"title":"Genehmigt"},"approved_flag":{"title":"Meldung genehmigt"},"approved_user":{"title":"Benutzer genehmigt"},"approved_post":{"title":"Beitrag genehmigt"},"rejected":{"title":"Abgelehnt"},"rejected_flag":{"title":"Meldung abgelehnt"},"rejected_user":{"title":"Benutzer abgelehnt"},"rejected_post":{"title":"Beitrag abgelehnt"},"ignored":{"title":"Meldung ignoriert"},"deleted":{"title":"Thema oder Beitrag gelöscht"},"reviewed":{"title":"Alle überprüft"},"all":{"title":"Alles"}},"context_question":{"is_this_post":"Ist diese(r/s) %{reviewable_type} %{reviewable_human_score_types}?","delimiter":"oder","something_else_wrong":"Stimmt etwas nicht mit diesem/dieser %{reviewable_type}?"},"types":{"reviewable_flagged_post":{"title":"Gemeldeter Beitrag","flagged_by":"Gemeldet von","noun":"Beitrag"},"reviewable_queued_topic":{"title":"Thema in der Warteschlange","noun":"Thema"},"reviewable_queued_post":{"title":"Beitrag in der Warteschlange","noun":"Beitrag"},"reviewable_user":{"title":"Benutzer","noun":"Benutzer"},"reviewable_post":{"title":"Beitrag","noun":"Beitrag"},"chat_reviewable_message":{"title":"Gemeldete Chat-Nachricht"},"reviewable_chat_message":{"title":"Gemeldete Chat-Nachricht","noun":"Chat-Nachricht"}},"approval":{"title":"Beitrag muss genehmigt werden","description":"Wir haben deinen neuen Beitrag erhalten. Dieser muss jedoch von einem Moderator genehmigt werden, bevor er angezeigt wird. Bitte habe etwas Geduld.","pending_posts":{"one":"Du hast \u003cstrong\u003e%{count}\u003c/strong\u003e verbleibenden Beitrag.","other":"Du hast \u003cstrong\u003e%{count}\u003c/strong\u003e verbleibende Beiträge."},"ok":"OK"},"example_username":"Benutzername","reject_reason":{"title":"Warum lehnst du diesen Benutzer ab?","send_email":"Ablehnungs-E-Mail senden"},"transcript":{"view":"Transkript früherer Nachrichten anzeigen"}},"relative_time_picker":{"minutes":{"one":"Minute","other":"Minuten"},"hours":{"one":"Stunde","other":"Stunden"},"days":{"one":"Tag","other":"Tage"},"months":{"one":"Monat","other":"Monate"},"years":{"one":"Jahr","other":"Jahre"},"relative":"Relativ"},"time_shortcut":{"now":"Jetzt","in_one_hour":"In einer Stunde","in_two_hours":"In zwei Stunden","later_today":"Im Laufe des Tages","two_days":"Zwei Tage","three_days":"In 3 Tagen","next_business_day":"Nächster Arbeitstag","tomorrow":"Morgen","post_local_date":"Datum im Beitrag","later_this_week":"Später in dieser Woche","this_weekend":"Dieses Wochenende","start_of_next_business_week":"Montag","start_of_next_business_week_alt":"Am kommenden Montag","next_week":"Nächste Woche","two_weeks":"Zwei Wochen","next_month":"Nächsten Monat","two_months":"Zwei Monate","three_months":"Drei Monate","four_months":"Vier Monate","six_months":"Sechs Monate","one_year":"Ein Jahr","forever":"Für immer","relative":"Relative Zeit","none":"Nicht notwendig","never":"Nie","last_custom":"Letztes benutzerdefiniertes Datum","custom":"Datum und Uhrzeit auswählen","more_options":"Mehr Optionen …","select_timeframe":"Wähle einen Zeitrahmen aus"},"user_action":{"user_posted_topic":"\u003ca href='%{userUrl}'\u003e%{user}\u003c/a\u003e hat \u003ca href='%{topicUrl}'\u003edas Thema\u003c/a\u003e verfasst","you_posted_topic":"\u003ca href='%{userUrl}'\u003eDu\u003c/a\u003e hast \u003ca href='%{topicUrl}'\u003edas Thema\u003c/a\u003e verfasst","user_replied_to_post":"\u003ca href='%{userUrl}'\u003e%{user}\u003c/a\u003e hat auf \u003ca href='%{postUrl}'\u003e%{post_number}\u003c/a\u003e geantwortet","you_replied_to_post":"\u003ca href='%{userUrl}'\u003eDu\u003c/a\u003e hast auf \u003ca href='%{postUrl}'\u003e%{post_number}\u003c/a\u003e geantwortet","user_replied_to_topic":"\u003ca href='%{userUrl}'\u003e%{user}\u003c/a\u003e hat auf \u003ca href='%{topicUrl}'\u003edas Thema\u003c/a\u003e geantwortet","you_replied_to_topic":"\u003ca href='%{userUrl}'\u003eDu\u003c/a\u003e hast auf \u003ca href='%{topicUrl}'\u003edas Thema\u003c/a\u003e geantwortet","user_mentioned_user":"\u003ca href='%{user1Url}'\u003e%{user}\u003c/a\u003e hat \u003ca href='%{user2Url}'\u003e%{another_user}\u003c/a\u003e erwähnt","user_mentioned_you":"\u003ca href='%{user1Url}'\u003e%{user}\u003c/a\u003e hat \u003ca href='%{user2Url}'\u003edich\u003c/a\u003e erwähnt","you_mentioned_user":"\u003ca href='%{user1Url}'\u003eDu\u003c/a\u003e hast \u003ca href='%{user2Url}'\u003e%{another_user}\u003c/a\u003e erwähnt","posted_by_user":"Geschrieben von \u003ca href='%{userUrl}'\u003e%{user}\u003c/a\u003e","posted_by_you":"Von \u003ca href='%{userUrl}'\u003edir\u003c/a\u003e geschrieben","sent_by_user":"Von \u003ca href='%{userUrl}'\u003e%{user}\u003c/a\u003e gesendet","sent_by_you":"Von \u003ca href='%{userUrl}'\u003edir\u003c/a\u003e gesendet"},"directory":{"username":"Benutzername","filter_name":"nach Benutzernamen filtern","title":"Benutzer","likes_given":"Gegeben","likes_received":"Erhalten","topics_entered":"Betrachtet","topics_entered_long":"Betrachtete Themen","time_read":"Lesezeit","topic_count":"Themen","topic_count_long":"Erstellte Themen","post_count":"Beiträge","post_count_long":"Verfasste Beiträge","no_results":{"body":"Hier wird eine Liste der Community-Mitglieder und ihrer Aktivitäten angezeigt. Im Moment ist die Liste noch leer, weil deine Community noch ganz neu ist!","extra_body":"Administratoren und Moderatoren können Benutzer in der \u003ca href='%{basePath}/admin/users/'\u003eBenutzerverwaltung\u003c/a\u003e sehen und verwalten."},"no_results_with_search":"Es wurden keine Ergebnisse gefunden.","days_visited":"Aufrufe","days_visited_long":"Besuchstage","posts_read":"Gelesen","posts_read_long":"Gelesene Beiträge","last_updated":"Zuletzt aktualisiert:","total_rows":{"one":"%{count} Benutzer","other":"%{count} Benutzer"},"edit_columns":{"title":"Verzeichnisspalten bearbeiten","save":"Speichern","reset_to_default":"Auf Standard zurücksetzen"},"group":{"all":"alle Gruppen"},"sort":{"label":"Sortieren nach %{criteria}"}},"group_histories":{"actions":{"change_group_setting":"Gruppeneinstellung ändern","add_user_to_group":"Benutzer hinzufügen","remove_user_from_group":"Benutzer entfernen","make_user_group_owner":"Zum Eigentümer machen","remove_user_as_group_owner":"Eigentümerrechte entziehen"}},"groups":{"member_added":"Hinzugefügt","member_requested":"Angefragt am","add_members":{"title":"Benutzer zu %{group_name} hinzufügen","description":"Gib eine Liste von Benutzern ein, die du in die Gruppe einladen möchtest, oder füge eine kommagetrennte Liste ein:","usernames_placeholder":"Benutzernamen","usernames_or_emails_placeholder":"Benutzernamen oder E-Mail-Adressen","notify_users":"Benutzer benachrichtigen","set_owner":"Benutzer als Eigentümer dieser Gruppe festlegen"},"requests":{"title":"Anfragen","reason":"Grund","accept":"Akzeptieren","accepted":"akzeptiert","deny":"ablehnen","denied":"abgelehnt","undone":"Anfrage zurückgenommen","handle":"Mitgliedschaftsanfrage bearbeiten","undo":"Rückgängig machen"},"manage":{"title":"Verwalten","name":"Name","full_name":"Vollständiger Name","add_members":"Benutzer hinzufügen","invite_members":"Einladen","delete_member_confirm":"Entferne „%{username}“ aus der Gruppe „%{group}“?","profile":{"title":"Profil"},"interaction":{"title":"Interaktion","posting":"Beiträge","notification":"Benachrichtigung"},"email":{"title":"E-Mail","status":"%{old_emails}/%{total_emails} E-Mails über IMAP synchronisiert.","enable_smtp":"SMTP aktivieren","enable_imap":"IMAP aktivieren","test_settings":"Test-Einstellungen","save_settings":"Einstellungen speichern","last_updated":"Zuletzt aktualisiert:","last_updated_by":"von","settings_required":"Alle Einstellungen sind erforderlich, bitte fülle alle Felder vor der Validierung aus.","smtp_settings_valid":"SMTP-Einstellungen gültig.","smtp_title":"SMTP","smtp_instructions":"Wenn du SMTP für die Gruppe aktivierst, werden alle ausgehenden E-Mails, die aus dem Posteingang der Gruppe gesendet werden, über die hier angegebenen SMTP-Einstellungen anstelle des E-Mail-Servers gesendet, der für andere von deinem Forum gesendete E-Mails konfiguriert ist.","imap_title":"IMAP","imap_additional_settings":"Weitere Einstellungen","imap_instructions":"Wenn du IMAP für die Gruppe aktivierst, werden E-Mails zwischen dem Gruppenposteingang und dem bereitgestellten IMAP-Server und -Postfach synchronisiert. SMTP muss mit gültigen und getesteten Anmeldedaten aktiviert werden, bevor IMAP aktiviert werden kann. Der für SMTP verwendete E-Mail-Benutzername und das Passwort werden für IMAP verwendet. Weitere Informationen findest du unter \u003ca target=\"_blank\" href=\"https://meta.discourse.org/t/imap-support-for-group-inboxes/160588\"\u003eFeature-Ankündigung auf Discourse Meta\u003c/a\u003e.","imap_alpha_warning":"Warnung: Dies ist eine Alpha-Phasen-Funktion. Nur Gmail wird offiziell unterstützt. Benutzung auf eigene Gefahr!","imap_settings_valid":"IMAP-Einstellungen gültig.","smtp_disable_confirm":"Wenn du SMTP deaktivierst, werden alle SMTP- und IMAP-Einstellungen zurückgesetzt und die zugehörigen Funktionen deaktiviert. Bist du sicher, dass du fortfahren möchtest?","imap_disable_confirm":"Wenn du IMAP deaktivierst, werden alle IMAP-Einstellungen zurückgesetzt und die zugehörigen Funktionen deaktiviert. Bist du sicher, dass du fortfahren möchtest?","imap_mailbox_not_selected":"Du musst ein Postfach für diese IMAP-Konfiguration auswählen, sonst werden keine Postfächer synchronisiert!","prefill":{"title":"Vorbefüllen mit Einstellungen für:","gmail":"Gmail","outlook":"Outlook.com","office365":"Microsoft 365"},"ssl_modes":{"none":"Keiner","ssl_tls":"SSL/TLS","starttls":"STARTTLS"},"credentials":{"title":"Anmeldedaten","smtp_server":"SMTP-Server","smtp_port":"SMTP-Port","smtp_ssl_mode":"SSL-Modus","imap_server":"IMAP-Server","imap_port":"IMAP-Port","imap_ssl":"SSL für IMAP verwenden","username":"Benutzername","password":"Passwort"},"settings":{"title":"Einstellungen","allow_unknown_sender_topic_replies":"Unbekannten Absendern das Antworten auf Gruppenthemen erlauben.","allow_unknown_sender_topic_replies_hint":"Erlaubt unbekannten Absendern, auf Gruppenthemen zu antworten. Wenn dies nicht aktiviert ist, werden Antworten von E-Mail-Adressen, die nicht bereits zu dem Thema eingeladen wurden, ein neues Thema erstellen.","from_alias":"Von Alias","from_alias_hint":"Alias, der beim Versenden von Gruppen-SMTP-E-Mails als Absenderadresse verwendet werden soll. Bitte beachte, dass dies nicht von allen E-Mail-Anbietern unterstützt wird; sieh in der Dokumentation deines E-Mail-Anbieters nach."},"mailboxes":{"synchronized":"Synchronisierte Mailbox","none_found":"In diesem E-Mail-Konto wurden keine Postfächer gefunden.","disabled":"Deaktiviert"}},"membership":{"title":"Mitgliedschaft","access":"Zugriff"},"categories":{"title":"Kategorien","long_title":"Standardbenachrichtigungen für Kategorien","description":"Wenn Benutzer zu dieser Gruppe hinzugefügt werden, werden ihre Einstellungen für die Kategoriebenachrichtigung auf diese Standardeinstellungen festgelegt. Danach können sie sie ändern.","watched_categories_instructions":"Beobachte automatisch alle Themen in diesen Kategorien. Gruppenmitglieder werden über alle neuen Beiträge sowie Themen informiert und neben dem Thema wird auch die Anzahl neuer Beiträge angezeigt.","tracked_categories_instructions":"Verfolge automatisch alle Themen in diesen Kategorien. Neben dem Thema wird die Anzahl neuer Beiträge angezeigt.","watching_first_post_categories_instructions":"Benutzer werden über den ersten Beitrag in jedem neuen Thema in diesen Kategorien informiert.","regular_categories_instructions":"Wenn diese Kategorien stummgeschaltet sind, werden sie für Gruppenmitglieder nicht stummgeschaltet. Benutzer werden benachrichtigt, wenn sie erwähnt werden oder jemand auf sie antwortet.","muted_categories_instructions":"Benutzer werden nicht über neue Themen in diesen Kategorien informiert und sie werden nicht auf den Seiten der Kategorien oder der neuesten Themen angezeigt."},"tags":{"title":"Schlagwörter","long_title":"Standardbenachrichtigungen für Schlagwörter","description":"Wenn Benutzer zu dieser Gruppe hinzugefügt werden, werden ihre Einstellungen für die Schlagwort-Benachrichtigung auf diese Standardeinstellungen festgelegt. Danach können sie sie ändern.","watched_tags_instructions":"Beobachte automatisch alle Themen mit diesen Schlagwörtern. Gruppenmitglieder werden über alle neuen Beiträge sowie Themen informiert und neben dem Thema wird auch die Anzahl neuer Beiträge angezeigt.","tracked_tags_instructions":"Verfolge automatisch alle Themen mit diesen Schlagwörtern. Neben dem Thema wird die Anzahl neuer Beiträge angezeigt.","watching_first_post_tags_instructions":"Benutzer werden über den ersten Beitrag in jedem neuen Thema mit diesen Schlagwörtern informiert.","regular_tags_instructions":"Wenn diese Schlagwörter stummgeschaltet sind, werden sie für Gruppenmitglieder nicht stummgeschaltet. Benutzer werden benachrichtigt, wenn sie erwähnt werden oder jemand auf sie antwortet.","muted_tags_instructions":"Benutzer werden nicht über neue Themen mit diesen Schlagwörtern benachrichtigt und sie werden nicht unter „Aktuell“ angezeigt."},"logs":{"title":"Protokolle","when":"Wann","action":"Aktion","acting_user":"Ausführender Benutzer","target_user":"Betroffener Benutzer","subject":"Betreff","details":"Details","from":"Von","to":"An"}},"permissions":{"title":"Berechtigungen","none":"Dieser Gruppe sind keine Kategorien zugeordnet.","description":"Mitglieder dieser Gruppe können auf diese Kategorien zugreifen"},"public_admission":"Erlaube Benutzern, die Gruppe eigenständig zu betreten (erfordert, dass die Gruppe öffentlich sichtbar ist)","public_exit":"Erlaube Benutzern, die Gruppe eigenständig zu verlassen","empty":{"posts":"Es gibt keine Beiträge von Mitgliedern dieser Gruppe","members":"Es gibt keine Mitglieder in dieser Gruppe","requests":"Keine Mitgliedschaftsanfragen für diese Gruppe","mentions":"Es gibt keine Erwähnungen dieser Gruppe","messages":"Es gibt keine Nachrichten für diese Gruppe","topics":"Es gibt keine Themen von Mitgliedern dieser Gruppe","logs":"Es gibt keine Protokolle für diese Gruppe"},"add":"Hinzufügen","join":"Beitreten","leave":"Verlassen","request":"Anfrage","message":"Nachricht","confirm_leave":"Willst du die Gruppe wirklich verlassen?","allow_membership_requests":"Erlaube Benutzern, Mitgliedschaftsanfragen an Gruppeneigentümer zu senden (erfordert öffentlich sichtbare Gruppen)","membership_request_template":"Individuelle Vorlage, die Benutzern angezeigt wird, welche eine Mitgliedschaftsanfrage senden","membership_request":{"submit":"Anfrage abschicken","title":"Beitrittsanfrage für @%{group_name}","reason":"Lass die Gruppeneigentümer wissen, warum du in diese Gruppe gehörst"},"membership":"Mitgliedschaft","name":"Name","group_name":"Gruppenname","user_count":"Benutzer","bio":"Über die Gruppe","selector_placeholder":"Benutzernamen eingeben","owner":"Eigentümer","index":{"title":"Gruppen","all":"Alle Gruppen","empty":"Es gibt keine sichtbaren Gruppen.","filter":"Filtern nach Art der Gruppe","owner_groups":"Gruppen, deren Eigentümer ich bin","close_groups":"Geschlossene Gruppen","automatic_groups":"Automatische Gruppen","automatic":"Automatisch","closed":"Geschlossen","public":"Öffentlich","private":"Privat","public_groups":"Öffentliche Gruppen","my_groups":"Meine Gruppen","group_type":"Art der Gruppe","is_group_user":"Mitglied","is_group_owner":"Eigentümer","search_results":"Die Suchergebnisse werden unten angezeigt."},"title":{"one":"Gruppe","other":"Gruppen"},"activity":"Aktivität","members":{"title":"Mitglieder","filter_placeholder_admin":"Benutzername oder E-Mail-Adresse","filter_placeholder":"Benutzername","remove_member":"Mitglied entfernen","remove_member_description":"Entferne \u003cb\u003e%{username}\u003c/b\u003e aus dieser Gruppe","make_owner":"Zum Eigentümer machen","make_owner_description":"Mache \u003cb\u003e%{username}\u003c/b\u003e zu einem Eigentümer dieser Gruppe","remove_owner":"Als Eigentümer entfernen","remove_owner_description":"Entferne \u003cb\u003e%{username}\u003c/b\u003e als Eigentümer dieser Gruppe","make_primary":"Als primäre Gruppe festlegen","make_primary_description":"Mache diese Gruppe zur primären Gruppe für \u003cb\u003e%{username}\u003c/b\u003e","remove_primary":"Als primäre Gruppe entfernen","remove_primary_description":"Entferne diese Gruppe als primäre Gruppe für \u003cb\u003e%{username}\u003c/b\u003e","remove_members":"Mitglieder entfernen","remove_members_description":"Ausgewählte Benutzer aus dieser Gruppe entfernen","make_owners":"Zu Eigentümern machen","make_owners_description":"Mache ausgewählte Benutzer zu Eigentümern dieser Gruppe","remove_owners":"Eigentümer entfernen","remove_owners_description":"Ausgewählte Benutzer als Eigentümer dieser Gruppe entfernen","make_all_primary":"Für alle als primäre Gruppe festlegen","make_all_primary_description":"Mache diese Gruppe zur primären Gruppe für alle ausgewählten Benutzer","remove_all_primary":"Als primäre Gruppe entfernen","remove_all_primary_description":"Diese Gruppe als primäre Gruppe entfernen","status":"Status","owner":"Eigentümer","primary":"Primär","forbidden":"Du hast nicht das Recht, die Mitglieder zu sehen.","no_filter_matches":"Keine Mitglieder entsprechen dieser Suche."},"topics":"Themen","posts":"Beiträge","aria_post_number":"%{title} – Beitrag #%{postNumber}","mentions":"Erwähnungen","messages":"Nachrichten","notification_level":"Standard-Benachrichtigungsstufe für Gruppen-Nachrichten","alias_levels":{"mentionable":"Wer kann diese Gruppe mit @ erwähnen?","messageable":"Wer kann dieser Gruppe eine Nachricht schicken?","nobody":"Niemand","only_admins":"Nur Administratoren","mods_and_admins":"Nur Moderatoren und Administratoren","members_mods_and_admins":"Nur Gruppenmitglieder, Moderatoren und Administratoren","owners_mods_and_admins":"Nur Gruppeneigentümer, Moderatoren und Administratoren","everyone":"Jeder"},"notifications":{"watching":{"title":"Beobachten","description":"Du wirst über jeden neuen Beitrag in jeder Nachricht benachrichtigt und die Anzahl neuer Antworten wird angezeigt."},"watching_first_post":{"title":"Ersten Beitrag beobachten","description":"Du wirst über neue Nachrichten in dieser Gruppe informiert, aber nicht über Antworten auf diese Nachrichten."},"tracking":{"title":"Verfolgen","description":"Du wirst benachrichtigt, wenn jemand deinen Namen mit @ erwähnt oder auf deinen Beitrag antwortet, und die Anzahl neuer Antworten wird angezeigt."},"regular":{"title":"Normal","description":"Du wirst benachrichtigt, wenn jemand deinen Namen mit @ erwähnt oder auf deinen Beitrag antwortet."},"muted":{"title":"Stummgeschaltet","description":"Du erhältst keine Benachrichtigungen im Zusammenhang mit Nachrichten in dieser Gruppe."}},"flair_url":"Avatar-Flair-Bild","flair_upload_description":"Verwende quadratische Bilder, die nicht kleiner als 20 x 20 Pixel sind.","flair_bg_color":"Avatar-Flair-Hintergrundfarbe","flair_bg_color_placeholder":"(Optional) Hex-Farbwert","flair_color":"Avatar-Flair-Farbe","flair_color_placeholder":"(Optional) Hex-Farbwert","flair_preview_icon":"Vorschau des Symbols","flair_preview_image":"Vorschaubild","flair_type":{"icon":"Wähle ein Symbol","image":"Lade ein Bild hoch"},"default_notifications":{"modal_title":"Benutzer-Standardbenachrichtigungen","modal_description":{"one":"Soll diese Änderung rückwirkend gelten? Das ändert die Einstellungen für %{count} bestehenden Benutzer.","other":"Soll diese Änderung rückwirkend gelten? Das ändert die Einstellungen für %{count} bestehende Benutzer."},"modal_yes":"Ja","modal_no":"Nein, die Änderung soll sich nur zukünftig auswirken"}},"user_action_groups":{"1":"Abgegebene „Gefällt mir“","2":"Erhaltene „Gefällt mir“","3":"Lesezeichen","4":"Themen","5":"Beiträge","6":"Antworten","7":"Erwähnungen","9":"Zitate","11":"Änderungen","12":"Gesendete Objekte","13":"Posteingang","14":"Ausstehend","15":"Entwürfe","17":"Links"},"categories":{"categories_label":"Kategorien","subcategories_label":"Unterkategorien","no_subcategories":"keine Unterkategorien","remove_filter":"Filter entfernen","plus_more_count":{"one":"+%{count} weitere","other":"+%{count} weitere"},"view_all":"alle ansehen","category":"Kategorie","category_list":"Kategorieliste anzeigen","reorder":{"title":"Kategorien neu sortieren","title_long":"Neustrukturierung der Kategorieliste","save":"Reihenfolge speichern","apply_all":"Anwenden","position":"Position"},"posts":"Beiträge","topics":"Themen","latest":"Aktuelle","subcategories":"Unterkategorien","muted":"Stummgeschaltete Kategorien","topic_sentence":{"one":"%{count} Thema","other":"%{count} Themen"},"topic_stat":{"one":"%{number} / %{unit}","other":"%{number} / %{unit}"},"topic_stat_unit":{"week":"Woche","month":"Monat"},"topic_stat_all_time":{"one":"%{number} gesamt","other":"%{number} gesamt"},"topic_stat_sentence_week":{"one":"%{count} neues Thema in der letzten Woche.","other":"%{count} neue Themen in der letzten Woche."},"topic_stat_sentence_month":{"one":"%{count} neues Thema im letzten Monat.","other":"%{count} neue Themen im letzten Monat."},"n_more":{"one":"Kategorien (%{count} weitere) …","other":"Kategorien (%{count} weitere) …"}},"ip_lookup":{"title":"IP-Adressen-Abfrage","hostname":"Hostname","location":"Standort","location_not_found":"(unbekannt)","organisation":"Organisation","phone":"Telefon","other_accounts":"Andere Konten mit dieser IP-Adresse:","delete_other_accounts":{"one":"%{count} löschen","other":"%{count} löschen"},"username":"Benutzername","trust_level":"Vertrauensstufe","read_time":"Lesezeit","topics_entered":"betrachtete Themen","post_count":"Beiträge","confirm_delete_other_accounts":"Bist du sicher, dass du diese Konten löschen willst?","powered_by":"verwendet \u003ca href='https://maxmind.com'\u003eMaxMindDB\u003c/a\u003e","copied":"kopiert"},"user_fields":{"none":"(wähle eine Option aus)","required":"Bitte gib einen Wert für „%{name}“ ein","required_checkbox":"Das Feld „%{name}“ ist erforderlich","same_as_password":"Dein Passwort sollte nicht in anderen Feldern wiederholt werden","optional":"(optional)"},"user":{"said":"%{username}:","profile":"Profil","profile_possessive":"Profil von %{username}","account_possessive":"Konto von %{name}","mute":"Stummschalten","edit":"Einstellungen bearbeiten","download_archive":{"title":"Exportiere deine Daten","description":"Lade ein Archiv deiner Kontoaktivitäten und Einstellungen herunter.","button_text":"Archiv anfordern","confirm":"Möchtest du wirklich ein Archiv deiner Kontoaktivitäten und Einstellungen herunterladen?","success":"Wir haben mit dem Zusammentragen deines Archivs begonnen. Du erhältst eine Nachricht, wenn der Vorgang abgeschlossen ist.","rate_limit_error":"Kontoarchive können nur einmal pro Tag heruntergeladen werden, bitte versuche es morgen noch einmal.","confirm_all":"Are you sure you want to download all of your information?","confirm_all_admin":"Are you sure you want to download all of the information of {{username}}?"},"new_private_message":"Neue Nachricht","private_message":"Nachricht","private_messages":"Nachrichten","user_notifications":{"filters":{"filter_by":"Filtern nach","all":"Alle","read":"Gelesen","unread":"Ungelesen","unseen":"Ungesehen"},"ignore_duration_title":"Benutzer ignorieren","ignore_duration_username":"Benutzername","ignore_duration_when":"Dauer:","ignore_duration_save":"Ignorieren","ignore_duration_note":"Bitte beachte, dass alle Ignorierungen automatisch entfernt werden, wenn die Ignorierungsdauer verstreicht.","ignore_duration_time_frame_required":"Bitte wähle einen Zeitrahmen aus","ignore_no_users":"Du hast keine Benutzer ignoriert.","ignore_option":"Ignoriert","ignore_option_title":"Du wirst keine Benachrichtigungen zu dieser Person erhalten und ihre Inhalte werden ausgeblendet.","add_ignored_user":"Hinzufügen …","mute_option":"Stummgeschaltet","mute_option_title":"Du wirst keine Benachrichtigungen, persönlichen Nachrichten oder Chat-Direktnachrichten von diesem Benutzer erhalten.","normal_option":"Normal","normal_option_title":"Du wirst benachrichtigt, wenn diese Person dir antwortet, dich zitiert oder erwähnt."},"notification_schedule":{"title":"Zeitplan für Benachrichtigungen","label":"Aktiviere den benutzerdefinierten Zeitplan für Benachrichtigungen","tip":"Außerhalb dieser Zeiten werden deine Benachrichtigungen pausiert.","midnight":"Mitternacht","none":"Keine","monday":"Montag","tuesday":"Dienstag","wednesday":"Mittwoch","thursday":"Donnerstag","friday":"Freitag","saturday":"Samstag","sunday":"Sonntag","to":"bis"},"activity_stream":"Aktivität","read":"Gelesen","read_help":"Kürzlich gelesene Themen","preferences":{"title":"Einstellungen","profile":{"enforced_required_fields":"Du musst zusätzliche Informationen angeben, bevor du diese Website weiter nutzen kannst."}},"feature_topic_on_profile":{"open_search":"Wähle ein neues Thema","title":"Wähle ein Thema","search_label":"Suche nach einem Thema anhand der Überschrift","save":"Speichern","clear":{"title":"Löschen","warning":"Bist du sicher, dass du dein hervorgehobenes Thema löschen möchtest?"}},"use_current_timezone":"Aktuelle Zeitzone verwenden","profile_hidden":"Das öffentliche Profil des Benutzers ist ausgeblendet.","login_to_view_profile":"Du musst dich anmelden, um Benutzerprofile zu sehen","inactive_user":"Dieser Benutzer ist nicht mehr aktiv.","expand_profile":"Erweitern","sr_expand_profile":"Profildetails erweitern","collapse_profile":"Zuklappen","sr_collapse_profile":"Profildetails ausblenden","bookmarks":"Lesezeichen","bio":"Über mich","timezone":"Zeitzone","invited_by":"Eingeladen von","trust_level":"Vertrauensstufe","notifications":"Benachrichtigungen","statistics":"Statistiken","desktop_notifications":{"label":"Live-Benachrichtigungen","not_supported":"Dieser Browser unterstützt leider keine Benachrichtigungen.","perm_default":"Benachrichtigungen einschalten","perm_denied_btn":"Berechtigung verweigert","perm_denied_expl":"Du hast das Anzeigen von Benachrichtigungen verboten. Aktiviere die Benachrichtigungen über deine Browser-Einstellungen.","disable":"Benachrichtigungen deaktivieren","enable":"Benachrichtigungen aktivieren","each_browser_note":"Hinweis: Du musst diese Einstellung in jedem Browser, den du verwendest, ändern. Alle Benachrichtigungen werden unabhängig von dieser Einstellung deaktiviert, wenn du die Benachrichtigungen im Benutzermenü pausierst.","consent_prompt":"Möchtest du Live-Benachrichtigungen erhalten, wenn jemand auf deine Beiträge antwortet?"},"dismiss":"Alles gelesen","dismiss_notifications":"Alles gelesen","dismiss_notifications_tooltip":"Alle ungelesenen Benachrichtigungen als gelesen markieren","dismiss_bookmarks_tooltip":"Markiere alle ungelesenen Lesezeichen-Erinnerungen als gelesen","dismiss_messages_tooltip":"Markiere alle ungelesenen persönlichen Nachrichten als gelesen","no_likes_title":"Du hast noch keine „Gefällt mir“-Angaben erhalten","no_likes_body":"Du wirst hier jedes Mal benachrichtigt, wenn jemand einem deiner Beiträge ein „Gefällt mir“ gibt, damit du sehen kannst, was andere für nützlich halten. Andere sehen das auch, wenn du ihren Beiträgen ein „Gefällt mir“ gibst! \u003cbr\u003e\u003cbr\u003e Benachrichtigungen über „Gefällt mir“-Angaben werden dir nie per E-Mail zugeschickt, aber du kannst in deinen \u003ca href='%{preferencesUrl}'\u003eBenachrichtigungseinstellungen\u003c/a\u003e festlegen, wie du Benachrichtigungen über „Gefällt mir“-Angaben auf der Website erhältst.\n","no_messages_title":"Du hast keine Nachrichten","no_messages_body":"Benötigst du ein direktes persönliches Gespräch mit jemandem außerhalb des normalen Gesprächsflusses? Sende der Person eine Nachricht, indem du ihren Avatar auswählst und die Schaltfläche %{icon} verwendest.\u003cbr\u003e\u003cbr\u003e Wenn du Hilfe benötigst, kannst du eine \u003ca href='%{aboutUrl}'\u003eNachricht an ein Team-Mitglied senden\u003c/a\u003e.\n","no_bookmarks_title":"Du hast noch nichts mit einem Lesezeichen versehen","no_bookmarks_body":"Beginne Lesezeichen von Beiträgen mit der Schaltfläche %{icon} zu setzen und sie werden hier zum einfachen Nachschlagen aufgeführt. Du kannst auch eine Erinnerung vereinbaren!\n","no_bookmarks_search":"Keine Lesezeichen mit der angegebenen Suchanfrage gefunden.","no_notifications_title":"Du hast noch keine Benachrichtigungen","no_notifications_body":"Du wirst in diesem Panel über für dich direkt relevante Aktivitäten benachrichtigt, einschließlich Antworten auf deine Themen und Beiträge, wenn dich jemand mit \u003cb\u003e@\u003c/b\u003e erwähnt oder zitiert und wenn jemand auf Themen antwortet, die du beobachtest. Benachrichtigungen werden auch an deine E-Mail-Adresse gesendet, wenn du dich eine Weile nicht eingeloggt hast. \u003cbr\u003e\u003cbr\u003e Suche nach %{icon}, um zu entscheiden, bei welchen Themen, Kategorien und Schlagwörtern du benachrichtigt werden möchtest. Weiteres findest du in den \u003ca href='%{preferencesUrl}'\u003eBenachrichtigungseinstellungen\u003c/a\u003e.\n","no_other_notifications_title":"Du hast noch keine anderen Benachrichtigungen","no_other_notifications_body":"In diesem Bereich wirst du über andere Aktivitäten benachrichtigt, die für dich relevant sein könnten – zum Beispiel, wenn jemand einen deiner Beiträge verlinkt oder bearbeitet.\n","no_notifications_page_title":"Du hast noch keine Benachrichtigungen","no_notifications_page_body":"Du wirst über für dich direkt relevante Aktivitäten benachrichtigt, einschließlich Antworten auf deine Themen und Beiträge, wenn dich jemand mit \u003cb\u003e@\u003c/b\u003e erwähnt oder zitiert und wenn jemand auf Themen antwortet, die du beobachtest. Benachrichtigungen werden auch an deine E-Mail-Adresse gesendet, wenn du dich eine Weile nicht eingeloggt hast. \u003cbr\u003e\u003cbr\u003e Suche nach %{icon}, um zu entscheiden, bei welchen Themen, Kategorien und Schlagwörtern du benachrichtigt werden möchtest. Weiteres findest du in den \u003ca href='%{preferencesUrl}'\u003eBenachrichtigungseinstellungen\u003c/a\u003e.\n","dynamic_favicon":"Zeige Anzahl im Browser-Icon","skip_new_user_tips":{"description":"Keine Tipps für neue Benutzer anzeigen und nicht über den Erhalt von „Erste Schritte“-Abzeichen informieren"},"reset_seen_user_tips":"Benutzertipps erneut anzeigen","theme_default_on_all_devices":"Mache dieses Theme zum Standard für alle meine Geräte","color_scheme_default_on_all_devices":"Standard-Farbpalette auf allen meinen Geräten festlegen","color_scheme":"Farbpalette","color_schemes":{"default_description":"Theme-Standard","disable_dark_scheme":"Gleich wie regulär","dark_instructions":"Du kannst die Farbpalette für den dunklen Modus ausprobieren, indem du den dunklen Modus auf deinem Gerät einschaltest.","undo":"Zurücksetzen","regular":"Regulär","dark":"Dunkler Modus","default_dark_scheme":"(Website-Standard)"},"dark_mode":"Dunkler Modus","dark_mode_enable":"Farbpalette für den dunklen Modus automatisch aktivieren","text_size_default_on_all_devices":"Mache diese Schriftgröße zum Standard für alle meine Geräte","allow_private_messages":"Anderen Benutzern erlauben, mir persönliche Nachrichten und Chat-Direktnachrichten zu senden","external_links_in_new_tab":"Öffne alle externen Links in einer neuen Registerkarte","enable_quoting":"Aktiviere Zitatantwort mit dem hervorgehobenen Text","enable_smart_lists":"Aktiviere intelligente Listen beim Schreiben im Composer","enable_defer":"„Themen als ungelesen markieren“ aktivieren","experimental_sidebar":{"enable":"Seitenleiste aktivieren","options":"Optionen","navigation_section":"Navigation","navigation_section_instruction":"Wenn eine Themenliste im Navigationsmenü neue oder ungelesene Elemente enthält …","link_to_filtered_list_checkbox_description":"Gefilterte Liste verlinken","show_count_new_items_checkbox_description":"Zähler für die neuen Elemente anzeigen"},"change":"ändern","featured_topic":"Hervorgehobenes Thema","moderator":"%{user} ist ein Moderator","admin":"%{user} ist ein Administrator","moderator_tooltip":"Dieser Benutzer ist ein Moderator","admin_tooltip":"Dieser Benutzer ist ein Administrator","silenced_tooltip":"Der Benutzer ist stummgeschaltet","suspended_notice":"Dieser Benutzer ist bis zum %{date} gesperrt.","suspended_permanently":"Der Benutzer ist gesperrt.","suspended_reason":"Grund: ","github_profile":"GitHub","email_activity_summary":"Aktivitäts-Übersicht","mailing_list_mode":{"label":"Mailinglisten-Modus","enabled":"Mailinglisten-Modus aktivieren","instructions":"Diese Einstellung überschreibt die Aktivitäts-Übersicht.\u003cbr /\u003e\nStummgeschaltete Themen und Kategorien werden in diese E-Mails nicht eingeschlossen.\n","individual":"Für jeden Beitrag eine E-Mail senden","individual_no_echo":"Sende für alle fremden Beträge eine E-Mail","many_per_day":"Sende mir für jeden neuen Beitrag eine E-Mail (etwa %{dailyEmailEstimate} pro Tag)","few_per_day":"Sende mir für jeden neuen Beitrag eine E-Mail (etwa 2 pro Tag)","warning":"Mailinglisten-Modus aktiviert. Einstellungen zur Benachrichtigung per E-Mail werden nicht berücksichtigt."},"tag_settings":"Schlagwörter","watched_tags":"Beobachtet","watched_tags_instructions":"Du wirst automatisch alle neuen Themen mit diesen Schlagwörtern beobachten. Du wirst über alle neuen Beiträge und Themen benachrichtigt und die Anzahl der neuen Beiträge wird bei den betroffenen Themen angezeigt.","tracked_tags":"Verfolgt","tracked_tags_instructions":"Du wirst automatisch alle Themen mit diesen Schlagwörtern verfolgen. Die Anzahl der neuen Beiträge wird bei den betroffenen Themen angezeigt.","muted_tags":"Stummgeschaltet","muted_tags_instructions":"Du erhältst keine Benachrichtigungen über neue Themen mit diesen Schlagwörtern und die Themen werden auch nicht in der Liste der aktuellen Themen erscheinen.","watched_categories":"Beobachtet","watched_categories_instructions":"Du wirst automatisch alle neuen Themen in diesen Kategorien beobachten. Du wirst über alle neuen Beiträge und Themen benachrichtigt und die Anzahl der neuen Beiträge wird bei den betroffenen Themen angezeigt.","tracked_categories":"Verfolgt","tracked_categories_instructions":"Du wirst automatisch alle Themen in diesen Kategorien verfolgen. Die Anzahl der neuen Beiträge wird bei den betroffenen Themen angezeigt.","watched_first_post_categories":"Ersten Beitrag beobachten","watched_first_post_categories_instructions":"Du erhältst eine Benachrichtigung für den ersten Beitrag in jedem neuen Thema in diesen Kategorien.","watched_first_post_tags":"Ersten Beitrag beobachten","watched_first_post_tags_instructions":"Du erhältst eine Benachrichtigung für den ersten Beitrag in jedem neuen Thema mit diesen Schlagwörtern.","watched_precedence_over_muted":"Benachrichtige mich über Themen in Kategorien oder mit Schlagwörtern, die ich beobachte und die auch zu einem Thema gehören, das ich stummgeschaltet habe","muted_categories":"Stummgeschaltet","muted_categories_instructions":"Du erhältst keine Benachrichtigungen über neue Themen in diesen Kategorien und sie werden auch nicht in der Liste der Kategorien oder der aktuellen Themen erscheinen.","muted_categories_instructions_dont_hide":"Du erhältst keine Benachrichtigungen über neue Themen in diesen Kategorien.","regular_categories":"Normal","regular_categories_instructions":"Diese Kategorien werden in den Themenlisten „Neueste“ und „Top“ angezeigt.","no_category_access":"Moderatoren haben eingeschränkte Kategorien-Berechtigungen, Speichern ist nicht verfügbar.","delete_account":"Lösche mein Benutzerkonto","delete_account_confirm":"Möchtest du wirklich dein Benutzerkonto permanent löschen? Diese Aktion kann nicht rückgängig gemacht werden!","deleted_yourself":"Dein Benutzerkonto wurde erfolgreich gelöscht.","delete_yourself_not_allowed":"Bitte kontaktiere ein Team-Mitglied, wenn du möchtest, dass dein Konto gelöscht wird.","unread_message_count":"Nachrichten","admin_delete":"Löschen","users":"Benutzer","muted_users":"Stummgeschaltet","muted_users_instructions":"Alle Benachrichtigungen, persönlichen Nachrichten und Chat-Direktnachrichten von diesen Benutzern unterdrücken.","allowed_pm_users":"Erlaubt","allowed_pm_users_instructions":"Nur persönliche Nachrichten oder Chat-Direktnachrichten von diesen Benutzern erlauben.","allow_private_messages_from_specific_users":"Nur bestimmten Benutzern erlauben, mir persönliche Nachrichten oder Chat-Direktnachrichten zu senden","ignored_users":"Ignoriert","ignored_users_instructions":"Alle Beiträge, Nachrichten, Benachrichtigungen, persönlichen Nachrichten und Chat-Direktnachrichten von diesen Benutzern unterdrücken.","tracked_topics_link":"Anzeigen","automatically_unpin_topics":"Angeheftete Themen automatisch loslösen, wenn ich deren letzten Beitrag gelesen habe","apps":"Apps","revoke_access":"Zugriffsrecht entziehen","undo_revoke_access":"Zugriffsrecht wiederherstellen","api_approved":"Genehmigt:","api_last_used_at":"Zuletzt benutzt am:","theme":"Theme","save_to_change_theme":"Das Theme wird aktualisiert, nachdem du auf „%{save_text}“ geklickt hast.","home":"Standard-Startseite","staged":"Vorbereitet","staff_counters":{"flags_given":{"one":"\u003cspan class=\"%{className}\"\u003e%{count}\u003c/span\u003e hilfreiche Meldung","other":"\u003cspan class=\"%{className}\"\u003e%{count}\u003c/span\u003e hilfreiche Meldungen"},"flagged_posts":{"one":"\u003cspan class=\"%{className}\"\u003e%{count}\u003c/span\u003e gemeldeter Beitrag","other":"\u003cspan class=\"%{className}\"\u003e%{count}\u003c/span\u003e gemeldete Beiträge"},"deleted_posts":{"one":"\u003cspan class=\"%{className}\"\u003e%{count}\u003c/span\u003e gelöschter Beitrag","other":"\u003cspan class=\"%{className}\"\u003e%{count}\u003c/span\u003e gelöschte Beiträge"},"suspensions":{"one":"\u003cspan class=\"%{className}\"\u003e%{count}\u003c/span\u003e Sperre","other":"\u003cspan class=\"%{className}\"\u003e%{count}\u003c/span\u003e Sperren"},"warnings_received":{"one":"\u003cspan class=\"%{className}\"\u003e%{count}\u003c/span\u003e Warnung","other":"\u003cspan class=\"%{className}\"\u003e%{count}\u003c/span\u003e Warnungen"},"rejected_posts":{"one":"\u003cspan class=\"%{className}\"\u003e%{count}\u003c/span\u003e abgelehnter Beitrag","other":"\u003cspan class=\"%{className}\"\u003e%{count}\u003c/span\u003e abgelehnte Beiträge"}},"messages":{"all":"alle Posteingänge","inbox":"Posteingang","personal":"Persönlich","latest":"Aktuelle","sent":"Gesendet","unread":"Ungelesen","unread_with_count":{"one":"Ungelesen (%{count})","other":"Ungelesen (%{count})"},"new":"Neu","new_with_count":{"one":"Neu (%{count})","other":"Neu (%{count})"},"archive":"Archiv","groups":"Meine Gruppen","move_to_inbox":"In Posteingang verschieben","move_to_archive":"Archivieren","failed_to_move":"Die ausgewählten Nachrichten konnten nicht verschoben werden. Vielleicht gibt es ein Netzwerkproblem.","tags":"Schlagwörter","all_tags":"Alle Schlagwörter","warnings":"Offizielle Warnungen","read_more_in_group":"Möchtest du mehr lesen? Entdecke andere Nachrichten in %{groupLink}.","read_more":"Möchtest du mehr lesen? Durchsuche andere Nachrichten in \u003ca href='%{basePath}/u/%{username}/messages'\u003epersönliche Nachrichten\u003c/a\u003e."},"preferences_nav":{"account":"Konto","security":"Sicherheit","profile":"Profil","emails":"E-Mails","notifications":"Benachrichtigungen","tracking":"Verfolgen","categories":"Kategorien","users":"Benutzer","tags":"Schlagwörter","interface":"Oberfläche","apps":"Apps","navigation_menu":"Navigationsmenü"},"change_password":{"success":"(E-Mail gesendet)","in_progress":"(E-Mail wird gesendet)","error":"(Fehler)","action":"Sende eine E-Mail zum Zurücksetzen des Passworts","set_password":"Passwort ändern","choose_new":"Wähle ein neues Passwort","choose":"Wähle ein Passwort","verify_identity":"Um fortzufahren, bestätige bitte deine Identität.","title":"Passwort zurücksetzen"},"second_factor_backup":{"title":"Wiederherstellungscodes für Zwei-Faktor-Authentifizierung","regenerate":"Erneuern","disable":"Deaktivieren","enable":"Wiederherstellungscodes erstellen","enable_long":"Wiederherstellungscodes hinzufügen","not_enabled":"Du hast noch keine Wiederherstellungscodes erstellt.","manage":{"one":"Du hast noch \u003cstrong\u003e%{count}\u003c/strong\u003e verbleibenden Wiederherstellungscode.","other":"Du hast noch \u003cstrong\u003e%{count}\u003c/strong\u003e verbleibende Wiederherstellungscodes."},"copy_to_clipboard":"In Zwischenablage kopieren","copy_to_clipboard_error":"Beim Kopieren in die Zwischenablage trat ein Fehler auf","copied_to_clipboard":"Wurde in Zwischenablage kopiert","download_backup_codes":"Wiederherstellungscodes herunterladen","remaining_codes":{"one":"Du hast noch \u003cstrong\u003e%{count}\u003c/strong\u003e verbleibenden Wiederherstellungscode.","other":"Du hast noch \u003cstrong\u003e%{count}\u003c/strong\u003e verbleibende Wiederherstellungscodes."},"use":"Benutze einen Wiederherstellungscode","enable_prerequisites":"Du musst vor dem Generieren von Wiederherstellungscodes einen primären, zweiten Faktor aktivieren.","codes":{"title":"Wiederherstellungscodes generiert","description":"Jeder dieser Wiederherstellungscodes kann nur einmal benutzt werden. Bewahre diese an einem sicheren, für dich zugänglichen Ort auf."}},"second_factor":{"title":"Zwei-Faktor-Authentifizierung","enable":"Zwei-Faktor-Authentifizierung verwalten","disable_all":"Alle deaktivieren","name":"Name","label":"Code","rate_limit":"Bitte warte ein wenig, bevor du es mit einem anderen Authentifizierungscode versuchst.","enable_description":"Scanne diesen QR-Code mit einer unterstützten App (\u003ca href=\"https://www.google.com/search?q=authenticator+apps+for+android\" target=\"_blank\"\u003eAndroid\u003c/a\u003e – \u003ca href=\"https://www.google.com/search?q=authenticator+apps+for+ios\" target=\"_blank\"\u003eiOS\u003c/a\u003e) und gib deinen Authentifizierungscode ein.\n","disable_description":"Bitte gib den Authentifizierungscode aus deiner App ein.","show_key_description":"Manuell eingeben","short_description":"Schütze dein Konto mit einmalig verwendbaren Sicherheitscodes oder physischen Sicherheitsschlüsseln.\n","extended_description":"Zwei-Faktor-Authentifizierung erhöht die Sicherheit deines Kontos, indem zusätzlich zum Passwort ein einmalig gültiger Code erforderlich ist. Codes können auf \u003ca href=\"https://www.google.de/search?q=authenticator+app+f%C3%BCr+android\" target='_blank'\u003eAndroid\u003c/a\u003e- und \u003ca href=\"https://www.google.de/search?q=authenticator+app+f%C3%BCr+iOS\"\u003eiOS\u003c/a\u003e-Geräten generiert werden.\n","oauth_enabled_warning":"Bitte beachte, dass soziale Anmeldemethoden deaktiviert werden, sobald die Zwei-Faktor-Authentifizierung für dein Konto aktiviert wurde.","use":"Benutze die Authentifizierungs-App","enforced_with_oauth_notice":"Du musst die Zwei-Faktor-Authentifizierung aktivieren. Du wirst nur aufgefordert, diese zu verwenden, wenn du dich mit einem Passwort anmeldest, nicht aber bei externer Authentifizierung oder bei der Anmeldung über soziale Netzwerke.","enforced_notice":"Du musst die Zwei-Faktor-Authentifizierung aktivieren, um auf die Website zugreifen zu können.","disable":"Deaktivieren","disable_confirm":"Bist du sicher, dass du die Zwei-Faktor-Authentifizierung deaktivieren willst?","delete":"Löschen","delete_confirm_header":"Diese tokenbasierten Authentifikatoren und physischen Sicherheitsschlüssel werden gelöscht:","delete_confirm_instruction":"Gib zur Bestätigung \u003cstrong\u003e%{confirm}\u003c/strong\u003e in das Feld unten ein.","delete_single_confirm_title":"Löschen eines Authentifikators","delete_single_confirm_message":"Du löschst %{name}. Du kannst diese Aktion nicht rückgängig machen. Wenn du deine Meinung änderst, musst du den Authentifikator erneut registrieren.","delete_backup_codes_confirm_title":"Wiederherstellungscodes löschen","delete_backup_codes_confirm_message":"Du löschst Wiederherstellungscodes. Du kannst diese Aktion nicht rückgängig machen. Wenn du deine Meinung änderst, musst du die Wiederherstellungscodes neu erstellen.","save":"Speichern","edit":"Bearbeiten","edit_title":"Authentifikator bearbeiten","edit_description":"Authentifikator-Name","enable_security_key_description":"Wenn du deinen \u003ca href=\"https://www.google.com/search?q=hardware+security+key\" target=\"_blank\"\u003eHardware-Sicherheitsschlüssel\u003c/a\u003e oder dein kompatibles Mobilgerät vorbereitet hast, klicke unten auf „Registrieren“.\n","totp":{"title":"Token-basierte Authentifikatoren","add":"Authentifikator hinzufügen","default_name":"Mein Authentifikator","name_and_code_required_error":"Du musst einen Namen und den Code aus deiner Authentifikator-App angeben."},"security_key":{"register":"Registrieren","title":"Physische Sicherheitsschlüssel","add":"Physischen Sicherheitsschlüssel hinzufügen","default_name":"Hauptsicherheitsschlüssel","iphone_default_name":"iPhone","android_default_name":"Android","not_allowed_error":"Der Registrierungsvorgang für den Sicherheitsschlüssel ist abgelaufen oder wurde abgebrochen.","already_added_error":"Du hast diesen Sicherheitsschlüssel bereits registriert. Du musst ihn nicht erneut registrieren.","edit":"Physischen Sicherheitsschlüssel bearbeiten","save":"Speichern","edit_description":"Name des physischen Sicherheitsschlüssels","name_required_error":"Du musst einen Namen für deinen Sicherheitsschlüssel angeben."}},"passkeys":{"rename_passkey":"Passkey umbenennen","add_passkey":"Passkey hinzufügen","confirm_delete_passkey":"Möchtest du wirklich diesen Passkey löschen?","passkey_successfully_created":"Erfolg! Dein neuer Passkey wurde erstellt.","rename_passkey_instructions":"Wähle einen Namen für den Passkey, mit dem du ihn leicht identifizieren kannst, zum Beispiel den Namen deines Passwortmanagers.","name":{"default":"Haupt-Passkey"},"save":"Speichern","title":"Passkeys","short_description":"Passkeys ersetzen Passwörter und validieren deine Identität biometrisch (z.B. durch Touch ID, Face ID) oder über eine Geräte-PIN/ein Passwort.","added_date":"Hinzugefügt am %{date}","last_used_date":"Zuletzt verwendet am %{date}","never_used":"Nie verwendet","not_allowed_error":"Bei der Registrierung des Passkeys wurde entweder das Zeitlimit überschritten, der Vorgang wurde abgebrochen oder er ist nicht zulässig.","already_added_error":"Du hast diesen Passkey bereits registriert. Du musst ihn nicht erneut registrieren.","confirm_button":"oder einen Passkey verwenden"},"change_about":{"title":"„Über mich“ ändern","error":"Beim Ändern dieses Wertes ist ein Fehler aufgetreten."},"change_username":{"title":"Benutzernamen ändern","confirm":"Bist du dir ganz sicher, dass du deinen Benutzernamen ändern möchtest?","taken":"Der Benutzername ist bereits vergeben.","invalid":"Der Benutzernamen ist nicht zulässig. Er darf nur Zahlen und Buchstaben enthalten."},"add_email":{"title":"E-Mail hinzufügen","add":"hinzufügen"},"change_email":{"title":"E-Mail-Adresse ändern","taken":"Entschuldige, diese E-Mail-Adresse ist nicht verfügbar.","error":"Beim Ändern der E-Mail-Adresse ist ein Fehler aufgetreten. Möglicherweise wird diese Adresse schon benutzt.","success":"Wir haben eine E-Mail an die angegebene E-Mail-Adresse gesendet. Folge zur Bestätigung der Adresse bitte den darin enthaltenen Anweisungen.","success_via_admin":"Wir haben eine E-Mail an diese Adresse gesendet. Der Benutzer muss den Bestätigungsanweisungen in der E-Mail folgen.","success_staff":"Wir haben eine E-Mail an deine aktuelle Adresse geschickt. Bitte folge den Bestätigungsanweisungen.","back_to_preferences":"Zurück zu den Einstellungen","confirm_success":"Deine E-Mail-Adresse wurde aktualisiert.","confirm":"Bestätigen","authorizing_new":{"description":"Bitte bestätige, dass du deine E-Mail-Adresse ändern möchtest in:","description_add":"Bitte bestätige, dass du eine alternative E-Mail-Adresse hinzufügen möchtest:"},"authorizing_old":{"title":"Alte E-Mail-Adresse verifizieren","description":"Bitte bestätige deine alte E-Mail-Adresse, um mit dem Ändern deiner E-Mail-Adresse fortzufahren:","description_add":"Bitte bestätige deine bestehende E-Mail-Adresse, um mit dem Hinzufügen einer alternativen Adresse fortzufahren:","old_email":"Alte E-Mail-Adresse: %{email}","new_email":"Neue E-Mail-Adresse: %{email}","confirm_success":"Wir haben eine E-Mail an deine neue E-Mail-Adresse gesendet, um die Änderung zu bestätigen!"}},"change_avatar":{"title":"Ändere dein Profilbild","gravatar":"\u003ca href='//%{gravatarBaseUrl}%{gravatarLoginUrl}' target='_blank'\u003e%{gravatarName}\u003c/a\u003e, basierend auf","gravatar_title":"Ändere deinen Avatar auf der Website von %{gravatarName}","gravatar_failed":"%{gravatarName} zu dieser Email-Adresse nicht gefunden.","refresh_gravatar_title":"Aktualisiere deinen %{gravatarName}","letter_based":"ein vom System zugeordnetes Profilbild","uploaded_avatar":"Eigenes Bild","uploaded_avatar_empty":"Eigenes Bild hinzufügen","upload_title":"Lade dein Bild hoch","image_is_not_a_square":"Achtung: Wir haben dein Bild zugeschnitten, weil Höhe und Breite nicht übereingestimmt haben.","logo_small":"Das kleine Logo der Website. Es wird standardmäßig verwendet.","use_custom":"Oder lade einen eigenen Avatar hoch:"},"change_profile_background":{"title":"Profil-Kopfzeile","instructions":"Profil-Kopfzeilen werden zentriert und haben eine Standardbreite von 1110 px."},"change_card_background":{"title":"Benutzerkarten-Hintergrund","instructions":"Hintergrundbilder werden zentriert und haben eine Standardbreite von 590 px."},"change_featured_topic":{"title":"Hervorgehobenes Thema","instructions":"Eine Verknüpfung zu diesem Thema wird auf deiner Benutzerkarte und deinem Profil sein."},"email":{"title":"E-Mail","primary":"Primäre E-Mail-Adresse","secondary":"Weitere E-Mail-Adressen","primary_label":"primär","unconfirmed_label":"unbestätigt","resend_label":"Bestätigungs-E-Mail erneut senden","resending_label":"wird gesendet …","resent_label":"E-Mail gesendet","update_email":"E-Mail-Adresse ändern","set_primary":"Primäre E-Mail-Adresse festlegen","destroy":"E-Mail entfernen","add_email":"Alternative E-Mail-Adresse hinzufügen","auth_override_instructions":"E-Mails können vom Authentifizierungsanbieter aktualisiert werden.","no_secondary":"Keine weiteren E-Mail-Adressen","instructions":"Nie öffentlich gezeigt","admin_note":"Hinweis: Ein Administrator, der die E-Mail-Adresse eines anderen Nicht-Administratorbenutzers ändert, zeigt an, dass der Benutzer den Zugriff auf sein ursprüngliches E-Mail-Konto verloren hat. Daher wird eine E-Mail zum Zurücksetzen des Passworts an seine neue Adresse gesendet. Die E-Mail-Adresse des Benutzers ändert sich erst, wenn der Vorgang zum Zurücksetzen des Passworts abgeschlossen ist.","ok":"Wir senden dir zur Bestätigung eine E-Mail","required":"Bitte gib eine E-Mail-Adresse ein","invalid":"Bitte gib eine gültige E-Mail-Adresse ein","authenticated":"Deine E-Mail wurde von %{provider} authentifiziert","invite_auth_email_invalid":"Deine Einladungs-E-Mail stimmt nicht mit der von %{provider} authentifizierten E-Mail überein","authenticated_by_invite":"Deine E-Mail wurde durch die Einladung authentifiziert","frequency":{"one":"Wir werden dir nur dann eine E-Mail senden, wenn wir dich nicht innerhalb der letzten Minute gesehen haben.","other":"Wir werden dir nur dann eine E-Mail senden, wenn wir dich nicht innerhalb der letzten %{count} Minuten gesehen haben."}},"associated_accounts":{"title":"Verknüpfte Konten","connect":"Verbinden","revoke":"Entziehen","cancel":"Abbrechen","not_connected":"(nicht verbunden)","confirm_modal_title":"Verbinde „%{provider}“-Konto","confirm_description":{"disconnect":"Dein bestehendes %{provider}-Konto „%{account_description}“ wird getrennt.","account_specific":"Dein „%{provider}“-Konto „%{account_description}“ wird für die Authentifizierung genutzt.","generic":"Dein „%{provider}“-Konto wird für die Authentifizierung genutzt."}},"activate_account":{"action":"Klicke hier, um dein Konto zu aktivieren","already_done":"Entschuldige, dieser Link zur Aktivierung des Benutzerkontos ist nicht mehr gültig. Ist dein Konto schon aktiviert?","please_continue":"Dein neues Konto ist jetzt bestätigt; du wirst auf die Startseite weitergeleitet.","continue_button":"Fertig!","welcome_to":"Willkommen bei %{site_name}!","approval_required":"Bevor du auf das Forum zugreifen kannst, muss dein neues Konto noch von einem Moderator genehmigt werden. Du erhältst eine E-Mail, sobald dies geschehen ist!"},"name":{"title":"Name","title_optional":"Name (optional)","instructions":"Dein vollständiger Name (optional)","instructions_required":"Dein vollständiger Name","required":"Bitte gib einen Namen ein","too_short":"Dein Name ist zu kurz","ok":"Dein Name sieht in Ordnung aus"},"username":{"title":"Benutzername","instructions":"Einzigartig, keine Leerzeichen, kurz","short_instructions":"Leute können dich mit @%{username} erwähnen","available":"Dein Benutzername ist verfügbar","not_available":"Nicht verfügbar. Wie wäre es mit %{suggestion}?","not_available_no_suggestion":"Nicht verfügbar","too_short":"Dein Benutzername ist zu kurz","too_long":"Dein Benutzername ist zu lang","checking":"Verfügbarkeit des Benutzernamens wird geprüft …","prefilled":"E-Mail-Adresse entspricht diesem registrierten Benutzernamen","required":"Bitte einen Benutzernamen eingeben","edit":"Benutzernamen bearbeiten"},"locale":{"title":"Oberflächensprache","instructions":"Die Sprache der Forumsoberfläche. Diese Änderung tritt nach dem Neuladen der Seite in Kraft.","default":"(Standard)","any":"(keine Einschränkung)"},"homepage":{"default":"(Standard)"},"password_confirmation":{"title":"Wiederholung des Passworts"},"invite_code":{"title":"Einladungs-Code","instructions":"Zur Registrierung eines Benutzerkontos wird ein Einladungs-Code benötigt."},"auth_tokens":{"title":"Kürzlich benutzte Geräte","short_description":"Dies ist eine Liste der Geräte, die sich kürzlich bei deinem Konto angemeldet haben.","details":"Details","log_out_all":"Überall abmelden","not_you":"Das bist nicht du?","show_all":"Alle anzeigen (%{count})","show_few":"Weniger anzeigen","was_this_you":"Warst das du?","was_this_you_description":"Falls du es nicht warst, empfehlen wir dir, dein Passwort zu ändern und dich überall abzumelden.","browser_and_device":"%{browser} auf %{device}","secure_account":"Mein Konto absichern","latest_post":"Dein letzter Beitrag …","device_location":"\u003cspan class=\"auth-token-device\"\u003e%{device}\u003c/span\u003e \u0026ndash; \u003cspan title=\"IP-Adresse: %{ip}\"\u003e%{location}\u003c/span\u003e","browser_active":"%{browser} | \u003cspan class=\"active\"\u003egerade aktiv\u003c/span\u003e","browser_last_seen":"%{browser} | %{date}"},"last_posted":"Letzter Beitrag","last_seen":"Zuletzt gesehen","created":"Beigetreten","log_out":"Abmelden","location":"Wohnort","website":"Website","email_settings":"E-Mail","hide_profile":"Mein öffentliches Profil ausblenden","enable_physical_keyboard":"Unterstützung für physische Tastatur auf dem iPad aktivieren","text_size":{"title":"Schriftgröße","smallest":"Am kleinsten","smaller":"Kleiner","normal":"Normal","larger":"Größer","largest":"Am größten"},"title_count_mode":{"title":"Hintergrund-Seitentitel zeigt Anzahl von:","notifications":"Neue Benachrichtigungen","contextual":"Neuer Seiteninhalt"},"bookmark_after_notification":{"title":"Nachdem eine Lesezeichen-Erinnerungsbenachrichtigung gesendet wurde:"},"like_notification_frequency":{"title":"Benachrichtigung für erhaltene „Gefällt mir“ anzeigen","always":"Immer","first_time_and_daily":"Für das erste „Gefällt mir“ sowie maximal täglich","first_time":"Nur für das erste „Gefällt mir“ eines Beitrags","never":"Nie"},"email_previous_replies":{"title":"Füge vorherige Beiträge ans Ende von E-Mails an","unless_emailed":"sofern noch nicht gesendet","always":"immer","never":"nie"},"email_digests":{"title":"Wenn ich nicht vorbeischaue, sende mir eine E-Mail-Zusammenfassung beliebter Themen und Antworten","every_30_minutes":"alle 30 Minuten","every_hour":"stündlich","daily":"täglich","weekly":"wöchentlich","every_month":"jeden Monat","every_six_months":"alle sechs Monate"},"email_level":{"title":"Mich per E-Mail benachrichtigen, wenn ich zitiert werde, wenn auf mich geantwortet wird, wenn ich per @ erwähnt werde oder wenn es neue Aktivitäten zu meinen beobachteten Kategorien, Schlagwörtern oder Themen gibt","always":"immer","only_when_away":"nur bei Abwesenheit","never":"nie"},"email_messages_level":"Mich per E-Mail benachrichtigen, wenn ich eine persönliche Nachricht erhalte","include_tl0_in_digests":"Inhalte neuer Benutzer in E-Mail-Zusammenfassung einschließen.","email_in_reply_to":"Einen Auszug aus dem beantworteten Beitrag in E-Mails einfügen.","other_settings":"Andere","categories_settings":"Kategorien","topics_settings":"Themen","new_topic_duration":{"label":"Themen als neu anzeigen, wenn","not_viewed":"ich diese noch nicht betrachtet habe","last_here":"seit meinem letzten Besuch erstellt","after_1_day":"innerhalb des letzten Tages erstellt","after_2_days":"in den letzten 2 Tagen erstellt","after_1_week":"in der letzten Woche erstellt","after_2_weeks":"in den letzten 2 Wochen erstellt"},"auto_track_topics":"Betrachtete Themen automatisch verfolgen","auto_track_options":{"never":"nie","immediately":"sofort","after_30_seconds":"nach 30 Sekunden","after_1_minute":"nach einer Minute","after_2_minutes":"nach 2 Minuten","after_3_minutes":"nach 3 Minuten","after_4_minutes":"nach 4 Minuten","after_5_minutes":"nach 5 Minuten","after_10_minutes":"nach 10 Minuten"},"notification_level_when_replying":{"label":"Beim Posten","watch_topic":"Thema beobachten","track_topic":"Thema verfolgen","do_nothing":"Nichts tun"},"topics_unread_when_closed":"Themen als ungelesen betrachten, wenn sie geschlossen sind","invited":{"title":"Einladungen","pending_tab":"Ausstehend","pending_tab_with_count":"Ausstehend (%{count})","expired_tab":"Abgelaufen","expired_tab_with_count":"Abgelaufen (%{count})","redeemed_tab":"Angenommen","redeemed_tab_with_count":"Angenommen (%{count})","invited_via":"Einladung","invited_via_link":"Link %{key} (%{count}/%{max} angenommen)","groups":"Gruppen","topic":"Thema","sent":"Erstellt/Zuletzt gesendet","expires_at":"Gültig bis","edit":"Bearbeiten","remove":"Entfernen","copy_link":"Link abrufen","reinvite":"E-Mail erneut senden","reinvited":"Einladung erneut gesendet","removed":"Entfernt","search":"zum Suchen nach Einladungen hier etwas eingeben …","user":"Eingeladener Benutzer","none":"Keine Einladungen anzuzeigen.","truncated":{"one":"Zeige die erste Einladung.","other":"Zeige die ersten %{count} Einladungen."},"redeemed":"Angenommene Einladungen","redeemed_at":"Angenommen","pending":"Ausstehende Einladungen","topics_entered":"Betrachtete Themen","posts_read_count":"Gelesene Beiträge","expired":"Diese Einladung ist abgelaufen.","remove_all":"Abgelaufene Einladungen entfernen","removed_all":"Alle abgelaufenen Einladungen entfernt!","remove_all_confirm":"Sollen alle abgelaufenen Einladungen entfernt werden?","reinvite_all":"Alle Einladungen erneut senden","reinvite_all_confirm":"Bist du sicher, dass du alle Einladungen erneut versenden möchtest?","reinvited_all":"Alle Einladungen gesendet!","time_read":"Lesezeit","days_visited":"Besuchstage","account_age_days":"Konto-Alter in Tagen","create":"Einladen","generate_link":"Einladungslink erstellen","link_generated":"Hier ist dein Einladungslink!","valid_for":"Der Einladungslink ist nur für die E-Mail-Adresse %{email} gültig","single_user":"Einladen per E-Mail","multiple_user":"Per Link einladen","invite_link":{"title":"Einladungslink","success":"Der Einladungslink wurde erfolgreich generiert!","error":"Beim Erstellen des Einladungslinks ist ein Fehler aufgetreten"},"cannot_invite_to_forum":"Du hast leider nicht die Erlaubnis, Einladungen zu erstellen. Bitte wende dich an einen Administrator, damit er dir das Recht zum Einladen erteilt.","invite":{"new_title":"Mitglieder einladen","edit_title":"Einladung bearbeiten","expires_in_time":"Läuft in %{time} ab","expired_at_time":"Abgelaufen um %{time}","create_link_to_invite":"Erstelle einen Link, der geteilt werden kann, um sofortigen Zugang zu dieser Website zu gewähren.","copy_link_and_share_it":"Kopiere den Link unten und teile ihn, um sofort Zugang zu dieser Website zu gewähren.","copy_link":"Link kopieren","link_copied":"Link kopiert!","share_link":"Link teilen","edit_link_options":"Link-Optionen bearbeiten oder per E-Mail versenden.","show_advanced":"Erweiterte Optionen anzeigen","hide_advanced":"Erweiterte Optionen ausblenden","restrict":"Beschränken auf","restrict_email":"Auf E-Mail beschränken","restrict_domain":"Auf Domain beschränken","email_or_domain_placeholder":"name@beispiel.de oder beispiel.de","max_redemptions_allowed":"Max. Verwendungen","add_to_groups":"Zu Gruppen hinzufügen","invite_to_topic":"Ankommen beim Thema","expires_at":"Läuft ab am","expires_after":"Verfällt nach","custom_message":"Benutzerdefinierte Nachricht","custom_message_placeholder":"Füge eine persönliche Notiz zu deiner Einladung hinzu","send_invite_email":"Speichern und E-Mail senden","send_invite_email_instructions":"Einladung auf E-Mail beschränken, um eine Einladungs-E-Mail zu senden","update_invite":"Aktualisieren","update_invite_and_send_email":"Aktualisieren und E-Mail senden","cancel":"Abbrechen","create_link":"Link erstellen","create_link_and_send_email":"Link erstellen und E-Mail senden","invite_saved_without_sending_email":"Einladung gespeichert. Kopiere den Link unten und teile ihn, um sofort Zugang zu dieser Website zu gewähren.","invite_saved_with_sending_email":"Die Einladungs-E-Mail wurde verschickt. Du kannst auch den Link unten kopieren und teilen, um sofort Zugang zu dieser Website zu gewähren."},"bulk_invite":{"none":"Keine Einladungen, die auf dieser Seite angezeigt werden können.","text":"Massen-Einladung","instructions":"\u003cp\u003eLade eine Liste von Benutzern ein, um deine Community schnell in Gang zu bringen. Bereite eine \u003ca href=\"https://de.wikipedia.org/wiki/CSV_(Dateiformat)\" target=\"_blank\"\u003eCSV-Datei\u003c/a\u003e mit mindestens einer Zeile pro E-Mail-Adresse vor, die du einladen möchtest. Die folgenden kommaseparierten Informationen können zur Verfügung gestellt werden, wenn du Personen zu Gruppen hinzufügen oder sie bei der ersten Anmeldung an ein bestimmtes Thema senden möchtest.\u003c/p\u003e\n\u003cpre\u003ejohn@smith.com,first_group_name;second_group_name,topic_id\u003c/pre\u003e\n\u003cp\u003eAn jede E-Mail-Adresse in deiner hochgeladenen CSV-Datei wird eine Einladung gesendet. Du kannst diese später verwalten.\u003c/p\u003e\n","progress":"%{progress} % hochgeladen …","success":"Die Datei wurde erfolgreich hochgeladen. Du erhältst eine Nachricht, sobald der Vorgang abgeschlossen ist.","error":"Die Datei sollte im CSV Format vorliegen."}},"confirm_access":{"title":"Zugriff bestätigen","incorrect_password":"Das eingegebene Passwort ist falsch.","incorrect_passkey":"Der Passkey ist falsch.","logged_in_as":"Du bist angemeldet als: ","forgot_password":"Passwort vergessen?","password_reset_email_sent":"E-Mail zum Zurücksetzen des Passworts gesendet.","cannot_send_password_reset_email":"E-Mail zum Zurücksetzen des Passworts konnte nicht gesendet werden.","instructions":"Bitte bestätige deine Identität, um diese Aktion abzuschließen.","fine_print":"Wir bitten dich, deine Identität zu bestätigen, da dies eine potenziell sensible Aktion ist. Wenn du dich einmal authentifiziert hast, wirst du erst nach ein paar Stunden Inaktivität wieder aufgefordert, dich erneut zu authentifizieren."},"password":{"title":"Passwort","too_short":{"one":"Dein Passwort ist zu kurz (Minimum: %{count} Zeichen).","other":"Dein Passwort ist zu kurz (Minimum: %{count} Zeichen)."},"common":"Das Passwort wird zu häufig verwendet.","same_as_username":"Dein Passwort entspricht deinem Benutzernamen.","same_as_name":"Dein Passwort entspricht deinem Namen.","same_as_email":"Dein Passwort entspricht deiner E-Mail-Adresse.","ok":"Dein Passwort sieht in Ordnung aus.","instructions":{"one":"Mindestens %{count} Zeichen","other":"Mindestens %{count} Zeichen"},"required":"Bitte Passwort eingeben","confirm":"Bestätigen","incorrect_password":"Das eingegebene Passwort ist falsch."},"summary":{"title":"Zusammenfassung","stats":"Statistiken","time_read":"Lesezeit","time_read_title":"%{duration} (die ganze Zeit)","recent_time_read":"aktuelle Lesezeit","recent_time_read_title":"%{duration} (in den letzten 60 Tagen)","topic_count":{"one":"Thema erstellt","other":"Themen erstellt"},"post_count":{"one":"Beitrag erstellt","other":"Beiträge erstellt"},"likes_given":{"one":"gegeben","other":"gegeben"},"likes_received":{"one":"erhalten","other":"erhalten"},"days_visited":{"one":"Besuchstag","other":"Besuchstage"},"topics_entered":{"one":"betrachtetes Thema","other":"betrachtete Themen"},"posts_read":{"one":"Beitrag gelesen","other":"Beiträge gelesen"},"bookmark_count":{"one":"Lesezeichen","other":"Lesezeichen"},"top_replies":"Die besten Beiträge","no_replies":"Noch keine Antworten.","more_replies":"Weitere Antworten","top_topics":"Angesagte Themen","no_topics":"Noch keine Themen.","more_topics":"Weitere Themen","top_badges":"Die besten Abzeichen","no_badges":"Noch keine Abzeichen.","more_badges":"Weitere Abzeichen","top_links":"Die besten Links","no_links":"Noch keine Links.","most_liked_by":"Häufigste „Gefällt mir“ von","most_liked_users":"Häufigste „Gefällt mir“ für","most_replied_to_users":"Häufigste Antworten an","no_likes":"Noch keine „Gefällt mir“.","top_categories":"Top-Kategorien","topics":"Themen","replies":"Antworten"},"ip_address":{"title":"Letzte IP-Adresse"},"registration_ip_address":{"title":"IP-Adresse bei Registrierung"},"avatar":{"title":"Profilbild","header_title":"Profil, Nachrichten, Lesezeichen und Einstellungen","name_and_description":"%{name} – %{description}","edit":"Profilbild bearbeiten"},"title":{"title":"Titel","none":"(keiner)","instructions":"erscheint nach deinem Benutzernamen"},"flair":{"title":"Flair","none":"(keiner)","instructions":"neben deinem Profilbild angezeigtes Symbol"},"status":{"title":"Benutzerdefinierter Status","not_set":"Nicht festgelegt"},"primary_group":{"title":"Primäre Gruppe","none":"(keine)"},"filters":{"all":"Alle"},"stream":{"posted_by":"Verfasst von","sent_by":"Gesendet von","private_message":"Senden","the_topic":"das Thema"},"card":"Benutzerkarte","profile_link":"%{username}, Profil besuchen"},"user_status":{"save":"Speichern","set_custom_status":"Benutzerdefinierten Status festlegen","what_are_you_doing":"Was machst du gerade?","pause_notifications":"Benachrichtigungen pausieren","remove_status":"Status entfernen"},"presence_toggle":{"online":"Online","offline":"Offline","title":"Präsenzfunktionen umschalten"},"user_tips":{"button":"Verstanden!","skip":"Tipps überspringen","first_notification":{"title":"Deine erste Benachrichtigung!","content":"Benachrichtigungen dienen dazu, dich auf dem Laufenden zu halten, was in der Community passiert."},"topic_timeline":{"title":"Themenzeitleiste","content":"Mit der Themenzeitleiste kannst du schnell durch lange Themen scrollen."},"post_menu":{"title":"Menü „Beitrag“","content":"Schau dir an, wie du sonst noch mit dem Beitrag interagieren kannst, indem du auf die drei Punkte klickst!"},"topic_notification_levels":{"title":"Du folgst nun diesem Thema","content":"Halte nach dieser Glocke Ausschau, um deine Benachrichtigungseinstellungen für bestimmte Themen oder ganze Kategorien anzupassen."},"suggested_topics":{"title":"Lies weiter!","content":"Hier sind einige Themen, von denen wir denken, dass du sie als Nächstes lesen möchtest."}},"loading":"Wird geladen …","errors":{"prev_page":"während des Ladens","reasons":{"network":"Netzwerkfehler","server":"Server-Fehler","forbidden":"Zugriff verweigert","unknown":"Fehler","not_found":"Seite nicht gefunden"},"desc":{"network":"Bitte überprüfe deine Netzwerkverbindung.","network_fixed":"Sieht aus, als wäre sie wieder da.","server":"Fehlercode: %{status}","forbidden":"Du darfst das nicht ansehen.","not_found":"Hoppla! Die Anwendung hat versucht, eine URL zu laden, die nicht existiert.","unknown":"Etwas ist schiefgelaufen."},"buttons":{"back":"Zurück","again":"Erneut versuchen","fixed":"Seite laden"}},"modal":{"close":"schließen","dismiss_error":"Fehler ignorieren"},"form_kit":{"reset":"Zurücksetzen","optional":"optional","errors_summary_title":"Dieses Formular enthält Fehler:","dirty_form":"Du hast deine Änderungen nicht gespeichert! Bist du sicher, dass du die Seite verlassen möchtest?","errors":{"required":"Erforderlich","invalid_url":"Muss eine gültige URL sein","not_an_integer":"Muss eine ganze Zahl sein","not_accepted":"Muss akzeptiert werden","not_a_number":"Muss eine Zahl sein","too_high":"Darf höchstens %{count} sein","too_low":"Muss mindestens %{count} sein","too_long":{"one":"Darf maximal %{count} Zeichen lang sein","other":"Darf maximal %{count} Zeichen lang sein"},"too_short":{"one":"Muss mindestens %{count} Zeichen lang sein","other":"Muss mindestens %{count} Zeichen lang sein"}}},"close":"Schließen","assets_changed_confirm":"Diese Website hat gerade ein Software-Update erhalten. Jetzt die neueste Version abrufen?","logout":"Du wurdest abgemeldet.","refresh":"Aktualisieren","home":"Startseite","read_only_mode":{"enabled":"Diese Website befindet sich im Nur-Lesen-Modus. Du kannst weiterhin Inhalte lesen, aber das Erstellen von Beiträgen, Vergeben von „Gefällt mir“ und Durchführen einiger weiterer Aktionen ist derzeit nicht möglich.","login_disabled":"Die Anmeldung ist deaktiviert, während sich die Website im Nur-Lesen-Modus befindet.","logout_disabled":"Die Abmeldung ist deaktiviert, während sich die Website im Nur-Lesen-Modus befindet."},"staff_writes_only_mode":{"enabled":"Diese Website befindet sich im Nur-Team-Modus. Du kannst weiterhin Inhalte lesen, aber das Antworten, Vergeben von „Gefällt mir“ und Durchführen einiger weiterer Aktionen ist derzeit nur für Team-Mitglieder möglich."},"logs_error_rate_notice":{},"learn_more":"Mehr erfahren …","learn_more_with_link":"\u003ca href='%{url}' target='_blank'\u003eMehr erfahren …\u003c/a\u003e","mute":"Stummschalten","unmute":"Stummschaltung aufheben","last_post":"Geschrieben","local_time":"Ortszeit","time_read":"Gelesen","time_read_recently":"%{time_read} aktuell","time_read_tooltip":"%{time_read} Lesezeit insgesamt","time_read_recently_tooltip":"%{time_read} Lesezeit insgesamt (%{recent_time_read} in den letzten 60 Tagen)","last_reply_lowercase":"letzte Antw.","replies_lowercase":{"one":"Antwort","other":"Antworten"},"signup_cta":{"sign_up":"Registrieren","hide_session":"Vielleicht später","hide_forever":"Nein danke","hidden_for_session":"In Ordnung, wir fragen dich morgen wieder. Du kannst dir auch jederzeit unter „Anmelden“ ein Benutzerkonto erstellen.","intro":"Hallo! Es sieht so aus, als ob dir diese Diskussion gefällt, aber du hast bislang noch kein Konto angelegt.","value_prop":"Hast du es satt, dich durch die gleichen Beiträge zu scrollen? Wenn du ein Konto erstellst, kommst du immer wieder dorthin zurück, wo du aufgehört hast. Mit einem Konto kannst du auch über neue Antworten benachrichtigt werden, Lesezeichen speichern und anderen mit „Gefällt mir“ danken. Wir können alle zusammenarbeiten, um diese Community zu etwas Großartigem zu machen. :heart:"},"offline_indicator":{"no_internet":"Keine Internetverbindung.","refresh_page":"Seite aktualisieren"},"summary":{"in_progress":"Thema mithilfe von KI zusammenfassen","summarized_on":"Zusammengefasst mit KI am %{date}","model_used":"KI verwendet: %{model}","outdated":"Zusammenfassung ist veraltet","outdated_posts":{"one":"(%{count} Beitrag fehlt)","other":"(%{count} Beiträge fehlen)"},"enabled_description":"Du siehst dir die Top-Antworten zu diesem Thema an: die interessantesten Beiträge, wie von der Community ermittelt","description":{"one":"Es gibt \u003cb\u003e%{count}\u003c/b\u003e Antwort.","other":"Es gibt \u003cb\u003e%{count}\u003c/b\u003e Antworten."},"buttons":{"hide":"Zusammenfassung ausblenden","generate":"Zusammenfassen","regenerate":"Erneut generieren"},"enable":"Top-Antworten anzeigen","disable":"Alle Beiträge anzeigen","short_label":"Top-Antworten","show_all_label":"Alle anzeigen","short_title":"Top-Antworten zu diesem Thema anzeigen: die interessantesten Beiträge, wie von der Community ermittelt"},"deleted_filter":{"enabled_description":"Dieses Thema enthält gelöschte Beiträge, die derzeit versteckt sind.","disabled_description":"Gelöschte Beiträge werden in diesem Thema angezeigt.","enable":"Gelöschte Beiträge ausblenden","disable":"Gelöschte Beiträge anzeigen"},"private_message_info":{"title":"Nachricht","invite":"Lade andere ein …","edit":"Hinzufügen oder entfernen …","remove":"Entfernen …","add":"Hinzufügen ...","leave_message":"Möchtest du diese Unterhaltung wirklich verlassen?","remove_allowed_user":"Willst du %{name} wirklich aus dieser Nachricht entfernen?","remove_allowed_group":"Willst du %{name} wirklich aus dieser Nachricht entfernen?","leave":"Verlassen","remove_group":"Gruppe entfernen","remove_user":"Benutzer entfernen"},"email":"E-Mail-Adresse","username":"Benutzername","last_seen":"Zuletzt gesehen","created":"Erstellt","created_lowercase":"erstellt","trust_level":"Vertrauensstufe","search_hint":"Benutzername, E-Mail- oder IP-Adresse","create_account":{"header_title":"Willkommen!","disclaimer":"Mit der Registrierung stimmst du der \u003ca href='%{privacy_link}' target='blank'\u003eDatenschutzerklärung\u003c/a\u003e und den \u003ca href='%{tos_link}' target='blank'\u003eNutzungsbedingungen\u003c/a\u003e zu.","title":"Registrieren","failed":"Etwas ist schiefgelaufen. Vielleicht ist diese E-Mail-Adresse bereits registriert. Versuche es mit dem „Passwort vergessen“-Link.","associate":"Hast du bereits ein Konto? \u003ca href='%{associate_link}'\u003eLogge dich ein\u003c/a\u003e, um dein %{provider}-Konto zu verknüpfen.","activation_title":"Aktiviere dein Konto","already_have_account":"Du hast bereits ein Konto?","no_account_yet":"Du hast noch kein Konto?","progress_bar":{"signup":"Registrieren","activate":"Aktivieren","approve":"Genehmigen","login":"Anmelden"}},"forgot_password":{"title":"Passwort zurücksetzen","action":"Ich habe mein Passwort vergessen","invite":"Gib deinen Benutzernamen oder deine E-Mail-Adresse ein. Wir senden dir eine E-Mail zum Zurücksetzen des Passworts.","invite_no_username":"Gib deine E-Mail-Adresse ein. Dann senden wir dir eine E-Mail zum Zurücksetzen des Passworts.","email-username":"E-Mail oder Benutzername","reset":"Passwort zurücksetzen","complete_username":"Wenn ein Benutzerkonto dem Benutzernamen \u003cb\u003e%{username}\u003c/b\u003e entspricht, solltest du in Kürze eine E-Mail mit Anweisungen zum Zurücksetzen deines Passwortes erhalten.","complete_email":"Wenn ein Benutzerkonto der E-Mail-Adresse \u003cb\u003e%{email}\u003c/b\u003e entspricht, solltest du in Kürze eine E-Mail mit Anweisungen zum Zurücksetzen deines Passwortes erhalten.","complete_username_found":"Wir haben ein zum Benutzernamen \u003cb\u003e%{username}\u003c/b\u003e gehörendes Konto gefunden. Du solltest in Kürze eine E-Mail mit Anweisungen zum Zurücksetzen deines Passwortes erhalten.","complete_email_found":"Wir haben ein zu \u003cb\u003e%{email}\u003c/b\u003e gehörendes Benutzerkonto gefunden. Du solltest in Kürze eine E-Mail mit Anweisungen zum Zurücksetzen deines Passwortes erhalten.","complete_username_not_found":"Es existiert kein Benutzerkonto mit dem Benutzernamen \u003cb\u003e%{username}\u003c/b\u003e.","complete_email_not_found":"Es existiert kein Benutzerkonto für \u003cb\u003e%{email}\u003c/b\u003e.","help":"E-Mail nicht angekommen? Bitte prüfe zuerst deinen Spam-Ordner. \u003cp\u003eNicht sicher, welche E-Mail-Adresse du verwendet hast? Gib eine E-Mail-Adresse ein und wir werden dir sagen, ob sie hier existiert.\u003c/p\u003e\u003cp\u003eFalls du keinen Zugriff mehr auf die hinterlegte E-Mail-Adresse deines Kontos hast, kontaktiere bitte \u003ca href='%{basePath}/about'\u003eunser hilfsbereites Team. \u003c/a\u003e\u003c/p\u003e","button_ok":"OK","button_help":"Hilfe"},"email_login":{"link_label":"Sende mir einen Anmeldelink","button_label":"über E-Mail","login_link":"Überspringe das Passwort; sende mir einen Anmeldelink","complete_username":"Sofern ein Benutzerkonto mit dem Benutzernamen \u003cb\u003e%{username}\u003c/b\u003e existiert, solltest du in Kürze eine E-Mail mit einem Anmeldelink erhalten.","complete_email":"Sofern ein Benutzerkonto für \u003cb\u003e%{email}\u003c/b\u003e existiert, solltest du in Kürze eine E-Mail mit einem Anmeldelink erhalten.","complete_username_found":"Wir haben ein Benutzerkonto mit dem Benutzernamen \u003cb\u003e%{username}\u003c/b\u003e gefunden, du solltest in Kürze einen Anmeldelink erhalten.","complete_email_found":"Wir haben ein Benutzerkonto für \u003cb\u003e%{email}\u003c/b\u003e erhalten, du solltest in Kürze einen Anmeldelink erhalten.","complete_username_not_found":"Es existiert kein Benutzerkonto mit dem Benutzernamen \u003cb\u003e%{username}\u003c/b\u003e.","complete_email_not_found":"Es existiert kein Benutzerkonto für \u003cb\u003e%{email}\u003c/b\u003e.","confirm_title":"Weiter zu %{site_name}","logging_in_as":"Anmeldung als %{email}","confirm_button":"Anmeldung fertigstellen"},"login":{"header_title":"Willkommen zurück","title":"Anmelden","username":"Benutzername","password":"Passwort","show_password":"Anzeigen","hide_password":"Ausblenden","show_password_title":"Passwort anzeigen","hide_password_title":"Passwort ausblenden","second_factor_title":"Zwei-Faktor-Authentifizierung","second_factor_description":"Bitte gib den Authentifizierungscode aus deiner App ein:","second_factor_backup":"Anmeldung mit einem Wiederherstellungscode","second_factor_backup_title":"Zwei-Faktor-Backup","second_factor_backup_description":"Bitte gib einen deiner Wiederherstellungscodes ein:","second_factor":"Anmeldung mit einer Authentifizierungs-App","security_key_description":"Wenn du deinen physischen Sicherheitsschlüssel oder dein kompatibles Mobilgerät vorbereitet hast, klicke unten auf die Schaltfläche „Mit Sicherheitsschlüssel authentifizieren“.","security_key_alternative":"Versuche es anderweitig","security_key_authenticate":"Mit Sicherheitsschlüssel authentifizieren","security_key_not_allowed_error":"Der Authentifizierungsprozess für den Sicherheitsschlüssel ist abgelaufen oder wurde abgebrochen.","security_key_no_matching_credential_error":"Im angegebenen Sicherheitsschlüssel wurden keine übereinstimmenden Anmeldedaten gefunden.","security_key_support_missing_error":"Dein aktuelles Gerät oder Browser unterstützt die Verwendung von Sicherheitsschlüsseln nicht. Bitte verwende eine andere Methode.","security_key_invalid_response_error":"Der Authentifizierungsprozess des Sicherheitsschlüssels ist aufgrund einer ungültigen Antwort fehlgeschlagen.","passkey_security_error":"Es gab einen Sicherheitsfehler: %{message}","email_placeholder":"E-Mail/Benutzername","caps_lock_warning":"Feststelltaste ist aktiviert","error":"Unbekannter Fehler","cookies_error":"Dein Browser scheint Cookies deaktiviert zu haben. Du kannst dich möglicherweise nicht anmelden, ohne diese zuerst zu aktivieren.","rate_limit":"Warte bitte ein wenig, bevor du erneut versuchst, dich anzumelden.","password_expired":"Passwort abgelaufen. Bitte \u003ca href='%{reset_url}'\u003esetze dein Passwort zurück\u003c/a\u003e.","blank_username":"Bitte gib deine E-Mail-Adresse oder deinen Benutzernamen ein.","blank_username_or_password":"Bitte gib deine E-Mail-Adresse oder deinen Benutzernamen und dein Passwort ein.","reset_password":"Passwort zurücksetzen","logging_in":"Anmeldung läuft …","previous_sign_up":"Du hast bereits ein Konto?","or":"Oder","authenticating":"Authentifizierung läuft …","awaiting_activation":"Dein Konto ist noch nicht aktiviert. Verwende den „Passwort vergessen“-Link, um eine weitere E-Mail mit Anweisungen zur Aktivierung zu erhalten.","awaiting_approval":"Dein Konto wurde noch nicht von einem Team-Mitglied genehmigt. Du bekommst eine E-Mail, sobald das geschehen ist.","requires_invite":"Entschuldige, der Zugriff auf dieses Forum ist nur mit einer Einladung möglich.","not_activated":"Du kannst dich noch nicht anmelden. Wir haben dir schon eine E-Mail zur Aktivierung an \u003cb\u003e%{sentTo}\u003c/b\u003e geschickt. Bitte folge den Anweisungen in dieser E-Mail, um dein Benutzerkonto zu aktivieren.","not_allowed_from_ip_address":"Von dieser IP-Adresse aus darfst du dich nicht anmelden.","admin_not_allowed_from_ip_address":"Von dieser IP-Adresse aus darfst du dich nicht als Administrator anmelden.","resend_activation_email":"Klicke hier, um eine neue Aktivierungsmail zu schicken.","omniauth_disallow_totp":"Für dein Benutzerkonto ist die Zwei-Faktor-Authentifizierung aktiviert. Bitte melde dich mit deinem Passwort an.","activate_account":"Konto aktivieren","resend_title":"Aktivierungs-E-Mail erneut senden","change_email":"E-Mail-Adresse ändern","provide_new_email":"Gib eine neue Adresse an und wir senden deine Bestätigungsmail erneut.","submit_new_email":"E-Mail-Adresse aktualisieren","sent_activation_email_again":"Wir haben dir eine weitere E-Mail zur Aktivierung an \u003cb\u003e%{currentEmail}\u003c/b\u003e geschickt. Es könnte ein paar Minuten dauern, bis diese ankommt; sieh auch im Spam-Ordner nach.","sent_activation_email_again_generic":"Wir haben eine weitere Aktivierungsmail verschickt. Es könnte ein paar Minuten dauern, bis diese ankommt; schaue auch im Spam-Ordner nach.","to_continue":"Melde dich bitte an","preferences":"Du musst angemeldet sein, um deine Benutzereinstellungen bearbeiten zu können.","not_approved":"Dein Benutzerkonto wurde noch nicht genehmigt. Du wirst per E-Mail benachrichtigt, sobald du dich anmelden kannst.","google_oauth2":{"name":"Google","title":"Mit Google anmelden","sr_title":"Mit Google anmelden"},"twitter":{"name":"Twitter","title":"Mit Twitter anmelden","sr_title":"Mit Twitter anmelden"},"instagram":{"name":"Instagram","title":"Mit Instagram anmelden","sr_title":"Mit Instagram anmelden"},"facebook":{"name":"Facebook","title":"Mit Facebook anmelden","sr_title":"Mit Facebook anmelden"},"github":{"name":"GitHub","title":"Mit GitHub anmelden","sr_title":"Mit GitHub anmelden"},"discord":{"name":"Discord","title":"Mit Discord anmelden","sr_title":"Mit Discord anmelden"},"linkedin_oidc":{"name":"LinkedIn","title":"Mit LinkedIn anmelden","sr_title":"Mit LinkedIn anmelden"},"passkey":{"name":"Mit einem Passkey anmelden"},"second_factor_toggle":{"totp":"Benutze stattdessen eine Authentifizierungs-App","backup_code":"Benutze stattdessen einen Wiederherstellungscode","security_key":"Stattdessen einen Sicherheitsschlüssel verwenden"},"no_login_methods":{"title":"Keine Anmeldemethoden","description":"Es sind keine Anmeldemethoden konfiguriert. Administratoren können \u003ca href='%{adminLoginPath}' target='_blank'\u003e%{adminLoginPath}\u003c/a\u003e besuchen, um die Website neu zu konfigurieren."},"oidc":{"name":"OpenID Connect","title":"mit OpenID Connect","message":"Authentifizierung mit OpenID Connect"}},"invites":{"accept_title":"Einladung","welcome_to":"Willkommen bei %{site_name}!","invited_by":"Du wurdest eingeladen von:","social_login_available":"Du wirst dich auch über andere soziale Netzwerke mit dieser E-Mail-Adresse anmelden können.","your_email":"Die E-Mail-Adresse deines Benutzerkontos ist \u003cb\u003e%{email}\u003c/b\u003e.","accept_invite":"Einladung annehmen","success":"Dein Konto wurde erstellt und du bist jetzt angemeldet.","name_label":"Name","password_label":"Passwort"},"password_reset":{"continue":"Weiter zu %{site_name}"},"emoji_set":{"apple_international":"Apple/International","google":"Google","twitter":"Twitter","win10":"Windows 10","google_classic":"Google Classic","facebook_messenger":"Facebook Messenger"},"category_page_style":{"categories_only":"Nur Kategorien","categories_with_featured_topics":"Kategorien mit hervorgehobenen Themen","categories_and_latest_topics":"Kategorien und aktuelle Themen","categories_and_latest_topics_created_date":"Kategorien und neueste Themen (sortiert nach Datum der Themenerstellung)","categories_and_top_topics":"Kategorien und angesagte Themen","categories_boxes":"Boxen mit Unterkategorien","categories_boxes_with_topics":"Spalten mit hervorgehobenen Themen","subcategories_with_featured_topics":"Unterkategorien mit hervorgehobenen Themen"},"full_name_requirement":{"required_at_signup":"Erforderlich","optional_at_signup":"Optional","hidden_at_signup":"Optional, bei der Anmeldung ausgeblendet"},"shortcut_modifier_key":{"shift":"Umschalt","ctrl":"Strg","alt":"Alt","enter":"Enter"},"conditional_loading_section":{"loading":"Wird geladen …"},"category_row":{"subcategory_count":{"one":"+%{count} Unterkategorie","other":"+%{count} Unterkategorien"},"topic_count":{"one":"%{count} Thema in dieser Kategorie","other":"%{count} Themen in dieser Kategorie"}},"select_kit":{"delete_item":"%{name} löschen","filter_by":"Filtern nach: %{name}","select_to_filter":"Wähle einen zu filternden Wert aus","default_header_text":"Auswählen …","no_content":"Keine Treffer gefunden","results_count":{"one":"%{count} Ergebnis","other":"%{count} Ergebnisse"},"filter_placeholder":"Suchen …","filter_placeholder_with_any":"Suchen oder erstellen …","create":"Erstelle: „%{content}“","max_content_reached":{"one":"Du kannst nur %{count} Eintrag auswählen.","other":"Du kannst nur %{count} Einträge auswählen."},"min_content_not_reached":{"one":"Wähle mindestens %{count} Eintrag aus.","other":"Wähle mindestens %{count} Einträge aus."},"components":{"filter_for_more":"Filtern nach mehr …","categories_admin_dropdown":{"title":"Kategorien verwalten"},"bulk_select_topics_dropdown":{"title":"Massenoperationen"},"bulk_select_bookmarks_dropdown":{"title":"Massenoperationen"}}},"date_time_picker":{"from":"Von","to":"An"},"file_size_input":{"error":{"size_too_large":"%{provided_file_size} ist größer als das zulässige Maximum %{max_file_size}","size_too_small":"%{provided_file_size} ist kleiner als erlaubtes Minimum von %{min_file_size}"}},"emoji_picker":{"filter_placeholder":"Emoji suchen","smileys_\u0026_emotion":"Smileys und Emotion","people_\u0026_body":"Menschen und Körper","animals_\u0026_nature":"Tiere und Natur","food_\u0026_drink":"Essen und Getränke","travel_\u0026_places":"Reisen und Orte","activities":"Tätigkeiten","objects":"Objekte","symbols":"Symbole","flags":"Flaggen","recent":"Zuletzt verwendet","default_tone":"Keine Hautfarbe","light_tone":"Helle Hautfarbe","medium_light_tone":"Mittel-helle Hautfarbe","medium_tone":"Mittlere Hautfarbe","medium_dark_tone":"Mittel-dunkle Hautfarbe","dark_tone":"Dunkle Hautfarbe","default":"Benutzerdefinierte Emojis"},"shared_drafts":{"title":"Gemeinsame Entwürfe","notice":"Dieses Thema ist nur für diejenigen sichtbar, die gemeinsame Entwürfe veröffentlichen können.","destination_category":"Ziel-Kategorie","publish":"Gemeinsamen Entwurf veröffentlichen","confirm_publish":"Bist du sicher, dass du diese Vorlage veröffentlichten möchtest?","publishing":"Thema wird veröffentlicht …"},"composer":{"emoji":"Emoji :)","more_emoji":"mehr …","options":"Optionen","whisper":"flüstern","unlist":"unsichtbar","add_warning":"Dies ist eine offizielle Warnung.","toggle_whisper":"Flüstermodus umschalten","toggle_unlisted":"Sichtbarkeit umschalten","insert_table":"Tabelle einfügen","posting_not_on_topic":"Auf welches Thema möchtest du antworten?","saved_local_draft_tip":"lokal gespeichert","similar_topics":"Dein Thema hat Ähnlichkeit mit …","drafts_offline":"Entwürfe offline","edit_conflict":"Konflikt bearbeiten","esc":"esc","esc_label":"Nachricht verwerfen","ok_proceed":"Ok, weiter","group_mentioned_limit":{"one":"\u003cb\u003eWarnung!\u003c/b\u003e Du erwähnst \u003ca href='%{group_link}'\u003e%{group}\u003c/a\u003e, jedoch übersteigt die Mitgliederzahl der Gruppe das vom Administrator konfigurierte Erwähnungslimit von %{count} Benutzer. Deshalb wird niemand benachrichtigt.","other":"\u003cb\u003eWarnung!\u003c/b\u003e Du erwähnst \u003ca href='%{group_link}'\u003e%{group}\u003c/a\u003e, jedoch übersteigt die Mitgliederzahl der Gruppe das vom Administrator konfigurierte Erwähnungslimit von %{count} Benutzern. Deshalb wird niemand benachrichtigt."},"group_mentioned":{"one":"Wenn du %{group} erwähnst, wird \u003ca href='%{group_link}'\u003e%{count} Person\u003c/a\u003e benachrichtigt.","other":"Wenn du %{group} erwähnst, werden \u003ca href='%{group_link}'\u003e%{count} Personen\u003c/a\u003e benachrichtigt."},"larger_group_mentioned":{"one":"Wenn du %{group} erwähnst, wird \u003ca href='%{group_link}'\u003e%{count} Person\u003c/a\u003e benachrichtigt. Bist du sicher?","other":"Wenn du %{group} erwähnst, werden \u003ca href='%{group_link}'\u003e%{count} Personen\u003c/a\u003e benachrichtigt. Bist du sicher?"},"cannot_see_mention":{"category":"Du hast @%{username} erwähnt, aber diese Person wird nicht benachrichtigt, da sie keinen Zugriff auf diese Kategorie hat. Füge sie einer Gruppe hinzu, die Zugriff auf diese Kategorie hat.","private":"Du hast @%{username} erwähnt, aber diese Person wird nicht benachrichtigt, da sie diese persönliche Nachricht nicht sehen kann. Lade sie zu dieser persönlichen Nachricht ein.","muted_topic":"Du hast @%{username} erwähnt, aber diese Person wird nicht benachrichtigt, weil sie dieses Thema stummgeschaltet hat.","not_allowed":"Du hast @%{username} erwähnt, aber diese Person wird nicht benachrichtigt, weil sie nicht zu diesem Thema eingeladen wurde."},"cannot_see_group_mention":{"not_mentionable":"Du kannst die Gruppe @%{group} nicht erwähnen.","some_not_allowed":{"one":"Du hast @%{group} erwähnt, aber nur %{count} Mitglied wird benachrichtigt, weil die anderen Mitglieder diese persönliche Nachricht nicht sehen können. Du musst sie zu dieser persönlichen Nachricht einladen.","other":"Du hast @%{group} erwähnt, aber nur %{count} Mitglieder werden benachrichtigt, weil die anderen Mitglieder diese persönliche Nachricht nicht sehen können. Du musst sie zu dieser persönlichen Nachricht einladen."},"not_allowed":"Du hast @%{group} erwähnt, aber keines der Mitglieder wird benachrichtigt, weil sie diese persönliche Nachricht nicht sehen können. Du musst sie zu dieser persönlichen Nachricht einladen."},"here_mention":{"one":"Indem du \u003cb\u003e@%{here}\u003c/b\u003e erwähnst, bist du im Begriff, %{count} Benutzer zu benachrichtigen – bist du sicher?","other":"Indem du \u003cb\u003e@%{here}\u003c/b\u003e erwähnst, bist du im Begriff, %{count} Benutzer zu benachrichtigen – bist du sicher?"},"duplicate_link":"Es sieht so aus, als ob dein Link zu \u003cb\u003e%{domain}\u003c/b\u003e bereits im Thema von \u003cb\u003e@%{username}\u003c/b\u003e in \u003ca href='%{post_url}'\u003eeiner Antwort vor %{ago}\u003c/a\u003e geteilt wurde – bist du sicher, dass du ihn noch einmal teilen möchtest?","duplicate_link_same_user":"Es sieht so aus, als hättest du bereits einen Link zu \u003cb\u003e%{domain}\u003c/b\u003e in diesem Thema in \u003ca href='%{post_url}'\u003eeiner Antwort am %{ago}\u003c/a\u003e gepostet – bist du sicher, dass du ihn erneut posten willst?","reference_topic_title":"AW: %{title}","error":{"title_missing":"Titel ist erforderlich","title_too_short":{"one":"Titel muss mindestens %{count} Zeichen lang sein","other":"Titel muss mindestens %{count} Zeichen lang sein"},"title_too_long":{"one":"Titel darf maximal %{count} Zeichen lang sein","other":"Titel darf maximal %{count} Zeichen lang sein"},"post_missing":"Beitrag darf nicht leer sein","post_length":{"one":"Beitrag muss mindestens %{count} Zeichen lang sein","other":"Beitrag muss mindestens %{count} Zeichen lang sein"},"try_like":"Hast du schon die %{heart}-Schaltfläche ausprobiert?","category_missing":"Du musst eine Kategorie auswählen","tags_missing":{"one":"Du musst mindestens %{count} Schlagwort wählen.","other":"Du musst mindestens %{count} Schlagwörter wählen."},"topic_template_not_modified":"Bitte füge Details und Spezifikationen zu deinem Thema hinzu, indem du die Themenvorlage anpasst."},"save_edit":"Bearbeitung speichern","overwrite_edit":"Bearbeitung überschreiben","reply":"Antworten","cancel":"Abbrechen","create_topic":"Thema erstellen","create_pm":"Nachricht senden","create_whisper":"Flüstern","create_shared_draft":"Gemeinsamen Entwurf erstellen","edit_shared_draft":"Gemeinsamen Entwurf bearbeiten","title":"Oder drücke %{modifier}Eingabetaste","users_placeholder":"Benutzer oder Gruppen hinzufügen","title_placeholder":"Um was geht es in dieser Diskussion? Schreib einen kurzen Satz.","title_or_link_placeholder":"Gib einen Titel ein oder füge einen Link ein","edit_reason_placeholder":"Welchen Grund gibt es für die Bearbeitung?","topic_featured_link_placeholder":"Link zum Titel eingeben.","remove_featured_link":"Link aus Thema entfernen.","reply_placeholder":"Schreib hier. Verwende Markdown, BBCode oder HTML zur Formatierung. Füge Bilder ein oder ziehe sie herein.","reply_placeholder_no_images":"Schreib hier. Verwende Markdown, BBCode oder HTML zur Formatierung.","reply_placeholder_choose_category":"Wähle vor der Eingabe eine Kategorie aus.","view_new_post":"Schau dir deinen neuen Beitrag an.","saving":"Wird gespeichert","saved":"Gespeichert!","saved_draft":"Beitrags-Entwurf vorhanden. Tippen, um fortzusetzen.","uploading":"Wird hochgeladen …","show_preview":"Vorschau zeigen","hide_preview":"Vorschau ausblenden","quote_post_title":"Ganzen Beitrag zitieren","bold_label":"F","bold_title":"Fett gedruckt","bold_text":"fett gedruckter Text","italic_label":"K","italic_title":"Betonung","italic_text":"betonter Text","link_title":"Link","link_description":"gib hier eine Link-Beschreibung ein","link_dialog_title":"Link einfügen","link_optional_text":"optionaler Titel","link_url_placeholder":"Füge eine URL ein oder tippe, um die Themen zu durchsuchen","blockquote_title":"Blockzitat","blockquote_text":"Blockzitat","code_title":"Vorformatierter Text","code_text":"vorformatierten Text mit 4 Leerzeichen einrücken","paste_code_text":"tippe oder füge den Code hier ein","upload_title":"Hochladen","upload_description":"gib hier eine Beschreibung des Uploads ein","olist_title":"Nummerierte Liste","ulist_title":"Liste mit Aufzählungszeichen","list_item":"Listenelement","toggle_direction":"Schreibrichtung wechseln","help":"Hilfe zur Markdown-Formatierung","collapse":"Editor minimieren","open":"Editor öffnen","abandon":"Editor schließen und Entwurf verwerfen","enter_fullscreen":"Vollbild-Editor öffnen","exit_fullscreen":"Vollbild-Editor verlassen","exit_fullscreen_prompt":"Drücke \u003ckbd\u003eESC\u003c/kbd\u003e, um den Vollbildmodus zu verlassen","show_toolbar":"Editor-Werkzeugleiste anzeigen","hide_toolbar":"Editor-Werkzeugleiste ausblenden","modal_ok":"OK","cant_send_pm":"Entschuldige, aber du kannst keine Nachricht an %{username} senden.","create_message_error":"Entschuldige, es gab einen Fehler beim Erstellen der Nachricht. Bitte versuche es noch einmal.","yourself_confirm":{"title":"Hast du vergessen, Empfänger hinzuzufügen?","body":"Im Augenblick wird diese Nachricht nur an dich selbst gesendet!"},"slow_mode":{"error":"Dieses Thema befindet sich im langsamen Modus. Du hast bereits kürzlich gepostet. Du kannst erneut in %{timeLeft} posten."},"user_not_seen_in_a_while":{"single":"Die Person, der du eine Nachricht sendest (\u003cb\u003e%{usernames}\u003c/b\u003e) wurde hier schon lange nicht mehr gesehen – %{time_ago}. Es kann sein, dass sie deine Nachricht nicht erhält. Du solltest nach alternativen Methoden suchen, um %{usernames} zu kontaktieren.","multiple":"Die Personen, denen du eine Nachricht sendest (\u003cb\u003e%{usernames}\u003c/b\u003e) wurden hier schon lange nicht mehr gesehen – %{time_ago}. Es kann sein, dass sie deine Nachricht nicht erhalten. Du solltest nach alternativen Methoden suchen, um sie zu kontaktieren."},"admin_options_title":"Optionale Team-Einstellungen für dieses Thema","composer_actions":{"reply":"Antworten","draft":"Entwurf","edit":"Bearbeiten","reply_to_post":{"label":"Auf einen Beitrag von %{postUsername} antworten","desc":"Antworte auf einen bestimmten Beitrag"},"reply_as_new_topic":{"label":"Mit verknüpftem Thema antworten","desc":"Erstelle ein neues Thema, das auf dieses Thema verweist","confirm":"Du hast einen neuen Themen-Entwurf gespeichert. Wenn du ein verknüpftes Thema erstellst, wird er überschrieben."},"reply_as_new_group_message":{"label":"Als neue Gruppen-Nachricht antworten","desc":"Neue Nachricht erstellen, beginnend mit denselben Empfängern"},"reply_to_topic":{"label":"Auf Thema antworten","desc":"Antworte auf das Thema, nicht auf einen bestimmten Beitrag"},"toggle_whisper":{"label":"Flüstermodus umschalten","desc":"Ein geflüsterter Beitrag ist nur für Team-Mitglieder sichtbar"},"create_topic":{"label":"Neues Thema","desc":"Erstelle ein neues Thema"},"shared_draft":{"label":"Gemeinsamer Entwurf","desc":"Entwurf eines Themas, das nur für erlaubte Benutzer sichtbar ist"},"toggle_topic_bump":{"label":"„Nach oben verschieben“ für Thema umschalten","desc":"Antworten, ohne das Datum der neuesten Antwort zu ändern"}},"reload":"Neu laden","ignore":"Ignorieren","image_alt_text":{"aria_label":"Alternativ-Text für Bild","title":"Bildbeschreibung hinzufügen"},"image_scale_button":"Bild auf %{percent} % skalieren","delete_image_button":"Bild löschen","toggle_image_grid":"Bildraster umschalten","details_title":"Zusammenfassung","details_text":"Dieser Text wird ausgeblendet","spoiler_text":"Dieser Text wird unkenntlich gemacht"},"notifications":{"tooltip":{"regular":{"one":"%{count} nicht gesehene Benachrichtigung","other":"%{count} nicht gesehene Benachrichtigungen"},"message":{"one":"%{count} ungelesene Nachricht","other":"%{count} ungelesene Nachrichten"},"high_priority":{"one":"%{count} ungelesene Benachrichtigung hoher Priorität","other":"%{count} ungelesene Benachrichtigungen hoher Priorität"},"new_message_notification":{"one":"%{count} neue Nachrichtenbenachrichtigung","other":"%{count} neue Nachrichtenbenachrichtigungen"},"new_reviewable":{"one":"%{count} neu zur Überprüfung","other":"%{count} neu zur Überprüfung"}},"paused":"Benachrichtigungen pausiert","title":"Benachrichtigungen über namentliche Erwähnungen mit @, Antworten auf deine Beiträge und Themen, Nachrichten usw.","none":"Die Benachrichtigungen können derzeit nicht geladen werden.","empty":"Keine Benachrichtigungen gefunden.","post_approved":"Dein Beitrag wurde genehmigt.","reviewable_items":"Elemente, die eine Überprüfung benötigen","watching_first_post_label":"Neues Thema","user_moved_post":"%{username} verschob","mentioned":"\u003cspan\u003e%{username}\u003c/span\u003e %{description}","group_mentioned":"\u003cspan\u003e%{username}\u003c/span\u003e %{description}","quoted":"\u003cspan\u003e%{username}\u003c/span\u003e %{description}","bookmark_reminder":"\u003cspan\u003e%{username}\u003c/span\u003e %{description}","replied":"\u003cspan\u003e%{username}\u003c/span\u003e %{description}","posted":"\u003cspan\u003e%{username}\u003c/span\u003e %{description}","watching_category_or_tag":"\u003cspan\u003e%{username}\u003c/span\u003e %{description}","edited":"\u003cspan\u003e%{username}\u003c/span\u003e %{description}","liked":"\u003cspan\u003e%{username}\u003c/span\u003e %{description}","liked_2":"\u003cspan class='double-user'\u003e%{username}, %{username2}\u003c/span\u003e %{description}","liked_many":{"one":"\u003cspan class='multi-user'\u003e%{username} und %{count} andere Person\u003c/span\u003e %{description}","other":"\u003cspan class='multi-user'\u003e%{username} und %{count} andere\u003c/span\u003e %{description}"},"liked_by_2_users":"%{username}, %{username2}","liked_by_multiple_users":{"one":"%{username} und %{count} andere Person","other":"%{username} und %{count} andere"},"liked_consolidated_description":{"one":"gefällt %{count} deiner Beiträge","other":"gefallen %{count} deiner Beiträge"},"liked_consolidated":"\u003cspan\u003e%{username}\u003c/span\u003e %{description}","linked_consolidated_description":{"one":"verlinkte %{count} deiner Beiträge","other":"verlinkte %{count} deiner Beiträge"},"linked_consolidated":"\u003cspan\u003e%{username}\u003c/span\u003e %{description}","private_message":"\u003cspan\u003e%{username}\u003c/span\u003e %{description}","invited_to_private_message":"\u003cp\u003e\u003cspan\u003e%{username}\u003c/span\u003e %{description}","invited_to_topic":"\u003cspan\u003e%{username}\u003c/span\u003e %{description}","invitee_accepted":"\u003cspan\u003e%{username}\u003c/span\u003e hat deine Einladung angenommen","invitee_accepted_your_invitation":"hat deine Einladung angenommen","moved_post":"\u003cspan\u003e%{username}\u003c/span\u003e hat %{description} verschoben","linked":"\u003cspan\u003e%{username}\u003c/span\u003e %{description}","granted_badge":"Du hast „%{description}“ verliehen bekommen","topic_reminder":"\u003cspan\u003e%{username}\u003c/span\u003e %{description}","watching_first_post":"\u003cspan\u003eNeues Thema\u003c/span\u003e %{description}","membership_request_accepted":"Mitgliedschaft akzeptiert in „%{group_name}“","membership_request_consolidated":{"one":"%{count} offene Mitgliedschaftsanfrage für '%{group_name}'","other":"%{count} offene Mitgliedschaftsanfragen für „%{group_name}“"},"reaction":"\u003cspan\u003e%{username}\u003c/span\u003e %{description}","reaction_2":"\u003cspan\u003e%{username}, %{username2}\u003c/span\u003e %{description}","votes_released":"%{description} – abgeschlossen","new_features":"Neue Funktionen verfügbar!","admin_problems":"Neue Ratschläge auf deinem Website-Dashboard","dismiss_confirmation":{"body":{"default":{"one":"Bist du sicher? Du hast %{count} wichtige Benachrichtigung.","other":"Bist du sicher? Du hast %{count} wichtige Benachrichtigungen."},"bookmarks":{"one":"Bist du sicher? Du hast %{count} ungelesene Lesezeichen-Erinnerung.","other":"Bist du sicher? Du hast %{count} ungelesene Lesezeichen-Erinnerungen."},"messages":{"one":"Bist du sicher? Du hast %{count} ungelesene persönliche Nachricht.","other":"Bist du sicher? Du hast %{count} ungelesene persönliche Nachrichten."}},"dismiss":"Verwerfen","cancel":"Abbrechen"},"group_message_summary":{"one":"%{count} Nachricht in deinem „%{group_name}“-Posteingang","other":"%{count} Nachrichten in deinem „%{group_name}“-Posteingang"},"popup":{"mentioned":"%{username} hat dich erwähnt in „%{topic}“ – %{site_title}","group_mentioned":"%{username} hat dich erwähnt in „%{topic}“ – %{site_title}","quoted":"%{username} hat dich zitiert in „%{topic}“ – %{site_title}","replied":"%{username} hat dir geantwortet in „%{topic}“ – %{site_title}","posted":"%{username} hat geschrieben in „%{topic}“ – %{site_title}","private_message":"%{username} hat dir eine Nachricht geschickt in „%{topic}“ – %{site_title}","linked":"%{username} hat deinen Beitrag verlinkt in „%{topic}“ – %{site_title}","watching_first_post":"%{username} hat ein neues Thema „%{topic}“ erstellt – %{site_title}","watching_category_or_tag":"%{username} hat geschrieben in „%{topic}“ – %{site_title}","confirm_title":"Benachrichtigungen aktiviert – %{site_title}","confirm_body":"Erfolgreich! Benachrichtigungen wurden aktiviert.","custom":"Benachrichtigung von %{username} auf %{site_title}","chat_mention":{"direct":"hat dich in „%{channel}“ erwähnt","direct_html":"\u003cspan\u003e%{username}\u003c/span\u003e \u003cspan\u003ehat dich in „%{channel}“ erwähnt\u003c/span\u003e","other_plain":"hat %{identifier} in „%{channel}“ erwähnt","other_html":"\u003cspan\u003e%{username}\u003c/span\u003e \u003cspan\u003ehat %{identifier} in „%{channel}“ erwähnt\u003c/span\u003e"},"direct_message_chat_mention":{"direct":"hat dich im persönlichen Chat erwähnt","direct_html":"\u003cspan\u003e%{username}\u003c/span\u003e \u003cspan\u003ehat dich im persönlichen Chat erwähnt\u003c/span\u003e","other_plain":"hat %{identifier} im persönlichen Chat erwähnt","other_html":"\u003cspan\u003e%{username}\u003c/span\u003e \u003cspan\u003ehat %{identifier} im persönlichen Chat erwähnt\u003c/span\u003e"},"chat_message":"Neue Chat-Nachricht","chat_quoted":"%{username} hat deine Chat-Nachricht zitiert"},"titles":{"mentioned":"erwähnte","replied":"neue Antwort","quoted":"zitiert","edited":"bearbeitet","liked":"neue „Gefällt mir“-Angabe","private_message":"neue persönliche Nachricht","invited_to_private_message":"zu einer persönlichen Nachricht eingeladen","invitee_accepted":"Einladung angenommen","posted":"neuer Beitrag","watching_category_or_tag":"neuer Beitrag","moved_post":"Beitrag verschoben","linked":"verknüpft","bookmark_reminder":"Erinnerung an Lesezeichen","bookmark_reminder_with_name":"Erinnerung an Lesezeichen — %{name}","granted_badge":"Abzeichen gewährt","invited_to_topic":"zum Thema eingeladen","group_mentioned":"Gruppe erwähnt","group_message_summary":"neue Gruppen-Nachrichten","watching_first_post":"neues Thema","topic_reminder":"Themen-Erinnerung","liked_consolidated":"neue „Gefällt mir“-Angaben","linked_consolidated":"neue Links","post_approved":"Beitrag genehmigt","membership_request_consolidated":"Neue Mitgliedschaftsanfragen","reaction":"neue Reaktion","votes_released":"Abstimmung wurde freigegeben","new_features":"Neue Discourse-Funktionen wurden veröffentlicht!","admin_problems":"neue Ratschläge auf deinem Website-Dashboard","chat_mention":"Im Chat erwähnt","chat_invitation":"Zum Chat-Kanal eingeladen","chat_quoted":"Chat-Nachricht zitiert","chat_watched_thread":"Beobachteter Chat-Thread"},"chat_invitation":"hat dich eingeladen, einem Chat-Kanal beizutreten","chat_invitation_html":"\u003cspan\u003e%{username}\u003c/span\u003e \u003cspan\u003ehat dich eingeladen, einem Chat-Kanal beizutreten\u003c/span\u003e","chat_quoted":"\u003cspan\u003e%{username}\u003c/span\u003e %{description}","chat_watched_thread_label":{"one":"%{username} und %{username2}","other":"%{username} und %{count} andere"}},"upload_selector":{"uploading":"Wird hochgeladen","processing":"Upload wird verarbeitet","select_file":"Datei auswählen","default_image_alt_text":"Bild"},"search":{"sort_by":"Sortieren nach","relevance":"Relevanz","latest_post":"Neuester Beitrag","latest_topic":"Neuestes Thema","most_viewed":"Anzahl der Aufrufe","most_liked":"Anzahl der „Gefällt mir“","select_all":"Alle auswählen","clear_all":"Auswahl aufheben","too_short":"Der Suchbegriff ist zu kurz.","open_advanced":"Erweiterte Suche öffnen","clear_search":"Suche löschen","sort_or_bulk_actions":"Ergebnisse sortieren oder massenweise auswählen","result_count":{"one":"\u003cspan\u003e%{count} Ergebnis für \u003c/span\u003e\u003cspan class='term'\u003e%{term}\u003c/span\u003e","other":"\u003cspan\u003e%{count}%{plus} Ergebnisse für \u003c/span\u003e\u003cspan class='term'\u003e%{term}\u003c/span\u003e"},"title":"Suche","full_page_title":"Suche","results":"Ergebnisse","no_results":"Keine Ergebnisse gefunden.","no_more_results":"Es wurden keine weiteren Ergebnisse gefunden.","post_format":"#%{post_number} von %{username}","results_page":"Suchergebnisse für „%{term}“","more_results":"Es gibt mehr Ergebnisse. Bitte grenze deine Suchkriterien weiter ein.","cant_find":"Nicht gefunden, wonach du suchst?","start_new_topic":"Wie wärs mit einem neuen Thema?","or_search_google":"Oder versuche stattdessen mit Google zu suchen:","search_google":"Versuche stattdessen mit Google zu suchen:","search_google_button":"Google","search_button":"Suche","search_term_label":"Suchbegriff eingeben","categories":"Kategorien","tags":"Schlagwörter","in":"in","in_this_topic":"in diesem Thema","in_this_topic_tooltip":"zur Suche in allen Themen wechseln","in_messages":"in Nachrichten","in_messages_tooltip":"zur Suche nach regulären Themen wechseln","in_topics_posts":"in allen Themen und Beiträgen","enter_hint":"oder drücke die Eingabetaste","in_posts_by":"in Beiträgen von %{username}","browser_tip":"%{modifier} + f","browser_tip_description":"noch mal, um die native Browsersuche zu verwenden","recent":"Letzte Suchanfragen","clear_recent":"Letzte Suchanfragen löschen","type":{"default":"Themen/Beiträge","users":"Benutzer","categories":"Kategorien","categories_and_tags":"Kategorien/Schlagwörter"},"context":{"user":"Beiträge von @%{username} durchsuchen","category":"Kategorie #%{category} durchsuchen","tag":"Das Schlagwort #%{tag} suchen","topic":"Dieses Thema durchsuchen","private_messages":"Nachrichten durchsuchen"},"tips":{"category_tag":"filtern nach Kategorie oder Schlagwort","author":"filtern nach Beitragsverfasser","in":"filtern nach Metadaten (z. B. in:title, in:personal, in:pinned)","status":"filtern nach Themenstatus","full_search":"startet die Ganzseitensuche","full_search_key":"%{modifier} + Eingabetaste","me":"zeigt nur deine Beiträge"},"advanced":{"title":"Erweiterte Filter","posted_by":{"label":"Beiträge von","aria_label":"Filtern nach Beitragsverfasser"},"in_category":{"label":"In der Kategorie"},"in_group":{"label":"In der Gruppe"},"with_badge":{"label":"Mit dem Abzeichen"},"with_tags":{"label":"Mit dem Schlagwort","aria_label":"Nach Schlagwörtern filtern"},"filters":{"label":"Nur Themen/Beiträge zurückgeben …","title":"Mit Treffer im Titel","likes":"Themen/Beiträge, die mir gefallen","posted":"Themen mit Beiträgen von mir","created":"Von mir erstellt","watching":"Themen, die ich beobachte","tracking":"Themen, die ich verfolge","private":"Beiträge in meinen Unterhaltungen","bookmarks":"von mir mit Lesezeichen versehen","first":"Erste Beiträge in Themen","pinned":"Angeheftete Themen","seen":"Gelesene Themen/Beiträge","unseen":"Ungelesene Themen/Beiträge","wiki":"Wikis","images":"mit Bildern","all_tags":"Enthält alle Schlagwörter"},"statuses":{"label":"Themen einschränken:","open":"Offene Themen","closed":"Geschlossene Themen","public":"Öffentliche Themen","archived":"Archivierte Themen","noreplies":"Themen ohne Antwort","single_user":"Themen mit nur einem Benutzer"},"post":{"count":{"label":"Beiträge"},"min":{"placeholder":"Minimum","aria_label":"nach Mindestanzahl von Beiträgen filtern"},"max":{"placeholder":"Maximum","aria_label":"nach maximaler Anzahl von Beiträgen filtern"},"time":{"label":"Zeitraum einschränken:","aria_label":"Nach Veröffentlichungsdatum filtern","before":"Beiträge vor dem","after":"Beiträge nach dem"}},"views":{"label":"Aufrufe"},"min_views":{"placeholder":"Minimum","aria_label":"nach minimaler Anzahl von Aufrufen filtern"},"max_views":{"placeholder":"Maximum","aria_label":"nach maximaler Anzahl von Aufrufen filtern"},"additional_options":{"label":"Nach Beitragsanzahl und Themenaufrufen filtern"},"vote":{"count":{"label":"Mindeststimmzahl"}}},"most_votes":"Meiste Stimmen"},"hamburger_menu":"Menü","new_item":"neu","go_back":"zurückgehen","not_logged_in_user":"Benutzerseite mit einer Zusammenfassung der Benutzeraktivitäten und Einstellungen","current_user":"zu deiner Benutzerseite gehen","view_all":"Alle %{tab} anzeigen","user_menu":{"generic_no_items":"Es gibt keine Einträge in dieser Liste.","sr_menu_tabs":"Registerkarten des Benutzermenüs","view_all_notifications":"alle Benachrichtigungen anzeigen","view_all_bookmarks":"alle Lesezeichen anzeigen","view_all_messages":"alle persönlichen Nachrichten anzeigen","tabs":{"all_notifications":"Alle Benachrichtigungen","replies":"Antworten","replies_with_unread":{"one":"Antworten – %{count} ungelesene Antwort","other":"Antworten – %{count} ungelesene Antworten"},"mentions":"Erwähnungen","mentions_with_unread":{"one":"Erwähnungen – %{count} ungelesene Erwähnung","other":"Erwähnungen – %{count} ungelesene Erwähnungen"},"likes":"„Gefällt mir“","likes_with_unread":{"one":"„Gefällt mir“ – %{count} ungelesenes „Gefällt mir“","other":"„Gefällt mir“ – %{count} ungelesene „Gefällt mir“"},"watching":"Beobachtete Themen","watching_with_unread":{"one":"Beobachtete Themen – %{count} ungelesenes beobachtetes Thema","other":"Beobachtete Themen – %{count} ungelesene beobachtete Themen"},"messages":"Persönliche Nachrichten","messages_with_unread":{"one":"Persönliche Nachrichten – %{count} ungelesene Nachricht","other":"Persönliche Nachrichten – %{count} ungelesene Nachrichten"},"bookmarks":"Lesezeichen","bookmarks_with_unread":{"one":"Lesezeichen – %{count} ungelesenes Lesezeichen","other":"Lesezeichen – %{count} ungelesene Lesezeichen"},"review_queue":"Warteschlange zur Überprüfung","review_queue_with_unread":{"one":"Warteschlange zur Überprüfung – %{count} Element benötigt Überprüfung","other":"Warteschlange zur Überprüfung – %{count} Elemente benötigen Überprüfung"},"other_notifications":"Andere Benachrichtigungen","other_notifications_with_unread":{"one":"Andere Benachrichtigungen – %{count} ungelesene Benachrichtigung","other":"Andere Benachrichtigungen – %{count} ungelesene Benachrichtigungen"},"profile":"Profil","chat_notifications":"Chat-Benachrichtigungen","chat_notifications_with_unread":{"one":"Chat-Benachrichtigungen – %{count} ungelesene Benachrichtigung","other":"Chat-Benachrichtigungen – %{count} ungelesene Benachrichtigungen"}},"reviewable":{"view_all":"alle Elemente zur Überprüfung anzeigen","queue":"Warteschlange","deleted_user":"(gelöschter Benutzer)","deleted_post":"(gelöschter Beitrag)","post_number_with_topic_title":"Beitrag #%{post_number} – %{title}","new_post_in_topic":"neuer Beitrag in %{title}","user_requires_approval":"%{username} erfordert eine Genehmigung","default_item":"Element zur Überprüfung #%{reviewable_id}"},"no_chat_notifications_title":"Du hast noch keine Chat-Benachrichtigungen","no_chat_notifications_body":"In diesem Bereich wirst du benachrichtigt, wenn dir jemand eine Direktnachricht sendet oder dich im Chat \u003cb\u003eper @ erwähnt\u003c/b\u003e. Außerdem werden Benachrichtigungen an deine E-Mail-Adresse geschickt, wenn du dich eine Weile nicht angemeldet hast. \u003cbr\u003e\u003cbr\u003e Klicke auf den Titel oben in einem Chat-Kanal, um festzulegen, welche Benachrichtigungen du in diesem Kanal erhältst. Weiteres findest du in deinen \u003ca href='%{preferencesUrl}'\u003eBenachrichtigungseinstellungen\u003c/a\u003e.\n"},"topics":{"new_messages_marker":"letzter Besuch","bulk":{"confirm":"Bestätigen","select_all":"Alle auswählen","clear_all":"Auswahl aufheben","unlist_topics":"Themen unsichtbar machen","relist_topics":"Themen neu auflisten","reset_bump_dates":"„Nach oben verschieben“-Zeitangaben zurücksetzen","defer":"Als ungelesen markieren","delete":"Themen löschen","dismiss":"Ignorieren","dismiss_read":"Blende alle ungelesenen Beiträge aus","dismiss_read_with_selected":{"one":"%{count} ungelesenes Thema ignorieren","other":"%{count} ungelesene Themen ignorieren"},"dismiss_button":"Ignorieren …","dismiss_button_with_selected":{"one":"Ignorieren (%{count}) …","other":"Ignorieren (%{count}) …"},"dismiss_tooltip":"Nur die neuen Beiträge ignorieren oder Themen nicht mehr verfolgen","also_dismiss_topics":"Diese Themen nicht mehr verfolgen, sodass mir diese nicht mehr als ungelesen angezeigt werden","dismiss_new":"Neue Themen ignorieren","dismiss_new_modal":{"title":"Neue verwerfen","topics":"Neue Themen verwerfen","posts":"Neue Antworten verwerfen","topics_with_count":{"one":"%{count} neues Thema verwerfen","other":"%{count} neue Themen verwerfen"},"replies_with_count":{"one":"%{count} neue Antwort verwerfen","other":"%{count} neue Antworten verwerfen"},"replies":"Neue Antworten verwerfen","untrack":"Diese Themen nicht mehr verfolgen, damit sie nicht mehr in meiner Liste „Neu“ auftauchen"},"dismiss_new_with_selected":{"one":"Neues Thema ignorieren (%{count})","other":"Neue Themen ignorieren (%{count})"},"toggle":"Massenauswahl von Themen umschalten","actions":"Massenoperationen","change_category":"Kategorie festlegen …","close_topics":"Themen schließen","archive_topics":"Themen archivieren","move_messages_to_inbox":"In Posteingang verschieben","archive_messages":"Ins Archiv verschieben","notification_level":"Benachrichtigungen …","change_notification_level":"Benachrichtigungsstufe ändern","choose_new_category":"Neue Kategorie für die gewählten Themen:","selected":{"one":"Du hast \u003cb\u003e%{count}\u003c/b\u003e Thema ausgewählt.","other":"Du hast \u003cb\u003e%{count}\u003c/b\u003e Themen ausgewählt."},"selected_sole_category":{"one":"Du hast \u003cb\u003e%{count}\u003c/b\u003e Thema aus der Kategorie ausgewählt:","other":"Du hast \u003cb\u003e%{count}\u003c/b\u003e Themen aus der Kategorie ausgewählt:"},"selected_count":{"one":"%{count} ausgewählt","other":"%{count} ausgewählt"},"change_tags":"Schlagwörter ersetzen","append_tags":"Schlagwörter hinzufügen","choose_new_tags":"Neue Schlagwörter für diese Themen wählen:","choose_append_tags":"Wähle neue Schlagwörter, die diesen Themen hinzugefügt werden sollen:","changed_tags":"Die Schlagwörter dieser Themen wurden geändert.","remove_tags":"Alle Schlagwörter entfernen","confirm_remove_tags":{"one":"Alle Schlagwörter werden aus diesem Thema entfernt. Bist du sicher?","other":"Alle Schlagwörter werden aus \u003cb\u003e%{count}\u003c/b\u003e Themen entfernt. Bist du sicher?"},"progress":{"one":"Fortschritt: \u003cstrong\u003e%{count}\u003c/strong\u003e Thema","other":"Fortschritt: \u003cstrong\u003e%{count}\u003c/strong\u003e Themen"},"silent":"Führe diese Aktion lautlos durch.","performing":"Massenoperationen werden durchgeführt, bitte warten …","completed":"Massenoperationen erfolgreich abgeschlossen!"},"none":{"unread":"Du hast alle Themen gelesen.","unseen":"Du hast keine ungesehenen Themen.","new":"Du hast keine neuen Themen.","read":"Du hast noch keine Themen gelesen.","posted":"Du hast noch keine Beiträge verfasst.","latest":"Du bist auf dem Laufenden!","bookmarks":"Du hast noch keine Themen mit einem Lesezeichen versehen.","category":"Es gibt keine Themen in %{category}.","top":"Es gibt keine angesagten Themen.","hot":"Es gibt keine heißen Themen.","filter":"Es gibt keine Themen.","educate":{"new":"\u003cp\u003eHier werden deine neuen Themen angezeigt. Standardmäßig werden Themen als neu erachtet und mit einem \u003cspan class=\"badge new-topic badge-notification\" style=\"vertical-align:middle;line-height:inherit;\"\u003e\u003c/span\u003e-Indikator dargestellt, wenn sie in den letzten 2 Tagen erstellt wurden. \u003c/p\u003e\u003cp\u003eBesuche deine \u003ca href=\"%{userPrefsUrl}\"\u003eEinstellungen\u003c/a\u003e, um dies zu ändern.\u003c/p\u003e","unread":"\u003cp\u003eHier werden deine ungelesenen Themen angezeigt.\u003c/p\u003e\u003cp\u003eStandardmäßig werden Themen als ungelesen erachtet und mit einem Zähler für ungelesene Beiträge \u003cspan class=\"badge unread-posts badge-notification\"\u003e1\u003c/span\u003e dargestellt, wenn du:\u003c/p\u003e\u003cul\u003e\u003cli\u003edas Thema erstellt hast;\u003c/li\u003e\u003cli\u003eauf das Thema geantwortet hast;\u003c/li\u003e\u003cli\u003edas Thema für mehr als 5 Minuten gelesen hast.\u003c/li\u003e\u003c/ul\u003e\u003cp\u003eOder falls du das Thema über 🔔 ausdrücklich auf „Verfolgen“ oder „Beobachten“ eingestellt hast.\u003c/p\u003e\u003cp\u003eBesuche deine \u003ca href=\"%{userPrefsUrl}\"\u003eEinstellungen\u003c/a\u003e, um dies zu ändern.\u003c/p\u003e","new_new":"\u003cp\u003eHier erscheinen deine neuen Themen und deine ungelesenen Themen werden ebenfalls angezeigt. Standardmäßig gelten Themen als neu und werden mit einem \u003cspan class=\"badge new-topic badge-notification\" style=\"vertical-align:middle;line-height:inherit;\"\u003e\u003c/span\u003e Symbol gekennzeichnet, wenn sie in den letzten 2 Tagen erstellt wurden. Ungelesene Themen werden mit einem Zähler für ungelesene Beiträge \u003cspan class=\"badge unread-posts badge-notification\"\u003e1\u003c/span\u003e dargestellt, wenn du: das Thema erstellt hast; auf das Thema geantwortet hast; das Thema für mehr als 5 Minuten gelesen hast; oder falls du das Thema über 🔔 ausdrücklich auf „Verfolgen“ oder „Beobachten“ eingestellt hast.\u003c/p\u003e\u003cp\u003eBesuche deine \u003ca href=\"%{userPrefsUrl}\"\u003eEinstellungen\u003c/a\u003e , um dies zu ändern.\u003c/p\u003e"}},"bottom":{"latest":"Das waren die aktuellen Themen.","posted":"Das waren alle Themen.","read":"Das waren alle gelesenen Themen.","new":"Das waren alle neuen Themen.","unread":"Das waren alle ungelesen Themen.","unseen":"Es gibt keine ungesehenen Themen mehr.","category":"Das waren alle Themen in der Kategorie „%{category}“.","tag":"Das waren alle Themen mit dem Schlagwort „%{tag}“.","top":"Das waren alle angesagten Themen.","hot":"Das waren alle heißen Themen.","bookmarks":"Das waren alle Themen, die du mit einem Lesezeichen versehen hast.","filter":"Es gibt keine weiteren Themen."}},"topic_bulk_actions":{"dismiss":{"name":"Verwerfen"},"close_topics":{"name":"Schließen","note":"Hinweis","optional":"(optional)"},"archive_topics":{"name":"Archivieren"},"archive_messages":{"name":"Ins Archiv verschieben"},"move_messages_to_inbox":{"name":"In Posteingang verschieben"},"unlist_topics":{"name":"Unsichtbar machen"},"relist_topics":{"name":"Wieder sichtbar machen"},"remove_tags":{"name":"Schlagwörter entfernen"},"append_tags":{"name":"Schlagwörter hinzufügen"},"replace_tags":{"name":"Schlagwörter ersetzen"},"delete_topics":{"name":"Löschen"},"update_category":{"name":"Kategorie aktualisieren","description":"Wähle die neue Kategorie für die ausgewählten Themen"},"reset_bump_dates":{"name":"„Nach oben verschieben“-Daten zurücksetzen","description":"Setzt das „Nach oben verschieben“-Datum auf das vom zuletzt erstellten Beitrag zurück, was die Reihenfolge in der Themenliste beeinflusst"},"defer":{"name":"Als ungelesen markieren","description":"Themen als ungelesen markieren"},"update_notifications":{"name":"Benachrichtigungsstufe aktualisieren","description":"Ändere die Benachrichtigungsstufe auf „Beobachten“, „Verfolgen“, „Normal“ oder „Stumm“"}},"topic":{"filter_to":{"one":"%{count} Beitrag im Thema","other":"%{count} Beiträge im Thema"},"create":"Neues Thema","create_disabled_category":"Du darfst keine Themen in dieser Kategorie erstellen","create_disabled_tag":"Du darfst keine Themen mit diesem Schlagwort erstellen","create_long":"Ein neues Thema erstellen","open_draft":"Entwurf öffnen","private_message":"Eine Unterhaltung beginnen","archive_message":{"help":"Nachricht ins Archiv verschieben","title":"Archivieren"},"move_to_inbox":{"title":"In Posteingang verschieben","help":"Nachricht in den Posteingang zurück verschieben"},"defer":{"help":"Thema als ungelesen markieren","title":"Als ungelesen markieren"},"list":"Themen","new":"neues Thema","unread":"ungelesen","new_topics":{"one":"%{count} neues Thema","other":"%{count} neue Themen"},"unread_topics":{"one":"%{count} ungelesenes Thema","other":"%{count} ungelesene Themen"},"title":"Thema","invalid_access":{"title":"Thema ist nicht öffentlich","description":"Entschuldige, du hast keinen Zugriff auf dieses Thema!","login_required":"Du musst dich anmelden, damit du dieses Thema sehen kannst."},"server_error":{"title":"Thema konnte nicht geladen werden","description":"Entschuldige, wir konnten dieses Thema nicht laden, möglicherweise aufgrund eines Verbindungsproblems. Bitte versuche es erneut. Wenn das Problem weiterhin besteht, lass es uns wissen."},"not_found":{"title":"Thema nicht gefunden","description":"Entschuldige, wir konnten dieses Thema nicht finden. Wurde es vielleicht von einem Moderator entfernt?"},"unread_posts":{"one":"du hast %{count} ungelesenen Beitrag in diesem Thema","other":"du hast %{count} ungelesene Beiträge in diesem Thema"},"likes":{"one":"Es gibt %{count} „Gefällt mir“ in diesem Thema","other":"Es gibt %{count} „Gefällt mir“ in diesem Thema"},"back_to_list":"Zurück zur Themenliste","options":"Themen-Optionen","show_links":"zeige Links innerhalb dieses Themas","collapse_details":"Themendetails einklappen","expand_details":"Themendetails erweitern","read_more_in_category":"Willst du mehr lesen? Durchstöbere andere Themen in %{categoryLink} oder \u003ca href='%{latestLink}'\u003esieh dir die aktuellen Themen an\u003c/a\u003e.","read_more":"Willst du mehr lesen? \u003ca href='%{categoryLink}'\u003eDurchstöbere alle Kategorien\u003c/a\u003e oder \u003ca href='%{latestLink}'\u003esieh dir die aktuellen Themen an\u003c/a\u003e.","unread_indicator":"Kein Mitglied hat den letzten Beitrag dieses Themas bisher gelesen.","participant_groups":"Teilnehmergruppen","created_at":"Erstellt: %{date}","bumped_at":"Letztes: %{date}","browse_all_categories_latest":"\u003ca href='%{basePath}/categories'\u003eDurchstöbere alle Kategorien\u003c/a\u003e oder \u003ca href='%{basePath}/latest'\u003esieh dir die aktuellen Themen an\u003c/a\u003e.","browse_all_categories_latest_or_top":"\u003ca href='%{basePath}/categories'\u003eDurchstöbere alle Kategorien\u003c/a\u003e, \u003ca href='%{basePath}/latest'\u003esieh dir die aktuellen Themen\u003c/a\u003e oder die Top-Themen an:","browse_all_tags_or_latest":"\u003ca href='%{basePath}/tags'\u003eDurchstöbere alle Schlagwörter\u003c/a\u003e oder \u003ca href='%{basePath}/latest'\u003esieh dir die aktuellen Themen an\u003c/a\u003e.","suggest_create_topic":"Bereit, \u003ca href\u003eeine neue Unterhaltung zu beginnen?\u003c/a\u003e","jump_reply":"Zum ursprünglichen Ort des Beitrags springen","jump_reply_aria":"Zum Beitrag von @%{username} an dessen ursprünglichen Ort springen","jump_reply_button":"Zum Beitrag springen","deleted":"Das Thema wurde gelöscht","slow_mode_update":{"title":"Langsamer Modus","select":"Benutzer dürfen nur einmal in diesem Thema schreiben:","description":"Um in schnellen oder umstrittenen Diskussionen eine durchdachte Diskussion zu fördern, müssen Benutzer warten, bevor sie in diesem Thema erneut einen Beitrag verfassen können.","enable":"Aktivieren","update":"Aktualisieren","enabled_until":"Aktiviert bis:","remove":"Deaktivieren","hours":"Stunden:","minutes":"Minuten:","seconds":"Sekunden:","durations":{"10_minutes":"10 Minuten","15_minutes":"15 Minuten","30_minutes":"30 Minuten","45_minutes":"45 Minuten","1_hour":"1 Stunde","2_hours":"2 Stunden","4_hours":"4 Stunden","8_hours":"8 Stunden","12_hours":"12 Stunden","24_hours":"24 Stunden","custom":"Benutzerdefinierte Dauer"}},"slow_mode_notice":{"duration":"Bitte warte zwischen dem Verfassen von Beiträgen in diesem Thema %{duration}."},"topic_status_update":{"title":"Zeitschaltuhr","save":"Zeitschaltuhr aktivieren","num_of_hours":"Stunden:","num_of_days":"Tage:","remove":"Zeitschaltuhr deaktivieren","publish_to":"Veröffentlichen in:","when":"Wann:","time_frame_required":"Bitte wähle einen Zeitrahmen aus","min_duration":"Dauer muss mehr als 0 betragen","max_duration":"Dauer muss weniger als 20 Jahre betragen","duration":"Dauer"},"publish_to_category":{"title":"Veröffentlichung planen"},"temp_open":{"title":"Vorübergehend öffnen"},"auto_reopen":{"title":"Thema automatisch öffnen"},"temp_close":{"title":"Vorübergehend schließen"},"auto_close":{"title":"Thema automatisch schließen","label":"Thema automatisch schließen nach:","error":"Bitte gib einen gültigen Wert ein.","based_on_last_post":"Nicht schließen, bevor der letzte Beitrag in dem Thema mindestens so alt ist."},"auto_close_after_last_post":{"title":"Thema nach dem letzten Beitrag automatisch schließen"},"auto_delete":{"title":"Thema automatisch löschen"},"auto_bump":{"title":"Thema automatisch nach oben verschieben"},"reminder":{"title":"Erinnere mich"},"auto_delete_replies":{"title":"Antworten automatisch löschen"},"status_update_notice":{"auto_open":"Dieses Thema wird automatisch geöffnet %{timeLeft}.","auto_close":"Dieses Thema wird automatisch geschlossen %{timeLeft}.","auto_publish_to_category":"Dieses Thema wird %{timeLeft} in \u003ca href=%{categoryUrl}\u003e#%{categoryName}\u003c/a\u003e veröffentlicht.","auto_close_after_last_post":"Dieses Thema wird %{duration} nach der letzten Antwort geschlossen.","auto_delete":"Dieses Thema wird automatisch gelöscht %{timeLeft}.","auto_bump":"Dieses Thema wird automatisch nach oben verschoben %{timeLeft}.","auto_reminder":"Du wirst über dieses Thema erinnert %{timeLeft}.","auto_delete_replies":"Antworten zu diesem Thema werden nach %{duration} automatisch gelöscht."},"auto_close_title":"Einstellungen für automatisches Schließen","auto_close_immediate":{"one":"Der letzte Beitrag in diesem Thema ist bereits %{count} Stunde alt. Das Thema wird daher sofort geschlossen.","other":"Der letzte Beitrag in diesem Thema ist bereits %{count} Stunden alt. Das Thema wird daher sofort geschlossen."},"auto_close_momentarily":{"one":"Der letzte Beitrag im Thema ist bereits %{count} Stunde alt, daher wird das Thema augenblicklich geschlossen.","other":"Der letzte Beitrag im Thema ist bereits %{count} Stunden alt, daher wird das Thema augenblicklich geschlossen."},"timeline":{"back":"Zurück","back_description":"Gehe zurück zum letzten ungelesenen Beitrag","replies_short":"%{current}/%{total}"},"progress":{"title":"Themen-Fortschritt","jump_prompt":"springe zu …","jump_prompt_of":{"one":"von %{count} Beitrag","other":"von %{count} Beiträgen"},"jump_prompt_long":"Springe zu …","jump_prompt_to_date":"zu Datum","jump_prompt_or":"oder"},"notifications":{"title":"ändere, wie häufig du zu diesem Thema benachrichtigt wirst","reasons":{"mailing_list_mode":"Du hast den Mailinglisten-Modus aktiviert, daher wirst du über Antworten zu diesem Thema per E-Mail benachrichtigt","3_10":"Du wirst Benachrichtigungen erhalten, weil du ein Schlagwort an diesem Thema beobachtest.","3_10_stale":"Du wirst Benachrichtigungen erhalten, weil du ein Schlagwort an diesem Thema beobachtet hast.","3_6":"Du wirst Benachrichtigungen erhalten, weil du diese Kategorie beobachtest.","3_6_stale":"Du wirst Benachrichtigungen erhalten, weil du diese Kategorie beobachtet hast.","3_5":"Du wirst Benachrichtigungen erhalten, weil dieses Thema automatisch von dir beobachtet wird.","3_2":"Du wirst Benachrichtigungen erhalten, weil du dieses Thema beobachtest.","3_1":"Du wirst Benachrichtigungen erhalten, weil du dieses Thema erstellt hast.","3":"Du wirst Benachrichtigungen erhalten, weil du dieses Thema beobachtest.","2_8":"Du wirst die Anzahl neuer Antworten sehen, weil du diese Kategorie verfolgst.","2_8_stale":"Du wirst die Anzahl neuer Antworten sehen, weil du diese Kategorie verfolgt hast.","2_4":"Du wirst die Anzahl neuer Antworten sehen, weil du einen Beitrag in diesem Thema geschrieben hast.","2_2":"Du wirst die Anzahl neuer Antworten sehen, weil du dieses Thema verfolgst.","2":"Du wirst die Anzahl neuer Antworten sehen, weil du \u003ca href=\"%{basePath}/u/%{username}/preferences/notifications\"\u003edieses Thema gelesen\u003c/a\u003e hast.","1_2":"Du wirst benachrichtigt, wenn jemand deinen Namen mit @ erwähnt oder auf deinen Beitrag antwortet.","1":"Du wirst benachrichtigt, wenn jemand deinen Namen mit @ erwähnt oder auf deinen Beitrag antwortet.","0_7":"Du ignorierst alle Benachrichtigungen dieser Kategorie.","0_2":"Du ignorierst alle Benachrichtigungen dieses Themas.","0":"Du ignorierst alle Benachrichtigungen dieses Themas."},"watching_pm":{"title":"Beobachten","description":"Du wirst über jeden neuen Beitrag in dieser Unterhaltung benachrichtigt und die Anzahl der neuen Beiträge wird angezeigt."},"watching":{"title":"Beobachten","description":"Du wirst über jeden neuen Beitrag in diesem Thema benachrichtigt und die Anzahl der neuen Antworten wird angezeigt."},"tracking_pm":{"title":"Verfolgen","description":"Die Anzahl der neuen Antworten wird bei dieser Unterhaltung angezeigt. Du wirst benachrichtigt, wenn jemand deinen Namen mit @ erwähnt oder auf deinen Beitrag antwortet."},"tracking":{"title":"Verfolgen","description":"Die Anzahl der neuen Antworten wird bei diesem Thema angezeigt. Du wirst benachrichtigt, wenn jemand deinen Namen mit @ erwähnt oder auf deinen Beitrag antwortet."},"regular":{"title":"Normal","description":"Du wirst benachrichtigt, wenn jemand deinen Namen mit @ erwähnt oder auf deinen Beitrag antwortet."},"regular_pm":{"title":"Normal","description":"Du wirst benachrichtigt, wenn jemand deinen Namen mit @ erwähnt oder auf deinen Beitrag antwortet."},"muted_pm":{"title":"Stummgeschaltet","description":"Du erhältst keine Benachrichtigungen im Zusammenhang mit dieser Unterhaltung."},"muted":{"title":"Stummgeschaltet","description":"Du erhältst keine Benachrichtigungen über neue Aktivitäten in diesem Thema und es wird auch nicht mehr in der Liste der aktuellen Themen erscheinen."}},"actions":{"title":"Aktionen","recover":"Löschen rückgängig machen","delete":"Thema löschen","open":"Thema öffnen","close":"Thema schließen","multi_select":"Beiträge auswählen …","slow_mode":"Langsamen Modus einstellen …","timed_update":"Themen-Timer einstellen …","pin":"Thema anheften …","unpin":"Thema loslösen …","unarchive":"Thema aus Archiv holen","archive":"Thema archivieren","invisible":"Thema nicht auflisten","visible":"Thema auflisten","reset_read":"„Gelesen“ zurücksetzen","make_public":"Umwandeln in öffentliches Thema …","make_private":"In persönliche Nachricht umwandeln","reset_bump_date":"„Nach oben verschieben“-Datum zurücksetzen"},"feature":{"pin":"Thema anheften","unpin":"Thema loslösen","pin_globally":"Thema global anheften","make_banner":"Ankündigungsbanner erstellen","remove_banner":"Thema des Ankündigungsbanners entfernen"},"reply":{"title":"Antworten","help":"beginne damit, eine Antwort auf dieses Thema zu verfassen"},"share":{"title":"Thema teilen","extended_title":"Link teilen","help":"teile einen Link zu diesem Thema","instructions":"Link zu diesem Thema teilen:","copied":"Themen-Link kopiert.","restricted_groups":{"one":"Nur für Mitglieder der folgenden Gruppe sichtbar: %{groupNames}","other":"Nur für Mitglieder der folgenden Gruppen sichtbar: %{groupNames}"},"invite_users":"Einladen"},"print":{"title":"Drucken","help":"Öffne eine druckfreundliche Version dieses Themas"},"flag_topic":{"title":"Melden","help":"dieses Thema privat melden oder eine persönliche Nachricht dazu versenden","success_message":"Du hast dieses Thema erfolgreich gemeldet."},"make_public":{"title":"In öffentliches Thema umwandeln","choose_category":"Bitte wähle eine Kategorie für das öffentliche Thema:"},"feature_topic":{"title":"Thema hervorheben","pin":"Dieses Thema am Anfang der „%{categoryLink}“-Kategorie anzeigen bis","unpin":"Dieses Thema vom Anfang der „%{categoryLink}“-Kategorie loslösen.","unpin_until":"Dieses Thema vom Anfang der „%{categoryLink}“-Kategorie loslösen oder bis \u003cstrong\u003e%{until}\u003c/strong\u003e warten.","pin_note":"Benutzer können das Thema für sich selbst loslösen.","pin_validation":"Ein Datum wird benötigt, um diesen Beitrag anzuheften.","not_pinned":"Es sind in %{categoryLink} keine Themen angeheftet.","already_pinned":{"one":"Momentan in %{categoryLink} angeheftete Themen: \u003cstrong class='badge badge-notification unread'\u003e%{count}\u003c/strong\u003e","other":"Momentan in %{categoryLink} angeheftete Themen: \u003cstrong class='badge badge-notification unread'\u003e%{count}\u003c/strong\u003e"},"pin_globally":"Dieses Thema am Anfang aller Themenlisten anzeigen bis","confirm_pin_globally":{"one":"Es gibt bereits %{count} global angeheftetes Thema. Zu viele angeheftete Themen könnten neue und anonyme Benutzer leicht überwältigen. Willst du wirklich noch ein weiteres Thema global anheften?","other":"Es gibt bereits %{count} global angeheftete Themen. Zu viele angeheftete Themen könnten neue und anonyme Benutzer leicht überwältigen. Willst du wirklich noch ein weiteres Thema global anheften?"},"unpin_globally":"Dieses Thema vom Anfang aller Themenlisten loslösen.","unpin_globally_until":"Dieses Thema vom Anfang aller Themenlisten loslösen oder bis \u003cstrong\u003e%{until}\u003c/strong\u003e warten.","global_pin_note":"Benutzer können das Thema für sich selbst loslösen.","not_pinned_globally":"Es sind keine Themen global angeheftet.","already_pinned_globally":{"one":"Momentan global angeheftete Themen: \u003cstrong class='badge badge-notification unread'\u003e%{count}\u003c/strong\u003e","other":"Momentan global angeheftete Themen: \u003cstrong class='badge badge-notification unread'\u003e%{count}\u003c/strong\u003e"},"make_banner":"Macht das Thema zu einem Ankündigungsbanner, welches am Anfang aller Seiten angezeigt wird.","remove_banner":"Entfernt das Ankündigungsbanner vom Anfang aller Seiten.","banner_note":"Benutzer können das Ankündigungsbanner schließen und so für sich selbst dauerhaft ausblenden. Es kann zu jeder Zeit höchstens ein Thema ein Banner sein.","no_banner_exists":"Es gibt kein Thema für das Ankündigungsbanner.","banner_exists":"Es \u003cstrong class='badge badge-notification unread'\u003egibt bereits\u003c/strong\u003e ein anderes Thema für das Ankündigungsbanner."},"inviting":"Einladungen werden gesendet …","automatically_add_to_groups":"Diese Einladung beinhaltet auch Zugang zu den folgenden Gruppen:","invite_private":{"title":"Zu einer Unterhaltung einladen","email_or_username":"E-Mail-Adresse oder Benutzername des Eingeladenen","email_or_username_placeholder":"E-Mail-Adresse oder Benutzername","action":"Einladen","success":"Wir haben den Benutzer gebeten, sich an dieser Unterhaltung zu beteiligen.","success_group":"Wir haben die Gruppe gebeten, sich an dieser Unterhaltung zu beteiligen.","error":"Entschuldige, es gab einen Fehler beim Einladen des Benutzers.","not_allowed":"Dieser Benutzer kann leider nicht eingeladen werden.","group_name":"Gruppenname"},"controls":"Weitere Aktionen","invite_reply":{"title":"Einladen","username_placeholder":"Benutzername","action":"Einladung versenden","help":"per E-Mail oder Benachrichtigung weitere Personen zu diesem Thema einladen","to_forum":"Wir werden eine kurze E-Mail versenden, die einen direkten Beitritt per Link ermöglicht.","discourse_connect_enabled":"Gib den Benutzernamen der Person ein, die du zu diesem Thema einladen möchtest.","to_topic_blank":"Gib den Benutzernamen oder die E-Mail-Adresse der Person ein, die du zu diesem Thema einladen möchtest.","to_topic_email":"Du hast eine E-Mail-Adresse eingegeben. Wir werden eine Einladung versenden, die ein direktes Antworten auf dieses Thema ermöglicht.","to_topic_username":"Du hast einen Benutzernamen eingegeben. Wir werden eine Benachrichtigung versenden und mit einem Link zur Teilnahme an diesem Thema einladen.","to_username":"Gib den Benutzernamen der Person ein, die du einladen möchtest. Wir werden eine Benachrichtigung versenden und mit einem Link zur Teilnahme an diesem Thema einladen.","email_placeholder":"name@example.com","success_email":"Wir haben eine Einladung an \u003cb\u003e%{invitee}\u003c/b\u003e gesendet. Wir werden dich benachrichtigen, wenn die Einladung angenommen wird. Überprüfe die Registerkarte „Einladungen“ auf deiner Benutzerseite, um deine Einladungen zu verfolgen.","success_username":"Wir haben den Benutzer gebeten, sich an diesem Thema zu beteiligen.","error":"Es tut uns leid, wir konnten diese Person nicht einladen. Wurde diese Person vielleicht schon eingeladen? (Einladungen sind in ihrer Zahl beschränkt)","success_existing_email":"Ein Benutzer mit der E-Mail-Adresse \u003cb\u003e%{emailOrUsername}\u003c/b\u003e existiert bereits. Wir haben den Benutzer eingeladen, sich an diesem Thema zu beteiligen."},"login_reply":"Anmelden, um zu antworten","filters":{"n_posts":{"one":"%{count} Beitrag","other":"%{count} Beiträge"},"cancel":"Filter entfernen"},"move_to":{"title":"Verschieben","action":"verschieben","error":"Beim Verschieben der Beiträge ist ein Fehler aufgetreten."},"split_topic":{"title":"In neues Thema verschieben","action":"in ein neues Thema verschieben","topic_name":"Neue Überschrift des Themas","radio_label":"Neues Thema","error":"Beim Verschieben der Beiträge ins neue Thema ist ein Fehler aufgetreten.","instructions":{"one":"Du bist dabei, ein neues Thema zu erstellen und den ausgewählten Beitrag dorthin zu verschieben.","other":"Du bist dabei, ein neues Thema zu erstellen und die \u003cb\u003e%{count}\u003c/b\u003e ausgewählten Beiträge dorthin zu verschieben."}},"merge_topic":{"title":"In ein vorhandenes Thema verschieben","action":"in ein vorhandenes Thema verschieben","error":"Beim Verschieben der Beiträge in das Thema ist ein Fehler aufgetreten.","radio_label":"Vorhandenes Thema","instructions":{"one":"Bitte wähle das Thema, in welches du den Beitrag verschieben möchtest.","other":"Bitte wähle das Thema, in welches du die \u003cb\u003e%{count}\u003c/b\u003e Beiträge verschieben möchtest."},"chronological_order":"die chronologische Reihenfolge nach dem Zusammenführen beibehalten"},"move_to_new_message":{"title":"Verschieben in neue Unterhaltung","action":"verschieben in neue Unterhaltung","message_title":"Neuer Titel der Unterhaltung","radio_label":"Neue Unterhaltung","participants":"Teilnehmer","instructions":{"one":"Du bist dabei, eine neue Unterhaltung zu erstellen und sie mit dem ausgewählten Beitrag zu befüllen.","other":"Du bist dabei, eine neue Unterhaltung zu erstellen und sie mit den \u003cb\u003e%{count}\u003c/b\u003e ausgewählten Beiträgen zu befüllen."}},"move_to_existing_message":{"title":"Verschieben in vorhandene Unterhaltung","action":"in eine vorhandene Unterhaltung verschieben","radio_label":"Vorhandene Unterhaltung","participants":"Teilnehmer","instructions":{"one":"Bitte wähle die Unterhaltung, in welche du den Beitrag verschieben möchtest.","other":"Bitte wähle die Unterhaltung, in welche du die \u003cb\u003e%{count}\u003c/b\u003e Beiträge verschieben möchtest."}},"merge_posts":{"title":"Ausgewählte Beiträge zusammenführen","action":"ausgewählte Beiträge zusammenführen","error":"Es gab einen Fehler beim Zusammenführen der ausgewählten Beiträge."},"publish_page":{"title":"Als Seite veröffentlichen","publish":"Veröffentlichen","description":"Wenn ein Thema als Seite veröffentlicht wird, kann seine URL geteilt werden und es wird mit benutzerdefiniertem Styling angezeigt.","slug":"Sprechender Name für URL","public":"Öffentlich","public_description":"Benutzer können die Seite auch dann sehen, wenn das zugehörige Thema privat ist.","publish_url":"Die Seite wurde unter folgender URL veröffentlicht:","topic_published":"Das Thema wurde unter folgender URL veröffentlicht:","preview_url":"Die Seite wird unter folgender URL veröffentlicht:","invalid_slug":"Du kannst diese Seite leider nicht veröffentlichen.","unpublish":"Veröffentlichung aufheben","unpublished":"Die Veröffentlichung der Seite wurde aufgehoben.","publishing_settings":"Veröffentlichungseinstellungen"},"change_owner":{"title":"Eigentümer ändern","action":"Eigentümer ändern","error":"Beim Ändern des Eigentümers der Beiträge ist ein Fehler aufgetreten.","placeholder":"Benutzername des neuen Eigentümers","instructions":{"one":"Bitte wähle einen neuen Eigentümer für den Beitrag von \u003cb\u003e@%{old_user}\u003c/b\u003e","other":"Bitte wähle einen neuen Eigentümer für %{count} Beiträge von \u003cb\u003e@%{old_user}\u003c/b\u003e"},"instructions_without_old_user":{"one":"Bitte wähle einen neuen Eigentümer für den Beitrag","other":"Bitte wähle einen neuen Eigentümer für %{count} Beiträge"}},"change_timestamp":{"title":"Zeitstempel ändern …","action":"Zeitstempel ändern","invalid_timestamp":"Zeitstempel kann nicht in der Zukunft liegen.","error":"Beim Ändern des Zeitstempels des Themas ist ein Fehler aufgetreten.","instructions":"Wähle bitte einen neuen Zeitstempel für das Thema aus. Alle Beiträge im Thema werden unter Beibehaltung der Zeitdifferenz ebenfalls angepasst."},"multi_select":{"select":"auswählen","selected":"ausgewählt (%{count})","select_post":{"label":"auswählen","title":"Beitrag zu Auswahl hinzufügen"},"selected_post":{"label":"ausgewählt","title":"Klicke, um den Beitrag aus der Auswahl zu entfernen"},"select_replies":{"label":"auswählen inkl. Antworten","title":"Beitrag und alle Antworten zu Auswahl hinzufügen"},"select_below":{"label":"auswählen inkl. folgender","title":"Beitrag und alles danach zu Auswahl hinzufügen"},"delete":"ausgewählte löschen","cancel":"Auswahlvorgang abbrechen","select_all":"alle auswählen","deselect_all":"alle abwählen","description":{"one":"Du hast \u003cb\u003e%{count}\u003c/b\u003e Beitrag ausgewählt.","other":"Du hast \u003cb\u003e%{count}\u003c/b\u003e Beiträge ausgewählt."}},"deleted_by_author_simple":"(Thema vom Verfasser gelöscht)"},"post_list":{"title":"Letzte Beiträge","empty":"Es gibt keine Beiträge","aria_post_number":"%{title} – Beitrag #%{postNumber}"},"post":{"confirm_delete":"Möchtest du wirklich diesen Beitrag löschen?","quote_reply":"Zitieren","quote_reply_shortcut":"Zitieren (oder q drücken)","quote_edit":"Bearbeiten","quote_edit_shortcut":"Bearbeiten (oder e drücken)","quote_copy":"Zitat kopieren","quote_copied_to_clibboard":"Zitat in die Zwischenablage kopiert","quote_share":"Teilen","edit_reason":"Grund: ","post_number":"Beitrag %{number}","ignored":"Ignorierter Inhalt","wiki_last_edited_on":"Wiki zuletzt bearbeitet am %{dateTime}","last_edited_on":"Beitrag zuletzt bearbeitet am %{dateTime}","edit_history":"Beitragsbearbeitungsverlauf","reply_as_new_topic":"Mit verknüpftem Thema antworten","reply_as_new_private_message":"Antworte als neue Nachricht an die gleichen Empfänger","continue_discussion":"Fortsetzung der Diskussion von %{postLink}:","follow_quote":"springe zum zitierten Beitrag","show_full":"Zeige ganzen Beitrag","show_hidden":"Ignorierte Inhalte anzeigen.","deleted_by_author_simple":"(Beitrag vom Verfasser gelöscht)","collapse":"zuklappen","load_more_replies":"weitere Antworten laden","sr_collapse_replies":"Eingebettete Antworten einklappen","sr_load_more_replies":"Weitere eingebettete Antworten laden","sr_date":"Beitragsdatum","sr_expand_replies":{"one":"Dieser Beitrag hat %{count} Antwort","other":"Dieser Beitrag hat %{count} Antworten"},"expand_collapse":"erweitern/zuklappen","sr_below_embedded_posts_description":"Beitrag #%{post_number} Antworten","sr_embedded_reply_description":"Antwort von @%{username} auf Beitrag #%{post_number}","locked":"ein Team-Mitglied hat diesen Beitrag für die weitere Bearbeitung gesperrt","gap":{"one":"%{count} versteckten Beitrag anzeigen","other":"%{count} versteckte Beiträge anzeigen"},"sr_reply_to":"Antworte auf Beitrag #%{post_number} von @%{username}","link_clicked":{"one":"Link %{count} Mal angeklickt","other":"Link %{count} Mal angeklickt"},"notice":{"new_user":"Dies ist der erste Beitrag von %{user} – lasst uns das neue Mitglied in unserer Community willkommen heißen!","returning_user":"Es ist eine Weile her, dass wir %{user} gesehen haben – der letzte Beitrag war %{time}.","custom_created_by":"(hinzugefügt von %{userLinkHTML})"},"unread":"Beitrag ist ungelesen","has_replies":{"one":"%{count} Antwort","other":"%{count} Antworten"},"has_replies_count":"%{count}","unknown_user":"(unbekannter/gelöschter Benutzer)","has_likes_title":{"one":"dieser Beitrag gefällt %{count} Person","other":"dieser Beitrag gefällt %{count} Personen"},"has_likes_title_only_you":"dir gefällt dieser Beitrag","has_likes_title_you":{"one":"dir und %{count} weiteren Person gefällt dieser Beitrag","other":"dir und %{count} weiteren Personen gefällt dieser Beitrag"},"sr_post_like_count_button":{"one":"%{count} Person gefällt dieser Beitrag. Zum Anzeigen klicken","other":"%{count} Personen gefällt dieser Beitrag. Zum Anzeigen klicken"},"sr_post_read_count_button":{"one":"%{count} Person hat diesen Beitrag gelesen. Zum Anzeigen klicken","other":"%{count} Personen haben diesen Beitrag gelesen. Zum Anzeigen klicken"},"filtered_replies_hint":{"one":"Diesen Beitrag und seine Antwort ansehen","other":"Diesen Beitrag und seine %{count} Antworten ansehen"},"filtered_replies_viewing":{"one":"Zeige %{count} Antwort an","other":"Zeige %{count} Antworten an"},"in_reply_to":"Übergeordneten Beitrag laden","view_all_posts":"Alle Beiträge anzeigen","badge_granted_tooltip":"%{username} hat für diesen Beitrag das Abzeichen „%{badge_name}“ erhalten!","errors":{"create":"Entschuldige, es gab einen Fehler beim Anlegen des Beitrags. Bitte versuche es noch einmal.","edit":"Entschuldige, es gab einen Fehler beim Bearbeiten des Beitrags. Bitte versuche es noch einmal.","upload":"Entschuldige, beim Hochladen von %{file_name} ist leider ein Fehler aufgetreten. Bitte versuche es noch einmal.","backup_too_large":"Leider ist die Backup-Datei zu groß.","file_too_large":"Entschuldige, die Datei ist zu groß (die maximale Größe beträgt %{max_size_kb} KB). Wie wäre es, die Datei bei einem Cloud-Sharing-Service hochzuladen und dann den Link einzufügen?","file_size_zero":"Entschuldigung, es sieht so aus, als ob etwas schiefgelaufen ist. Die Datei, die du hochladen möchtest, ist 0 Byte groß. Bitte versuche es erneut.","file_too_large_humanized":"Entschuldigung, diese Datei ist zu groß (die maximale Größe beträgt %{max_size}). Lade deine große Datei bitte bei einem Cloud-Sharing-Dienst hoch und füge den Link ein.","too_many_uploads":"Entschuldige, du darfst immer nur eine Datei hochladen.","too_many_dragged_and_dropped_files":{"one":"Es kann leider nur %{count} Datei gleichzeitig hochgeladen werden.","other":"Es können leider nur %{count} Dateien gleichzeitig hochgeladen werden."},"upload_not_authorized":"Entschuldige, die Datei, die du hochladen möchtest, ist nicht erlaubt (erlaubte Dateiendungen sind: %{authorized_extensions}).","no_uploads_authorized":"Es dürfen keine Dateien hochgeladen werden.","image_upload_not_allowed_for_new_user":"Entschuldige, neue Benutzer dürfen keine Bilder hochladen.","attachment_upload_not_allowed_for_new_user":"Entschuldige, neue Benutzer dürfen keine Anhänge hochladen.","attachment_download_requires_login":"Entschuldige, du musst angemeldet sein, um Anhänge herunterladen zu können."},"cancel_composer":{"confirm":"Was würdest du gerne mit deinem Beitrag machen?","discard":"Verwerfen","save_draft":"Entwurf für später speichern","keep_editing":"Weiter bearbeiten"},"via_email":"dieser Beitrag ist per E-Mail eingetroffen","via_auto_generated_email":"dieser Beitrag ist per automatisch generierter E-Mail eingegangen","whisper":"dies ist ein privater geflüsterter Beitrag für Moderatoren","whisper_groups":"dieser Beitrag ist ein privater geflüsterter Beitrag, der nur für %{groupNames} sichtbar ist","wiki":{"about":"dieser Beitrag ist ein Wiki"},"few_likes_left":"Danke fürs Teilen der Liebe! Du hast für heute nur noch wenige „Gefällt mir“ übrig.","controls":{"reply":"verfasse eine Antwort auf diesen Beitrag","like_action":"Gefällt mir","like":"dieser Beitrag gefällt mir","has_liked":"dir gefällt dieser Beitrag","read_indicator":"Mitglieder, die diesen Beitrag gelesen haben","undo_like_action":"Gefällt mir nicht mehr","undo_like":"gefällt mir nicht mehr","edit":"diesen Beitrag bearbeiten","edit_action":"Bearbeiten","edit_anonymous":"Entschuldige, du musst angemeldet sein, um diesen Beitrag zu bearbeiten.","flag_action":"Melden","flag":"diesen Beitrag privat melden oder eine persönliche Nachricht dazu versenden","anonymous_flag":"Sende eine E-Mail ans Team, um diesen Beitrag zu melden","delete_action":"Beitrag löschen","delete":"diesen Beitrag löschen","undelete_action":"Beitrag wiederherstellen","undelete":"diesen Beitrag wiederherstellen","share_action":"Teilen","share":"Link zu diesem Beitrag teilen","copy_action":"Link kopieren","copy_title":"kopiere einen Link zu diesem Beitrag in die Zwischenablage","link_copied":"Link kopiert!","more":"Mehr","delete_replies":{"confirm":"Möchtest du auch die Antworten auf diesen Beitrag löschen?","direct_replies":{"one":"Ja und %{count} direkte Antwort","other":"Ja und %{count} direkte Antworten"},"all_replies":{"one":"Ja und %{count} Antwort","other":"Ja und alle %{count} Antworten"},"just_the_post":"Nein, nur diesen Beitrag"},"admin":"Administrative Aktionen","admin_action":"Admin-Panel","permanently_delete":"Endgültig löschen","permanently_delete_confirmation":"Bist du sicher, dass du diesen Beitrag endgültig löschen möchtest? Du kannst ihn nicht wiederherstellen.","wiki":"Wiki erstellen","unwiki":"Wiki entfernen","convert_to_moderator":"Team-Einfärbung hinzufügen","revert_to_regular":"Team-Einfärbung entfernen","rebake":"HTML erneuern","publish_page":"Als Seite veröffentlichen","unhide":"Einblenden","change_owner":"Eigentümer ändern …","grant_badge":"Abzeichen verleihen …","lock_post":"Beitrag sperren","lock_post_description":"verhindern, dass der Autor den Beitrag bearbeitet","unlock_post":"Beitrag entsperren","unlock_post_description":"erlauben, dass der Autor den Beitrag bearbeitet","delete_topic_disallowed_modal":"Du hast keine Berechtigung, dieses Thema zu löschen. Wenn du wirklich möchtest, dass es gelöscht wird, melde es mit einer Begründung, um einen Moderator darauf aufmerksam zu machen.","delete_topic_disallowed":"du hast keine Berechtigung, dieses Thema zu löschen","delete_topic_confirm_modal":{"one":"Dieses Thema hat derzeit mehr als %{count} Aufruf und kann ein beliebtes Suchziel sein. Bist du sicher, dass du dieses Thema komplett löschen möchtest, anstatt es zu bearbeiten, um es zu verbessern?","other":"Dieses Thema hat derzeit mehr als %{count} Aufrufe und kann ein beliebtes Suchziel sein. Bist du sicher, dass du dieses Thema komplett löschen möchtest, anstatt es zu bearbeiten, um es zu verbessern?"},"delete_topic_confirm_modal_yes":"Ja, dieses Thema löschen","delete_topic_confirm_modal_no":"Nein, dieses Thema behalten","delete_topic_error":"Beim Löschen dieses Themas ist ein Fehler aufgetreten","delete_topic":"Thema löschen","add_post_notice":"Offizielle Mitteilung hinzufügen …","change_post_notice":"Offizielle Mitteilung ändern …","delete_post_notice":"Offizielle Mitteilung löschen","remove_timer":"Zeitschaltuhr deaktivieren","edit_timer":"Zeitschaltuhr bearbeiten"},"actions":{"people":{"like":{"one":"gefällt dies","other":"gefällt dies"},"read":{"one":"hat dies gelesen","other":"hat dies gelesen"},"like_capped":{"one":"und %{count} anderen gefällt das","other":"und %{count} anderen gefällt das"},"read_capped":{"one":"and %{count} anderer haben dies gelesen","other":"und %{count} andere haben dies gelesen"},"sr_post_likers_list_description":"Benutzer, denen dieser Beitrag gefällt","sr_post_readers_list_description":"Benutzer, die diesen Beitrag gelesen haben"},"by_you":{"off_topic":"Du hast das als „am Thema vorbei“ gemeldet","spam":"Du hast das als Spam gemeldet","inappropriate":"Du hast das als „unangemessen“ gemeldet","illegal":"Du hast dies als rechtswidrig gemeldet","notify_moderators":"Du hast dies den Moderatoren gemeldet","notify_user":"Du hast diesem Benutzer eine Nachricht gesendet","custom":"Du hast dieses Thema als %{custom} gemeldet"}},"delete":{"confirm":{"one":"Möchtest du wirklich diesen Beitrag löschen?","other":"Möchtest du wirklich diese %{count} Beiträge löschen?"}},"merge":{"confirm":{"one":"Möchtest du diese Beiträge wirklich zusammenführen?","other":"Möchtest du diese %{count} Beiträge wirklich zusammenführen?"}},"revisions":{"controls":{"first":"Erste Überarbeitung","previous":"Vorherige Überarbeitung","next":"Nächste Überarbeitung","last":"Letzte Überarbeitung","hide":"Überarbeitung verstecken","show":"Überarbeitung anzeigen","destroy":"Revisionen löschen","destroy_confirm":"Bist du sicher, dass du alle Revisionen dieses Beitrags löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden.","revert":"Auf Überarbeitung %{revision} zurücksetzen","edit_wiki":"Wiki bearbeiten","edit_post":"Beitrag bearbeiten","comparing_previous_to_current_out_of_total":"\u003cstrong\u003e%{previous}\u003c/strong\u003e %{icon} \u003cstrong\u003e%{current}\u003c/strong\u003e / %{total}"},"displays":{"inline":{"title":"Zeige die Änderungen inline an","button":"HTML"},"side_by_side":{"title":"Zeige die Änderungen nebeneinander an","button":"HTML"},"side_by_side_markdown":{"title":"Zeige die Quelltexte zum Vergleich nebeneinander an","button":"Quelltext"}}},"raw_email":{"displays":{"raw":{"title":"Zeige den Quelltext der E-Mail","button":"Quelltext"},"text_part":{"title":"Zeige den Text-Teil der E-Mail","button":"Text"},"html_part":{"title":"Zeige den HTML-Teil der E-Mail","button":"HTML"}}},"bookmarks":{"create":"Lesezeichen erstellen","create_for_topic":"Lesezeichen für Thema erstellen","edit":"Lesezeichen bearbeiten","edit_for_topic":"Lesezeichen für Thema bearbeiten","updated":"Aktualisiert","name":"Name","name_placeholder":"Wofür dient dieses Lesezeichen?","name_input_label":"Name des Lesezeichens","set_reminder":"Erinnere mich","options":"Optionen","actions":{"delete_bookmark":{"name":"Lesezeichen löschen","description":"Entfernt das Lesezeichen aus deinem Profil und stoppt alle Erinnerungen für dieses Lesezeichen."},"edit_bookmark":{"name":"Lesezeichen bearbeiten","description":"Ändere den Namen des Lesezeichens oder den Erinnerungszeitpunkt."},"clear_bookmark_reminder":{"name":"Erinnerung löschen","description":"Datum und Uhrzeit der Erinnerung löschen"},"pin_bookmark":{"name":"Lesezeichen anheften","description":"Das Lesezeichen anheften, damit es oben auf der Liste der Lesezeichen erscheint."},"unpin_bookmark":{"name":"Lesezeichen loslösen","description":"Löse das Lesezeichen los. Es wird nicht mehr oben in deiner Lesezeichenliste angezeigt."}}},"filtered_replies":{"viewing_posts_by":"Zeige %{post_count} Beiträge von","viewing_subset":"Einige Antworten sind reduziert","viewing_summary":"Anzeige der Top-Antworten zu diesem Thema","post_number":"%{username}, Beitrag #%{post_number}","show_all":"Alle anzeigen"},"share":{"title":"Beitrag #%{post_number} teilen","instructions":"Link zu diesem Beitrag teilen:"}},"category":{"none":"(keine Kategorie)","all":"Alle Kategorien","choose":"Kategorie \u0026hellip;","edit":"Bearbeiten","edit_title":"Diese Kategorie bearbeiten","edit_dialog_title":"Bearbeiten: %{categoryName}","view":"Zeige Themen in Kategorie","back":"Zurück zur Kategorie","general":"Allgemeines","settings":"Einstellungen","topic_template":"Vorlage","tags":"Schlagwörter","tags_allowed_tags":"Schlagwörter auf diese Kategorie einschränken:","tags_allowed_tag_groups":"Schlagwortgruppen auf diese Kategorie einschränken:","tags_placeholder":"(Optional) Liste erlaubter Schlagwörter","tags_tab_description":"Die oben spezifizierten Schlagwörter und Schlagwortgruppen werden nur in dieser Kategorie und anderen Kategorien, für die sie ebenfalls spezifiziert sind, verfügbar sein. Darüber hinaus werden sie nicht in weiteren Kategorien verwendbar sein.","tag_groups_placeholder":"(Optional) Liste erlaubter Schlagwortgruppen","manage_tag_groups_link":"Schlagwortgruppen verwalten","allow_global_tags_label":"Erlaube auch andere Schlagwörter.","required_tag_group":{"description":"Neue Themen müssen Schlagwörter aus Schlagwortgruppen haben:","delete":"Löschen","add":"Erforderliche Schlagwortgruppe hinzufügen","placeholder":"Schlagwortgruppe auswählen …"},"topic_featured_link_allowed":"Erlaube hervorgehobene Links in dieser Kategorie","delete":"Kategorie löschen","create":"Neue Kategorie","create_long":"Eine neue Kategorie erstellen","save":"Kategorie speichern","slug":"Sprechender Name für URL der Kategorie","slug_placeholder":"(Optional) durch Bindestrich getrennte Wörter für URL","creation_error":"Beim Erstellen der Kategorie ist ein Fehler aufgetreten.","save_error":"Beim Speichern der Kategorie ist ein Fehler aufgetreten.","name":"Name der Kategorie","description":"Beschreibung","logo":"Logo für Kategorie","logo_dark":"Logobild der Kategorie „Dunkler Modus“","background_image":"Hintergrundbild für Kategorie","background_image_dark":"Dunkles Kategorie-Hintergrundbild","badge_colors":"Farben des Abzeichens","background_color":"Hintergrundfarbe","foreground_color":"Vordergrundfarbe","color_used":"Verwendete Farbe","predefined_colors":"Vordefinierte Farboptionen","name_placeholder":"Ein oder maximal zwei Wörter","color_placeholder":"Beliebige Web-Farbe","delete_confirm":"Möchtest du wirklich diese Kategorie löschen?","delete_error":"Beim Löschen der Kategorie ist ein Fehler aufgetreten.","list":"Kategorien auflisten","no_description":"Bitte füge eine Beschreibung für diese Kategorie hinzu.","change_in_category_topic":"Beschreibung bearbeiten","already_used":"Diese Farbe wird bereits für eine andere Kategorie verwendet.","security":"Sicherheit","security_add_group":"Eine Gruppe hinzufügen","permissions":{"group":"Gruppe","see":"Ansehen","reply":"Antworten","create":"Erstellen","no_groups_selected":"Es wurde keinen Gruppen Zugriff gewährt. Diese Kategorie ist nur für das Team sichtbar.","everyone_has_access":"Diese Kategorie ist öffentlich, jeder kann Beiträge sehen, beantworten und erstellen. Entferne eine oder mehrere der Berechtigungen, die der Gruppe „Jeder“ erteilt wurden, um die Berechtigungen einzuschränken.","toggle_reply":"Antwortberechtigung umschalten","toggle_full":"Erstellungsberechtigung umschalten","inherited":"Diese Berechtigung wird von „Jeder“ vererbt"},"special_warning":"Warnung: Diese Kategorie wurde bei der Installation angelegt. Die Sicherheitseinstellungen können daher nicht verändert werden. Wenn du diese Kategorie nicht benötigst, dann solltest du sie löschen, anstatt sie für andere Zwecke zu verwenden.","uncategorized_security_warning":"Diese Kategorie ist etwas Spezielles. Sie dient als Bereich für Themen, die keine Kategorie haben und besitzt keine Sicherheitseinstellungen.","uncategorized_general_warning":"Diese Kategorie ist etwas Spezielles. Sie wird als Standard-Kategorie für neue Themen genutzt, für die keine Kategorie ausgewählt wurde. Deaktiviere \u003ca href=\"%{settingLink}\"\u003ediese Einstellung\u003c/a\u003e, wenn dieses Verhalten verhindert und eine Kategoriewahl erzwungen werden soll. Der Name und die Beschreibung können unter \u003ca href=\"%{customizeLink}\"\u003eAnpassen/Textinhalte\u003c/a\u003e geändert werden.","pending_permission_change_alert":"Du hast %{group} nicht zu dieser Kategorie hinzugefügt; klicke diese Schaltfläche, um sie zuzufügen.","images":"Bilder","email_in":"Benutzerdefinierte Adresse für eingehende E-Mails:","email_in_tooltip":"Du kannst mehrere E-Mail-Adressen mit dem Zeichen | trennen.","email_in_allow_strangers":"Akzeptiere E-Mails von anonymen Benutzern.","email_in_disabled":"Das Veröffentlichen neuer Themen per E-Mail ist deaktiviert. Um das Veröffentlichen neuer Themen per E-Mail zu ermöglichen, aktiviere die Einstellung \u003ca href='%{setting_url}'\u003e„email in“\u003c/a\u003e.","mailinglist_mirror":"Kategorie spiegelt eine Mailingliste","show_subcategory_list":"Zeige Liste von Unterkategorien oberhalb von Themen in dieser Kategorie.","read_only_banner":"Bannertext, wenn ein Benutzer kein Thema in dieser Kategorie erstellen kann:","num_featured_topics":"Anzahl der Themen, die auf der Kategorien-Seite angezeigt werden:","subcategory_num_featured_topics":"Anzahl der hervorgehobenen Themen, die auf der Seite der übergeordneten Kategorie angezeigt werden:","all_topics_wiki":"Mache neue Themen standardmäßig zu Wikis.","allow_unlimited_owner_edits_on_first_post":"Erlaube unbegrenzte Änderungen des Eigentümers am ersten Beitrag","subcategory_list_style":"Listenstil für Unterkategorien:","sort_order":"Themenliste sortieren nach:","default_view":"Standard-Themenliste:","default_top_period":"Standard-Zeitraum für angesagte Themen:","default_list_filter":"Standard-Listenfilter:","allow_badges_label":"Erlaube das Verleihen von Abzeichen in dieser Kategorie.","edit_permissions":"Berechtigungen bearbeiten","reviewable_by_group":"Zusätzlich zum Team können Inhalte in dieser Kategorie auch überprüft werden von:","review_group_name":"Gruppenname","require_topic_approval":"Erfordere Moderator-Genehmigung für alle neuen Themen","require_reply_approval":"Erfordere Moderator-Genehmigung für alle neuen Antworten","this_year":"dieses Jahr","position":"Position auf der Kategorien-Seite:","default_position":"Standardposition","position_disabled":"Die Kategorien werden in der Reihenfolge ihrer Aktivität angezeigt. Um die Reihenfolge der Kategorien in den Listen zu kontrollieren, aktiviere die Einstellung \u003ca href='%{url}'\u003e„fixed category positions“\u003c/a\u003e.","minimum_required_tags":"Mindestanzahl an Schlagwörtern, die ein Thema erfordert","default_slow_mode":"„Langsamer Modus“ für neue Themen in dieser Kategorie aktivieren.","parent":"Übergeordnete Kategorie","num_auto_bump_daily":"Anzahl der offenen Themen, die automatisch täglich nach oben verschoben werden:","auto_bump_cooldown_days":"Mindestanzahl an Tagen, bevor das gleiche Thema erneut angesprochen wird:","navigate_to_first_post_after_read":"Gehe zum ersten Beitrag, nachdem Themen gelesen wurden","notifications":{"title":"Benachrichtigungsstufe für diese Kategorie ändern","watching":{"title":"Beobachten","description":"Du wirst automatisch alle Themen in dieser Kategorie beobachten. Du wirst über alle neuen Beiträge in allen Themen benachrichtigt und die Anzahl der neuen Antworten wird angezeigt."},"watching_first_post":{"title":"Ersten Beitrag beobachten","description":"Du wirst über neue Themen in dieser Kategorie benachrichtigt, aber nicht über Antworten auf diese Themen."},"tracking":{"title":"Verfolgen","description":"Du wirst automatisch alle Themen in dieser Kategorie verfolgen. Du wirst benachrichtigt, wenn jemand deinen Namen mit @ erwähnt oder dir antwortet, und die Anzahl der neuen Antworten wird angezeigt."},"regular":{"title":"Normal","description":"Du wirst benachrichtigt, wenn jemand deinen Namen mit @ erwähnt oder auf deinen Beitrag antwortet."},"muted":{"title":"Stummgeschaltet","description":"Du erhältst nie mehr Benachrichtigungen über neue Themen in dieser Kategorie und die Themen werden auch nicht in der Liste der aktuellen Themen erscheinen."}},"search_priority":{"label":"Suchpriorität","options":{"normal":"Normal","ignore":"Ignorieren","very_low":"Sehr niedrig","low":"Niedrig","high":"Hoch","very_high":"Sehr hoch"}},"sort_options":{"default":"Standard","likes":"„Gefällt mir“","op_likes":"„Gefällt mir“ des Originalbeitrags","views":"Aufrufe","posts":"Beiträge","activity":"Aktivität","posters":"Beitragende","category":"Kategorie","created":"Erstellt","votes":"Stimmen"},"sort_ascending":"Aufsteigend","sort_descending":"Absteigend","subcategory_list_styles":{"rows":"Zeilen","rows_with_featured_topics":"Zeilen mit hervorgehobenen Themen","boxes":"Boxen","boxes_with_featured_topics":"Boxen mit hervorgehobenen Themen"},"settings_sections":{"general":"Allgemein","moderation":"Moderation","appearance":"Erscheinungsbild","email":"E-Mail"},"list_filters":{"all":"alle Themen","none":"keine Unterkategorien"},"colors_disabled":"Du kannst keine Farben auswählen, weil du den „category style“ „none“ verwendest."},"anonymous_flagging":{"title":"Illegale Inhalte melden","description":"Um illegale Inhalte zu melden, wende dich bitte an \u003ca href='mailto:%{email}?subject=Illegaler Inhalt: %{topic_title}\u0026body=Dieser Beitrag %{url} enthält illegalen Inhalt.'\u003e%{email}\u003c/a\u003e"},"flagging":{"title":"Danke für deine Mithilfe!","action":"Beitrag melden","take_action":"Reagieren …","take_action_options":{"default":{"title":"Beitrag verstecken","details":"Erreiche die Meldungsschwelle sofort, verstecke den Beitrag und stimme allen ausstehenden Meldungen zu"},"suspend":{"title":"Benutzer sperren","details":"Erreiche den Meldungsschwellenwert und sperre den Benutzer"},"silence":{"title":"Benutzer stummschalten","details":"Erreiche den Meldungsschwellenwert und schalte den Benutzer stumm"}},"notify_action":"Nachricht","official_warning":"Offizielle Warnung","delete_spammer":"Spammer löschen","flag_for_review":"Zur Überprüfung einreihen","yes_delete_spammer":"Ja, lösche den Spammer","ip_address_missing":"(nicht verfügbar)","hidden_email_address":"(versteckt)","submit_tooltip":"Private Meldung abschicken","take_action_tooltip":"Erreiche die Meldungsschwelle sofort, verstecke den Beitrag und stimme allen ausstehenden Meldungen zu","cant":"Entschuldige, du kannst diesen Beitrag derzeit nicht melden.","notify_staff":"Team privat benachrichtigen","formatted_name":{"off_topic":"Am Thema vorbei","inappropriate":"Unangemessen","spam":"Spam","illegal":"Es ist rechtswidrig"},"custom_placeholder_notify_user":"Sei konkret, konstruktiv und immer freundlich.","notify_user_textarea_label":"Nachricht für den Benutzer","custom_placeholder_notify_moderators":"Bitte lass uns wissen, was genau dich beunruhigt. Verweise, wenn möglich, auf relevante Links und Beispiele.","notify_moderators_textarea_label":"Nachricht für die Moderatoren","custom_placeholder_illegal":"Teile uns mit, warum du glaubst, dass dieser Inhalt rechtswidrig ist, und gib, wenn möglich, relevante Links und Beispiele an.","confirmation_illegal":"Was ich oben geschrieben habe, ist richtig und vollständig.","custom_message":{"at_least":{"one":"gib mindestens %{count} Zeichen ein","other":"gib mindestens %{count} Zeichen ein"},"more":{"one":"%{count} weitere …","other":"%{count} weitere …"},"left":{"one":"%{count} übrig","other":"%{count} übrig"}}},"flagging_topic":{"title":"Danke für deine Mithilfe!","action":"Thema melden","notify_action":"Nachricht"},"topic_map":{"title":"Zusammenfassung des Themas","participants_title":"Autoren vieler Beiträge","links_title":"Beliebte Links","links_shown":"mehr Links anzeigen …","clicks":{"one":"%{count} Klick","other":"%{count} Klicks"},"menu_titles":{"replies":"Antworten mit den meisten „Gefällt mir“","views":"Aktuelle Aufrufe"},"view_explainer":"Ein Aufruf pro eindeutigem Besucher alle 8 Stunden.","no_views":"Noch keine Aufrufstatistiken, schau später wieder vorbei.","chart_error":"Fehler beim Rendern des Diagramms, bitte versuche es erneut.","views":"Aufrufe","predicted_views":"Prognostizierte Aufrufe","so_far":"(bis jetzt)","read":"lesen","minutes":"min."},"post_links":{"about":"weitere Links für diesen Beitrag aufklappen","title":{"one":"%{count} weiterer","other":"%{count} weitere"}},"topic_statuses":{"warning":{"help":"Dies ist eine offizielle Warnung."},"bookmarked":{"help":"Du hast dieses Thema mit einem Lesezeichen versehen."},"locked":{"help":"Dieses Thema ist geschlossen. Das Antworten ist nicht mehr möglich."},"archived":{"help":"Dieses Thema ist archiviert; es ist eingefroren und kann nicht mehr geändert werden"},"locked_and_archived":{"help":"Dieses Thema ist geschlossen. Das Antworten oder das Bearbeiten ist nicht mehr möglich."},"unpinned":{"title":"Losgelöst","help":"Dieses Thema ist für dich losgelöst; es wird in der normalen Reihenfolge angezeigt"},"pinned_globally":{"title":"Global angeheftet","help":"Dieses Thema ist global angeheftet; es wird immer am Anfang der Liste der aktuellen Themen und in seiner Kategorie auftauchen"},"pinned":{"title":"Angeheftet","help":"Dieses Thema ist für dich angeheftet; es wird immer am Anfang seiner Kategorie auftauchen"},"unlisted":{"help":"Dieses Thema ist unsichtbar. Es wird in keiner Themenliste angezeigt und kann nur mit einem direkten Link betrachtet werden. %{unlistedReason}"},"personal_message":{"title":"Dieses Thema ist eine persönliche Nachricht","help":"Dieses Thema ist eine persönliche Nachricht"},"visibility_reasons":{"op_flag_threshold_reached":"Dieses Thema wurde automatisch unsichtbar gemacht, weil es die Meldungsschwelle erreicht hat","op_unhidden":"Dieses Thema wurde vom Verfasser wieder sichtbar gemacht","embedded_topic":"Dieses Thema wurde wieder sichtbar gemacht, weil es ein eingebettetes Thema ist","manually_unlisted":"Dieses Thema wurde manuell von einem Administrator oder Moderator unsichtbar gemacht","manually_relisted":"Dieses Thema wurde manuell von einem Administrator oder Moderator wieder sichtbar gemacht","bulk_action":"Die Sichtbarkeit dieses Themas wurde aufgrund einer Massenoperation eines Benutzers geändert"},"chat":{"help":"Der Chat ist für dieses Thema aktiviert"}},"posts":"Beiträge","pending_posts":{"label":"Ausstehend","label_with_count":"Ausstehend (%{count})"},"sr_topic_list_caption":"Themenliste, Spaltenüberschriften mit Schaltflächen sind sortierbar.","posters":"Beitragende","latest_poster_link":"Profil von %{username}, neuester Beitragender","original_post":"Original-Beitrag","views":"Aufrufe","views_lowercase":{"one":"Aufruf","other":"Aufrufe"},"replies":"Antworten","views_long":{"one":"dieses Thema wurde %{count}-mal betrachtet","other":"dieses Thema wurde %{count}-mal betrachtet"},"activity":"Aktivität","likes":"„Gefällt mir“","likes_lowercase":{"one":"„Gefällt mir“","other":"„Gefällt mir“"},"users":"Benutzer","users_lowercase":{"one":"Benutzer","other":"Benutzer"},"category_title":"Kategorie","history_capped_revisions":"Verlauf, letzte 100 Überarbeitungen","history":"Verlauf","raw_email":{"title":"Eingegangene E-Mail","not_available":"Nicht verfügbar!"},"categories_list":"Liste der Kategorien","filters":{"with_topics":"%{filter}","with_category":"%{filter} in %{category}","filter":{"title":"Gefilterte Ergebnisse für %{filter}","button":{"label":"Filter"}},"latest":{"title":"Aktuell","title_with_count":{"one":"Aktuell (%{count})","other":"Aktuell (%{count})"},"help":"Themen mit aktuellen Beiträgen"},"read":{"title":"Gelesen","help":"Themen, die du gelesen hast; werden in der Reihenfolge angezeigt, in der du diese gelesen hast"},"categories":{"title":"Kategorien","title_in":"Kategorie – %{categoryName}","help":"alle Themen, gruppiert nach Kategorie"},"unread":{"title":"Ungelesen","title_with_count":{"one":"Ungelesen (%{count})","other":"Ungelesen (%{count})"},"help":"Themen mit ungelesenen Beiträgen, die du derzeit beobachtest oder verfolgst","lower_title_with_count":{"one":"%{count} ungelesenes","other":"%{count} ungelesene"}},"unseen":{"title":"Ungesehen","lower_title":"ungesehen","help":"neue Themen und Themen mit ungelesenen Beiträgen, die du derzeit beobachtest oder verfolgst"},"hot":{"title":"Heiß","lower_title":"heiß","help":"aktuelle Top-Themen"},"new":{"lower_title_with_count":{"one":"%{count} neues","other":"%{count} neue"},"lower_title":"neu","title":"Neu","title_with_count":{"one":"Neu (%{count})","other":"Neu (%{count})"},"help":"Themen, die in den letzten paar Tagen erstellt wurden","all":"Alle","all_with_count":"Alle (%{count})","topics":"Themen","topics_with_count":"Themen (%{count})","replies":"Antworten","replies_with_count":"Antworten (%{count})"},"posted":{"title":"Meine Beiträge","help":"Themen, zu denen du beigetragen hast"},"bookmarks":{"title":"Lesezeichen","help":"Themen, die du mit einem Lesezeichen versehen hast."},"category":{"title":"%{categoryName}","title_with_count":{"one":"%{categoryName} (%{count})","other":"%{categoryName} (%{count})"},"help":"aktuelle Themen in der Kategorie %{categoryName}"},"top":{"title":"Angesagt","help":"die aktivsten Themen in diesem Jahr, in diesem Monat, in dieser Woche und heute","all":{"title":"Gesamt"},"yearly":{"title":"Jährlich"},"quarterly":{"title":"Vierteljährlich"},"monthly":{"title":"Monatlich"},"weekly":{"title":"Wöchentlich"},"daily":{"title":"Täglich"},"all_time":"Gesamt","this_year":"Jahr","this_quarter":"Quartal","this_month":"Monat","this_week":"Woche","today":"Heute"},"votes":{"title":"Stimmen","help":"Themen mit den meisten Stimmen"},"my_votes":{"title":"Meine Stimmen","help":"Themen, über die du abgestimmt hast"}},"custom_homepage":{"admin_message":"Eines deiner Themes hat den Modifikator \"custom_homepage\" aktiviert, aber es gibt nichts im [custom-homepage]-Connector aus. (Diese Meldung wird nur für Website-Administratoren angezeigt.)"},"browser_update":"Leider wird \u003ca href=\"https://www.discourse.org/faq/#browser\"\u003edein Browser nicht unterstützt\u003c/a\u003e. Bitte \u003ca href=\"https://browsehappy.com\"\u003ewechsle zu einem unterstützten Browser\u003c/a\u003e, um die Inhalte in vollem Umfang zu sehen, dich anzumelden und zu antworten.","permission_types":{"full":"Erstellen/Antworten/Ansehen","create_post":"Antworten/Ansehen","readonly":"Ansehen"},"preloader_text":"Wird geladen","lightbox":{"download":"herunterladen","open":"Originalbild","previous":"Zurück (linke Pfeiltaste)","next":"Weiter (rechte Pfeiltaste)","counter":"%curr% von %total%","close":"Schließen (Esc)","content_load_error":"\u003ca href=\"%url%\"\u003eDer Inhalt\u003c/a\u003e konnte nicht geladen werden.","image_load_error":"\u003ca href=\"%url%\"\u003eDas Bild\u003c/a\u003e konnte nicht geladen werden."},"cannot_render_video":"Dieses Video kann nicht gerendert werden, da dein Browser den Codec nicht unterstützt.","invalid_video_url":"Dieses Video kann nicht abgespielt werden, da die URL ungültig oder nicht verfügbar ist.","keyboard_shortcuts_help":{"shortcut_key_delimiter_comma":", ","shortcut_key_delimiter_plus":"+","shortcut_delimiter_or":"%{shortcut1} oder %{shortcut2}","shortcut_delimiter_slash":"%{shortcut1}/%{shortcut2}","shortcut_delimiter_space":"%{shortcut1} %{shortcut2}","shortcut_delimiter_newline":"%{shortcut1}\u003cbr\u003e%{shortcut2}","title":"Tastenkombinationen","short_title":"Tastenkombinationen","jump_to":{"title":"Springe zu","home":"%{shortcut} Startseite","latest":"%{shortcut} Neueste Beiträge","new":"%{shortcut} Neue Beiträge","unread":"%{shortcut} Ungelesene Beiträge","categories":"%{shortcut} Kategorien","top":"%{shortcut} Top-Beiträge","bookmarks":"%{shortcut} Lesezeichen","profile":"%{shortcut} Profil","messages":"%{shortcut} Nachrichten","drafts":"%{shortcut} Entwürfe","next":"%{shortcut} Nächstes Thema","previous":"%{shortcut} Vorheriges Thema"},"navigation":{"title":"Navigation","jump":"%{shortcut} Springe zu Beitrag #","back":"%{shortcut} Zurück","up_down":"%{shortcut} Auswahl bewegen \u0026uarr; \u0026darr;","open":"%{shortcut} Ausgewähltes Thema öffnen","next_prev":"%{shortcut} Nächster/Vorheriger Abschnitt","go_to_unread_post":"%{shortcut} Zum ersten ungelesenen Beitrag springen"},"application":{"title":"Anwendung","create":"%{shortcut} Neues Thema erstellen","notifications":"%{shortcut} Benachrichtigungen öffnen","hamburger_menu":"%{shortcut} Navigationsmenü öffnen","user_profile_menu":"%{shortcut} Benutzermenü öffnen","show_incoming_updated_topics":"%{shortcut} Aktualisierte Themen anzeigen","search":"%{shortcut} Suche","filter_sidebar":"%{shortcut} Seitenleiste filtern","help":"%{shortcut} Tastenkombinationen anzeigen","toggle_bulk_select":"%{shortcut} Massenauswahl umschalten","dismiss":"%{shortcut} Ausgewählte Themen verwerfen","x":"%{shortcut} Auswahl umschalten (im Massenauswahlmodus)","log_out":"%{shortcut} Abmelden"},"composing":{"title":"Schreiben","return":"%{shortcut} Zurück zum Editor","fullscreen":"%{shortcut} Vollbild-Editor","insert_current_time":"%{shortcut} Aktuelle Uhrzeit einfügen"},"bookmarks":{"title":"Lesezeichen setzen","enter":"%{shortcut} Speichern und schließen","later_today":"%{shortcut} Im Laufe des Tages","later_this_week":"%{shortcut} Später in dieser Woche","tomorrow":"%{shortcut} Morgen","next_week":"%{shortcut} Nächste Woche","next_month":"%{shortcut} Nächsten Monat","next_business_week":"%{shortcut} Anfang nächster Woche","next_business_day":"%{shortcut} Nächster Arbeitstag","custom":"%{shortcut} Datum und Uhrzeit auswählen","none":"%{shortcut} Keine Erinnerung","delete":"%{shortcut} Lesezeichen löschen"},"actions":{"title":"Aktionen","bookmark_topic":"%{shortcut} Lesezeichen hinzufügen/entfernen","pin_unpin_topic":"%{shortcut} Thema anheften/loslösen","share_topic":"%{shortcut} Thema teilen","share_post":"%{shortcut} Beitrag teilen","reply_as_new_topic":"%{shortcut} Mit verknüpftem Thema antworten","reply_topic":"%{shortcut} Auf Thema antworten","reply_post":"%{shortcut} Auf Beitrag antworten","quote_post":"%{shortcut} Beitrag zitieren","like":"%{shortcut} Beitrag mit „Gefällt mir“ markieren","flag":"%{shortcut} Beitrag melden","bookmark":"%{shortcut} Beitrag mit Lesezeichen versehen","edit":"%{shortcut} Beitrag bearbeiten","delete":"%{shortcut} Beitrag löschen","mark_muted":"%{shortcut} Thema stummschalten","mark_regular":"%{shortcut} Thema auf Normal (Standard) setzen","mark_tracking":"%{shortcut} Thema verfolgen","mark_watching":"%{shortcut} Thema beobachten","print":"%{shortcut} Thema ausdrucken","defer":"%{shortcut} Thema als ungelesen markieren","topic_admin_actions":"%{shortcut} Themen-Administration öffnen","archive_private_message":"%{shortcut} Persönliche Nachricht archivieren/entarchivieren"},"search_menu":{"title":"Suchmenü","prev_next":"%{shortcut} Auswahl bewegen ↑ ↓","insert_url":"%{shortcut} Auswahl in geöffneten Editor einfügen","full_page_search":"%{shortcut} Startet die Ganzseitensuche"},"chat":{"title":"Chat","keyboard_shortcuts":{"switch_channel_arrows":"%{shortcut} Kanal wechseln","switch__unread_channel_arrows":"%{shortcut} Ungelesenen Kanal wechseln","open_quick_channel_selector":"%{shortcut} Schnellauswahl für Kanäle öffnen","open_insert_link_modal":"%{shortcut} Hyperlink einfügen (nur Composer)","composer_bold":"%{shortcut} Fett (nur Composer)","composer_italic":"%{shortcut} Kursiv (nur Composer)","composer_code":"%{shortcut} Code (nur Composer)","drawer_open":"%{shortcut} Chat-Bereich öffnen","drawer_close":"%{shortcut} Chat-Bereich schließen","mark_all_channels_read":"%{shortcut} Alle Kanäle als gelesen markieren"}}},"badges":{"earned_n_times":{"one":"Abzeichen %{count}-mal erhalten","other":"Abzeichen %{count}-mal erhalten"},"granted_on":"Verliehen %{date}","others_count":{"one":"%{count} Mal an andere vergeben","other":"%{count} Mal an andere vergeben"},"title":"Abzeichen","allow_title":"Du kannst dieses Abzeichen als Titel verwenden","multiple_grant":"Du kannst dieses Abzeichen mehrmals verliehen bekommen","badge_count":{"one":"%{count} Abzeichen","other":"%{count} Abzeichen"},"more_badges":{"one":"+%{count} weiteres","other":"+%{count} weitere"},"awarded":{"one":"%{number} ausgezeichnet","other":"%{number} ausgezeichnet"},"select_badge_for_title":"Wähle ein Abzeichen als deinen Titel aus","none":"(keines)","successfully_granted":"%{badge} erfolgreich verliehen an %{username}","badge_grouping":{"getting_started":{"name":"Erste Schritte"},"community":{"name":"Community"},"trust_level":{"name":"Vertrauensstufe"},"other":{"name":"Andere"},"posting":{"name":"Schreiben"}},"favorite_max_reached":"Du kannst keine weiteren Abzeichen favorisieren.","favorite_max_not_reached":"Markiere dieses Abzeichen als Favorit","favorite_count":"%{count}/%{max} Abzeichen als Favorit markiert"},"download_calendar":{"title":"Kalender herunterladen","save_ics":".ics-Datei herunterladen","save_google":"Zum Google-Kalender hinzufügen","remember":"Nicht mehr fragen","remember_explanation":"(Du kannst diese Einstellung in deinen Benutzereinstellungen ändern)","download":"Herunterladen","default_calendar":"Standard-Kalender","default_calendar_instruction":"Lege fest, welcher Kalender verwendet werden soll, wenn Daten gespeichert werden","add_to_calendar":"Zum Kalender hinzufügen","google":"Google Kalender","ics":"ICS"},"tagging":{"all_tags":"Alle Schlagwörter","other_tags":"Sonstige Schlagwörter","selector_tags":"Schlagwörter","selector_no_tags":"keine Schlagwörter","selector_remove_filter":"Filter entfernen","tags":"Schlagwörter","choose_for_topic":"optionale Schlagwörter","choose_for_topic_required":{"one":"mindestens %{count} Schlagwort auswählen …","other":"mindestens %{count} Schlagwörter auswählen …"},"choose_for_topic_required_group":{"one":"%{count} Schlagwort von „%{name}“ auswählen …","other":"%{count} Schlagwörter von „%{name}“ auswählen …"},"info":"Info","default_info":"Dieses Schlagwort ist nicht auf Kategorien beschränkt und hat keine Synonyme.","staff_info":"Um Einschränkungen hinzuzufügen, füge dieses Schlagwort einer \u003ca href=%{basePath}/tag_groups\u003eSchlagwortgruppe\u003c/a\u003e hinzu.","category_restricted":"Dieses Schlagwort ist auf Kategorien beschränkt, für die du keine Zugriffsberechtigung hast.","synonyms":"Synonyme","synonyms_description":"Wenn die folgenden Schlagwörter verwendet werden, werden sie durch \u003cb\u003e%{base_tag_name}\u003c/b\u003e ersetzt.","save":"Name und Beschreibung des Schlagwortes speichern","tag_groups_info":{"one":"Dieses Schlagwort gehört zur Gruppe „%{tag_groups}“.","other":"Dieses Schlagwort gehört zu diesen Gruppen: %{tag_groups}"},"category_restrictions":{"one":"Es kann nur in dieser Kategorie verwendet werden:","other":"Es kann nur in folgenden Kategorien verwendet werden:"},"edit_synonyms":"Synonyme bearbeiten","add_synonyms_label":"Synonyme hinzufügen:","add_synonyms":"Hinzufügen","add_synonyms_explanation":{"one":"Jede Stelle, die dieses Schlagwort aktuell verwendet, wird auf die Verwendung von \u003cb\u003e%{tag_name}\u003c/b\u003e geändert. Bist du sicher, dass diese Änderung erfolgen soll?","other":"Jede Stelle, die diese Schlagwörter aktuell verwendet, wird auf die Verwendung von \u003cb\u003e%{tag_name}\u003c/b\u003e geändert. Bist du sicher, dass diese Änderung erfolgen soll?"},"add_synonyms_failed":"Die folgenden Schlagwörter konnten nicht als Synonyme hinzugefügt werden: \u003cb\u003e%{tag_names}\u003c/b\u003e. Stelle sicher, dass sie keine Synonyme haben und keine Synonyme eines anderen Schlagworts sind.","remove_synonym":"Synonym entfernen","delete_synonym_confirm":"Bist du sicher, dass du das Synonym „%{tag_name}“ löschen möchtest?","delete_tag":"Schlagwort löschen","delete_confirm":{"one":"Bist du sicher, dass du dieses Schlagwort löschen und von %{count} zugeordneten Thema entfernen möchtest?","other":"Bist du sicher, dass du dieses Schlagwort löschen und von %{count} zugeordneten Themen entfernen möchtest?"},"delete_confirm_no_topics":"Bist du sicher, dass du dieses Schlagwort löschen möchtest?","delete_confirm_synonyms":{"one":"Das Synonym wird ebenfalls gelöscht.","other":"Es werden %{count} weitere Synonyme ebenfalls gelöscht."},"edit_tag":"Name und Beschreibung des Schlagwortes bearbeiten","description":"Beschreibung (max. 1000 Zeichen)","sort_by":"Sortieren nach:","sort_by_count":"Anzahl","sort_by_name":"Name","manage_groups":"Schlagwortgruppen verwalten","manage_groups_description":"Gruppen definieren, um Schlagwörter zu organisieren","upload":"Schlagwörter hochladen","upload_description":"Lade eine CSV-Datei hoch, um mehrere Schlagwörter auf einmal zu erstellen","upload_instructions":"Ein Schlagwort pro Zeile, optional mit einer Schlagwortgruppe nach dem Schema „tag_name,tag_group“.","upload_successful":"Schlagwörter erfolgreich hochgeladen","delete_unused_confirmation":{"one":"%{count} Schlagwort wird gelöscht: %{tags}","other":"%{count} Schlagwörter werden gelöscht: %{tags}"},"delete_unused_confirmation_more_tags":{"one":"%{tags} und%{count} weiteres","other":"%{tags} und %{count} weitere"},"delete_no_unused_tags":"Es gibt keine ungenutzten Schlagwörter.","tag_list_joiner":", ","delete_unused":"Nicht verwendete Schlagwörter löschen","delete_unused_description":"Alle Schlagwörter löschen, die keinem Thema und keiner Nachricht zugeordnet sind.","filters":{"without_category":"%{filter} %{tag} Themen","with_category":"%{filter} %{tag} Themen in %{category}","untagged_without_category":"%{filter} Themen ohne Schlagwörter","untagged_with_category":"%{filter} Themen ohne Schlagwörter in %{category}"},"notifications":{"watching":{"title":"Beobachten","description":"Du wirst automatisch alle Themen mit diesem Schlagwort beobachten. Du wirst über alle neuen Beiträge und Themen benachrichtigt werden. Außerdem wird die Anzahl der ungelesenen und neuen Beiträge neben dem Thema erscheinen."},"watching_first_post":{"title":"Ersten Beitrag beobachten","description":"Du wirst über neue Themen mit diesem Schlagwort benachrichtigt, aber nicht über Antworten auf diese Themen."},"tracking":{"title":"Verfolgen","description":"Du wirst automatisch alle Themen mit diesem Schlagwort verfolgen. Die Anzahl der ungelesenen und neuen Beiträge wird neben dem Thema erscheinen."},"regular":{"title":"Normal","description":"Du wirst benachrichtigt, wenn jemand deinen Namen mit @ erwähnt oder auf deinen Beitrag antwortet."},"muted":{"title":"Stummgeschaltet","description":"Du wirst nicht über neue Themen mit diesem Schlagwort benachrichtigt und sie werden nicht unter „Ungelesen“ auftauchen."}},"groups":{"back_btn":"Zurück zu allen Schlagwörtern","title":"Schlagwortgruppen","about_heading":"Wähle eine Schlagwortgruppe oder erstelle eine neue.","about_heading_empty":"Erstelle eine neue Schlagwortgruppe, um loszulegen","about_description":"Schlagwortgruppen helfen dir, Berechtigungen für viele Schlagwörter an einem Ort zu verwalten.","new":"Neue Gruppe","new_title":"Neue Gruppe erstellen","edit_title":"Schlagwortgruppe bearbeiten","tags_label":"Schlagwörter in dieser Gruppe","parent_tag_label":"Übergeordnetes Schlagwort","parent_tag_description":"Schlagwörter aus dieser Gruppe können nur verwendet werden, wenn das übergeordnete Schlagwort vorhanden ist.","one_per_topic_label":"Beschränke diese Gruppe auf ein Schlagwort pro Thema","new_name":"Neue Schlagwortgruppe","name_placeholder":"Name","save":"Speichern","delete":"Löschen","confirm_delete":"Möchtest du wirklich diese Schlagwortgruppe löschen?","everyone_can_use":"Schlagwörter können von jedem verwendet werden","usable_only_by_groups":"Schlagwörter sind für jeden sichtbar, aber nur die folgenden Gruppen können sie benutzen","visible_only_to_groups":"Schlagwörter sind nur für folgende Gruppen sichtbar","cannot_save":{"empty_name":"Schlagwortgruppe kann nicht gespeichert werden. Vergewissere dich, dass der Name der Schlagwortgruppe nicht leer ist.","no_tags":"Die Schlagwortgruppe kann nicht gespeichert werden. Vergewissere dich, dass mindestens ein Schlagwort ausgewählt ist.","no_groups":"Schlagwortgruppe kann nicht gespeichert werden. Vergewissere dich, dass mindestens eine Gruppe für die Genehmigung ausgewählt ist."},"tags_placeholder":"Schlagwörter suchen oder erstellen","parent_tag_placeholder":"Optional","select_groups_placeholder":"Gruppen auswählen …","disabled":"Verwendung von Schlagwörtern ist deaktiviert. "},"topics":{"none":{"unread":"Du hast alle Themen gelesen.","unseen":"Du hast keine ungesehenen Themen.","new":"Du hast keine neuen Themen.","read":"Du hast noch keine Themen gelesen.","posted":"Du hast noch keine Beiträge verfasst.","latest":"Es gibt keine aktuellen Themen.","bookmarks":"Du hast noch keine Themen, die du mit einem Lesezeichen versehen hast.","top":"Es gibt keine angesagten Themen."}}},"invite":{"custom_message":"Gestalte deine Einladung etwas persönlicher, indem du eine \u003ca href\u003eeigene Nachricht\u003c/a\u003e schreibst.","custom_message_placeholder":"Gib deine persönliche Nachricht ein","approval_not_required":"Benutzer werden beim Annehmen der Einladung sofort automatisch genehmigt.","custom_message_template_forum":"Hey, du solltest diesem Forum beitreten!","custom_message_template_topic":"Hey, ich dachte, dir könnte dieses Thema gefallen!"},"forced_anonymous":"Aufgrund einer außergewöhnlichen Last wird dies vorübergehend so angezeigt, wie es ein nicht angemeldeter Benutzer sehen würde.","forced_anonymous_login_required":"Die Seite befindet sich unter extremer Belastung und kann zu diesem Zeitpunkt nicht geladen werden. Versuche es in ein paar Minuten erneut.","footer_nav":{"back":"Zurück","forward":"Vorwärts","share":"Teilen","dismiss":"Schließen"},"safe_mode":{"enabled":"Der abgesicherte Modus ist aktiviert. Schließe das Browserfenster, um ihn zu verlassen."},"theme_preview_notice":"Du siehst gerade eine Vorschau eines Themes. Schließe diese Browser-Registerkarte oder dieses Fenster, um zur normalen Konfiguration deiner Website zurückzukehren.","image_removed":"(Bild entfernt)","pause_notifications":{"title":"Benachrichtigungen pausieren für …","label":"Benachrichtigungen pausieren","options":{"half_hour":"30 Minuten","one_hour":"1 Stunde","two_hours":"2 Stunden","tomorrow":"Bis morgen"},"set_schedule":"Zeitplan für Benachrichtigungen festlegen"},"trust_levels":{"names":{"newuser":"neuer Benutzer","basic":"Anwärter","member":"Mitglied","regular":"Stammgast","leader":"Anführer"},"detailed_name":"%{level}: %{name}"},"pick_files_button":{"unsupported_file_picked":"Du hast eine nicht unterstützte Datei ausgewählt. Unterstützte Dateitypen – %{types}."},"user_activity":{"no_activity_title":"Noch keine Aktivität","no_activity_body":"Willkommen in unserer Community! Du bist ganz neu hier und hast noch nicht an Diskussionen teilgenommen. Besuche als ersten Schritt \u003ca href='%{topUrl}'\u003eTop\u003c/a\u003e oder \u003ca href='%{categoriesUrl}'\u003eKategorien\u003c/a\u003e und fang einfach an zu lesen! Wähle %{heartIcon} bei Beiträgen aus, die dir gefallen oder über die du mehr erfahren möchtest. Wenn du teilnimmst, wird deine Aktivität hier aufgelistet.","no_replies_title":"Du hast noch keine Themen beantwortet","no_replies_title_others":"%{username} hat noch auf keine Themen geantwortet","no_replies_body":"Wenn du eine interessante Unterhaltung \u003ca href='%{searchUrl}'\u003eentdeckst\u003c/a\u003e, zu der du etwas beitragen möchtest, klicke auf die Schaltfläche \u003ckbd\u003eAntworten\u003c/kbd\u003e direkt unter einem Beitrag, um auf diesen Beitrag zu antworten. Wenn du lieber auf das allgemeine Thema als auf einen einzelnen Beitrag oder eine Person antworten möchtest, findest du die Schaltfläche \u003ckbd\u003eAntworten\u003c/kbd\u003e ganz unten im Thema oder unter der Zeitleiste des Themas.","no_drafts_title":"Du hast noch keine Entwürfe begonnen","no_drafts_body":"Noch nicht ganz bereit? Wir speichern automatisch einen neuen Entwurf und listen ihn hier auf, wenn du ein Thema, eine Antwort oder eine persönliche Nachricht verfasst. Wähle die Abbrechen-Schaltfläche aus, um deinen Entwurf zu verwerfen, oder speichere ihn, um später fortzusetzen.","no_likes_title":"Du hast noch keine Themen mit „Gefällt mir“ markiert","no_likes_title_others":"%{username} hat noch keine Themen mit „Gefällt mir“ markiert","no_likes_body":"Eine großartige Möglichkeit, loszulegen und etwas beizutragen, besteht darin, bereits stattgefundene Unterhaltungen zu lesen und %{heartIcon} bei Beiträgen auszuwählen, die dir gefallen!","no_topics_title":"Du hast noch keine Themen begonnen","no_topics_body":"Es ist immer am besten, nach bestehenden Themen zu \u003ca href='%{searchUrl}'\u003esuchen\u003c/a\u003e, bevor du ein neues Thema eröffnest. Wenn du dir aber sicher bist, dass es das gewünschte Thema noch nicht gibt, kannst du auch einfach ein neues Thema erstellen. Suche nach der Schaltfläche \u003ckbd\u003e+ Neues Thema\u003c/kbd\u003e oben rechts in der Themenliste, bei der Kategorie oder bei dem Schlagwort, um ein neues Thema in diesem Bereich zu erstellen.","no_topics_title_others":"%{username} hat noch keine Themen begonnen","no_read_topics_title":"Du hast noch keine Themen gelesen","no_read_topics_body":"Sobald du mit dem Lesen von Diskussionen beginnst, siehst du hier eine Liste. Zum Lesen suche in \u003ca href='%{topUrl}'\u003eTop\u003c/a\u003e oder \u003ca href='%{categoriesUrl}'\u003eKategorien\u003c/a\u003e nach Themen, die dich interessieren, oder suche nach einem Schlüsselwort %{searchIcon}"},"no_group_messages_title":"Keine Gruppennachrichten gefunden","topic_entrance":{"sr_jump_top_button":"Zum ersten Beitrag springen – %{date}","sr_jump_bottom_button":"Zum letzten Beitrag springen – %{date}","jump_top_button_title":"Zum ersten Beitrag springen","jump_bottom_button_title":"Zum letzten Beitrag springen"},"fullscreen_table":{"expand_btn":"Tabelle erweitern","view_table":"Tabelle ansehen"},"second_factor_auth":{"redirect_after_success":"Die Zwei-Faktor-Authentifizierung war erfolgreich. Weiterleitung zur vorherigen Seite …"},"sidebar":{"title":"Seitenleiste","unread_count":{"one":"%{count} ungelesen","other":"%{count} ungelesen"},"new_count":{"one":"%{count} neu","other":"%{count} neu"},"toggle_section":"Abschnitt umschalten","more":"Mehr","all_categories":"Alle Kategorien","all_tags":"Alle Schlagwörter","categories_form_modal":{"title":"Kategorien-Navigation bearbeiten","subtitle":{"text":"und wir zeigen automatisch die beliebtesten Kategorien dieser Website an"},"filter_placeholder":"Kategorien filtern","no_categories":"Es gibt keine Kategorien, die dem angegebenen Begriff entsprechen.","show_more":"Mehr anzeigen"},"tags_form_modal":{"title":"Schlagwörter-Navigation bearbeiten","filter_placeholder":"Schlagwörter filtern","no_tags":"Es gibt keine Schlagwörter, die dem angegebenen Begriff entsprechen.","subtitle":{"text":"und wir zeigen automatisch die Top-Schlagwörter dieser Website an"}},"edit_navigation_modal_form":{"deselect_button_text":"Alle abwählen","reset_to_defaults":"Auf Standards zurücksetzen","filter_dropdown":{"all":"Alle","selected":"Ausgewählt","unselected":"Nicht ausgewählt"}},"sections":{"custom":{"add":"Benutzerdefinierten Abschnitt hinzufügen","edit":"Benutzerdefinierten Abschnitt bearbeiten","save":"Speichern","delete":"Löschen","delete_confirm":"Bist du sicher, dass du diesen Abschnitt löschen willst?","delete_public_confirm":"Dieser Abschnitt ist \u003cstrong\u003efür alle sichtbar\u003c/strong\u003e. Bist du sicher, dass du ihn löschen willst?","update_public_confirm":"Die Änderungen werden \u003cstrong\u003efür alle auf dieser Website sichtbar\u003c/strong\u003e sein. Bist du sicher?","mark_as_private_confirm":"Dieser Abschnitt ist \u003cstrong\u003efür alle sichtbar\u003c/strong\u003e. Nach dem Update wird er \u003cstrong\u003enur noch für dich sichtbar\u003c/strong\u003e sein. Bist du sicher?","reset_confirm":"Bist du sicher, dass du diesen Abschnitt auf die Standardeinstellungen zurücksetzen willst?","public":"Für alle sichtbar","always_public":"Die Inhalte in diesem Abschnitt sind immer öffentlich","more_menu":"Menü „Mehr“","links":{"add":"Einen weiteren Link hinzufügen","delete":"Link löschen","reset":"Auf Standard zurücksetzen","icon":{"label":"Symbol","validation":{"blank":"Das Symbol darf nicht leer sein","maximum":{"one":"Symbol muss kürzer als %{count} Zeichen sein","other":"Symbol muss kürzer als %{count} Zeichen sein"}}},"name":{"label":"Name","validation":{"blank":"Der Name darf nicht leer sein","maximum":{"one":"Der Name muss kürzer als %{count} Zeichen sein","other":"Der Name muss kürzer als %{count} Zeichen sein"}}},"value":{"label":"Link","validation":{"blank":"Link darf nicht leer sein","maximum":{"one":"Der Link muss kürzer als %{count} Zeichen sein","other":"Der Link muss kürzer als %{count} Zeichen sein"},"invalid":"Format ist ungültig"}}},"title":{"label":"Titel des Abschnitts","validation":{"blank":"Der Titel darf nicht leer sein","maximum":{"one":"Titel muss kürzer als %{count} Zeichen sein","other":"Titel muss kürzer als %{count} Zeichen sein"}}}},"about":{"header_link_text":"Über uns"},"messages":{"header_link_text":"Nachrichten","header_action_title":"Eine persönliche Nachricht erstellen","links":{"inbox":"Posteingang","sent":"Gesendet","new":"Neu","new_with_count":"Neu (%{count})","unread":"Ungelesen","unread_with_count":"Ungelesen (%{count})","archive":"Archiv"}},"tags":{"none":"Du hast keine Schlagwörter hinzugefügt.","click_to_get_started":"Klicke hier, um zu beginnen.","header_link_text":"Schlagwörter","header_action_title":"Bearbeite die Schlagwörter in deiner Seitenleiste","configure_defaults":"Standardeinstellungen konfigurieren"},"categories":{"none":"Du hast keine Kategorien hinzugefügt.","click_to_get_started":"Klicke hier, um zu beginnen.","header_link_text":"Kategorien","header_action_title":"Bearbeite die Kategorien in deiner Seitenleiste","configure_defaults":"Standardeinstellungen konfigurieren"},"community":{"edit_section":{"sidebar":"Abschnitt anpassen","header_dropdown":"Anpassen"},"links":{"about":{"content":"Über uns","title":"Weitere Details zu dieser Website"},"admin":{"content":"Admin-Panel","title":"Website-Einstellungen und -Berichte"},"badges":{"content":"Abzeichen","title":"Alle Abzeichen, die es zu verdienen gibt"},"topics":{"content":"Themen","title":"Alle Themen"},"faq":{"content":"FAQ","title":"Richtlinien für die Nutzung dieser Website"},"guidelines":{"content":"Richtlinien","title":"Richtlinien für die Nutzung dieser Website"},"groups":{"content":"Gruppen","title":"Liste der verfügbaren Benutzergruppen"},"users":{"content":"Benutzer","title":"Liste aller Benutzer"},"my_posts":{"content":"Meine Beiträge","content_drafts":"Meine Entwürfe","title":"Meine aktuelle Themenaktivität","title_drafts":"Meine nicht geposteten Entwürfe","draft_count":{"one":"%{count} Entwurf","other":"%{count} Entwürfe"}},"review":{"content":"Überprüfen","title":"Gemeldete Beiträge und andere Elemente in der Warteschlange","pending_count":{"one":"%{count} ausstehend","other":"%{count} ausstehend"}},"invite":{"content":"Einladen","title":"Neue Mitglieder einladen"}}},"global_section":"Globaler Abschnitt, für alle sichtbar"},"panels":{"forum":{"label":"Forum"},"chat":{"label":"Chat"}},"back_to_forum":"Zurück zum Forum","collapse_all_sections":"Alle Abschnitte einklappen","expand_all_sections":"Alle Abschnitte erweitern","filter":"Filter …","clear_filter":"Filter löschen","no_results":{"title":"Keine Ergebnisse","description":"Wir konnten nichts finden, das zu „%{filter}“ passt.\u003cbr\u003e\u003cbr\u003eWolltest du die \u003ca class=\"sidebar-additional-filter-settings\" href=\"%{settings_filter_url}\"\u003eWebsite-Einstellungen\u003c/a\u003e oder die \u003ca class=\"sidebar-additional-filter-users\" href=\"%{user_list_filter_url}\"\u003eAdministrator-Benutzerliste\u003c/a\u003e durchsuchen?"}},"welcome_topic_banner":{"title":"Erstelle dein Willkommensthema","description":"Dein Willkommen-Thema ist das erste, was neue Mitglieder lesen. Betrachte es als dein „Fahrstuhl-Vorstellungsgespräch“ oder „Leitbild“. Hier erfährt jeder, für wen diese Community gedacht ist, was einen hier erwartet und was man direkt zu Beginn tun soll.","button_title":"Bearbeitung beginnen"},"until":"Bis:","char_counter":{"exceeded":"Die maximal zulässige Anzahl von Zeichen wurde überschritten."},"form_template_chooser":{"select_template":"Formularvorlagen auswählen"},"form_templates":{"upload_field":{"upload":"Hochladen","uploading":"Wird hochgeladen"},"errors":{"value_missing":{"default":"Bitte fülle dieses Feld aus.","select_one":"Bitte wähle ein Element aus der Liste aus.","select_multiple":"Bitte wähle mindestens ein Element aus der Liste aus.","checkbox":"Bitte markiere dieses Kästchen, wenn du fortfahren möchtest."},"type_mismatch":{"default":"Bitte gib einen gültigen Wert ein.","color":"Bitte gib eine Farbe ein.","date":"Bitte gib ein Datum ein.","email":"Bitte gib eine gültige E-Mail-Adresse ein.","number":"Bitte gib eine Zahl ein.","password":"Bitte gib ein gültiges Passwort ein.","tel":"Bitte gib eine gültige Telefonnummer ein.","text":"Bitte gib einen Textwert ein.","url":"Bitte gib eine gültige URL ein."},"too_short":{"one":"Die Eingabe muss %{count} Zeichen oder länger sein.","other":"Die Eingabe muss %{count} Zeichen oder länger sein."},"too_long":{"one":"Die Eingabe muss weniger als %{count} Zeichen umfassen.","other":"Die Eingabe muss weniger als %{count} Zeichen umfassen."},"range_overflow":{"one":"Die Eingabe muss kleiner als %{count} sein.","other":"Die Eingabe muss kleiner als %{count} sein."},"range_underflow":{"one":"Die Eingabe muss größer als %{count} sein.","other":"Die Eingabe muss größer als %{count} sein."},"pattern_mismatch":"Bitte beachte das erforderliche Format.","bad_input":"Bitte stelle eine gültige Eingabe zur Verfügung."}},"table_builder":{"title":"Tabellenersteller","modal":{"title":"Tabellenersteller","create":"Tabelle erstellen","help":{"title":"Verwendung des Tabellenkalkulationseditors","enter_key":"Enter","tab_key":"Tab","new_row":"am Ende einer Zeile, um eine neue Zeile einzufügen.","new_col":"am Ende einer Spalte, um eine neue Spalte einzufügen.","options":"Klicke mit der rechten Maustaste auf Zellen, um weitere Optionen in einem Drop-down-Menü aufzurufen."},"confirm_close":"Bist du sicher, dass du den Tabellenersteller schließen willst? Alle nicht gespeicherten Änderungen gehen dann verloren."},"edit":{"btn_edit":"Tabelle bearbeiten","modal":{"title":"Tabelle bearbeiten","cancel":"Abbrechen","create":"Speichern","reason":"Welchen Grund gibt es für die Bearbeitung?","trigger_reason":"Grund für die Bearbeitung hinzufügen"},"default_edit_reason":"Tabelle per Tabelleneditor aktualisieren"},"default_header":{"col_1":"Spalte 1","col_2":"Spalte 2","col_3":"Spalte 3","col_4":"Spalte 4"},"spreadsheet":{"no_records_found":"Keine Datensätze gefunden","show":"Anzeigen","entries":"Einträge","about":"Über","prompts":{"delete_selected_rows":"Bist du sicher, dass du die ausgewählten Zeilen löschen willst?","delete_selected_cols":"Bist du sicher, dass du die ausgewählten Spalten löschen willst?","will_destroy_merged_cells":"Durch diese Aktion werden alle vorhandenen zusammengeführten Zellen zerstört. Bist du sicher?","will_clear_search_results":"Durch diese Aktion werden alle vorhandenen zusammengeführten Zellen zerstört. Bist du sicher?","conflicts_with_merged_cells":"Es liegt ein Konflikt mit einer anderen zusammengeführten Zelle vor"},"invalid_merge_props":"Ungültige zusammengeführte Eigenschaften","cells_already_merged":"Zelle bereits zusammengeführt","no_cells_selected":"Keine Zellen ausgewählt","context_menu":{"row":{"before":"Davor neue Zeile einfügen","after":"Danach neue Zeile einfügen","delete":"Ausgewählte Zeilen löschen"},"col":{"before":"Davor neue Spalte einfügen","after":"Danach neue Spalte einfügen","delete":"Ausgewählte Spalten löschen","rename":"Diese Spalte umbenennen"},"order":{"ascending":"Reihenfolge aufsteigend","descending":"Reihenfolge absteigend"},"copy":"Kopieren …","paste":"Einfügen …","save":"Speichern als …"}}},"powered_by_discourse":"Bereitgestellt von Discourse","admin":{"logs":{"staff_actions":{"actions":{"delete_automation":"Automatisierung löschen","chat_channel_status_change":"Chat-Kanal-Status geändert","chat_channel_delete":"Chat-Kanal gelöscht","chat_auto_remove_membership":"Mitgliedschaften werden automatisch aus den Kanälen entfernt"}}},"site_settings":{"chat_separate_sidebar_mode":{"always":"Immer","fullscreen":"Wenn der Chat im Vollbildmodus ist","never":"Nie"}},"api":{"scopes":{"descriptions":{"chat":{"create_message":"Erstelle eine Chat-Nachricht in einem bestimmten Kanal."}}}},"web_hooks":{"chat_event":{"group_name":"Chat-Ereignisse","chat_message_created":"Nachricht erstellt","chat_message_edited":"Nachricht bearbeitet","chat_message_trashed":"Nachricht gelöscht","chat_message_restored":"Nachricht wiederhergestellt"},"voting_event":{"group_name":"Themenabstimmungsereignis","topic_upvote":"Wenn ein Benutzer über ein Thema abstimmt","topic_unvote":"Wenn ein Benutzer seine Stimme für ein Thema zurücknimmt"}}},"discourse_automation":{"title":"Automatisierung","create":"Erstellen","update":"Aktualisieren","select_script":"Skript auswählen","select_trigger":"Auslöser auswählen","confirm_automation_reset":"Diese Aktion setzt die Skript- und Auslöseroptionen zurück. Der neue Zustand wird gespeichert. Willst du fortfahren?","confirm_automation_trigger":"Diese Aktion löst die Automatisierung aus. Willst du fortfahren?","no_automation_yet":"Du hast noch keine Automatisierungen erstellt. Wähle unten eine Option, um loszulegen.","filter_placeholder":"Nach Namen oder Beschreibung filtern …","edit_automation":{"trigger_section":{"forced":"Dieser Auslöser wird vom Skript erzwungen.","next_pending_automation":"Die nächste Automatisierung wird ausgelöst am: %{date}","trigger_now":"Jetzt auslösen","title":"Wann/Was …"},"fields_section":{"title":"Skriptoptionen"}},"destroy_automation":{"confirm":"Bist du sicher, dass du `%{name}` löschen willst?"},"fields":{"key_value":{"label_without_count":"Konfigurieren","label_with_count":{"one":"Konfiguration bearbeiten (%{count})","other":"Konfiguration bearbeiten (%{count})"}},"user":{"label":"Benutzer"},"pm":{"title":{"label":"Titel"},"raw":{"label":"Hauptteil"}},"pms":{"confirm_remove_pm":"Bist du sicher, dass du diese PN entfernen möchtest?","placeholder_title":"PN-Titel","add_pm":"PN hinzufügen","no_pm_created":"Du hast noch keine PN erstellt. PN werden verschickt, sobald deine Automatisierung ausgelöst wird.","title":{"label":"Titel"},"raw":{"label":"Hauptteil"},"delay":{"label":"Verzögerung (Minuten)"},"prefers_encrypt":{"label":"Verschlüsselt PN, falls verfügbar"}},"group":{"label":"Gruppe"},"text":{"label":"Text"}},"triggerables":{"not_found":"Konnte den Auslöser `%{trigger}` für die Automatisierung `%{automation}` nicht finden. Stelle sicher, dass das zugehörige Plug-in installiert ist","user_badge_granted":{"fields":{"badge":{"label":"Abzeichen"},"only_first_grant":{"label":"Nur bei erster Vergabe"}}},"stalled_topic":{"durations":{"PT1H":"Eine Stunde","P1D":"Ein Tag","P1W":"Eine Woche","P2W":"Zwei Wochen","P1M":"Ein Monat","P3M":"Drei Monate","P6M":"Sechs Monate","P1Y":"Ein Jahr"},"fields":{"categories":{"label":"Beschränkt auf Kategorien"},"tags":{"label":"Beschränkt auf Schlagwörter"},"stalled_after":{"label":"Festgefahren nach"}}},"recurring":{"every":"Jede(n/s)","frequencies":{"minute":"Minute","hour":"Stunde","day":"Tag","weekday":"Wochentag","week":"Woche","month":"Monat","year":"Jahr"},"fields":{"recurrence":{"label":"Wiederholung"},"start_date":{"label":"Startdatum"}}},"stalled_wiki":{"durations":{"PT1H":"Eine Stunde","P1D":"Ein Tag","P1W":"Eine Woche","P2W":"Zwei Wochen","P1M":"Ein Monat","P3M":"Drei Monate","P6M":"Sechs Monate","P1Y":"Ein Jahr"},"fields":{"restricted_category":{"label":"Auf Kategorie beschränkt"},"stalled_after":{"label":"Auslöseverzögerung","description":"Definiert die Verzögerung zwischen der letzten Wiki-Bearbeitung und dem Auslöser der Automatisierung"},"retriggered_after":{"label":"Verzögerung der erneuten Auslösung","description":"Definiert die Verzögerung zwischen dem ersten Auslöser und dem nächsten Auslöser, falls das Wiki nach dem ersten Auslöser noch nicht bearbeitet wurde"}}},"user_added_to_group":{"fields":{"joined_group":{"label":"Verfolgte Gruppe"}}},"user_removed_from_group":{"fields":{"left_group":{"label":"Verfolgte Gruppe"}}},"user_promoted":{"fields":{"restricted_group":{"label":"Auf Gruppe beschränken"},"trust_level_transition":{"label":"Vertrauensstufenübergang"}},"trust_levels":{"ALL":"Alle Vertrauensstufen","TL01":"VS0 auf VS1","TL12":"VS1 auf VS2","TL23":"VS2 auf VS3","TL34":"VS3 auf VS4"}},"point_in_time":{"fields":{"execute_at":{"label":"Ausführen um"}}},"topic":{"fields":{"restricted_topic":{"label":"Themen-ID"}}},"post_created_edited":{"fields":{"original_post_only":{"label":"Nur Originalbeitrag","description":"Wird nur ausgelöst, wenn der Beitrag der ursprüngliche Beitrag im Thema ist"},"action_type":{"label":"Aktionstyp","description":"Optional. Beschränke die Auslösung auf erstellte oder bearbeitete Ereignisse"},"valid_trust_levels":{"label":"Gültige Vertrauensstufen","description":"Wird nur ausgelöst, wenn ein Beitrag von einem Benutzer mit diesen Vertrauensstufen erstellt wird. Standardmäßig eine beliebige Vertrauensstufe"},"restricted_tags":{"label":"Schlagwörter","description":"Optional. Wird nur bei Beiträgen mit einem dieser Schlagwörter ausgelöst"},"restricted_category":{"label":"Kategorie","description":"Optional. Wird nur ausgelöst, wenn das Thema des Beitrags in dieser Kategorie ist"},"restricted_group":{"label":"Gruppe","description":"Optional. Wird nur ausgelöst, wenn der Beitrag eine persönliche Nachricht im Posteingang dieser Gruppe ist"},"restricted_groups":{"label":"Gruppen","description":"Optional. Wird nur ausgelöst, wenn der Beitrag eine persönliche Nachricht im Posteingang einer der Gruppen ist"},"ignore_group_members":{"label":"Gruppenmitglieder ignorieren","description":"Den Auslöser überspringen, falls der Absender ein Mitglied der oben angegebenen Gruppe ist"},"ignore_automated":{"label":"Automatisierte Nachrichten ignorieren","description":"Überspringe den Auslöser, wenn der Absender eine Noreply-E-Mail-Adresse nutzt oder die Nachricht von einer automatischen Quelle stammt. Gilt nur für Beiträge, die per E-Mail erstellt wurden"},"first_post_only":{"label":"Nur erster Beitrag","description":"Wird nur ausgelöst, wenn der Beitrag der erste Beitrag ist, den ein Benutzer erstellt hat"},"first_topic_only":{"label":"Nur erstes Thema","description":"Wird nur ausgelöst, wenn das Thema das erste Thema ist, das ein Benutzer erstellt hat"},"skip_via_email":{"label":"„Per E-Mail“ überspringen","description":"Den Auslöser überspringen, wenn der Beitrag per E-Mail erstellt wurde"}},"created":"Erstellt","edited":"Bearbeitet"},"user_updated":{"fields":{"user_profile":{"label":"Benutzerprofilfelder","description":"Wird nur ausgelöst, wenn der Benutzer alle diese Felder ausgefüllt hat"},"custom_fields":{"label":"Benutzerdefinierte Felder","description":"Wird nur ausgelöst, wenn der Benutzer alle diese Felder ausgefüllt hat"},"once_per_user":{"label":"Einmal pro Benutzer","description":"Wird nur einmal pro Benutzer ausgelöst"},"new_users_only":{"label":"Nur neue Benutzer","description":"Wird nur für neue Benutzer ausgelöst, die nach der Aktivierung dieser Automatisierung beitreten"}}},"category_created_edited":{"fields":{"restricted_category":{"label":"Übergeordnete Kategorie","description":"Optional. Ermöglicht es, die Ausführung des Auslösers auf diese Kategorie zu beschränken"}}},"pm_created":{"fields":{"restricted_user":{"label":"Benutzer","description":"Wird nur für PN ausgelöst, die an diesen Benutzer gesendet werden"},"restricted_group":{"label":"Gruppe","description":"Wird nur für PN ausgelöst, die an diese Gruppe gesendet werden"},"ignore_staff":{"label":"Teammitglieder ignorieren","description":"Den Auslöser überspringen, falls der Absender ein Teammitglied ist"},"ignore_group_members":{"label":"Gruppenmitglieder ignorieren","description":"Den Auslöser überspringen, falls der Absender ein Mitglied der oben angegebenen Gruppe ist"},"ignore_automated":{"label":"Automatisierte Nachrichten ignorieren","description":"Den Auslöser überspringen, falls der Absender eine Noreply-E-Mail-Adresse nutzt oder die Nachricht von einer automatisierten Quelle stammt. Gilt nur für PN, die per E-Mail erstellt wurden"},"valid_trust_levels":{"label":"Gültige Vertrauensstufen","description":"Wird nur ausgelöst, wenn ein Beitrag von einem Benutzer mit diesen Vertrauensstufen erstellt wird. Standardmäßig eine beliebige Vertrauensstufe"}}},"topic_tags_changed":{"trigger_on_modes":{"tags_added_or_removed":"Schlagwörter hinzugefügt oder entfernt","tags_added":"Schlagwörter hinzugefügt","tags_removed":"Schlagwörter entfernt"},"fields":{"watching_categories":{"label":"Überwachte Kategorien","description":"Wird nur bei Themen aus einer dieser Kategorien ausgelöst"},"watching_tags":{"label":"Überwachte Schlagwörter","description":"Wird nur bei Themen mit einem dieser Schlagwörter ausgelöst"},"trigger_on":{"label":"Auslösen wenn"},"trigger_with_pms":{"label":"Auslösen mit PN","description":"Wird auch ausgelöst, wenn die Schlagwörter in einer PN geändert wurden"}}},"after_post_cook":{"fields":{"valid_trust_levels":{"label":"Gültige Vertrauensstufen","description":"Wird nur ausgelöst, wenn ein Beitrag von einem Benutzer mit diesen Vertrauensstufen erstellt wird. Standardmäßig eine beliebige Vertrauensstufe"},"restricted_category":{"label":"Kategorie","description":"Optional. Wird nur ausgelöst, wenn das Thema des Beitrags in dieser Kategorie ist"},"restricted_tags":{"label":"Schlagwörter","description":"Optional. Wird nur ausgelöst, wenn der Beitrag eines dieser Schlagwörter enthält"}}}},"scriptables":{"not_found":"Konnte das Skript `%{script}` für die Automatisierung `%{automation}` nicht finden. Stelle sicher, dass das zugehörige Plug-in installiert ist","zapier_webhook":{"fields":{"webhook_url":{"label":"Webhook-URL","description":"Erwartet eine gültige Zapier-Webhook-URL, z. B.: https://hooks.zapier.com/hooks/catch/xxx/yyy/"}}},"auto_responder":{"fields":{"once":{"label":"Einmal","description":"Antwortet nur einmal pro Thema"},"word_answer_list":{"label":"Liste von Wort/Antwort-Paaren","description":"Definiert eine Liste von Schlüssel/Wert-Gruppen, wobei `key` der gesuchte Begriff und `value` der Text der Antwort ist. `key` kann leer gelassen werden, um unabhängig vom Inhalt auf alle Auslöser zu reagieren. Beachte, dass `value` `{{key}}` als Platzhalter akzeptiert, der in der Antwort durch den Wert von `key` ersetzt wird. Beachte weiterhin, dass `key` als Regex ausgewertet wird und Sonderzeichen wie `.` maskiert werden müssen, wenn du tatsächlich einen Punkt meinst, z. B.: `\\.`"},"answering_user":{"label":"Antwortender Benutzer","description":"Standardmäßig Systembenutzer"}}},"auto_tag_topic":{"fields":{"tags":{"label":"Schlagwörter","description":"Liste der Schlagwörter, die dem Thema hinzugefügt werden sollen."}}},"post":{"fields":{"creator":{"label":"Ersteller","post_creator_context":"Der Ersteller des Beitrags","updated_user_context":"Der aktualisierte Benutzer"},"topic":{"label":"Themen-ID"},"post":{"label":"Beitragsinhalt"}}},"topic":{"fields":{"creator":{"label":"Ersteller","updated_user_context":"Der aktualisierte Benutzer"},"body":{"label":"Hauptteil des Themas"},"title":{"label":"Titel des Themas"},"category":{"label":"Kategorie des Themas"},"tags":{"label":"Schlagwörter des Themas"}}},"group_category_notification_default":{"fields":{"group":{"label":"Gruppe"},"notification_level":{"label":"Benachrichtigungsstufe"},"update_existing_members":{"label":"Bestehende Mitglieder aktualisieren","description":"Aktualisiert die Benachrichtigungsstufe für bestehende Gruppenmitglieder"}}},"user_global_notice":{"fields":{"level":{"label":"Stufe"},"notice":{"label":"Hinweis","description":"Akzeptiert HTML. Gib nur vertrauenswürdige Inhalte ein!"}},"levels":{"warning":"Warnung","info":"Info","success":"Erfolg","error":"Fehler"}},"user_group_membership_through_badge":{"fields":{"badge_name":{"label":"Abzeichenname"},"group":{"label":"Gruppe","description":"Zielgruppe. Benutzer mit dem angegebenen Abzeichen werden dieser Gruppe hinzugefügt"},"update_user_title_and_flair":{"label":"Benutzertitel und Flair aktualisieren","description":"Optional. Benutzertitel und Flair aktualisieren"},"remove_members_without_badge":{"label":"Bestehende Mitglieder ohne Abzeichen entfernen","description":"Optional. Bestehende Gruppenmitglieder ohne das angegebene Abzeichen entfernen"},"badge":{"label":"Abzeichen","description":"Abzeichen auswählen"}}},"suspend_user_by_email":{"fields":{"suspend_until":{"label":"Aussetzen bis (Standard)"},"reason":{"label":"Grund (Standard)"},"actor":{"label":"Benutzer","description":"Der für die Sperre verantwortliche Benutzer (Standard: System)"}}},"pin_topic":{"fields":{"pinnable_topic":{"label":"Themen-ID"},"pinned_globally":{"label":"Global angeheftet"},"pinned_until":{"label":"Angeheftet bis"}}},"banner_topic":{"fields":{"topic_id":{"label":"Themen-ID"},"banner_until":{"label":"Banner machen bis"},"user":{"label":"Benutzer","description":"Der Benutzer, der das Banner erstellt (Standard: System)"}}},"flag_post_on_words":{"fields":{"words":{"label":"Geprüfte Wörter"}}},"topic_required_words":{"fields":{"words":{"label":"Liste der erforderlichen Wörter"}}},"gift_exchange":{"fields":{"gift_exchangers_group":{"label":"Gruppenname der Teilnehmer"},"giftee_assignment_messages":{"label":"An den Schenkenden gesendete Nachrichten"}}},"send_pms":{"add_a_pm_btn":{"label":"PN hinzufügen"},"fields":{"receiver":{"label":"PN-Empfänger"},"sendable_pms":{"label":"PN"},"sender":{"label":"PN-Absender"}}},"close_topic":{"fields":{"topic":{"label":"Themen-ID"},"message":{"label":"Nachricht bzgl. Schließung","description":"Optionale Nachricht, die im Eintrag „Thema geschlossen“ angezeigt wird"},"user":{"label":"Benutzer","description":"Der Benutzer, der das Thema schließt (Standard: System)"}}},"add_user_to_group_through_custom_field":{"fields":{"custom_field_name":{"label":"Name des benutzerdefinierten Benutzerfelds"}}},"send_chat_message":{"title":"Chat-Nachricht senden","fields":{"chat_channel_id":{"label":"Chat-Kanal-ID"},"message":{"label":"Nachricht"},"sender":{"label":"Absender","description":"Standardmäßig System"}}}},"unnamed_automation":"Automatisierung ohne Titel","models":{"script":{"name":{"label":"Skript"}},"trigger":{"name":{"label":"Auslöser"}},"automation":{"name":{"label":"Name"},"trigger":{"label":"Auslöser"},"script":{"label":"Skript"},"version":{"label":"Version"},"status":{"label":"Status"},"enabled":{"label":"Aktiviert"},"disabled":{"label":"Deaktiviert"},"placeholders":{"label":"Platzhalter"},"last_updated_at":{"label":"Letzte Aktualisierung"},"last_updated_by":{"label":"Aktualisiert von"}}}},"chat":{"text_copied":"Text in die Zwischenablage kopiert","link_copied":"Link in die Zwischenablage kopiert","back_to_forum":"Forum","deleted_chat_username":"gelöscht","dates":{"yesterday":"Gestern"},"all_loaded":"Alle Nachrichten werden angezeigt","already_enabled":"Der Chat ist für dieses Thema bereits aktiviert. Bitte aktualisieren.","disabled_for_topic":"Der Chat ist für dieses Thema deaktiviert.","bot":"Bot","create":"Erstellen","cancel":"Abbrechen","cancel_reply":"Antwort verwerfen","chat_channels":"Kanäle","browse_all_channels":"Alle Kanäle durchsuchen","see_in":"Ansehen in","move_to_channel":{"title":"Nachrichten in Kanal verschieben","instructions":{"one":"Du verschiebst \u003cstrong\u003e%{count}\u003c/strong\u003e Nachricht. Wähle einen Zielkanal aus. Im Kanal \u003cstrong\u003e%{channelTitle}\u003c/strong\u003e wird eine Platzhalter-Nachricht erstellt, um anzuzeigen, dass diese Nachricht verschoben wurde. Beachte, dass Antwortketten im neuen Kanal nicht erhalten bleiben und dass Nachrichten im alten Kanal nicht mehr als Antwort auf verschobene Nachrichten angezeigt werden.","other":"Du verschiebst \u003cstrong\u003e%{count}\u003c/strong\u003e Nachrichten. Wähle einen Zielkanal aus. Im Kanal \u003cstrong\u003e%{channelTitle}\u003c/strong\u003e wird eine Platzhalter-Nachricht erstellt, um anzuzeigen, dass diese Nachrichten verschoben wurden. Beachte, dass die Antwortketten im neuen Kanal nicht erhalten bleiben und dass die Nachrichten im alten Kanal nicht mehr als Antwort auf die verschobenen Nachrichten angezeigt werden."},"confirm_move":"Nachrichten verschieben"},"delete_messages":{"confirm":{"one":"Bist du sicher, dass du diese Nachricht löschen willst?","other":"Bist du sicher, dass du diese %{count} Nachrichten löschen willst?"}},"channel_settings":{"title":"Kanaleinstellungen","edit":"Bearbeiten","add":"Hinzufügen","close_channel":"Kanal schließen","open_channel":"Kanal öffnen","archive_channel":"Kanal archivieren","delete_channel":"Kanal löschen","join_channel":"Kanal beitreten","leave_channel":"Kanal verlassen","leave_groupchat_info":"Wenn du den Gruppenchat verlässt, hast du keinen Zugriff mehr darauf und erhältst keine Benachrichtigungen mehr. Um wieder teilzunehmen, musst du von einem Mitglied des Gruppenchats erneut eingeladen werden.","join":"Beitreten","leave":"Verlassen","save_label":{"mute_channel":"Einstellung für „Kanal stummschalten“ gespeichert","desktop_notification":"Einstellung für Desktop-Benachrichtigungen gespeichert","mobile_notification":"Einstellung für mobile Push-Benachrichtigungen gespeichert"}},"channel_archive":{"title":"Kanal archivieren","instructions":"\u003cp\u003eDas Archivieren eines Kanals versetzt ihn in den schreibgeschützten Modus und verschiebt alle Nachrichten aus dem Kanal in ein neues oder vorhandenes Thema. Es können keine neuen Nachrichten gesendet und keine bestehenden Nachrichten bearbeitet oder gelöscht werden.\u003c/p\u003e\u003cp\u003eMöchtest du den Kanal \u003cstrong\u003e%{channelTitle}\u003c/strong\u003e wirklich archivieren?\u003c/p\u003e","process_started":"Der Archivierungsprozess hat begonnen. Dieser Modal-Dialog wird in Kürze geschlossen und du erhältst eine persönliche Nachricht, wenn der Archivierungsvorgang abgeschlossen ist.","retry":"Erneut versuchen"},"channel_open":{"title":"Kanal öffnen","instructions":"Öffnet den Kanal wieder. Alle Benutzer können Nachrichten senden und ihre bestehenden Nachrichten bearbeiten."},"channel_close":{"title":"Kanal schließen","instructions":"Das Schließen des Kanals verhindert, dass Nicht-Teammitglieder neue Nachrichten senden oder bestehende Nachrichten bearbeiten können. Bist du sicher, dass du diesen Kanal schließen möchtest?"},"channel_delete":{"title":"Kanal löschen","instructions":"\u003cp\u003eLöscht den Kanal \u003cstrong\u003e%{name}\u003c/strong\u003e und den Chatverlauf. Alle Nachrichten und zugehörigen Daten wie Reaktionen und Uploads werden dauerhaft gelöscht. Wenn du den Kanalverlauf aufbewahren und stilllegen möchtest, solltest du den Kanal stattdessen archivieren.\u003c/p\u003e \u003cp\u003eBist du sicher, dass du den Kanal \u003cstrong\u003edauerhaft löschen möchtest\u003c/strong\u003e? Gib zur Bestätigung den Namen des Kanals in das Feld unten ein.\u003c/p\u003e","confirm":"Ich verstehe die Konsequenzen und möchte den Kanal löschen","confirm_channel_name":"Kanalnamen eingeben","process_started":"Der Löschvorgang für den Kanal hat begonnen. Dieser Modal-Dialog wird in Kürze geschlossen und du wirst den gelöschten Kanal nirgendwo mehr sehen."},"channels_list_popup":{"browse":"Kanäle durchsuchen","create":"Neuer Kanal"},"close":"Schließen","remove":"Entfernen","collapse":"Chat-Bereich ausblenden","expand":"Chat-Bereich erweitern","confirm_flag":"Bist du sicher, dass du die Nachricht von %{username} melden möchtest?","deleted":{"one":"Eine Nachricht wurde gelöscht. [Anzeigen]","other":"%{count} Nachrichten wurden gelöscht. [Alle anzeigen]"},"hidden":"Eine Nachricht wurde ausgeblendet. [Anzeigen]","delete":"Löschen","edited":"bearbeitet","muted":"stummgeschaltet","joined":"beigetreten","empty_state":{"direct_message_cta":"Persönlichen Chat beginnen","direct_message":"Du kannst auch einen persönlichen Chat mit einem oder mehreren Benutzern beginnen.","title":"Keine Kanäle gefunden","my_threads":"Du hast noch keine Threads. Threads, an denen du teilnimmst, werden hier angezeigt."},"email_frequency":{"description":"Wir schicken dir nur dann eine E-Mail, wenn wir dich in den letzten 15 Minuten nicht gesehen haben.","never":"Niemals","title":"E-Mail-Benachrichtigungen","when_away":"Nur bei Abwesenheit"},"header_indicator_preference":{"title":"Aktivitätsindikator in der Kopfzeile anzeigen","all_new":"bei allen neuen Nachrichten","dm_and_mentions":"Direktnachrichten, Erwähnungen und beobachtete Threads","only_mentions":"Nur Erwähnungen","never":"niemals"},"separate_sidebar_mode":{"title":"Separate Seitenleisten-Modi für Forum und Chat anzeigen"},"send_shortcut":{"enter":{"label":"Senden mit Enter","description":"Neue Zeile mit Umschalt + Enter"},"meta_enter":{"label":"Senden mit %{meta_key} + Enter","description":"Neue Zeile mit Enter"}},"enable":"Chat aktivieren","flag":"Melden","emoji":"Emoji einfügen","flagged":"Diese Nachricht wurde zur Überprüfung markiert","invalid_access":"Du bist nicht befugt, diesen Chat-Kanal anzuzeigen","invitation_notification":"\u003cspan\u003e%{username}\u003c/span\u003e \u003cspan\u003ehat dich eingeladen, einem Chat-Kanal beizutreten\u003c/span\u003e","in_reply_to":"Als Antwort auf","heading":"Chat","join":"Beitreten","last_visit":"letzter Besuch","mention_warning":{"invitations_sent":{"one":"Einladung gesendet","other":"Einladungen gesendet"},"invite":"Zum Kanal einladen","channel_wide_mentions_disallowed":"Die Erwähnungen von @here und @all sind in diesem Kanal deaktiviert.","groups":{"header":{"some":"Einige Benutzer werden nicht benachrichtigt","all":"Niemand wird benachrichtigt"},"unreachable_1":"@%{group} erlaubt keine Erwähnungen.","unreachable_2":"@%{group1} und @%{group2} erlauben keine Erwähnungen.","unreachable_multiple":{"one":"@%{group} und %{count} andere Gruppe erlauben keine Erwähnungen.","other":"@%{group} und %{count} andere Gruppen erlauben keine Erwähnungen."}},"too_many_mentions":{"one":"Diese Nachricht überschreitet das Benachrichtigungslimit von %{count} Erwähnung.","other":"Diese Nachricht überschreitet das Benachrichtigungslimit von %{count} Erwähnungen."},"too_many_mentions_admin":{"one":"Diese Nachricht überschreitet das \u003ca href=\"%{siteSettingUrl}\" target=\"_blank\"\u003eBenachrichtigungslimit\u003c/a\u003e von %{count} Erwähnung.","other":"Diese Nachricht überschreitet das \u003ca href=\"%{siteSettingUrl}\" target=\"_blank\"\u003eBenachrichtigungslimit\u003c/a\u003e von %{count} Erwähnungen."}},"aria_roles":{"header":"Chat-Kopfzeile","composer":"Chat-Composer","channels_list":"Liste der Chat-Kanäle"},"no_direct_message_channels":"Du bist noch keiner Unterhaltung per Direktnachricht beigetreten!","no_direct_message_channels_cta":"Eine Unterhaltung starten","no_public_channels":"Du bist noch keinem Kanal beigetreten!","no_public_channels_cta":"Kanäle durchsuchen","kicked_from_channel":"Du kannst nicht mehr auf diesen Kanal zugreifen.","only_chat_push_notifications":{"title":"Nur Chat-Push-Benachrichtigungen senden","description":"Alle Nicht-Chat-Push-Benachrichtigungen blockieren und nicht senden"},"ignore_channel_wide_mention":{"title":"Kanalweite Erwähnungen ignorieren","description":"Keine Benachrichtigungen für kanalweite Erwähnungen senden (@here und @all)"},"show_thread_title_prompts":{"title":"Eingabeaufforderungen für Thread-Titel anzeigen","description":"Eingabeaufforderungen zum Festlegen eines Titels für neue Threads anzeigen"},"open":"Chat öffnen","open_full_page":"Vollbild-Chat öffnen","close_full_page":"Vollbild-Chat schließen","open_message":"Nachricht im Chat öffnen","placeholder_self":"Etwas notieren","placeholder_channel":"Chat in %{channelName}","placeholder_thread":"Chat im Thread","placeholder_users":"Chat mit %{commaSeparatedNames}","placeholder_group":"In der Gruppe chatten","placeholder_new_message_disallowed":{"archived":"Der Kanal ist archiviert, du kannst im Moment keine neuen Nachrichten senden.","closed":"Der Kanal ist geschlossen, du kannst im Moment keine neuen Nachrichten senden.","read_only":"Der Kanal ist schreibgeschützt, du kannst im Moment keine neuen Nachrichten senden."},"placeholder_silenced":"Du kannst derzeit keine Nachrichten senden.","remove_upload":"Datei löschen","react":"Mit Emoji reagieren","reply":"Antworten","edit":"Bearbeiten","copy_link":"Link kopieren","copy_text":"Text kopieren","rebake_message":"HTML neu erstellen","message_too_long":"Nachricht ist zu lang. Nachrichten dürfen maximal %{count} Zeichen lang sein.","retry_staged_message":{"title":"Netzwerkfehler","action":"Erneut senden?"},"unreliable_network":"Das Netzwerk ist unzuverlässig, das Senden von Nachrichten und das Speichern von Entwürfen funktioniert möglicherweise nicht","bookmark_message":"Lesezeichen","bookmark_message_edit":"Lesezeichen bearbeiten","restore":"Gelöschte Nachricht wiederherstellen","save":"Speichern","select":"Auswählen","return_to_list":"Zurück zur Kanalliste","return_to_channel":"Zurück zum Kanal","return_to_threads_list":"Zurück zur Thread-Liste","unread_threads_count":{"one":"Du hast %{count} ungelesene Diskussion","other":"Du hast %{count} ungelesene Diskussionen"},"scroll_to_bottom":"Nach unten scrollen","scroll_to_new_messages":"Neue Nachrichten anzeigen","sound":{"title":"Desktop-Chat-Benachrichtigungston"},"sounds":{"none":"Keiner","bell":"Glocke","ding":"Ding"},"title":"Chat","title_capitalized":"Chat","upload":"Datei anhängen","upload_to_channel":"In %{title} hochladen","upload_to_thread":"In Thread hochladen","uploaded_files":{"one":"%{count} Datei","other":"%{count} Dateien"},"you_flagged":"Du hast diese Nachricht markiert","exit":"zurück","channel_status":{"read_only_header":"Kanal ist schreibgeschützt","read_only":"Schreibgeschützt","archived_header":"Kanal ist archiviert","archived":"Archiviert","archive_failed":"Archivieren des Kanals fehlgeschlagen. %{completed}/%{total} Nachrichten wurden archiviert. \u003ca target=\"_blank\" href=\"%{topic_url}\"\u003eDas Zielthema\u003c/a\u003e wurde erstellt. Drücke auf „Erneut versuchen“, um zu versuchen, die Archivierung abzuschließen.","archive_failed_no_topic":"Archivieren des Kanals fehlgeschlagen. %{completed}/%{total} Nachrichten wurden archiviert, das Zielthema wurde nicht erstellt. Drücke auf „Erneut versuchen“, um zu versuchen, die Archivierung abzuschließen.","archive_completed":"\u003ca target=\"_blank\" href=\"%{topic_url}\"\u003eArchivthema\u003c/a\u003e anzeigen","closed_header":"Kanal ist geschlossen","closed":"Geschlossen","open_header":"Kanal ist offen","open":"Offen"},"browse":{"back":"Zurück","title":"Kanäle","filter_all":"Alle","filter_open":"Offen","filter_closed":"Geschlossen","filter_archived":"Archiviert","filter_input_placeholder":"Kanal nach Namen suchen"},"chat_message_separator":{"today":"Heute","yesterday":"Gestern"},"members_view":{"filter_placeholder":"Mitglieder finden","add_member":"Mitglied hinzufügen","back_to_settings":"Zurück zu den Einstellungen"},"about_view":{"associated_topic":"Verknüpftes Thema","associated_category":"Verknüpfte Kategorie","title":"Titel","name":"Name","description":"Beschreibung"},"channel_info":{"back_to_all_channels":"Alle Kanäle","back_to_channel":"Zurück","tabs":{"members":"Mitglieder","settings":"Einstellungen"}},"new_message_modal":{"title":"Nachricht senden","add_user_long":"\u003ckbd\u003eUmschalt + Klick\u003c/kbd\u003e oder \u003ckbd\u003eUmschalt + Eingabe\u003c/kbd\u003e\u003cspan\u003e@%{username} hinzufügen\u003c/span\u003e","add_user_short":"\u003cspan\u003eBenutzer hinzufügen\u003c/span\u003e","open_channel":"\u003cspan\u003eKanal öffnen\u003c/span\u003e","default_search_placeholder":"#ein-kanal, @jemand oder sonstiges","default_channel_search_placeholder":"#ein-kanal","default_user_search_placeholder":"@jemand","user_search_placeholder":"… weitere Mitglieder hinzufügen","disabled_user":"hat den Chat deaktiviert","no_items":"Keine Elemente","create_group_placeholder":"Name des Gruppenchats (optional)","participants_counter":"%{selection_count}/%{max} Teilnehmer","new_group_chat":"Neuer Gruppenchat","filter":"Filter","cant_add_more_members":"Maximale Anzahl von Mitgliedern erreicht","create_new_group_chat":"Gruppenchat erstellen","group_with_too_many_members":"hat zu viele Mitglieder (%{membersCount})"},"channel_edit_name_slug_modal":{"title":"Kanal bearbeiten","input_placeholder":"Einen Namen hinzufügen","slug_description":"In der URL wird anstelle des Kanalnamens ein Kanal-Kürzel verwendet","name":"Kanalname","slug":"Kanal-Kürzel (optional)"},"channel_edit_description_modal":{"title":"Beschreibung bearbeiten","input_placeholder":"Beschreibung hinzufügen","description":"Sag den Leuten, worum es in diesem Kanal geht"},"direct_message_creator":{"add_to_channel":"Zum Kanal hinzufügen","title":"Neue Nachricht","prefix":"An:","no_results":"Keine Ergebnisse","selected_user_title":"%{username} abwählen","group_name":"Name des Gruppenchats (optional)","members_counter":{"one":"%{count}/%{max} Mitglied","other":"%{count}/%{max} Mitglieder"}},"channel":{"no_memberships":"Dieser Kanal hat keine Mitglieder","no_memberships_found":"Keine Mitglieder gefunden","memberships_count":{"one":"%{count} Mitglied","other":"%{count} Mitglieder"}},"create_channel":{"threading":{"label":"Threading aktivieren"},"auto_join_users":{"public_category_warning":"%{category} ist eine öffentliche Kategorie. Alle kürzlich aktiven Benutzer automatisch zu diesem Kanal hinzufügen?","warning_1_group":{"one":"Automatisch %{count} Benutzer aus %{group} hinzufügen?","other":"Automatisch %{count} Benutzer aus %{group} hinzufügen?"},"warning_2_groups":{"one":"Automatisch %{count} Benutzer aus %{group1} und %{group2} hinzufügen?","other":"Automatisch %{count} Benutzer aus %{group1} und %{group2} hinzufügen?"}},"choose_category":{"label":"Kategorie auswählen","none":"eine auswählen …","default_hint":"Verwalte den Zugang, indem du die \u003ca href=%{link} target=\"_blank\"\u003eSicherheitseinstellungen für %{category}\u003c/a\u003e besuchst","hint_1_group":"Benutzer in %{group} haben gemäß den \u003ca href=\"%{settingLink}\" target=\"_blank\"\u003eSicherheitseinstellungen\u003c/a\u003e Zugriff auf diesen Kanal","hint_2_groups":"Benutzer in %{group1} und %{group2} haben gemäß den \u003ca href=\"%{settingLink}\" target=\"_blank\"\u003eSicherheitseinstellungen\u003c/a\u003e Zugriff auf diesen Kanal","hint_multiple_groups":{"one":"Benutzer in %{group} und %{count} anderen Gruppe haben gemäß den \u003ca href=\"%{settingLink}\" target=\"_blank\"\u003eSicherheitseinstellungen\u003c/a\u003e Zugriff auf diesen Kanal","other":"Benutzer in %{group} und %{count} anderen Gruppen haben gemäß den \u003ca href=\"%{settingLink}\" target=\"_blank\"\u003eSicherheitseinstellungen\u003c/a\u003e Zugriff auf diesen Kanal"}},"create":"Kanal erstellen","description":"Beschreibung (optional)","name":"Kanalname","slug":"Kanal-Kürzel (optional)","title":"Neuer Kanal","type":"Typ","types":{"category":"Kategorie","topic":"Thema"}},"reviewable":{"type":"Chat-Nachricht"},"reactions":{"only_you":"\u003cspan\u003eDu hast mit reagiert mit \u003c/span\u003e:%{emoji}:","you_and_single_user":"\u003cspan\u003eDu und %{username} habt reagiert mit \u003c/span\u003e:%{emoji}:","you_and_multiple_users":"\u003cspan\u003eDu, %{commaSeparatedUsernames} und %{username} habt reagiert mit \u003c/span\u003e:%{emoji}:","you_multiple_users_and_more":{"one":"\u003cspan\u003eDu, %{commaSeparatedUsernames} und %{count} weitere Person habt reagiert mit \u003c/span\u003e:%{emoji}:","other":"\u003cspan\u003eDu, %{commaSeparatedUsernames} und %{count} andere Personen habt reagiert mit \u003c/span\u003e:%{emoji}:"},"single_user":"\u003cspan\u003e%{username} reagierte mit \u003c/span\u003e:%{emoji}:","multiple_users":"\u003cspan\u003e%{commaSeparatedUsernames} und %{username} reagierten mit \u003c/span\u003e:%{emoji}:","multiple_users_and_more":{"one":"\u003cspan\u003e%{commaSeparatedUsernames} und %{count} andere Person reagierten mit \u003c/span\u003e:%{emoji}:","other":"\u003cspan\u003e%{commaSeparatedUsernames} und %{count} andere Personen reagierten mit \u003c/span\u003e:%{emoji}:"}},"composer":{"toggle_toolbar":"Symbolleiste umschalten","italic_text":"hervorgehobener Text","bold_text":"fett gedruckter Text","code_text":"Code-Text","send":"Senden"},"quote":{"original_channel":"Ursprünglich gesendet in \u003ca href=\"%{channelLink}\"\u003e%{channel}\u003c/a\u003e","copy_success":"Chat-Zitat in die Zwischenablage kopiert","default_thread_title":"Thread"},"notification_levels":{"never":"Niemals","mention":"Nur für Erwähnungen","always":"Für alle Aktivitäten"},"settings":{"channel_wide_mentions_label":"@all- und @here-Erwähnungen zulassen","channel_wide_mentions_description":"Erlaube Benutzern, alle Mitglieder von #%{channel} mit @all zu benachrichtigen oder nur diejenigen, die gerade aktiv sind, mit @here","channel_threading_label":"Threading","channel_threading_description":"Wenn Threading aktiviert ist, wird durch Antworten auf eine Chat-Nachricht eine separate Unterhaltung erstellt, die neben dem Hauptkanal existiert.","auto_join_users_label":"Benutzer automatisch hinzufügen","auto_join_users_info":"Stündlich prüfen, welche Benutzer in den letzten 3 Monaten aktiv waren. Diese Benutzer zu diesem Kanal hinzufügen, wenn sie Zugang zur Kategorie %{category} haben.","auto_join_users_info_no_category":"Stündlich prüfen, welche Benutzer in den letzten 3 Monaten aktiv waren. Diese Benutzer zu diesem Kanal hinzufügen, wenn sie Zugang zur ausgewählten Kategorie haben.","auto_join_users_warning":"Jeder Benutzer, der kein Mitglied dieses Kanals ist und Zugriff auf die Kategorie %{category} hat, wird beitreten. Bist du dir sicher?","notification_level":"Push-Benachrichtigungen senden","follow":"Beitreten","followed":"Beigetreten","mute":"Kanal stummschalten","threading_enabled":"Aktiviert","threading_disabled":"Deaktiviert","muted_on":"An","muted_off":"Aus","notifications":"Benachrichtigungen","preview":"Vorschau","save":"Speichern","saved":"Gespeichert","unfollow":"Verlassen","admin_title":"Administrator","settings_title":"Einstellungen","info_title":"Kanal-Info","category_label":"Kategorie","history_label":"Verlauf","members_label":"Mitglieder"},"admin":{"title":"Chat","export_messages":{"title":"Chat-Nachrichten exportieren","description":"Dadurch werden alle Nachrichten aus allen Kanälen exportiert.","create_export":"Export erstellen","confirm_export":"Dies exportiert alle Nachrichten aus allen Kanälen und schickt dir das Ergebnis in einer persönlichen Nachricht. Bist du sicher, dass du exportieren willst?","export_has_started":"Der Export hat begonnen. Du erhältst eine PN, wenn er abgeschlossen ist."}},"my_threads":{"title":"Meine Threads","aria_label":"Zu meiner Thread-Liste wechseln"},"direct_messages":{"title":"DN","aria_label":"Zu Direktnachrichten wechseln","new":"Persönlichen Chat erstellen","create":"Los","leave":"Diesen persönlichen Chat verlassen","close":"Schließe diesen persönlichen Chat","cannot_create":"Du kannst leider keine Direktnachrichten senden."},"channel_list":{"title":"Kanäle","aria_label":"Zur Kanalliste wechseln"},"incoming_webhooks":{"back":"Zurück","channel_placeholder":"Kanal auswählen","channel":"Kanal","confirm_destroy":"Bist du sicher, dass du diesen eingehenden Webhook löschen willst? Dies kann nicht rückgängig gemacht werden.","current_emoji":"Aktuelles Emoji","description":"Beschreibung","delete":"Löschen","emoji":"Emoji","emoji_instructions":"Der System-Avatar wird verwendet, wenn Emoji leer gelassen wird.","name":"Name","name_placeholder":"Name …","new":"Neuer eingehender Webhook","none":"Es wurden keine eingehenden Webhooks erstellt.","no_emoji":"Kein Emoji ausgewählt","post_to":"Veröffentlichen in","reset_emoji":"Emoji zurücksetzen","save":"Speichern","edit":"Bearbeiten","select_emoji":"Emoji auswählen","system":"System","title":"Eingehende Webhooks","url":"URL","url_instructions":"Diese URL enthält einen geheimen Wert – bewahre ihn sicher auf.","username":"Benutzername","username_instructions":"Benutzername des Bots, der etwas im Kanal veröffentlicht. Standardmäßig „System“, wenn das Feld leer gelassen wird.","instructions":"Eingehende Webhooks können von externen Systemen verwendet werden, um Nachrichten als Bot-Benutzer über den Endpunkt \u003ccode\u003e/hooks/:key\u003c/code\u003e in einem bestimmten Chat-Kanal zu posten. Die Payload besteht aus einem einzigen \u003ccode\u003etext\u003c/code\u003e-Parameter, der auf 2000 Zeichen begrenzt ist.\u003cbr\u003e\u003cbr\u003eWir unterstützen auch in begrenztem Umfang Slack-formatierte \u003ccode\u003etext\u003c/code\u003e-Parameter und extrahieren Links und Erwähnungen basierend auf dem Format unter \u003ca href=\"https://api.slack.com/reference/surfaces/formatting\"\u003ehttps://api.slack.com/reference/surfaces/formatting\u003c/a\u003e, aber dazu muss der Endpunkt \u003ccode\u003e/hooks/:key/slack\u003c/code\u003e verwendet werden.","saved":"Webhook-Änderungen gespeichert","created":"Webhook erstellt"},"selection":{"cancel":"Abbrechen","quote_selection":"In Thema zitieren","copy":"Kopieren","delete":"Löschen (%{selectionCount}/%{totalCount})","move_selection_to_channel":"In Kanal verschieben","error":"Beim Verschieben der Chat-Nachrichten ist ein Fehler aufgetreten","title":"Chat in Thema verschieben","new_topic":{"title":"In neues Thema verschieben","instructions":{"one":"Du bist dabei, ein neues Thema zu erstellen und es mit der ausgewählten Chat-Nachricht zu füllen.","other":"Du bist dabei, ein neues Thema zu erstellen und es mit den \u003cb\u003e%{count}\u003c/b\u003e ausgewählten Chat-Nachrichten zu füllen."},"instructions_channel_archive":"Du bist dabei, ein neues Thema zu erstellen und die Kanalnachrichten darin zu archivieren."},"existing_topic":{"title":"In bestehendes Thema verschieben","instructions":{"one":"Bitte wähle das Thema aus, in das du die Chat-Nachricht verschieben möchtest.","other":"Bitte wähle das Thema aus, in das du die \u003cb\u003e%{count}\u003c/b\u003e Chat-Nachrichten verschieben möchtest."},"instructions_channel_archive":"Bitte wähle das Thema aus, in dem du die Kanalnachrichten archivieren möchtest."},"new_message":{"title":"In neue Nachricht verschieben","instructions":{"one":"Du bist dabei, eine neue Nachricht zu erstellen und sie mit der ausgewählten Chat-Nachricht zu füllen.","other":"Du bist dabei, eine neue Nachricht zu erstellen und sie mit den \u003cb\u003e%{count}\u003c/b\u003e ausgewählten Chat-Nachrichten zu füllen."}}},"replying_indicator":{"single_user":"%{username} schreibt","multiple_users":"%{commaSeparatedUsernames} und %{lastUsername} schreiben","many_users":{"one":"%{commaSeparatedUsernames} und %{count} andere Person schreiben","other":"%{commaSeparatedUsernames} und %{count} andere Personen schreiben"}},"retention_reminders":{"indefinitely_short":"unbestimmt","indefinitely_long":"Die Chat-Einstellungen wurden so eingestellt, dass Kanalnachrichten auf unbestimmte Zeit gespeichert werden.","short":{"one":"%{count} Tag","other":"%{count} Tage"},"long":{"one":"Die Chat-Einstellungen wurden so eingestellt, dass Kanalnachrichten für %{count} Tag aufbewahrt werden.","other":"Die Chat-Einstellungen wurden so eingestellt, dass Kanalnachrichten für %{count} Tage aufbewahrt werden."}},"flags":{"off_topic":"Diese Nachricht ist für die aktuelle Diskussion im Sinne des Kanaltitels nicht relevant und sollte wahrscheinlich an eine andere Stelle verschoben werden.","inappropriate":"Diese Nachricht enthält Inhalte, die eine vernünftige Person als anstößig, beleidigend oder als Verstoß gegen \u003ca href=\"%{basePath}/guidelines\"\u003eunsere Community-Richtlinien\u003c/a\u003e ansehen würde.","illegal":"Dieser Beitrag erfordert die Aufmerksamkeit des Teams, da er meiner Meinung nach rechtswidrige Inhalte enthält.","spam":"Diese Nachricht ist Werbung oder Vandalismus. Sie ist nicht nützlich oder relevant für den aktuellen Kanal.","notify_user":"Ich möchte mit dieser Person direkt und persönlich über ihre Nachricht sprechen.","notify_moderators":"Diese Nachricht erfordert die Aufmerksamkeit des Teams aus einem anderen, oben nicht aufgeführten Grund."},"flagging":{"action":"Nachricht melden"},"emoji_picker":{"favorites":"Häufig verwendet","smileys_\u0026_emotion":"Smileys und Emotionen","objects":"Objekte","people_\u0026_body":"Mensch und Körper","travel_\u0026_places":"Reisen und Orte","animals_\u0026_nature":"Tiere und Natur","food_\u0026_drink":"Essen und Trinken","activities":"Aktivitäten","flags":"Flaggen","symbols":"Symbole","search_placeholder":"Nach Emoji-Namen und -Alias suchen …","no_results":"Keine Ergebnisse"},"thread":{"title":"Titel","view_thread":"Thread aufrufen","replies":{"one":"%{count} Antwort","other":"%{count} Antworten"},"label":"Thread","close":"Thread schließen","original_message":{"started_by":"Gestartet von"},"settings":"Einstellungen","last_reply":"letzte Antw.","notifications":{"regular":{"title":"Normal","description":"Werde benachrichtigt, wenn dich jemand in diesem Thread erwähnt."},"tracking":{"title":"Verfolgen","description":"Lass dich benachrichtigen, wenn dich jemand in diesem Thread erwähnt, und sieh dir die Anzahl der neuen Antworten in der Thread-Liste an."},"watching":{"title":"Beobachten","description":"Lass dich über alle Antworten in diesem Thread benachrichtigen und sieh dir die Anzahl der neuen Antworten in der Thread-Liste an."}},"participants_other_count":{"one":"+%{count}","other":"+%{count}"}},"thread_title_toast":{"title":"Thread-Titel festlegen","message":"Hilf anderen, diese Unterhaltung zu entdecken.","dismiss_action":"Nicht erneut anzeigen","primary_action":"Titel festlegen"},"thread_title_modal":{"title":"Thread-Titel festlegen","input_placeholder":"Sag anderen, worum es in dieser Unterhaltung geht …","discourse_ai":{"title":"Thread-Titel automatisch generieren","description":"Unter %{url} erfährst du mehr über diese und andere Verbesserungen für dein Discourse-Erlebnis."}},"threads":{"open":"Thread öffnen","list":"Threads","none":"Du nimmst an keinem Thread in diesem Kanal teil."},"draft_channel_screen":{"header":"Neue Nachricht","cancel":"Abbrechen"}},"styleguide":{"sections":{"chat":{"title":"Chat"},"bem":{"title":"BEM"},"typography":{"title":"Typografie","example":"Willkommen bei Discourse","paragraph":"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."},"date_time_inputs":{"title":"Datum/Uhrzeit"},"menus":{"title":"Menüs"},"toasts":{"title":"Toasts"},"font_scale":{"title":"Schrift"},"colors":{"title":"Farben"},"icons":{"title":"Symbole","full_list":"Siehe vollständige Liste der „Font Awesome“-Symbole"},"forms":{"title":"Formulare"},"buttons":{"title":"Buttons"},"dropdowns":{"title":"Dropdowns"},"categories":{"title":"Kategorien"},"bread_crumbs":{"title":"Breadcrumbs"},"navigation":{"title":"Navigation"},"navigation_bar":{"title":"Navigationsleiste"},"navigation_stacked":{"title":"Gestapelte Navigation"},"categories_list":{"title":"Kategorienliste"},"topic_link":{"title":"Link zu Thema"},"topic_list_item":{"title":"Element in Themenliste"},"topic_statuses":{"title":"Themenstatus"},"topic_list":{"title":"Themenliste"},"basic_topic_list":{"title":"Grundlegende Themenliste"},"footer_message":{"title":"Fußzeile"},"signup_cta":{"title":"Aufforderung zur Registrierung"},"topic_timer_info":{"title":"Zeitschaltuhren"},"topic_footer_buttons":{"title":"Buttons in Themen-Fußzeile"},"topic_notifications":{"title":"Themen-Benachrichtigungen"},"post":{"title":"Beitrag"},"post_list":{"title":"Beitragsliste","empty_example":"\u003cPostList /\u003e leerer Zustand","populated_example":"\u003cPostList /\u003e gefüllter Zustand"},"topic_map":{"title":"Themenübersicht"},"site_header":{"title":"Seitenkopf"},"suggested_topics":{"title":"Vorgeschlagene Themen"},"post_menu":{"title":"Beitrag-Aktionen"},"modal":{"title":"Dialogbox","header":"Dialogbox-Titel","footer":"Dialogbox-Fußzeile"},"user_about":{"title":"Benutzerprofil"},"header_icons":{"title":"Header-Symbole"},"spinners":{"title":"Spinner"},"empty_state":{"title":"Empty State"},"tooltips":{"title":"Tooltipps","description":"Beschreibung","header":"Kopfzeile","hover_to_see":"Bewege den Mauszeiger darüber, um einen Tooltipp zu sehen"},"char_counter":{"title":"Zeichenzähler","placeholder":"Gib deinen Text hier ein …"}},"title":"Styleguide","welcome":"Wähle einen Abschnitt aus dem linken Menü aus, um loszulegen.","categories":{"syntax":"Syntax","atoms":"Atome","molecules":"Moleküle","organisms":"Organismen"}},"checklist":{"edit_reason":"Checklisten-Änderung"},"details":{"title":"Details ausblenden"},"discourse_local_dates":{"relative_dates":{"today":"Heute %{time}","tomorrow":"Morgen %{time}","yesterday":"Gestern %{time}","countdown":{"passed":"Datum liegt in der Vergangenheit"}},"title":"Datum/Uhrzeit einfügen","create":{"form":{"insert":"Einfügen","advanced_mode":"Erweiterter Modus","simple_mode":"Einfacher Modus","format_description":"Format, mit dem das Datum dem Benutzer angezeigt wird. Verwende „Z” zum Anzeigen der Differenz zu UTC und „zz” für den Zeitzonen-Namen.","timezones_title":"Anzuzeigende Zeitzonen","timezones_description":"Zeitzonen werden verwendet, um Datumsangaben in der Vorschau und als Ausweichlösung anzuzeigen.","recurring_title":"Wiederholung","recurring_description":"Definiere die Wiederholung eines Ereignisses. Du kannst die vom Formular generierte Wiederholung auch manuell ändern und einen der folgenden Schlüssel verwenden: years, quarters, months, weeks, days, hours, minutes, seconds, milliseconds.","recurring_none":"Keine Wiederholung","invalid_date":"Ungültige Datumsangabe. Stelle sicher, dass Datum und Uhrzeit korrekt sind.","date_title":"Datum","time_title":"Uhrzeit","format_title":"Datumsformat","timezone":"Zeitzone","until":"Bis …","current_timezone":"Aktuelle Zeitzone:","recurring":{"every_day":"Jeden Tag","every_week":"Jede Woche","every_two_weeks":"Alle 2 Wochen","every_month":"Jeden Monat","every_two_months":"Alle 2 Monate","every_three_months":"Alle 3 Monate","every_six_months":"Alle 6 Monate","every_year":"Jedes Jahr"}}},"default_title":"%{site_name}-Ereignis"},"discourse_narrative_bot":{"welcome_post_type":{"new_user_track":"Starte bei allen neuen Benutzern das „Tutorial für neue Benutzer“","welcome_message":"Sende allen neuen Benutzern eine Begrüßungsnachricht mit einer Kurzanleitung"}},"presence":{"replying":{"one":"antwortet","other":"antworten"},"editing":{"one":"bearbeitet","other":"bearbeiten"},"replying_to_topic":{"one":"antwortet","other":"antworten"}},"topic_voting":{"title":"Themenabstimmung","reached_limit":"Du hast keine Stimmen mehr. Entferne eine bestehende Stimme!","list_votes":"Deine Stimmen auflisten","votes_nav_help":"Themen mit den meisten Stimmen","voted":"Du hast für dieses Thema gestimmt","allow_topic_voting":"Benutzern erlauben, für Themen in dieser Kategorie zu stimmen","vote_title":"Stimme","vote_title_plural":"Stimmen","voted_title":"Abgestimmt","voting_closed_title":"Geschlossen","voting_limit":"Limit","votes_left":{"one":"Du hast noch %{count} Stimme übrig, siehe \u003ca href='%{path}'\u003edeine Stimmen\u003c/a\u003e.","other":"Du hast noch %{count} Stimmen übrig, siehe \u003ca href='%{path}'\u003edeine Stimmen\u003c/a\u003e."},"votes_left_button_title":{"one":"Du hast noch %{count} Stimme übrig.","other":"Du hast noch %{count} Stimmen übrig."},"votes":{"one":"%{count} Stimme","other":"%{count} Stimmen"},"anonymous_button":{"one":"Stimme","other":"Stimmen"},"remove_vote":"Stimme entfernen","no_votes_title_self":"Du hast noch für kein Thema gestimmt","no_votes_title_others":"%{username} hat noch für kein Thema gestimmt"},"user_notes":{"title":"Benutzer-Notizen","attach":"Benutzer-Notiz hinzufügen","remove":"Benutzer-Notiz entfernen","show":"Benutzer-Notizen (%{count})","delete_confirm":"Bist du sicher, dass du diese Benutzer-Notiz löschen möchtest?","show_post":"Beitrag anzeigen"},"poll":{"voters":{"one":"Teilnehmer","other":"Teilnehmer"},"total_votes":{"one":"abgegebene Stimme","other":"abgegebene Stimmen"},"votes":{"one":"%{count} Stimme","other":"%{count} Stimmen"},"average_rating":"Durchschnittliche Bewertung: \u003cstrong\u003e%{average}\u003c/strong\u003e","public":{"title":"Stimmen sind \u003cstrong\u003eöffentlich\u003c/strong\u003e."},"results":{"groups":{"title":"Du musst ein Mitglied von %{groups} sein, um an dieser Umfrage teilnehmen zu können."},"vote":{"title":"Ergebnisse werden \u003cstrong\u003enach Stimmabgabe\u003c/strong\u003e angezeigt."},"closed":{"title":"Ergebnisse werden angezeigt, sobald die Abstimmung \u003cstrong\u003ebeendet\u003c/strong\u003e ist."},"staff":{"title":"Ergebnisse werden nur \u003cstrong\u003eTeam-Mitgliedern\u003c/strong\u003e angezeigt."},"tabs":{"votes":"Stimmen","outcome":"Ergebnis"}},"multiple":{"help":{"at_least_min_options":{"one":"Wähle mindestens \u003cstrong\u003e%{count} Option\u003c/strong\u003e aus.","other":"Wähle mindestens \u003cstrong\u003e%{count} Optionen\u003c/strong\u003e aus."},"up_to_max_options":{"one":"Wähle bis zu \u003cstrong\u003e%{count} Option\u003c/strong\u003e aus.","other":"Wähle bis zu \u003cstrong\u003e%{count} Optionen\u003c/strong\u003e aus."},"x_options":{"one":"Wähle \u003cstrong\u003e%{count} Option\u003c/strong\u003e aus.","other":"Wähle \u003cstrong\u003e%{count} Optionen\u003c/strong\u003e aus."},"between_min_and_max_options":"Wähle zwischen \u003cstrong\u003e%{min} und %{max} Optionen\u003c/strong\u003e aus."}},"cast-votes":{"title":"Gib deine Stimmen ab","label":"Jetzt abstimmen!"},"show-results":{"title":"Das Ergebnis der Umfrage anzeigen","label":"Ergebnisse"},"show-tally":{"title":"Abstimmungsergebnisse als absolute Zahlen anzeigen","label":"Anzahl anzeigen"},"show-percentage":{"title":"Abstimmungsergebnisse als Prozentsätze anzeigen","label":"Prozentsätze anzeigen"},"remove-vote":{"title":"Entferne deine Stimme","label":"Abstimmung zurücknehmen"},"hide-results":{"title":"Zurück zur Umfrage","label":"Abstimmen"},"group-results":{"title":"Stimmen anhand von Benutzerfeld gruppieren","label":"Aufschlüsselung anzeigen"},"export-results":{"title":"Ergebnisse der Umfrage exportieren","label":"Exportieren"},"open":{"title":"Umfrage starten","label":"Starten","confirm":"Möchtest du diese Umfrage wirklich starten?"},"close":{"title":"Umfrage beenden","label":"Beenden","confirm":"Möchtest du diese Umfrage wirklich beenden?"},"automatic_close":{"closes_in":"Wird in \u003cstrong\u003e%{timeLeft}\u003c/strong\u003e beendet.","age":"Geschlossen \u003cstrong\u003e%{age}\u003c/strong\u003e"},"breakdown":{"title":"Ergebnisse der Umfrage","votes":"%{count} Stimmen","breakdown":"Aufschlüsselung","percentage":"Prozentsatz","count":"Anzahl"},"ranked_choice":{"title":{"rounds":"Runden","outcome":"Ergebnis"},"none":"Keiner","majority":"Mehrheit","eliminated":"Eliminiert","round":"Runde","winner":{"one":"Der Gewinner war %{winner} nach einer Runde.","other":"Der Gewinner war %{winner} nach %{count} Runden."},"tied":{"one":"Gleichstand nach einer Runde zwischen folgenden Kandidaten:","other":"Gleichstand nach %{count} Runden zwischen folgenden Kandidaten:"}},"options":{"label":"Optionen","ranked_choice":{"abstain":"Enthalten","highest_priority":"(höchste Priorität)","lowest_priority":"(niedrigste Priorität)","login":"Zum Abstimmen anmelden!"}},"error_while_toggling_status":"Leider ist beim Umschalten des Status dieser Umfrage ein Fehler aufgetreten.","error_while_casting_votes":"Leider ist beim Abgeben deiner Stimmen ein Fehler aufgetreten.","error_while_fetching_voters":"Leider ist beim Anzeigen der Teilnehmer ein Fehler aufgetreten.","error_while_exporting_results":"Leider ist beim Exportieren der Umfrageergebnisse ein Fehler aufgetreten.","ui_builder":{"title":"Umfrage erstellen","insert":"Umfrage einfügen","help":{"options_min_count":"Gib mindestens eine Option ein.","options_max_count":"Gib maximal %{count} Optionen ein.","invalid_min_value":"Der Mindestwert muss mindestens 1 betragen.","invalid_max_value":"Der Maximalwert muss mindestens 1 betragen, aber kleiner oder gleich der Anzahl der Optionen sein.","invalid_values":"Der Mindestwert muss kleiner als der Höchstwert sein.","min_step_value":"Die minimale Schrittweite beträgt 1."},"poll_type":{"label":"Art","regular":"Einfachauswahl","multiple":"Mehrfachauswahl","ranked_choice":"Rangfolgewahl","number":"Bewertung"},"poll_result":{"label":"Ergebnisse anzeigen …","always":"Immer sichtbar","vote":"Nur nach Stimmabgabe","closed":"Wenn die Umfrage geschlossen ist","staff":"Nur Team-Mitglieder"},"poll_groups":{"label":"Abstimmung auf diese Gruppen beschränken"},"poll_chart_type":{"label":"Ergebnisübersicht","bar":"Balken","pie":"Torte"},"poll_config":{"max":"Max. Auswahl","min":"Min. Auswahl","step":"Schrittweite"},"poll_public":{"label":"Anzeigen, wer abgestimmt hat"},"poll_title":{"label":"Titel (optional)"},"poll_options":{"label":"Optionen (eine pro Zeile)","add":"Option hinzufügen"},"automatic_close":{"label":"Umfrage automatisch beenden"},"show_advanced":"Erweiterte Optionen anzeigen","hide_advanced":"Erweiterte Optionen ausblenden"}},"spoiler":{"title":"Spoiler unkenntlich machen","label":{"show":"Zeige ausgeblendeten Inhalt"}}}},"en":{"js":{"footnote":{"title":"Footnotes"}}}};
I18n.locale = 'de';
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i,
            arrLen = arr.length;
        for (i = 0; i < arrLen; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        var flags = null,
            parsedParts = false,
            isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            isNowValid =
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidEra &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));
            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        } else {
            return isNowValid;
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i,
            prop,
            val,
            momentPropertiesLen = momentProperties.length;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentPropertiesLen > 0) {
            for (i = 0; i < momentPropertiesLen; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key,
                    argLen = arguments.length;
                for (i = 0; i < argLen; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens =
            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year',
    };

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1,
    };

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord =
            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        match1to2NoLeadingZero = /^[1-9]\d?/, //         1-99
        match1to2HasZero = /^([1-9]\d|\d)/, //           0-99
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(
                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
                    function (matched, p1, p2, p3, p4) {
                        return p1 || p2 || p3 || p4;
                    }
                )
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback,
            tokenLen;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        tokenLen = token.length;
        for (i = 0; i < tokenLen; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        if (!mom.isValid()) {
            return NaN;
        }

        var d = mom._d,
            isUTC = mom._isUTC;

        switch (unit) {
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }

    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;

        if (!mom.isValid() || isNaN(value)) {
            return;
        }

        d = mom._d;
        isUTC = mom._isUTC;

        switch (unit) {
            case 'Milliseconds':
                return void (isUTC
                    ? d.setUTCMilliseconds(value)
                    : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }

        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        void (isUTC
            ? d.setUTCFullYear(year, month, date)
            : d.setFullYear(year, month, date));
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i,
                prioritizedLen = prioritized.length;
            for (i = 0; i < prioritizedLen; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // PARSING

    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths =
            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
                '_'
            ),
        defaultLocaleMonthsShort =
            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        var month = value,
            date = mom.date();

        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        void (mom._isUTC
            ? mom._d.setUTCMonth(month, date)
            : mom._d.setMonth(month, date));
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            shortP,
            longP;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // PARSING

    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(
        ['w', 'ww', 'W', 'WW'],
        function (input, week, config, token) {
            week[token.substr(0, 1)] = toInt(input);
        }
    );

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays =
            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
              ? weekdays[m.day()]
              : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
              ? this._weekdaysShort[m.day()]
              : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
              ? this._weekdaysMin[m.day()]
              : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            typeof module !== 'undefined' &&
            module &&
            module.exports &&
            isLocaleNameSane(name)
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = require;
                aliasedRequire('./locale/' + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                      ? DATE
                      : a[HOUR] < 0 ||
                          a[HOUR] > 24 ||
                          (a[HOUR] === 24 &&
                              (a[MINUTE] !== 0 ||
                                  a[SECOND] !== 0 ||
                                  a[MILLISECOND] !== 0))
                        ? HOUR
                        : a[MINUTE] < 0 || a[MINUTE] > 59
                          ? MINUTE
                          : a[SECOND] < 0 || a[SECOND] > 59
                            ? SECOND
                            : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                              ? MILLISECOND
                              : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 =
            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat,
            isoDatesLen = isoDates.length,
            isoTimesLen = isoTimes.length;

        if (match) {
            getParsingFlags(config).iso = true;
            for (i = 0, l = isoDatesLen; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimesLen; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^()]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era,
            tokenLen;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for (i = 0; i < tokenLen; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false,
            configfLen = config._f.length;

        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < configfLen; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i,
            orderLen = ordering.length;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < orderLen; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex =
            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property,
            propertyLen = properties.length;

        for (i = 0; i < propertyLen; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
              ? 'lastWeek'
              : diff < 0
                ? 'lastDay'
                : diff < 1
                  ? 'sameDay'
                  : diff < 2
                    ? 'nextDay'
                    : diff < 7
                      ? 'nextWeek'
                      : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(
        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
        function (input, array, config, token) {
            var era = config._locale.erasParse(input, token, config._strict);
            if (era) {
                getParsingFlags(config).era = era;
            } else {
                getParsingFlags(config).invalidEra = input;
            }
        }
    );

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            erasName,
            erasAbbr,
            erasNarrow,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);

            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(
        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
        function (input, week, config, token) {
            week[token.substr(0, 2)] = toInt(input);
        }
    );

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday() + this.localeData()._week.dow,
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // PARSING

    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // PARSING

    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // PARSING

    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y'),
        valueOf$1 = asMilliseconds;

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.30.1';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));
//! moment-timezone.js
//! version : 0.5.45
//! Copyright (c) JS Foundation and other contributors
//! license : MIT
//! github.com/moment/moment-timezone

(function (root, factory) {
	"use strict";

	/*global define*/
	if (typeof module === 'object' && module.exports) {
		module.exports = factory(require('moment')); // Node
	} else if (typeof define === 'function' && define.amd) {
		define(['moment'], factory);                 // AMD
	} else {
		factory(root.moment);                        // Browser
	}
}(this, function (moment) {
	"use strict";

	// Resolves es6 module loading issue
	if (moment.version === undefined && moment.default) {
		moment = moment.default;
	}

	// Do not load moment-timezone a second time.
	// if (moment.tz !== undefined) {
	// 	logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
	// 	return moment;
	// }

	var VERSION = "0.5.45",
		zones = {},
		links = {},
		countries = {},
		names = {},
		guesses = {},
		cachedGuess;

	if (!moment || typeof moment.version !== 'string') {
		logError('Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/');
	}

	var momentVersion = moment.version.split('.'),
		major = +momentVersion[0],
		minor = +momentVersion[1];

	// Moment.js version check
	if (major < 2 || (major === 2 && minor < 6)) {
		logError('Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js ' + moment.version + '. See momentjs.com');
	}

	/************************************
		Unpacking
	************************************/

	function charCodeToInt(charCode) {
		if (charCode > 96) {
			return charCode - 87;
		} else if (charCode > 64) {
			return charCode - 29;
		}
		return charCode - 48;
	}

	function unpackBase60(string) {
		var i = 0,
			parts = string.split('.'),
			whole = parts[0],
			fractional = parts[1] || '',
			multiplier = 1,
			num,
			out = 0,
			sign = 1;

		// handle negative numbers
		if (string.charCodeAt(0) === 45) {
			i = 1;
			sign = -1;
		}

		// handle digits before the decimal
		for (i; i < whole.length; i++) {
			num = charCodeToInt(whole.charCodeAt(i));
			out = 60 * out + num;
		}

		// handle digits after the decimal
		for (i = 0; i < fractional.length; i++) {
			multiplier = multiplier / 60;
			num = charCodeToInt(fractional.charCodeAt(i));
			out += num * multiplier;
		}

		return out * sign;
	}

	function arrayToInt (array) {
		for (var i = 0; i < array.length; i++) {
			array[i] = unpackBase60(array[i]);
		}
	}

	function intToUntil (array, length) {
		for (var i = 0; i < length; i++) {
			array[i] = Math.round((array[i - 1] || 0) + (array[i] * 60000)); // minutes to milliseconds
		}

		array[length - 1] = Infinity;
	}

	function mapIndices (source, indices) {
		var out = [], i;

		for (i = 0; i < indices.length; i++) {
			out[i] = source[indices[i]];
		}

		return out;
	}

	function unpack (string) {
		var data = string.split('|'),
			offsets = data[2].split(' '),
			indices = data[3].split(''),
			untils  = data[4].split(' ');

		arrayToInt(offsets);
		arrayToInt(indices);
		arrayToInt(untils);

		intToUntil(untils, indices.length);

		return {
			name       : data[0],
			abbrs      : mapIndices(data[1].split(' '), indices),
			offsets    : mapIndices(offsets, indices),
			untils     : untils,
			population : data[5] | 0
		};
	}

	/************************************
		Zone object
	************************************/

	function Zone (packedString) {
		if (packedString) {
			this._set(unpack(packedString));
		}
	}

	function closest (num, arr) {
		var len = arr.length;
		if (num < arr[0]) {
			return 0;
		} else if (len > 1 && arr[len - 1] === Infinity && num >= arr[len - 2]) {
			return len - 1;
		} else if (num >= arr[len - 1]) {
			return -1;
		}

		var mid;
		var lo = 0;
		var hi = len - 1;
		while (hi - lo > 1) {
			mid = Math.floor((lo + hi) / 2);
			if (arr[mid] <= num) {
				lo = mid;
			} else {
				hi = mid;
			}
		}
		return hi;
	}

	Zone.prototype = {
		_set : function (unpacked) {
			this.name       = unpacked.name;
			this.abbrs      = unpacked.abbrs;
			this.untils     = unpacked.untils;
			this.offsets    = unpacked.offsets;
			this.population = unpacked.population;
		},

		_index : function (timestamp) {
			var target = +timestamp,
				untils = this.untils,
				i;

			i = closest(target, untils);
			if (i >= 0) {
				return i;
			}
		},

		countries : function () {
			var zone_name = this.name;
			return Object.keys(countries).filter(function (country_code) {
				return countries[country_code].zones.indexOf(zone_name) !== -1;
			});
		},

		parse : function (timestamp) {
			var target  = +timestamp,
				offsets = this.offsets,
				untils  = this.untils,
				max     = untils.length - 1,
				offset, offsetNext, offsetPrev, i;

			for (i = 0; i < max; i++) {
				offset     = offsets[i];
				offsetNext = offsets[i + 1];
				offsetPrev = offsets[i ? i - 1 : i];

				if (offset < offsetNext && tz.moveAmbiguousForward) {
					offset = offsetNext;
				} else if (offset > offsetPrev && tz.moveInvalidForward) {
					offset = offsetPrev;
				}

				if (target < untils[i] - (offset * 60000)) {
					return offsets[i];
				}
			}

			return offsets[max];
		},

		abbr : function (mom) {
			return this.abbrs[this._index(mom)];
		},

		offset : function (mom) {
			logError("zone.offset has been deprecated in favor of zone.utcOffset");
			return this.offsets[this._index(mom)];
		},

		utcOffset : function (mom) {
			return this.offsets[this._index(mom)];
		}
	};

	/************************************
		Country object
	************************************/

	function Country (country_name, zone_names) {
		this.name = country_name;
		this.zones = zone_names;
	}

	/************************************
		Current Timezone
	************************************/

	function OffsetAt(at) {
		var timeString = at.toTimeString();
		var abbr = timeString.match(/\([a-z ]+\)/i);
		if (abbr && abbr[0]) {
			// 17:56:31 GMT-0600 (CST)
			// 17:56:31 GMT-0600 (Central Standard Time)
			abbr = abbr[0].match(/[A-Z]/g);
			abbr = abbr ? abbr.join('') : undefined;
		} else {
			// 17:56:31 CST
			// 17:56:31 GMT+0800 (台北標準時間)
			abbr = timeString.match(/[A-Z]{3,5}/g);
			abbr = abbr ? abbr[0] : undefined;
		}

		if (abbr === 'GMT') {
			abbr = undefined;
		}

		this.at = +at;
		this.abbr = abbr;
		this.offset = at.getTimezoneOffset();
	}

	function ZoneScore(zone) {
		this.zone = zone;
		this.offsetScore = 0;
		this.abbrScore = 0;
	}

	ZoneScore.prototype.scoreOffsetAt = function (offsetAt) {
		this.offsetScore += Math.abs(this.zone.utcOffset(offsetAt.at) - offsetAt.offset);
		if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, '') !== offsetAt.abbr) {
			this.abbrScore++;
		}
	};

	function findChange(low, high) {
		var mid, diff;

		while ((diff = ((high.at - low.at) / 12e4 | 0) * 6e4)) {
			mid = new OffsetAt(new Date(low.at + diff));
			if (mid.offset === low.offset) {
				low = mid;
			} else {
				high = mid;
			}
		}

		return low;
	}

	function userOffsets() {
		var startYear = new Date().getFullYear() - 2,
			last = new OffsetAt(new Date(startYear, 0, 1)),
			lastOffset = last.offset,
			offsets = [last],
			change, next, nextOffset, i;

		for (i = 1; i < 48; i++) {
			nextOffset = new Date(startYear, i, 1).getTimezoneOffset();
			if (nextOffset !== lastOffset) {
				// Create OffsetAt here to avoid unnecessary abbr parsing before checking offsets
				next = new OffsetAt(new Date(startYear, i, 1));
				change = findChange(last, next);
				offsets.push(change);
				offsets.push(new OffsetAt(new Date(change.at + 6e4)));
				last = next;
				lastOffset = nextOffset;
			}
		}

		for (i = 0; i < 4; i++) {
			offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
			offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
		}

		return offsets;
	}

	function sortZoneScores (a, b) {
		if (a.offsetScore !== b.offsetScore) {
			return a.offsetScore - b.offsetScore;
		}
		if (a.abbrScore !== b.abbrScore) {
			return a.abbrScore - b.abbrScore;
		}
		if (a.zone.population !== b.zone.population) {
			return b.zone.population - a.zone.population;
		}
		return b.zone.name.localeCompare(a.zone.name);
	}

	function addToGuesses (name, offsets) {
		var i, offset;
		arrayToInt(offsets);
		for (i = 0; i < offsets.length; i++) {
			offset = offsets[i];
			guesses[offset] = guesses[offset] || {};
			guesses[offset][name] = true;
		}
	}

	function guessesForUserOffsets (offsets) {
		var offsetsLength = offsets.length,
			filteredGuesses = {},
			out = [],
			checkedOffsets = {},
			i, j, offset, guessesOffset;

		for (i = 0; i < offsetsLength; i++) {
			offset = offsets[i].offset;
			if (checkedOffsets.hasOwnProperty(offset)) {
				continue;
			}
			guessesOffset = guesses[offset] || {};
			for (j in guessesOffset) {
				if (guessesOffset.hasOwnProperty(j)) {
					filteredGuesses[j] = true;
				}
			}
			checkedOffsets[offset] = true;
		}

		for (i in filteredGuesses) {
			if (filteredGuesses.hasOwnProperty(i)) {
				out.push(names[i]);
			}
		}

		return out;
	}

	function rebuildGuess () {

		// use Intl API when available and returning valid time zone
		try {
			var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
			if (intlName && intlName.length > 3) {
				var name = names[normalizeName(intlName)];
				if (name) {
					return name;
				}
				logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
			}
		} catch (e) {
			// Intl unavailable, fall back to manual guessing.
		}

		var offsets = userOffsets(),
			offsetsLength = offsets.length,
			guesses = guessesForUserOffsets(offsets),
			zoneScores = [],
			zoneScore, i, j;

		for (i = 0; i < guesses.length; i++) {
			zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
			for (j = 0; j < offsetsLength; j++) {
				zoneScore.scoreOffsetAt(offsets[j]);
			}
			zoneScores.push(zoneScore);
		}

		zoneScores.sort(sortZoneScores);

		return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
	}

	function guess (ignoreCache) {
		if (!cachedGuess || ignoreCache) {
			cachedGuess = rebuildGuess();
		}
		return cachedGuess;
	}

	/************************************
		Global Methods
	************************************/

	function normalizeName (name) {
		return (name || '').toLowerCase().replace(/\//g, '_');
	}

	function addZone (packed) {
		var i, name, split, normalized;

		if (typeof packed === "string") {
			packed = [packed];
		}

		for (i = 0; i < packed.length; i++) {
			split = packed[i].split('|');
			name = split[0];
			normalized = normalizeName(name);
			zones[normalized] = packed[i];
			names[normalized] = name;
			addToGuesses(normalized, split[2].split(' '));
		}
	}

	function getZone (name, caller) {

		name = normalizeName(name);

		var zone = zones[name];
		var link;

		if (zone instanceof Zone) {
			return zone;
		}

		if (typeof zone === 'string') {
			zone = new Zone(zone);
			zones[name] = zone;
			return zone;
		}

		// Pass getZone to prevent recursion more than 1 level deep
		if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
			zone = zones[name] = new Zone();
			zone._set(link);
			zone.name = names[name];
			return zone;
		}

		return null;
	}

	function getNames () {
		var i, out = [];

		for (i in names) {
			if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) {
				out.push(names[i]);
			}
		}

		return out.sort();
	}

	function getCountryNames () {
		return Object.keys(countries);
	}

	function addLink (aliases) {
		var i, alias, normal0, normal1;

		if (typeof aliases === "string") {
			aliases = [aliases];
		}

		for (i = 0; i < aliases.length; i++) {
			alias = aliases[i].split('|');

			normal0 = normalizeName(alias[0]);
			normal1 = normalizeName(alias[1]);

			links[normal0] = normal1;
			names[normal0] = alias[0];

			links[normal1] = normal0;
			names[normal1] = alias[1];
		}
	}

	function addCountries (data) {
		var i, country_code, country_zones, split;
		if (!data || !data.length) return;
		for (i = 0; i < data.length; i++) {
			split = data[i].split('|');
			country_code = split[0].toUpperCase();
			country_zones = split[1].split(' ');
			countries[country_code] = new Country(
				country_code,
				country_zones
			);
		}
	}

	function getCountry (name) {
		name = name.toUpperCase();
		return countries[name] || null;
	}

	function zonesForCountry(country, with_offset) {
		country = getCountry(country);

		if (!country) return null;

		var zones = country.zones.sort();

		if (with_offset) {
			return zones.map(function (zone_name) {
				var zone = getZone(zone_name);
				return {
					name: zone_name,
					offset: zone.utcOffset(new Date())
				};
			});
		}

		return zones;
	}

	function loadData (data) {
		addZone(data.zones);
		addLink(data.links);
		addCountries(data.countries);
		tz.dataVersion = data.version;
	}

	function zoneExists (name) {
		if (!zoneExists.didShowError) {
			zoneExists.didShowError = true;
				logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
		}
		return !!getZone(name);
	}

	function needsOffset (m) {
		var isUnixTimestamp = (m._f === 'X' || m._f === 'x');
		return !!(m._a && (m._tzm === undefined) && !isUnixTimestamp);
	}

	function logError (message) {
		if (typeof console !== 'undefined' && typeof console.error === 'function') {
			console.error(message);
		}
	}

	/************************************
		moment.tz namespace
	************************************/

	function tz (input) {
		var args = Array.prototype.slice.call(arguments, 0, -1),
			name = arguments[arguments.length - 1],
			out  = moment.utc.apply(null, args),
			zone;

		if (!moment.isMoment(input) && needsOffset(out) && (zone = getZone(name))) {
			out.add(zone.parse(out), 'minutes');
		}

		out.tz(name);

		return out;
	}

	tz.version      = VERSION;
	tz.dataVersion  = '';
	tz._zones       = zones;
	tz._links       = links;
	tz._names       = names;
	tz._countries	= countries;
	tz.add          = addZone;
	tz.link         = addLink;
	tz.load         = loadData;
	tz.zone         = getZone;
	tz.zoneExists   = zoneExists; // deprecated in 0.1.0
	tz.guess        = guess;
	tz.names        = getNames;
	tz.Zone         = Zone;
	tz.unpack       = unpack;
	tz.unpackBase60 = unpackBase60;
	tz.needsOffset  = needsOffset;
	tz.moveInvalidForward   = true;
	tz.moveAmbiguousForward = false;
	tz.countries    = getCountryNames;
	tz.zonesForCountry = zonesForCountry;

	/************************************
		Interface with Moment.js
	************************************/

	var fn = moment.fn;

	moment.tz = tz;

	moment.defaultZone = null;

	moment.updateOffset = function (mom, keepTime) {
		var zone = moment.defaultZone,
			offset;

		if (mom._z === undefined) {
			if (zone && needsOffset(mom) && !mom._isUTC && mom.isValid()) {
				mom._d = moment.utc(mom._a)._d;
				mom.utc().add(zone.parse(mom), 'minutes');
			}
			mom._z = zone;
		}
		if (mom._z) {
			offset = mom._z.utcOffset(mom);
			if (Math.abs(offset) < 16) {
				offset = offset / 60;
			}
			if (mom.utcOffset !== undefined) {
				var z = mom._z;
				mom.utcOffset(-offset, keepTime);
				mom._z = z;
			} else {
				mom.zone(offset, keepTime);
			}
		}
	};

	fn.tz = function (name, keepTime) {
		if (name) {
			if (typeof name !== 'string') {
				throw new Error('Time zone name must be a string, got ' + name + ' [' + typeof name + ']');
			}
			this._z = getZone(name);
			if (this._z) {
				moment.updateOffset(this, keepTime);
			} else {
				logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
			}
			return this;
		}
		if (this._z) { return this._z.name; }
	};

	function abbrWrap (old) {
		return function () {
			if (this._z) { return this._z.abbr(this); }
			return old.call(this);
		};
	}

	function resetZoneWrap (old) {
		return function () {
			this._z = null;
			return old.apply(this, arguments);
		};
	}

	function resetZoneWrap2 (old) {
		return function () {
			if (arguments.length > 0) this._z = null;
			return old.apply(this, arguments);
		};
	}

	fn.zoneName  = abbrWrap(fn.zoneName);
	fn.zoneAbbr  = abbrWrap(fn.zoneAbbr);
	fn.utc       = resetZoneWrap(fn.utc);
	fn.local     = resetZoneWrap(fn.local);
	fn.utcOffset = resetZoneWrap2(fn.utcOffset);

	moment.tz.setDefault = function(name) {
		if (major < 2 || (major === 2 && minor < 9)) {
			logError('Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js ' + moment.version + '.');
		}
		moment.defaultZone = name ? getZone(name) : null;
		return moment;
	};

	// Cloning a moment should include the _z property.
	var momentProperties = moment.momentProperties;
	if (Object.prototype.toString.call(momentProperties) === '[object Array]') {
		// moment 2.8.1+
		momentProperties.push('_z');
		momentProperties.push('_a');
	} else if (momentProperties) {
		// moment 2.7.0
		momentProperties._z = null;
	}

	loadData({
		"version": "2024a",
		"zones": [
			"Africa/Abidjan|GMT|0|0||48e5",
			"Africa/Nairobi|EAT|-30|0||47e5",
			"Africa/Algiers|CET|-10|0||26e5",
			"Africa/Lagos|WAT|-10|0||17e6",
			"Africa/Khartoum|CAT|-20|0||51e5",
			"Africa/Cairo|EET EEST|-20 -30|010101010101010|29NW0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0|15e6",
			"Africa/Casablanca|+01 +00|-10 0|010101010101010101010101|208q0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600|32e5",
			"Europe/Paris|CET CEST|-10 -20|01010101010101010101010|1XSp0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0|11e6",
			"Africa/Johannesburg|SAST|-20|0||84e5",
			"Africa/Juba|EAT CAT|-30 -20|01|24nx0|",
			"Africa/Sao_Tome|WAT GMT|-10 0|01|1XiN0|",
			"Africa/Tripoli|EET|-20|0||11e5",
			"America/Adak|HST HDT|a0 90|01010101010101010101010|1XKc0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0|326",
			"America/Anchorage|AKST AKDT|90 80|01010101010101010101010|1XKb0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0|30e4",
			"America/Santo_Domingo|AST|40|0||29e5",
			"America/Fortaleza|-03|30|0||34e5",
			"America/Asuncion|-03 -04|30 40|01010101010101010101010|1XPD0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0|28e5",
			"America/Panama|EST|50|0||15e5",
			"America/Mexico_City|CST CDT|60 50|010101010|1XVk0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|20e6",
			"America/Managua|CST|60|0||22e5",
			"America/Caracas|-04|40|0||29e5",
			"America/Lima|-05|50|0||11e6",
			"America/Denver|MST MDT|70 60|01010101010101010101010|1XK90 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0|26e5",
			"America/Campo_Grande|-03 -04|30 40|01|1XBD0|77e4",
			"America/Chicago|CST CDT|60 50|01010101010101010101010|1XK80 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0|92e5",
			"America/Chihuahua|MST MDT CST|70 60 60|010101012|1XVl0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|81e4",
			"America/Ciudad_Juarez|MST MDT CST|70 60 60|010101012010101010101010|1XK90 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1wn0 cm0 EP0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Phoenix|MST|70|0||42e5",
			"America/Whitehorse|PST PDT MST|80 70 70|01012|1XKa0 1zb0 Op0 1z90|23e3",
			"America/New_York|EST EDT|50 40|01010101010101010101010|1XK70 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0|21e6",
			"America/Los_Angeles|PST PDT|80 70|01010101010101010101010|1XKa0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0|15e6",
			"America/Halifax|AST ADT|40 30|01010101010101010101010|1XK60 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0|39e4",
			"America/Godthab|-03 -02 -01|30 20 10|0101010101212121212121|1XSp0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 2so0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0|17e3",
			"America/Havana|CST CDT|50 40|01010101010101010101010|1XK50 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5",
			"America/Mazatlan|MST MDT|70 60|010101010|1XVl0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|44e4",
			"America/Metlakatla|PST AKST AKDT|80 90 80|012121212121212121212121|1Xqy0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0|14e2",
			"America/Miquelon|-03 -02|30 20|01010101010101010101010|1XK50 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0|61e2",
			"America/Noronha|-02|20|0||30e2",
			"America/Ojinaga|MST MDT CST CDT|70 60 60 50|01010101232323232323232|1XK90 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1wn0 Rc0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0|23e3",
			"America/Santiago|-03 -04|30 40|01010101010101010101010|1XVf0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|62e5",
			"America/Sao_Paulo|-02 -03|20 30|01|1XBC0|20e6",
			"America/Scoresbysund|-01 +00 -02|10 0 20|0101010101020202020202|1XSp0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 2pA0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0|452",
			"America/St_Johns|NST NDT|3u 2u|01010101010101010101010|1XK5u 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0|11e4",
			"Antarctica/Casey|+11 +08|-b0 -80|0101010101|1XME0 1kr0 12l0 1o01 14kX 1lf1 14kX 1lf1 13bX|10",
			"Asia/Bangkok|+07|-70|0||15e6",
			"Asia/Vladivostok|+10|-a0|0||60e4",
			"Australia/Sydney|AEDT AEST|-b0 -a0|01010101010101010101010|1XV40 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0|40e5",
			"Asia/Tashkent|+05|-50|0||23e5",
			"Pacific/Auckland|NZDT NZST|-d0 -c0|01010101010101010101010|1XV20 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0|14e5",
			"Europe/Istanbul|+03|-30|0||13e6",
			"Antarctica/Troll|+00 +02|0 -20|01010101010101010101010|1XSp0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0|40",
			"Antarctica/Vostok|+07 +05|-70 -50|01|2bnv0|25",
			"Asia/Almaty|+06 +05|-60 -50|01|2bR60|15e5",
			"Asia/Amman|EET EEST +03|-20 -30 -30|010101012|1XRy0 1o00 11A0 1qM0 WM0 1qM0 LA0 1C00|25e5",
			"Asia/Kamchatka|+12|-c0|0||18e4",
			"Asia/Dubai|+04|-40|0||39e5",
			"Asia/Beirut|EET EEST|-20 -30|01010101010101010101010|1XSm0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0|22e5",
			"Asia/Dhaka|+06|-60|0||16e6",
			"Asia/Kuala_Lumpur|+08|-80|0||71e5",
			"Asia/Kolkata|IST|-5u|0||15e6",
			"Asia/Chita|+09|-90|0||33e4",
			"Asia/Shanghai|CST|-80|0||23e6",
			"Asia/Colombo|+0530|-5u|0||22e5",
			"Asia/Damascus|EET EEST +03|-20 -30 -30|010101012|1XRy0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0|26e5",
			"Europe/Athens|EET EEST|-20 -30|01010101010101010101010|1XSp0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0|35e5",
			"Asia/Gaza|EET EEST|-20 -30|01010101010101010101010|1XRy0 1on0 11B0 1o00 11A0 1qo0 XA0 1qp0 1cN0 1cL0 1a10 1fz0 17d0 1in0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0|18e5",
			"Asia/Hong_Kong|HKT|-80|0||73e5",
			"Asia/Jakarta|WIB|-70|0||31e6",
			"Asia/Jayapura|WIT|-90|0||26e4",
			"Asia/Jerusalem|IST IDT|-20 -30|01010101010101010101010|1XRA0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0|81e4",
			"Asia/Kabul|+0430|-4u|0||46e5",
			"Asia/Karachi|PKT|-50|0||24e6",
			"Asia/Kathmandu|+0545|-5J|0||12e5",
			"Asia/Sakhalin|+11|-b0|0||58e4",
			"Asia/Makassar|WITA|-80|0||15e5",
			"Asia/Manila|PST|-80|0||24e6",
			"Asia/Seoul|KST|-90|0||23e6",
			"Asia/Rangoon|+0630|-6u|0||48e5",
			"Asia/Tehran|+0330 +0430|-3u -4u|010101010|1XOIu 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0|14e6",
			"Asia/Tokyo|JST|-90|0||38e6",
			"Atlantic/Azores|-01 +00|10 0|01010101010101010101010|1XSp0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0|25e4",
			"Europe/Lisbon|WET WEST|0 -10|01010101010101010101010|1XSp0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0|27e5",
			"Atlantic/Cape_Verde|-01|10|0||50e4",
			"Australia/Adelaide|ACDT ACST|-au -9u|01010101010101010101010|1XV4u 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0|11e5",
			"Australia/Brisbane|AEST|-a0|0||20e5",
			"Australia/Darwin|ACST|-9u|0||12e4",
			"Australia/Eucla|+0845|-8J|0||368",
			"Australia/Lord_Howe|+11 +1030|-b0 -au|01010101010101010101010|1XV30 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu|347",
			"Australia/Perth|AWST|-80|0||18e5",
			"Pacific/Easter|-05 -06|50 60|01010101010101010101010|1XVf0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|30e2",
			"Europe/Dublin|GMT IST|0 -10|01010101010101010101010|1XSp0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0|12e5",
			"Etc/GMT-1|+01|-10|0||",
			"Pacific/Tongatapu|+13|-d0|0||75e3",
			"Pacific/Kiritimati|+14|-e0|0||51e2",
			"Etc/GMT-2|+02|-20|0||",
			"Pacific/Tahiti|-10|a0|0||18e4",
			"Pacific/Niue|-11|b0|0||12e2",
			"Etc/GMT+12|-12|c0|0||",
			"Pacific/Galapagos|-06|60|0||25e3",
			"Etc/GMT+7|-07|70|0||",
			"Pacific/Pitcairn|-08|80|0||56",
			"Pacific/Gambier|-09|90|0||125",
			"Etc/UTC|UTC|0|0||",
			"Europe/London|GMT BST|0 -10|01010101010101010101010|1XSp0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0|10e6",
			"Europe/Chisinau|EET EEST|-20 -30|01010101010101010101010|1XSo0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0|67e4",
			"Europe/Moscow|MSK|-30|0||16e6",
			"Europe/Volgograd|+04 MSK|-40 -30|01|249a0|10e5",
			"Pacific/Honolulu|HST|a0|0||37e4",
			"MET|MET MEST|-10 -20|01010101010101010101010|1XSp0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0|",
			"Pacific/Chatham|+1345 +1245|-dJ -cJ|01010101010101010101010|1XV20 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0|600",
			"Pacific/Apia|+14 +13|-e0 -d0|010101|1XV20 1a00 1fA0 1a00 1fA0|37e3",
			"Pacific/Fiji|+13 +12|-d0 -c0|010101|1Xnq0 20o0 pc0 2hc0 bc0|88e4",
			"Pacific/Guam|ChST|-a0|0||17e4",
			"Pacific/Marquesas|-0930|9u|0||86e2",
			"Pacific/Pago_Pago|SST|b0|0||37e2",
			"Pacific/Norfolk|+11 +12|-b0 -c0|0101010101010101010101|219P0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0|25e4"
		],
		"links": [
			"Africa/Abidjan|Africa/Accra",
			"Africa/Abidjan|Africa/Bamako",
			"Africa/Abidjan|Africa/Banjul",
			"Africa/Abidjan|Africa/Bissau",
			"Africa/Abidjan|Africa/Conakry",
			"Africa/Abidjan|Africa/Dakar",
			"Africa/Abidjan|Africa/Freetown",
			"Africa/Abidjan|Africa/Lome",
			"Africa/Abidjan|Africa/Monrovia",
			"Africa/Abidjan|Africa/Nouakchott",
			"Africa/Abidjan|Africa/Ouagadougou",
			"Africa/Abidjan|Africa/Timbuktu",
			"Africa/Abidjan|America/Danmarkshavn",
			"Africa/Abidjan|Atlantic/Reykjavik",
			"Africa/Abidjan|Atlantic/St_Helena",
			"Africa/Abidjan|Etc/GMT",
			"Africa/Abidjan|Etc/GMT+0",
			"Africa/Abidjan|Etc/GMT-0",
			"Africa/Abidjan|Etc/GMT0",
			"Africa/Abidjan|Etc/Greenwich",
			"Africa/Abidjan|GMT",
			"Africa/Abidjan|GMT+0",
			"Africa/Abidjan|GMT-0",
			"Africa/Abidjan|GMT0",
			"Africa/Abidjan|Greenwich",
			"Africa/Abidjan|Iceland",
			"Africa/Algiers|Africa/Tunis",
			"Africa/Cairo|Egypt",
			"Africa/Casablanca|Africa/El_Aaiun",
			"Africa/Johannesburg|Africa/Maseru",
			"Africa/Johannesburg|Africa/Mbabane",
			"Africa/Khartoum|Africa/Blantyre",
			"Africa/Khartoum|Africa/Bujumbura",
			"Africa/Khartoum|Africa/Gaborone",
			"Africa/Khartoum|Africa/Harare",
			"Africa/Khartoum|Africa/Kigali",
			"Africa/Khartoum|Africa/Lubumbashi",
			"Africa/Khartoum|Africa/Lusaka",
			"Africa/Khartoum|Africa/Maputo",
			"Africa/Khartoum|Africa/Windhoek",
			"Africa/Lagos|Africa/Bangui",
			"Africa/Lagos|Africa/Brazzaville",
			"Africa/Lagos|Africa/Douala",
			"Africa/Lagos|Africa/Kinshasa",
			"Africa/Lagos|Africa/Libreville",
			"Africa/Lagos|Africa/Luanda",
			"Africa/Lagos|Africa/Malabo",
			"Africa/Lagos|Africa/Ndjamena",
			"Africa/Lagos|Africa/Niamey",
			"Africa/Lagos|Africa/Porto-Novo",
			"Africa/Nairobi|Africa/Addis_Ababa",
			"Africa/Nairobi|Africa/Asmara",
			"Africa/Nairobi|Africa/Asmera",
			"Africa/Nairobi|Africa/Dar_es_Salaam",
			"Africa/Nairobi|Africa/Djibouti",
			"Africa/Nairobi|Africa/Kampala",
			"Africa/Nairobi|Africa/Mogadishu",
			"Africa/Nairobi|Indian/Antananarivo",
			"Africa/Nairobi|Indian/Comoro",
			"Africa/Nairobi|Indian/Mayotte",
			"Africa/Tripoli|Europe/Kaliningrad",
			"Africa/Tripoli|Libya",
			"America/Adak|America/Atka",
			"America/Adak|US/Aleutian",
			"America/Anchorage|America/Juneau",
			"America/Anchorage|America/Nome",
			"America/Anchorage|America/Sitka",
			"America/Anchorage|America/Yakutat",
			"America/Anchorage|US/Alaska",
			"America/Campo_Grande|America/Cuiaba",
			"America/Caracas|America/Boa_Vista",
			"America/Caracas|America/Guyana",
			"America/Caracas|America/La_Paz",
			"America/Caracas|America/Manaus",
			"America/Caracas|America/Porto_Velho",
			"America/Caracas|Brazil/West",
			"America/Caracas|Etc/GMT+4",
			"America/Chicago|America/Indiana/Knox",
			"America/Chicago|America/Indiana/Tell_City",
			"America/Chicago|America/Knox_IN",
			"America/Chicago|America/Matamoros",
			"America/Chicago|America/Menominee",
			"America/Chicago|America/North_Dakota/Beulah",
			"America/Chicago|America/North_Dakota/Center",
			"America/Chicago|America/North_Dakota/New_Salem",
			"America/Chicago|America/Rainy_River",
			"America/Chicago|America/Rankin_Inlet",
			"America/Chicago|America/Resolute",
			"America/Chicago|America/Winnipeg",
			"America/Chicago|CST6CDT",
			"America/Chicago|Canada/Central",
			"America/Chicago|US/Central",
			"America/Chicago|US/Indiana-Starke",
			"America/Denver|America/Boise",
			"America/Denver|America/Cambridge_Bay",
			"America/Denver|America/Edmonton",
			"America/Denver|America/Inuvik",
			"America/Denver|America/Shiprock",
			"America/Denver|America/Yellowknife",
			"America/Denver|Canada/Mountain",
			"America/Denver|MST7MDT",
			"America/Denver|Navajo",
			"America/Denver|US/Mountain",
			"America/Fortaleza|America/Araguaina",
			"America/Fortaleza|America/Argentina/Buenos_Aires",
			"America/Fortaleza|America/Argentina/Catamarca",
			"America/Fortaleza|America/Argentina/ComodRivadavia",
			"America/Fortaleza|America/Argentina/Cordoba",
			"America/Fortaleza|America/Argentina/Jujuy",
			"America/Fortaleza|America/Argentina/La_Rioja",
			"America/Fortaleza|America/Argentina/Mendoza",
			"America/Fortaleza|America/Argentina/Rio_Gallegos",
			"America/Fortaleza|America/Argentina/Salta",
			"America/Fortaleza|America/Argentina/San_Juan",
			"America/Fortaleza|America/Argentina/San_Luis",
			"America/Fortaleza|America/Argentina/Tucuman",
			"America/Fortaleza|America/Argentina/Ushuaia",
			"America/Fortaleza|America/Bahia",
			"America/Fortaleza|America/Belem",
			"America/Fortaleza|America/Buenos_Aires",
			"America/Fortaleza|America/Catamarca",
			"America/Fortaleza|America/Cayenne",
			"America/Fortaleza|America/Cordoba",
			"America/Fortaleza|America/Jujuy",
			"America/Fortaleza|America/Maceio",
			"America/Fortaleza|America/Mendoza",
			"America/Fortaleza|America/Montevideo",
			"America/Fortaleza|America/Paramaribo",
			"America/Fortaleza|America/Punta_Arenas",
			"America/Fortaleza|America/Recife",
			"America/Fortaleza|America/Rosario",
			"America/Fortaleza|America/Santarem",
			"America/Fortaleza|Antarctica/Palmer",
			"America/Fortaleza|Antarctica/Rothera",
			"America/Fortaleza|Atlantic/Stanley",
			"America/Fortaleza|Etc/GMT+3",
			"America/Godthab|America/Nuuk",
			"America/Halifax|America/Glace_Bay",
			"America/Halifax|America/Goose_Bay",
			"America/Halifax|America/Moncton",
			"America/Halifax|America/Thule",
			"America/Halifax|Atlantic/Bermuda",
			"America/Halifax|Canada/Atlantic",
			"America/Havana|Cuba",
			"America/Lima|America/Bogota",
			"America/Lima|America/Eirunepe",
			"America/Lima|America/Guayaquil",
			"America/Lima|America/Porto_Acre",
			"America/Lima|America/Rio_Branco",
			"America/Lima|Brazil/Acre",
			"America/Lima|Etc/GMT+5",
			"America/Los_Angeles|America/Ensenada",
			"America/Los_Angeles|America/Santa_Isabel",
			"America/Los_Angeles|America/Tijuana",
			"America/Los_Angeles|America/Vancouver",
			"America/Los_Angeles|Canada/Pacific",
			"America/Los_Angeles|Mexico/BajaNorte",
			"America/Los_Angeles|PST8PDT",
			"America/Los_Angeles|US/Pacific",
			"America/Managua|America/Belize",
			"America/Managua|America/Costa_Rica",
			"America/Managua|America/El_Salvador",
			"America/Managua|America/Guatemala",
			"America/Managua|America/Regina",
			"America/Managua|America/Swift_Current",
			"America/Managua|America/Tegucigalpa",
			"America/Managua|Canada/Saskatchewan",
			"America/Mazatlan|Mexico/BajaSur",
			"America/Mexico_City|America/Bahia_Banderas",
			"America/Mexico_City|America/Merida",
			"America/Mexico_City|America/Monterrey",
			"America/Mexico_City|Mexico/General",
			"America/New_York|America/Detroit",
			"America/New_York|America/Fort_Wayne",
			"America/New_York|America/Grand_Turk",
			"America/New_York|America/Indiana/Indianapolis",
			"America/New_York|America/Indiana/Marengo",
			"America/New_York|America/Indiana/Petersburg",
			"America/New_York|America/Indiana/Vevay",
			"America/New_York|America/Indiana/Vincennes",
			"America/New_York|America/Indiana/Winamac",
			"America/New_York|America/Indianapolis",
			"America/New_York|America/Iqaluit",
			"America/New_York|America/Kentucky/Louisville",
			"America/New_York|America/Kentucky/Monticello",
			"America/New_York|America/Louisville",
			"America/New_York|America/Montreal",
			"America/New_York|America/Nassau",
			"America/New_York|America/Nipigon",
			"America/New_York|America/Pangnirtung",
			"America/New_York|America/Port-au-Prince",
			"America/New_York|America/Thunder_Bay",
			"America/New_York|America/Toronto",
			"America/New_York|Canada/Eastern",
			"America/New_York|EST5EDT",
			"America/New_York|US/East-Indiana",
			"America/New_York|US/Eastern",
			"America/New_York|US/Michigan",
			"America/Noronha|Atlantic/South_Georgia",
			"America/Noronha|Brazil/DeNoronha",
			"America/Noronha|Etc/GMT+2",
			"America/Panama|America/Atikokan",
			"America/Panama|America/Cancun",
			"America/Panama|America/Cayman",
			"America/Panama|America/Coral_Harbour",
			"America/Panama|America/Jamaica",
			"America/Panama|EST",
			"America/Panama|Jamaica",
			"America/Phoenix|America/Creston",
			"America/Phoenix|America/Dawson_Creek",
			"America/Phoenix|America/Fort_Nelson",
			"America/Phoenix|America/Hermosillo",
			"America/Phoenix|MST",
			"America/Phoenix|US/Arizona",
			"America/Santiago|Chile/Continental",
			"America/Santo_Domingo|America/Anguilla",
			"America/Santo_Domingo|America/Antigua",
			"America/Santo_Domingo|America/Aruba",
			"America/Santo_Domingo|America/Barbados",
			"America/Santo_Domingo|America/Blanc-Sablon",
			"America/Santo_Domingo|America/Curacao",
			"America/Santo_Domingo|America/Dominica",
			"America/Santo_Domingo|America/Grenada",
			"America/Santo_Domingo|America/Guadeloupe",
			"America/Santo_Domingo|America/Kralendijk",
			"America/Santo_Domingo|America/Lower_Princes",
			"America/Santo_Domingo|America/Marigot",
			"America/Santo_Domingo|America/Martinique",
			"America/Santo_Domingo|America/Montserrat",
			"America/Santo_Domingo|America/Port_of_Spain",
			"America/Santo_Domingo|America/Puerto_Rico",
			"America/Santo_Domingo|America/St_Barthelemy",
			"America/Santo_Domingo|America/St_Kitts",
			"America/Santo_Domingo|America/St_Lucia",
			"America/Santo_Domingo|America/St_Thomas",
			"America/Santo_Domingo|America/St_Vincent",
			"America/Santo_Domingo|America/Tortola",
			"America/Santo_Domingo|America/Virgin",
			"America/Sao_Paulo|Brazil/East",
			"America/St_Johns|Canada/Newfoundland",
			"America/Whitehorse|America/Dawson",
			"America/Whitehorse|Canada/Yukon",
			"Asia/Almaty|Asia/Qostanay",
			"Asia/Bangkok|Antarctica/Davis",
			"Asia/Bangkok|Asia/Barnaul",
			"Asia/Bangkok|Asia/Ho_Chi_Minh",
			"Asia/Bangkok|Asia/Hovd",
			"Asia/Bangkok|Asia/Krasnoyarsk",
			"Asia/Bangkok|Asia/Novokuznetsk",
			"Asia/Bangkok|Asia/Novosibirsk",
			"Asia/Bangkok|Asia/Phnom_Penh",
			"Asia/Bangkok|Asia/Saigon",
			"Asia/Bangkok|Asia/Tomsk",
			"Asia/Bangkok|Asia/Vientiane",
			"Asia/Bangkok|Etc/GMT-7",
			"Asia/Bangkok|Indian/Christmas",
			"Asia/Chita|Asia/Dili",
			"Asia/Chita|Asia/Khandyga",
			"Asia/Chita|Asia/Yakutsk",
			"Asia/Chita|Etc/GMT-9",
			"Asia/Chita|Pacific/Palau",
			"Asia/Dhaka|Asia/Bishkek",
			"Asia/Dhaka|Asia/Dacca",
			"Asia/Dhaka|Asia/Kashgar",
			"Asia/Dhaka|Asia/Omsk",
			"Asia/Dhaka|Asia/Thimbu",
			"Asia/Dhaka|Asia/Thimphu",
			"Asia/Dhaka|Asia/Urumqi",
			"Asia/Dhaka|Etc/GMT-6",
			"Asia/Dhaka|Indian/Chagos",
			"Asia/Dubai|Asia/Baku",
			"Asia/Dubai|Asia/Muscat",
			"Asia/Dubai|Asia/Tbilisi",
			"Asia/Dubai|Asia/Yerevan",
			"Asia/Dubai|Etc/GMT-4",
			"Asia/Dubai|Europe/Astrakhan",
			"Asia/Dubai|Europe/Samara",
			"Asia/Dubai|Europe/Saratov",
			"Asia/Dubai|Europe/Ulyanovsk",
			"Asia/Dubai|Indian/Mahe",
			"Asia/Dubai|Indian/Mauritius",
			"Asia/Dubai|Indian/Reunion",
			"Asia/Gaza|Asia/Hebron",
			"Asia/Hong_Kong|Hongkong",
			"Asia/Jakarta|Asia/Pontianak",
			"Asia/Jerusalem|Asia/Tel_Aviv",
			"Asia/Jerusalem|Israel",
			"Asia/Kamchatka|Asia/Anadyr",
			"Asia/Kamchatka|Etc/GMT-12",
			"Asia/Kamchatka|Kwajalein",
			"Asia/Kamchatka|Pacific/Funafuti",
			"Asia/Kamchatka|Pacific/Kwajalein",
			"Asia/Kamchatka|Pacific/Majuro",
			"Asia/Kamchatka|Pacific/Nauru",
			"Asia/Kamchatka|Pacific/Tarawa",
			"Asia/Kamchatka|Pacific/Wake",
			"Asia/Kamchatka|Pacific/Wallis",
			"Asia/Kathmandu|Asia/Katmandu",
			"Asia/Kolkata|Asia/Calcutta",
			"Asia/Kuala_Lumpur|Asia/Brunei",
			"Asia/Kuala_Lumpur|Asia/Choibalsan",
			"Asia/Kuala_Lumpur|Asia/Irkutsk",
			"Asia/Kuala_Lumpur|Asia/Kuching",
			"Asia/Kuala_Lumpur|Asia/Singapore",
			"Asia/Kuala_Lumpur|Asia/Ulaanbaatar",
			"Asia/Kuala_Lumpur|Asia/Ulan_Bator",
			"Asia/Kuala_Lumpur|Etc/GMT-8",
			"Asia/Kuala_Lumpur|Singapore",
			"Asia/Makassar|Asia/Ujung_Pandang",
			"Asia/Rangoon|Asia/Yangon",
			"Asia/Rangoon|Indian/Cocos",
			"Asia/Sakhalin|Asia/Magadan",
			"Asia/Sakhalin|Asia/Srednekolymsk",
			"Asia/Sakhalin|Etc/GMT-11",
			"Asia/Sakhalin|Pacific/Bougainville",
			"Asia/Sakhalin|Pacific/Efate",
			"Asia/Sakhalin|Pacific/Guadalcanal",
			"Asia/Sakhalin|Pacific/Kosrae",
			"Asia/Sakhalin|Pacific/Noumea",
			"Asia/Sakhalin|Pacific/Pohnpei",
			"Asia/Sakhalin|Pacific/Ponape",
			"Asia/Seoul|Asia/Pyongyang",
			"Asia/Seoul|ROK",
			"Asia/Shanghai|Asia/Chongqing",
			"Asia/Shanghai|Asia/Chungking",
			"Asia/Shanghai|Asia/Harbin",
			"Asia/Shanghai|Asia/Macao",
			"Asia/Shanghai|Asia/Macau",
			"Asia/Shanghai|Asia/Taipei",
			"Asia/Shanghai|PRC",
			"Asia/Shanghai|ROC",
			"Asia/Tashkent|Antarctica/Mawson",
			"Asia/Tashkent|Asia/Aqtau",
			"Asia/Tashkent|Asia/Aqtobe",
			"Asia/Tashkent|Asia/Ashgabat",
			"Asia/Tashkent|Asia/Ashkhabad",
			"Asia/Tashkent|Asia/Atyrau",
			"Asia/Tashkent|Asia/Dushanbe",
			"Asia/Tashkent|Asia/Oral",
			"Asia/Tashkent|Asia/Qyzylorda",
			"Asia/Tashkent|Asia/Samarkand",
			"Asia/Tashkent|Asia/Yekaterinburg",
			"Asia/Tashkent|Etc/GMT-5",
			"Asia/Tashkent|Indian/Kerguelen",
			"Asia/Tashkent|Indian/Maldives",
			"Asia/Tehran|Iran",
			"Asia/Tokyo|Japan",
			"Asia/Vladivostok|Antarctica/DumontDUrville",
			"Asia/Vladivostok|Asia/Ust-Nera",
			"Asia/Vladivostok|Etc/GMT-10",
			"Asia/Vladivostok|Pacific/Chuuk",
			"Asia/Vladivostok|Pacific/Port_Moresby",
			"Asia/Vladivostok|Pacific/Truk",
			"Asia/Vladivostok|Pacific/Yap",
			"Atlantic/Cape_Verde|Etc/GMT+1",
			"Australia/Adelaide|Australia/Broken_Hill",
			"Australia/Adelaide|Australia/South",
			"Australia/Adelaide|Australia/Yancowinna",
			"Australia/Brisbane|Australia/Lindeman",
			"Australia/Brisbane|Australia/Queensland",
			"Australia/Darwin|Australia/North",
			"Australia/Lord_Howe|Australia/LHI",
			"Australia/Perth|Australia/West",
			"Australia/Sydney|Antarctica/Macquarie",
			"Australia/Sydney|Australia/ACT",
			"Australia/Sydney|Australia/Canberra",
			"Australia/Sydney|Australia/Currie",
			"Australia/Sydney|Australia/Hobart",
			"Australia/Sydney|Australia/Melbourne",
			"Australia/Sydney|Australia/NSW",
			"Australia/Sydney|Australia/Tasmania",
			"Australia/Sydney|Australia/Victoria",
			"Etc/UTC|Etc/UCT",
			"Etc/UTC|Etc/Universal",
			"Etc/UTC|Etc/Zulu",
			"Etc/UTC|UCT",
			"Etc/UTC|UTC",
			"Etc/UTC|Universal",
			"Etc/UTC|Zulu",
			"Europe/Athens|Asia/Famagusta",
			"Europe/Athens|Asia/Nicosia",
			"Europe/Athens|EET",
			"Europe/Athens|Europe/Bucharest",
			"Europe/Athens|Europe/Helsinki",
			"Europe/Athens|Europe/Kiev",
			"Europe/Athens|Europe/Kyiv",
			"Europe/Athens|Europe/Mariehamn",
			"Europe/Athens|Europe/Nicosia",
			"Europe/Athens|Europe/Riga",
			"Europe/Athens|Europe/Sofia",
			"Europe/Athens|Europe/Tallinn",
			"Europe/Athens|Europe/Uzhgorod",
			"Europe/Athens|Europe/Vilnius",
			"Europe/Athens|Europe/Zaporozhye",
			"Europe/Chisinau|Europe/Tiraspol",
			"Europe/Dublin|Eire",
			"Europe/Istanbul|Antarctica/Syowa",
			"Europe/Istanbul|Asia/Aden",
			"Europe/Istanbul|Asia/Baghdad",
			"Europe/Istanbul|Asia/Bahrain",
			"Europe/Istanbul|Asia/Istanbul",
			"Europe/Istanbul|Asia/Kuwait",
			"Europe/Istanbul|Asia/Qatar",
			"Europe/Istanbul|Asia/Riyadh",
			"Europe/Istanbul|Etc/GMT-3",
			"Europe/Istanbul|Europe/Minsk",
			"Europe/Istanbul|Turkey",
			"Europe/Lisbon|Atlantic/Canary",
			"Europe/Lisbon|Atlantic/Faeroe",
			"Europe/Lisbon|Atlantic/Faroe",
			"Europe/Lisbon|Atlantic/Madeira",
			"Europe/Lisbon|Portugal",
			"Europe/Lisbon|WET",
			"Europe/London|Europe/Belfast",
			"Europe/London|Europe/Guernsey",
			"Europe/London|Europe/Isle_of_Man",
			"Europe/London|Europe/Jersey",
			"Europe/London|GB",
			"Europe/London|GB-Eire",
			"Europe/Moscow|Europe/Kirov",
			"Europe/Moscow|Europe/Simferopol",
			"Europe/Moscow|W-SU",
			"Europe/Paris|Africa/Ceuta",
			"Europe/Paris|Arctic/Longyearbyen",
			"Europe/Paris|Atlantic/Jan_Mayen",
			"Europe/Paris|CET",
			"Europe/Paris|Europe/Amsterdam",
			"Europe/Paris|Europe/Andorra",
			"Europe/Paris|Europe/Belgrade",
			"Europe/Paris|Europe/Berlin",
			"Europe/Paris|Europe/Bratislava",
			"Europe/Paris|Europe/Brussels",
			"Europe/Paris|Europe/Budapest",
			"Europe/Paris|Europe/Busingen",
			"Europe/Paris|Europe/Copenhagen",
			"Europe/Paris|Europe/Gibraltar",
			"Europe/Paris|Europe/Ljubljana",
			"Europe/Paris|Europe/Luxembourg",
			"Europe/Paris|Europe/Madrid",
			"Europe/Paris|Europe/Malta",
			"Europe/Paris|Europe/Monaco",
			"Europe/Paris|Europe/Oslo",
			"Europe/Paris|Europe/Podgorica",
			"Europe/Paris|Europe/Prague",
			"Europe/Paris|Europe/Rome",
			"Europe/Paris|Europe/San_Marino",
			"Europe/Paris|Europe/Sarajevo",
			"Europe/Paris|Europe/Skopje",
			"Europe/Paris|Europe/Stockholm",
			"Europe/Paris|Europe/Tirane",
			"Europe/Paris|Europe/Vaduz",
			"Europe/Paris|Europe/Vatican",
			"Europe/Paris|Europe/Vienna",
			"Europe/Paris|Europe/Warsaw",
			"Europe/Paris|Europe/Zagreb",
			"Europe/Paris|Europe/Zurich",
			"Europe/Paris|Poland",
			"Pacific/Auckland|Antarctica/McMurdo",
			"Pacific/Auckland|Antarctica/South_Pole",
			"Pacific/Auckland|NZ",
			"Pacific/Chatham|NZ-CHAT",
			"Pacific/Easter|Chile/EasterIsland",
			"Pacific/Galapagos|Etc/GMT+6",
			"Pacific/Gambier|Etc/GMT+9",
			"Pacific/Guam|Pacific/Saipan",
			"Pacific/Honolulu|HST",
			"Pacific/Honolulu|Pacific/Johnston",
			"Pacific/Honolulu|US/Hawaii",
			"Pacific/Kiritimati|Etc/GMT-14",
			"Pacific/Niue|Etc/GMT+11",
			"Pacific/Pago_Pago|Pacific/Midway",
			"Pacific/Pago_Pago|Pacific/Samoa",
			"Pacific/Pago_Pago|US/Samoa",
			"Pacific/Pitcairn|Etc/GMT+8",
			"Pacific/Tahiti|Etc/GMT+10",
			"Pacific/Tahiti|Pacific/Rarotonga",
			"Pacific/Tongatapu|Etc/GMT-13",
			"Pacific/Tongatapu|Pacific/Enderbury",
			"Pacific/Tongatapu|Pacific/Fakaofo",
			"Pacific/Tongatapu|Pacific/Kanton"
		],
		"countries": [
			"AD|Europe/Andorra",
			"AE|Asia/Dubai",
			"AF|Asia/Kabul",
			"AG|America/Puerto_Rico America/Antigua",
			"AI|America/Puerto_Rico America/Anguilla",
			"AL|Europe/Tirane",
			"AM|Asia/Yerevan",
			"AO|Africa/Lagos Africa/Luanda",
			"AQ|Antarctica/Casey Antarctica/Davis Antarctica/Mawson Antarctica/Palmer Antarctica/Rothera Antarctica/Troll Antarctica/Vostok Pacific/Auckland Pacific/Port_Moresby Asia/Riyadh Antarctica/McMurdo Antarctica/DumontDUrville Antarctica/Syowa",
			"AR|America/Argentina/Buenos_Aires America/Argentina/Cordoba America/Argentina/Salta America/Argentina/Jujuy America/Argentina/Tucuman America/Argentina/Catamarca America/Argentina/La_Rioja America/Argentina/San_Juan America/Argentina/Mendoza America/Argentina/San_Luis America/Argentina/Rio_Gallegos America/Argentina/Ushuaia",
			"AS|Pacific/Pago_Pago",
			"AT|Europe/Vienna",
			"AU|Australia/Lord_Howe Antarctica/Macquarie Australia/Hobart Australia/Melbourne Australia/Sydney Australia/Broken_Hill Australia/Brisbane Australia/Lindeman Australia/Adelaide Australia/Darwin Australia/Perth Australia/Eucla",
			"AW|America/Puerto_Rico America/Aruba",
			"AX|Europe/Helsinki Europe/Mariehamn",
			"AZ|Asia/Baku",
			"BA|Europe/Belgrade Europe/Sarajevo",
			"BB|America/Barbados",
			"BD|Asia/Dhaka",
			"BE|Europe/Brussels",
			"BF|Africa/Abidjan Africa/Ouagadougou",
			"BG|Europe/Sofia",
			"BH|Asia/Qatar Asia/Bahrain",
			"BI|Africa/Maputo Africa/Bujumbura",
			"BJ|Africa/Lagos Africa/Porto-Novo",
			"BL|America/Puerto_Rico America/St_Barthelemy",
			"BM|Atlantic/Bermuda",
			"BN|Asia/Kuching Asia/Brunei",
			"BO|America/La_Paz",
			"BQ|America/Puerto_Rico America/Kralendijk",
			"BR|America/Noronha America/Belem America/Fortaleza America/Recife America/Araguaina America/Maceio America/Bahia America/Sao_Paulo America/Campo_Grande America/Cuiaba America/Santarem America/Porto_Velho America/Boa_Vista America/Manaus America/Eirunepe America/Rio_Branco",
			"BS|America/Toronto America/Nassau",
			"BT|Asia/Thimphu",
			"BW|Africa/Maputo Africa/Gaborone",
			"BY|Europe/Minsk",
			"BZ|America/Belize",
			"CA|America/St_Johns America/Halifax America/Glace_Bay America/Moncton America/Goose_Bay America/Toronto America/Iqaluit America/Winnipeg America/Resolute America/Rankin_Inlet America/Regina America/Swift_Current America/Edmonton America/Cambridge_Bay America/Inuvik America/Dawson_Creek America/Fort_Nelson America/Whitehorse America/Dawson America/Vancouver America/Panama America/Puerto_Rico America/Phoenix America/Blanc-Sablon America/Atikokan America/Creston",
			"CC|Asia/Yangon Indian/Cocos",
			"CD|Africa/Maputo Africa/Lagos Africa/Kinshasa Africa/Lubumbashi",
			"CF|Africa/Lagos Africa/Bangui",
			"CG|Africa/Lagos Africa/Brazzaville",
			"CH|Europe/Zurich",
			"CI|Africa/Abidjan",
			"CK|Pacific/Rarotonga",
			"CL|America/Santiago America/Punta_Arenas Pacific/Easter",
			"CM|Africa/Lagos Africa/Douala",
			"CN|Asia/Shanghai Asia/Urumqi",
			"CO|America/Bogota",
			"CR|America/Costa_Rica",
			"CU|America/Havana",
			"CV|Atlantic/Cape_Verde",
			"CW|America/Puerto_Rico America/Curacao",
			"CX|Asia/Bangkok Indian/Christmas",
			"CY|Asia/Nicosia Asia/Famagusta",
			"CZ|Europe/Prague",
			"DE|Europe/Zurich Europe/Berlin Europe/Busingen",
			"DJ|Africa/Nairobi Africa/Djibouti",
			"DK|Europe/Berlin Europe/Copenhagen",
			"DM|America/Puerto_Rico America/Dominica",
			"DO|America/Santo_Domingo",
			"DZ|Africa/Algiers",
			"EC|America/Guayaquil Pacific/Galapagos",
			"EE|Europe/Tallinn",
			"EG|Africa/Cairo",
			"EH|Africa/El_Aaiun",
			"ER|Africa/Nairobi Africa/Asmara",
			"ES|Europe/Madrid Africa/Ceuta Atlantic/Canary",
			"ET|Africa/Nairobi Africa/Addis_Ababa",
			"FI|Europe/Helsinki",
			"FJ|Pacific/Fiji",
			"FK|Atlantic/Stanley",
			"FM|Pacific/Kosrae Pacific/Port_Moresby Pacific/Guadalcanal Pacific/Chuuk Pacific/Pohnpei",
			"FO|Atlantic/Faroe",
			"FR|Europe/Paris",
			"GA|Africa/Lagos Africa/Libreville",
			"GB|Europe/London",
			"GD|America/Puerto_Rico America/Grenada",
			"GE|Asia/Tbilisi",
			"GF|America/Cayenne",
			"GG|Europe/London Europe/Guernsey",
			"GH|Africa/Abidjan Africa/Accra",
			"GI|Europe/Gibraltar",
			"GL|America/Nuuk America/Danmarkshavn America/Scoresbysund America/Thule",
			"GM|Africa/Abidjan Africa/Banjul",
			"GN|Africa/Abidjan Africa/Conakry",
			"GP|America/Puerto_Rico America/Guadeloupe",
			"GQ|Africa/Lagos Africa/Malabo",
			"GR|Europe/Athens",
			"GS|Atlantic/South_Georgia",
			"GT|America/Guatemala",
			"GU|Pacific/Guam",
			"GW|Africa/Bissau",
			"GY|America/Guyana",
			"HK|Asia/Hong_Kong",
			"HN|America/Tegucigalpa",
			"HR|Europe/Belgrade Europe/Zagreb",
			"HT|America/Port-au-Prince",
			"HU|Europe/Budapest",
			"ID|Asia/Jakarta Asia/Pontianak Asia/Makassar Asia/Jayapura",
			"IE|Europe/Dublin",
			"IL|Asia/Jerusalem",
			"IM|Europe/London Europe/Isle_of_Man",
			"IN|Asia/Kolkata",
			"IO|Indian/Chagos",
			"IQ|Asia/Baghdad",
			"IR|Asia/Tehran",
			"IS|Africa/Abidjan Atlantic/Reykjavik",
			"IT|Europe/Rome",
			"JE|Europe/London Europe/Jersey",
			"JM|America/Jamaica",
			"JO|Asia/Amman",
			"JP|Asia/Tokyo",
			"KE|Africa/Nairobi",
			"KG|Asia/Bishkek",
			"KH|Asia/Bangkok Asia/Phnom_Penh",
			"KI|Pacific/Tarawa Pacific/Kanton Pacific/Kiritimati",
			"KM|Africa/Nairobi Indian/Comoro",
			"KN|America/Puerto_Rico America/St_Kitts",
			"KP|Asia/Pyongyang",
			"KR|Asia/Seoul",
			"KW|Asia/Riyadh Asia/Kuwait",
			"KY|America/Panama America/Cayman",
			"KZ|Asia/Almaty Asia/Qyzylorda Asia/Qostanay Asia/Aqtobe Asia/Aqtau Asia/Atyrau Asia/Oral",
			"LA|Asia/Bangkok Asia/Vientiane",
			"LB|Asia/Beirut",
			"LC|America/Puerto_Rico America/St_Lucia",
			"LI|Europe/Zurich Europe/Vaduz",
			"LK|Asia/Colombo",
			"LR|Africa/Monrovia",
			"LS|Africa/Johannesburg Africa/Maseru",
			"LT|Europe/Vilnius",
			"LU|Europe/Brussels Europe/Luxembourg",
			"LV|Europe/Riga",
			"LY|Africa/Tripoli",
			"MA|Africa/Casablanca",
			"MC|Europe/Paris Europe/Monaco",
			"MD|Europe/Chisinau",
			"ME|Europe/Belgrade Europe/Podgorica",
			"MF|America/Puerto_Rico America/Marigot",
			"MG|Africa/Nairobi Indian/Antananarivo",
			"MH|Pacific/Tarawa Pacific/Kwajalein Pacific/Majuro",
			"MK|Europe/Belgrade Europe/Skopje",
			"ML|Africa/Abidjan Africa/Bamako",
			"MM|Asia/Yangon",
			"MN|Asia/Ulaanbaatar Asia/Hovd Asia/Choibalsan",
			"MO|Asia/Macau",
			"MP|Pacific/Guam Pacific/Saipan",
			"MQ|America/Martinique",
			"MR|Africa/Abidjan Africa/Nouakchott",
			"MS|America/Puerto_Rico America/Montserrat",
			"MT|Europe/Malta",
			"MU|Indian/Mauritius",
			"MV|Indian/Maldives",
			"MW|Africa/Maputo Africa/Blantyre",
			"MX|America/Mexico_City America/Cancun America/Merida America/Monterrey America/Matamoros America/Chihuahua America/Ciudad_Juarez America/Ojinaga America/Mazatlan America/Bahia_Banderas America/Hermosillo America/Tijuana",
			"MY|Asia/Kuching Asia/Singapore Asia/Kuala_Lumpur",
			"MZ|Africa/Maputo",
			"NA|Africa/Windhoek",
			"NC|Pacific/Noumea",
			"NE|Africa/Lagos Africa/Niamey",
			"NF|Pacific/Norfolk",
			"NG|Africa/Lagos",
			"NI|America/Managua",
			"NL|Europe/Brussels Europe/Amsterdam",
			"NO|Europe/Berlin Europe/Oslo",
			"NP|Asia/Kathmandu",
			"NR|Pacific/Nauru",
			"NU|Pacific/Niue",
			"NZ|Pacific/Auckland Pacific/Chatham",
			"OM|Asia/Dubai Asia/Muscat",
			"PA|America/Panama",
			"PE|America/Lima",
			"PF|Pacific/Tahiti Pacific/Marquesas Pacific/Gambier",
			"PG|Pacific/Port_Moresby Pacific/Bougainville",
			"PH|Asia/Manila",
			"PK|Asia/Karachi",
			"PL|Europe/Warsaw",
			"PM|America/Miquelon",
			"PN|Pacific/Pitcairn",
			"PR|America/Puerto_Rico",
			"PS|Asia/Gaza Asia/Hebron",
			"PT|Europe/Lisbon Atlantic/Madeira Atlantic/Azores",
			"PW|Pacific/Palau",
			"PY|America/Asuncion",
			"QA|Asia/Qatar",
			"RE|Asia/Dubai Indian/Reunion",
			"RO|Europe/Bucharest",
			"RS|Europe/Belgrade",
			"RU|Europe/Kaliningrad Europe/Moscow Europe/Simferopol Europe/Kirov Europe/Volgograd Europe/Astrakhan Europe/Saratov Europe/Ulyanovsk Europe/Samara Asia/Yekaterinburg Asia/Omsk Asia/Novosibirsk Asia/Barnaul Asia/Tomsk Asia/Novokuznetsk Asia/Krasnoyarsk Asia/Irkutsk Asia/Chita Asia/Yakutsk Asia/Khandyga Asia/Vladivostok Asia/Ust-Nera Asia/Magadan Asia/Sakhalin Asia/Srednekolymsk Asia/Kamchatka Asia/Anadyr",
			"RW|Africa/Maputo Africa/Kigali",
			"SA|Asia/Riyadh",
			"SB|Pacific/Guadalcanal",
			"SC|Asia/Dubai Indian/Mahe",
			"SD|Africa/Khartoum",
			"SE|Europe/Berlin Europe/Stockholm",
			"SG|Asia/Singapore",
			"SH|Africa/Abidjan Atlantic/St_Helena",
			"SI|Europe/Belgrade Europe/Ljubljana",
			"SJ|Europe/Berlin Arctic/Longyearbyen",
			"SK|Europe/Prague Europe/Bratislava",
			"SL|Africa/Abidjan Africa/Freetown",
			"SM|Europe/Rome Europe/San_Marino",
			"SN|Africa/Abidjan Africa/Dakar",
			"SO|Africa/Nairobi Africa/Mogadishu",
			"SR|America/Paramaribo",
			"SS|Africa/Juba",
			"ST|Africa/Sao_Tome",
			"SV|America/El_Salvador",
			"SX|America/Puerto_Rico America/Lower_Princes",
			"SY|Asia/Damascus",
			"SZ|Africa/Johannesburg Africa/Mbabane",
			"TC|America/Grand_Turk",
			"TD|Africa/Ndjamena",
			"TF|Asia/Dubai Indian/Maldives Indian/Kerguelen",
			"TG|Africa/Abidjan Africa/Lome",
			"TH|Asia/Bangkok",
			"TJ|Asia/Dushanbe",
			"TK|Pacific/Fakaofo",
			"TL|Asia/Dili",
			"TM|Asia/Ashgabat",
			"TN|Africa/Tunis",
			"TO|Pacific/Tongatapu",
			"TR|Europe/Istanbul",
			"TT|America/Puerto_Rico America/Port_of_Spain",
			"TV|Pacific/Tarawa Pacific/Funafuti",
			"TW|Asia/Taipei",
			"TZ|Africa/Nairobi Africa/Dar_es_Salaam",
			"UA|Europe/Simferopol Europe/Kyiv",
			"UG|Africa/Nairobi Africa/Kampala",
			"UM|Pacific/Pago_Pago Pacific/Tarawa Pacific/Midway Pacific/Wake",
			"US|America/New_York America/Detroit America/Kentucky/Louisville America/Kentucky/Monticello America/Indiana/Indianapolis America/Indiana/Vincennes America/Indiana/Winamac America/Indiana/Marengo America/Indiana/Petersburg America/Indiana/Vevay America/Chicago America/Indiana/Tell_City America/Indiana/Knox America/Menominee America/North_Dakota/Center America/North_Dakota/New_Salem America/North_Dakota/Beulah America/Denver America/Boise America/Phoenix America/Los_Angeles America/Anchorage America/Juneau America/Sitka America/Metlakatla America/Yakutat America/Nome America/Adak Pacific/Honolulu",
			"UY|America/Montevideo",
			"UZ|Asia/Samarkand Asia/Tashkent",
			"VA|Europe/Rome Europe/Vatican",
			"VC|America/Puerto_Rico America/St_Vincent",
			"VE|America/Caracas",
			"VG|America/Puerto_Rico America/Tortola",
			"VI|America/Puerto_Rico America/St_Thomas",
			"VN|Asia/Bangkok Asia/Ho_Chi_Minh",
			"VU|Pacific/Efate",
			"WF|Pacific/Tarawa Pacific/Wallis",
			"WS|Pacific/Apia",
			"YE|Asia/Riyadh Asia/Aden",
			"YT|Africa/Nairobi Indian/Mayotte",
			"ZA|Africa/Johannesburg",
			"ZM|Africa/Maputo Africa/Lusaka",
			"ZW|Africa/Maputo Africa/Harare"
		]
	});


	return moment;
}));
//! moment.js locale configuration
//! locale : German [de]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var de = moment.defineLocale('de', {
        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays:
            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
                '_'
            ),
        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return de;

})));

// moment-timezone-localization for lang code: de

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


moment.tz.localizedNames = function() {
  return [{"value":"Africa/Abidjan","name":"Abidjan","id":"Africa/Abidjan"},{"value":"Africa/Accra","name":"Accra","id":"Africa/Accra"},{"value":"Africa/Addis_Ababa","name":"Addis Abeba","id":"Africa/Addis_Ababa"},{"value":"Africa/Algiers","name":"Algier","id":"Africa/Algiers"},{"value":"Africa/Asmera","name":"Asmara","id":"Africa/Asmera"},{"value":"Africa/Bamako","name":"Bamako","id":"Africa/Bamako"},{"value":"Africa/Bangui","name":"Bangui","id":"Africa/Bangui"},{"value":"Africa/Banjul","name":"Banjul","id":"Africa/Banjul"},{"value":"Africa/Bissau","name":"Bissau","id":"Africa/Bissau"},{"value":"Africa/Blantyre","name":"Blantyre","id":"Africa/Blantyre"},{"value":"Africa/Brazzaville","name":"Brazzaville","id":"Africa/Brazzaville"},{"value":"Africa/Bujumbura","name":"Bujumbura","id":"Africa/Bujumbura"},{"value":"Africa/Cairo","name":"Kairo","id":"Africa/Cairo"},{"value":"Africa/Casablanca","name":"Casablanca","id":"Africa/Casablanca"},{"value":"Africa/Ceuta","name":"Ceuta","id":"Africa/Ceuta"},{"value":"Africa/Conakry","name":"Conakry","id":"Africa/Conakry"},{"value":"Africa/Dakar","name":"Dakar","id":"Africa/Dakar"},{"value":"Africa/Dar_es_Salaam","name":"Daressalam","id":"Africa/Dar_es_Salaam"},{"value":"Africa/Djibouti","name":"Dschibuti","id":"Africa/Djibouti"},{"value":"Africa/Douala","name":"Douala","id":"Africa/Douala"},{"value":"Africa/El_Aaiun","name":"El Aaiún","id":"Africa/El_Aaiun"},{"value":"Africa/Freetown","name":"Freetown","id":"Africa/Freetown"},{"value":"Africa/Gaborone","name":"Gaborone","id":"Africa/Gaborone"},{"value":"Africa/Harare","name":"Harare","id":"Africa/Harare"},{"value":"Africa/Johannesburg","name":"Johannesburg","id":"Africa/Johannesburg"},{"value":"Africa/Juba","name":"Juba","id":"Africa/Juba"},{"value":"Africa/Kampala","name":"Kampala","id":"Africa/Kampala"},{"value":"Africa/Khartoum","name":"Khartum","id":"Africa/Khartoum"},{"value":"Africa/Kigali","name":"Kigali","id":"Africa/Kigali"},{"value":"Africa/Kinshasa","name":"Kinshasa","id":"Africa/Kinshasa"},{"value":"Africa/Lagos","name":"Lagos","id":"Africa/Lagos"},{"value":"Africa/Libreville","name":"Libreville","id":"Africa/Libreville"},{"value":"Africa/Lome","name":"Lomé","id":"Africa/Lome"},{"value":"Africa/Luanda","name":"Luanda","id":"Africa/Luanda"},{"value":"Africa/Lubumbashi","name":"Lubumbashi","id":"Africa/Lubumbashi"},{"value":"Africa/Lusaka","name":"Lusaka","id":"Africa/Lusaka"},{"value":"Africa/Malabo","name":"Malabo","id":"Africa/Malabo"},{"value":"Africa/Maputo","name":"Maputo","id":"Africa/Maputo"},{"value":"Africa/Maseru","name":"Maseru","id":"Africa/Maseru"},{"value":"Africa/Mbabane","name":"Mbabane","id":"Africa/Mbabane"},{"value":"Africa/Mogadishu","name":"Mogadischu","id":"Africa/Mogadishu"},{"value":"Africa/Monrovia","name":"Monrovia","id":"Africa/Monrovia"},{"value":"Africa/Nairobi","name":"Nairobi","id":"Africa/Nairobi"},{"value":"Africa/Ndjamena","name":"N’Djamena","id":"Africa/Ndjamena"},{"value":"Africa/Niamey","name":"Niamey","id":"Africa/Niamey"},{"value":"Africa/Nouakchott","name":"Nouakchott","id":"Africa/Nouakchott"},{"value":"Africa/Ouagadougou","name":"Ouagadougou","id":"Africa/Ouagadougou"},{"value":"Africa/Porto-Novo","name":"Porto Novo","id":"Africa/Porto-Novo"},{"value":"Africa/Sao_Tome","name":"São Tomé","id":"Africa/Sao_Tome"},{"value":"Africa/Tripoli","name":"Tripolis","id":"Africa/Tripoli"},{"value":"Africa/Tunis","name":"Tunis","id":"Africa/Tunis"},{"value":"Africa/Windhoek","name":"Windhoek","id":"Africa/Windhoek"},{"value":"America/Adak","name":"Adak","id":"America/Adak"},{"value":"America/Anchorage","name":"Anchorage","id":"America/Anchorage"},{"value":"America/Anguilla","name":"Anguilla","id":"America/Anguilla"},{"value":"America/Antigua","name":"Antigua","id":"America/Antigua"},{"value":"America/Araguaina","name":"Araguaina","id":"America/Araguaina"},{"value":"America/Argentina/La_Rioja","name":"La Rioja","id":"America/Argentina/La_Rioja"},{"value":"America/Argentina/Rio_Gallegos","name":"Rio Gallegos","id":"America/Argentina/Rio_Gallegos"},{"value":"America/Argentina/Salta","name":"Salta","id":"America/Argentina/Salta"},{"value":"America/Argentina/San_Juan","name":"San Juan","id":"America/Argentina/San_Juan"},{"value":"America/Argentina/San_Luis","name":"San Luis","id":"America/Argentina/San_Luis"},{"value":"America/Argentina/Tucuman","name":"Tucuman","id":"America/Argentina/Tucuman"},{"value":"America/Argentina/Ushuaia","name":"Ushuaia","id":"America/Argentina/Ushuaia"},{"value":"America/Aruba","name":"Aruba","id":"America/Aruba"},{"value":"America/Asuncion","name":"Asunción","id":"America/Asuncion"},{"value":"America/Bahia","name":"Bahia","id":"America/Bahia"},{"value":"America/Bahia_Banderas","name":"Bahia Banderas","id":"America/Bahia_Banderas"},{"value":"America/Barbados","name":"Barbados","id":"America/Barbados"},{"value":"America/Belem","name":"Belem","id":"America/Belem"},{"value":"America/Belize","name":"Belize","id":"America/Belize"},{"value":"America/Blanc-Sablon","name":"Blanc-Sablon","id":"America/Blanc-Sablon"},{"value":"America/Boa_Vista","name":"Boa Vista","id":"America/Boa_Vista"},{"value":"America/Bogota","name":"Bogotá","id":"America/Bogota"},{"value":"America/Boise","name":"Boise","id":"America/Boise"},{"value":"America/Buenos_Aires","name":"Buenos Aires","id":"America/Buenos_Aires"},{"value":"America/Cambridge_Bay","name":"Cambridge Bay","id":"America/Cambridge_Bay"},{"value":"America/Campo_Grande","name":"Campo Grande","id":"America/Campo_Grande"},{"value":"America/Cancun","name":"Cancún","id":"America/Cancun"},{"value":"America/Caracas","name":"Caracas","id":"America/Caracas"},{"value":"America/Catamarca","name":"Catamarca","id":"America/Catamarca"},{"value":"America/Cayenne","name":"Cayenne","id":"America/Cayenne"},{"value":"America/Cayman","name":"Kaimaninseln","id":"America/Cayman"},{"value":"America/Chicago","name":"Chicago","id":"America/Chicago"},{"value":"America/Chihuahua","name":"Chihuahua","id":"America/Chihuahua"},{"value":"America/Coral_Harbour","name":"Atikokan","id":"America/Coral_Harbour"},{"value":"America/Cordoba","name":"Córdoba","id":"America/Cordoba"},{"value":"America/Costa_Rica","name":"Costa Rica","id":"America/Costa_Rica"},{"value":"America/Creston","name":"Creston","id":"America/Creston"},{"value":"America/Cuiaba","name":"Cuiaba","id":"America/Cuiaba"},{"value":"America/Curacao","name":"Curaçao","id":"America/Curacao"},{"value":"America/Danmarkshavn","name":"Danmarkshavn","id":"America/Danmarkshavn"},{"value":"America/Dawson","name":"Dawson","id":"America/Dawson"},{"value":"America/Dawson_Creek","name":"Dawson Creek","id":"America/Dawson_Creek"},{"value":"America/Denver","name":"Denver","id":"America/Denver"},{"value":"America/Detroit","name":"Detroit","id":"America/Detroit"},{"value":"America/Dominica","name":"Dominica","id":"America/Dominica"},{"value":"America/Edmonton","name":"Edmonton","id":"America/Edmonton"},{"value":"America/Eirunepe","name":"Eirunepe","id":"America/Eirunepe"},{"value":"America/El_Salvador","name":"El Salvador","id":"America/El_Salvador"},{"value":"America/Fort_Nelson","name":"Fort Nelson","id":"America/Fort_Nelson"},{"value":"America/Fortaleza","name":"Fortaleza","id":"America/Fortaleza"},{"value":"America/Glace_Bay","name":"Glace Bay","id":"America/Glace_Bay"},{"value":"America/Godthab","name":"Nuuk","id":"America/Godthab"},{"value":"America/Goose_Bay","name":"Goose Bay","id":"America/Goose_Bay"},{"value":"America/Grand_Turk","name":"Grand Turk","id":"America/Grand_Turk"},{"value":"America/Grenada","name":"Grenada","id":"America/Grenada"},{"value":"America/Guadeloupe","name":"Guadeloupe","id":"America/Guadeloupe"},{"value":"America/Guatemala","name":"Guatemala","id":"America/Guatemala"},{"value":"America/Guayaquil","name":"Guayaquil","id":"America/Guayaquil"},{"value":"America/Guyana","name":"Guyana","id":"America/Guyana"},{"value":"America/Halifax","name":"Halifax","id":"America/Halifax"},{"value":"America/Havana","name":"Havanna","id":"America/Havana"},{"value":"America/Hermosillo","name":"Hermosillo","id":"America/Hermosillo"},{"value":"America/Indiana/Knox","name":"Knox, Indiana","id":"America/Indiana/Knox"},{"value":"America/Indiana/Marengo","name":"Marengo, Indiana","id":"America/Indiana/Marengo"},{"value":"America/Indiana/Petersburg","name":"Petersburg, Indiana","id":"America/Indiana/Petersburg"},{"value":"America/Indiana/Tell_City","name":"Tell City, Indiana","id":"America/Indiana/Tell_City"},{"value":"America/Indiana/Vevay","name":"Vevay, Indiana","id":"America/Indiana/Vevay"},{"value":"America/Indiana/Vincennes","name":"Vincennes, Indiana","id":"America/Indiana/Vincennes"},{"value":"America/Indiana/Winamac","name":"Winamac, Indiana","id":"America/Indiana/Winamac"},{"value":"America/Indianapolis","name":"Indianapolis","id":"America/Indianapolis"},{"value":"America/Inuvik","name":"Inuvik","id":"America/Inuvik"},{"value":"America/Iqaluit","name":"Iqaluit","id":"America/Iqaluit"},{"value":"America/Jamaica","name":"Jamaika","id":"America/Jamaica"},{"value":"America/Jujuy","name":"Jujuy","id":"America/Jujuy"},{"value":"America/Juneau","name":"Juneau","id":"America/Juneau"},{"value":"America/Kentucky/Monticello","name":"Monticello, Kentucky","id":"America/Kentucky/Monticello"},{"value":"America/Kralendijk","name":"Kralendijk","id":"America/Kralendijk"},{"value":"America/La_Paz","name":"La Paz","id":"America/La_Paz"},{"value":"America/Lima","name":"Lima","id":"America/Lima"},{"value":"America/Los_Angeles","name":"Los Angeles","id":"America/Los_Angeles"},{"value":"America/Louisville","name":"Louisville","id":"America/Louisville"},{"value":"America/Lower_Princes","name":"Lower Prince’s Quarter","id":"America/Lower_Princes"},{"value":"America/Maceio","name":"Maceio","id":"America/Maceio"},{"value":"America/Managua","name":"Managua","id":"America/Managua"},{"value":"America/Manaus","name":"Manaus","id":"America/Manaus"},{"value":"America/Marigot","name":"Marigot","id":"America/Marigot"},{"value":"America/Martinique","name":"Martinique","id":"America/Martinique"},{"value":"America/Matamoros","name":"Matamoros","id":"America/Matamoros"},{"value":"America/Mazatlan","name":"Mazatlan","id":"America/Mazatlan"},{"value":"America/Mendoza","name":"Mendoza","id":"America/Mendoza"},{"value":"America/Menominee","name":"Menominee","id":"America/Menominee"},{"value":"America/Merida","name":"Merida","id":"America/Merida"},{"value":"America/Metlakatla","name":"Metlakatla","id":"America/Metlakatla"},{"value":"America/Mexico_City","name":"Mexiko-Stadt","id":"America/Mexico_City"},{"value":"America/Miquelon","name":"Miquelon","id":"America/Miquelon"},{"value":"America/Moncton","name":"Moncton","id":"America/Moncton"},{"value":"America/Monterrey","name":"Monterrey","id":"America/Monterrey"},{"value":"America/Montevideo","name":"Montevideo","id":"America/Montevideo"},{"value":"America/Montserrat","name":"Montserrat","id":"America/Montserrat"},{"value":"America/Nassau","name":"Nassau","id":"America/Nassau"},{"value":"America/New_York","name":"New York","id":"America/New_York"},{"value":"America/Nipigon","name":"Nipigon","id":"America/Nipigon"},{"value":"America/Nome","name":"Nome","id":"America/Nome"},{"value":"America/Noronha","name":"Noronha","id":"America/Noronha"},{"value":"America/North_Dakota/Beulah","name":"Beulah, North Dakota","id":"America/North_Dakota/Beulah"},{"value":"America/North_Dakota/Center","name":"Center, North Dakota","id":"America/North_Dakota/Center"},{"value":"America/North_Dakota/New_Salem","name":"New Salem, North Dakota","id":"America/North_Dakota/New_Salem"},{"value":"America/Ojinaga","name":"Ojinaga","id":"America/Ojinaga"},{"value":"America/Panama","name":"Panama","id":"America/Panama"},{"value":"America/Pangnirtung","name":"Pangnirtung","id":"America/Pangnirtung"},{"value":"America/Paramaribo","name":"Paramaribo","id":"America/Paramaribo"},{"value":"America/Phoenix","name":"Phoenix","id":"America/Phoenix"},{"value":"America/Port-au-Prince","name":"Port-au-Prince","id":"America/Port-au-Prince"},{"value":"America/Port_of_Spain","name":"Port of Spain","id":"America/Port_of_Spain"},{"value":"America/Porto_Velho","name":"Porto Velho","id":"America/Porto_Velho"},{"value":"America/Puerto_Rico","name":"Puerto Rico","id":"America/Puerto_Rico"},{"value":"America/Punta_Arenas","name":"Punta Arenas","id":"America/Punta_Arenas"},{"value":"America/Rainy_River","name":"Rainy River","id":"America/Rainy_River"},{"value":"America/Rankin_Inlet","name":"Rankin Inlet","id":"America/Rankin_Inlet"},{"value":"America/Recife","name":"Recife","id":"America/Recife"},{"value":"America/Regina","name":"Regina","id":"America/Regina"},{"value":"America/Resolute","name":"Resolute","id":"America/Resolute"},{"value":"America/Rio_Branco","name":"Rio Branco","id":"America/Rio_Branco"},{"value":"America/Santa_Isabel","name":"Santa Isabel","id":"America/Santa_Isabel"},{"value":"America/Santarem","name":"Santarem","id":"America/Santarem"},{"value":"America/Santiago","name":"Santiago","id":"America/Santiago"},{"value":"America/Santo_Domingo","name":"Santo Domingo","id":"America/Santo_Domingo"},{"value":"America/Sao_Paulo","name":"São Paulo","id":"America/Sao_Paulo"},{"value":"America/Scoresbysund","name":"Ittoqqortoormiit","id":"America/Scoresbysund"},{"value":"America/Sitka","name":"Sitka","id":"America/Sitka"},{"value":"America/St_Barthelemy","name":"Saint-Barthélemy","id":"America/St_Barthelemy"},{"value":"America/St_Johns","name":"St. John’s","id":"America/St_Johns"},{"value":"America/St_Kitts","name":"St. Kitts","id":"America/St_Kitts"},{"value":"America/St_Lucia","name":"St. Lucia","id":"America/St_Lucia"},{"value":"America/St_Thomas","name":"St. Thomas","id":"America/St_Thomas"},{"value":"America/St_Vincent","name":"St. Vincent","id":"America/St_Vincent"},{"value":"America/Swift_Current","name":"Swift Current","id":"America/Swift_Current"},{"value":"America/Tegucigalpa","name":"Tegucigalpa","id":"America/Tegucigalpa"},{"value":"America/Thule","name":"Thule","id":"America/Thule"},{"value":"America/Thunder_Bay","name":"Thunder Bay","id":"America/Thunder_Bay"},{"value":"America/Tijuana","name":"Tijuana","id":"America/Tijuana"},{"value":"America/Toronto","name":"Toronto","id":"America/Toronto"},{"value":"America/Tortola","name":"Tortola","id":"America/Tortola"},{"value":"America/Vancouver","name":"Vancouver","id":"America/Vancouver"},{"value":"America/Whitehorse","name":"Whitehorse","id":"America/Whitehorse"},{"value":"America/Winnipeg","name":"Winnipeg","id":"America/Winnipeg"},{"value":"America/Yakutat","name":"Yakutat","id":"America/Yakutat"},{"value":"America/Yellowknife","name":"Yellowknife","id":"America/Yellowknife"},{"value":"Antarctica/Casey","name":"Casey","id":"Antarctica/Casey"},{"value":"Antarctica/Davis","name":"Davis","id":"Antarctica/Davis"},{"value":"Antarctica/DumontDUrville","name":"Dumont d’Urville","id":"Antarctica/DumontDUrville"},{"value":"Antarctica/Macquarie","name":"Macquarie","id":"Antarctica/Macquarie"},{"value":"Antarctica/Mawson","name":"Mawson","id":"Antarctica/Mawson"},{"value":"Antarctica/McMurdo","name":"McMurdo","id":"Antarctica/McMurdo"},{"value":"Antarctica/Palmer","name":"Palmer","id":"Antarctica/Palmer"},{"value":"Antarctica/Rothera","name":"Rothera","id":"Antarctica/Rothera"},{"value":"Antarctica/Syowa","name":"Syowa","id":"Antarctica/Syowa"},{"value":"Antarctica/Troll","name":"Troll","id":"Antarctica/Troll"},{"value":"Antarctica/Vostok","name":"Wostok","id":"Antarctica/Vostok"},{"value":"Arctic/Longyearbyen","name":"Longyearbyen","id":"Arctic/Longyearbyen"},{"value":"Asia/Aden","name":"Aden","id":"Asia/Aden"},{"value":"Asia/Almaty","name":"Almaty","id":"Asia/Almaty"},{"value":"Asia/Amman","name":"Amman","id":"Asia/Amman"},{"value":"Asia/Anadyr","name":"Anadyr","id":"Asia/Anadyr"},{"value":"Asia/Aqtau","name":"Aqtau","id":"Asia/Aqtau"},{"value":"Asia/Aqtobe","name":"Aktobe","id":"Asia/Aqtobe"},{"value":"Asia/Ashgabat","name":"Aşgabat","id":"Asia/Ashgabat"},{"value":"Asia/Atyrau","name":"Atyrau","id":"Asia/Atyrau"},{"value":"Asia/Baghdad","name":"Bagdad","id":"Asia/Baghdad"},{"value":"Asia/Bahrain","name":"Bahrain","id":"Asia/Bahrain"},{"value":"Asia/Baku","name":"Baku","id":"Asia/Baku"},{"value":"Asia/Bangkok","name":"Bangkok","id":"Asia/Bangkok"},{"value":"Asia/Barnaul","name":"Barnaul","id":"Asia/Barnaul"},{"value":"Asia/Beirut","name":"Beirut","id":"Asia/Beirut"},{"value":"Asia/Bishkek","name":"Bischkek","id":"Asia/Bishkek"},{"value":"Asia/Brunei","name":"Brunei Darussalam","id":"Asia/Brunei"},{"value":"Asia/Calcutta","name":"Kalkutta","id":"Asia/Calcutta"},{"value":"Asia/Chita","name":"Tschita","id":"Asia/Chita"},{"value":"Asia/Choibalsan","name":"Tschoibalsan","id":"Asia/Choibalsan"},{"value":"Asia/Colombo","name":"Colombo","id":"Asia/Colombo"},{"value":"Asia/Damascus","name":"Damaskus","id":"Asia/Damascus"},{"value":"Asia/Dhaka","name":"Dhaka","id":"Asia/Dhaka"},{"value":"Asia/Dili","name":"Dili","id":"Asia/Dili"},{"value":"Asia/Dubai","name":"Dubai","id":"Asia/Dubai"},{"value":"Asia/Dushanbe","name":"Duschanbe","id":"Asia/Dushanbe"},{"value":"Asia/Famagusta","name":"Famagusta","id":"Asia/Famagusta"},{"value":"Asia/Gaza","name":"Gaza","id":"Asia/Gaza"},{"value":"Asia/Hebron","name":"Hebron","id":"Asia/Hebron"},{"value":"Asia/Hong_Kong","name":"Hongkong","id":"Asia/Hong_Kong"},{"value":"Asia/Hovd","name":"Chowd","id":"Asia/Hovd"},{"value":"Asia/Irkutsk","name":"Irkutsk","id":"Asia/Irkutsk"},{"value":"Asia/Jakarta","name":"Jakarta","id":"Asia/Jakarta"},{"value":"Asia/Jayapura","name":"Jayapura","id":"Asia/Jayapura"},{"value":"Asia/Jerusalem","name":"Jerusalem","id":"Asia/Jerusalem"},{"value":"Asia/Kabul","name":"Kabul","id":"Asia/Kabul"},{"value":"Asia/Kamchatka","name":"Kamtschatka","id":"Asia/Kamchatka"},{"value":"Asia/Karachi","name":"Karatschi","id":"Asia/Karachi"},{"value":"Asia/Katmandu","name":"Kathmandu","id":"Asia/Katmandu"},{"value":"Asia/Khandyga","name":"Chandyga","id":"Asia/Khandyga"},{"value":"Asia/Krasnoyarsk","name":"Krasnojarsk","id":"Asia/Krasnoyarsk"},{"value":"Asia/Kuala_Lumpur","name":"Kuala Lumpur","id":"Asia/Kuala_Lumpur"},{"value":"Asia/Kuching","name":"Kuching","id":"Asia/Kuching"},{"value":"Asia/Kuwait","name":"Kuwait","id":"Asia/Kuwait"},{"value":"Asia/Macau","name":"Macau","id":"Asia/Macau"},{"value":"Asia/Magadan","name":"Magadan","id":"Asia/Magadan"},{"value":"Asia/Makassar","name":"Makassar","id":"Asia/Makassar"},{"value":"Asia/Manila","name":"Manila","id":"Asia/Manila"},{"value":"Asia/Muscat","name":"Maskat","id":"Asia/Muscat"},{"value":"Asia/Nicosia","name":"Nikosia","id":"Asia/Nicosia"},{"value":"Asia/Novokuznetsk","name":"Nowokuznetsk","id":"Asia/Novokuznetsk"},{"value":"Asia/Novosibirsk","name":"Nowosibirsk","id":"Asia/Novosibirsk"},{"value":"Asia/Omsk","name":"Omsk","id":"Asia/Omsk"},{"value":"Asia/Oral","name":"Oral","id":"Asia/Oral"},{"value":"Asia/Phnom_Penh","name":"Phnom Penh","id":"Asia/Phnom_Penh"},{"value":"Asia/Pontianak","name":"Pontianak","id":"Asia/Pontianak"},{"value":"Asia/Pyongyang","name":"Pjöngjang","id":"Asia/Pyongyang"},{"value":"Asia/Qatar","name":"Katar","id":"Asia/Qatar"},{"value":"Asia/Qyzylorda","name":"Qysylorda","id":"Asia/Qyzylorda"},{"value":"Asia/Rangoon","name":"Rangun","id":"Asia/Rangoon"},{"value":"Asia/Riyadh","name":"Riad","id":"Asia/Riyadh"},{"value":"Asia/Saigon","name":"Ho-Chi-Minh-Stadt","id":"Asia/Saigon"},{"value":"Asia/Sakhalin","name":"Sachalin","id":"Asia/Sakhalin"},{"value":"Asia/Samarkand","name":"Samarkand","id":"Asia/Samarkand"},{"value":"Asia/Seoul","name":"Seoul","id":"Asia/Seoul"},{"value":"Asia/Shanghai","name":"Shanghai","id":"Asia/Shanghai"},{"value":"Asia/Singapore","name":"Singapur","id":"Asia/Singapore"},{"value":"Asia/Srednekolymsk","name":"Srednekolymsk","id":"Asia/Srednekolymsk"},{"value":"Asia/Taipei","name":"Taipeh","id":"Asia/Taipei"},{"value":"Asia/Tashkent","name":"Taschkent","id":"Asia/Tashkent"},{"value":"Asia/Tbilisi","name":"Tiflis","id":"Asia/Tbilisi"},{"value":"Asia/Tehran","name":"Teheran","id":"Asia/Tehran"},{"value":"Asia/Thimphu","name":"Thimphu","id":"Asia/Thimphu"},{"value":"Asia/Tokyo","name":"Tokio","id":"Asia/Tokyo"},{"value":"Asia/Tomsk","name":"Tomsk","id":"Asia/Tomsk"},{"value":"Asia/Ulaanbaatar","name":"Ulaanbaatar","id":"Asia/Ulaanbaatar"},{"value":"Asia/Urumqi","name":"Ürümqi","id":"Asia/Urumqi"},{"value":"Asia/Ust-Nera","name":"Ust-Nera","id":"Asia/Ust-Nera"},{"value":"Asia/Vientiane","name":"Vientiane","id":"Asia/Vientiane"},{"value":"Asia/Vladivostok","name":"Wladiwostok","id":"Asia/Vladivostok"},{"value":"Asia/Yakutsk","name":"Jakutsk","id":"Asia/Yakutsk"},{"value":"Asia/Yekaterinburg","name":"Jekaterinburg","id":"Asia/Yekaterinburg"},{"value":"Asia/Yerevan","name":"Eriwan","id":"Asia/Yerevan"},{"value":"Atlantic/Azores","name":"Azoren","id":"Atlantic/Azores"},{"value":"Atlantic/Bermuda","name":"Bermuda","id":"Atlantic/Bermuda"},{"value":"Atlantic/Canary","name":"Kanaren","id":"Atlantic/Canary"},{"value":"Atlantic/Cape_Verde","name":"Cabo Verde","id":"Atlantic/Cape_Verde"},{"value":"Atlantic/Faeroe","name":"Färöer","id":"Atlantic/Faeroe"},{"value":"Atlantic/Madeira","name":"Madeira","id":"Atlantic/Madeira"},{"value":"Atlantic/Reykjavik","name":"Reyk­ja­vík","id":"Atlantic/Reykjavik"},{"value":"Atlantic/South_Georgia","name":"Südgeorgien","id":"Atlantic/South_Georgia"},{"value":"Atlantic/St_Helena","name":"St. Helena","id":"Atlantic/St_Helena"},{"value":"Atlantic/Stanley","name":"Stanley","id":"Atlantic/Stanley"},{"value":"Australia/Adelaide","name":"Adelaide","id":"Australia/Adelaide"},{"value":"Australia/Brisbane","name":"Brisbane","id":"Australia/Brisbane"},{"value":"Australia/Broken_Hill","name":"Broken Hill","id":"Australia/Broken_Hill"},{"value":"Australia/Currie","name":"Currie","id":"Australia/Currie"},{"value":"Australia/Darwin","name":"Darwin","id":"Australia/Darwin"},{"value":"Australia/Eucla","name":"Eucla","id":"Australia/Eucla"},{"value":"Australia/Hobart","name":"Hobart","id":"Australia/Hobart"},{"value":"Australia/Lindeman","name":"Lindeman","id":"Australia/Lindeman"},{"value":"Australia/Lord_Howe","name":"Lord Howe","id":"Australia/Lord_Howe"},{"value":"Australia/Melbourne","name":"Melbourne","id":"Australia/Melbourne"},{"value":"Australia/Perth","name":"Perth","id":"Australia/Perth"},{"value":"Australia/Sydney","name":"Sydney","id":"Australia/Sydney"},{"value":"Etc/UTC","name":"Koordinierte Weltzeit","id":"Etc/UTC"},{"value":"Europe/Amsterdam","name":"Amsterdam","id":"Europe/Amsterdam"},{"value":"Europe/Andorra","name":"Andorra","id":"Europe/Andorra"},{"value":"Europe/Astrakhan","name":"Astrachan","id":"Europe/Astrakhan"},{"value":"Europe/Athens","name":"Athen","id":"Europe/Athens"},{"value":"Europe/Belgrade","name":"Belgrad","id":"Europe/Belgrade"},{"value":"Europe/Berlin","name":"Berlin","id":"Europe/Berlin"},{"value":"Europe/Bratislava","name":"Bratislava","id":"Europe/Bratislava"},{"value":"Europe/Brussels","name":"Brüssel","id":"Europe/Brussels"},{"value":"Europe/Bucharest","name":"Bukarest","id":"Europe/Bucharest"},{"value":"Europe/Budapest","name":"Budapest","id":"Europe/Budapest"},{"value":"Europe/Busingen","name":"Büsingen","id":"Europe/Busingen"},{"value":"Europe/Chisinau","name":"Kischinau","id":"Europe/Chisinau"},{"value":"Europe/Copenhagen","name":"Kopenhagen","id":"Europe/Copenhagen"},{"value":"Europe/Dublin","name":"Irische SommerzeitDublin","id":"Europe/Dublin"},{"value":"Europe/Gibraltar","name":"Gibraltar","id":"Europe/Gibraltar"},{"value":"Europe/Guernsey","name":"Guernsey","id":"Europe/Guernsey"},{"value":"Europe/Helsinki","name":"Helsinki","id":"Europe/Helsinki"},{"value":"Europe/Isle_of_Man","name":"Isle of Man","id":"Europe/Isle_of_Man"},{"value":"Europe/Istanbul","name":"Istanbul","id":"Europe/Istanbul"},{"value":"Europe/Jersey","name":"Jersey","id":"Europe/Jersey"},{"value":"Europe/Kaliningrad","name":"Kaliningrad","id":"Europe/Kaliningrad"},{"value":"Europe/Kiev","name":"Kiew","id":"Europe/Kiev"},{"value":"Europe/Kirov","name":"Kirow","id":"Europe/Kirov"},{"value":"Europe/Lisbon","name":"Lissabon","id":"Europe/Lisbon"},{"value":"Europe/Ljubljana","name":"Ljubljana","id":"Europe/Ljubljana"},{"value":"Europe/London","name":"Britische SommerzeitLondon","id":"Europe/London"},{"value":"Europe/Luxembourg","name":"Luxemburg","id":"Europe/Luxembourg"},{"value":"Europe/Madrid","name":"Madrid","id":"Europe/Madrid"},{"value":"Europe/Malta","name":"Malta","id":"Europe/Malta"},{"value":"Europe/Mariehamn","name":"Mariehamn","id":"Europe/Mariehamn"},{"value":"Europe/Minsk","name":"Minsk","id":"Europe/Minsk"},{"value":"Europe/Monaco","name":"Monaco","id":"Europe/Monaco"},{"value":"Europe/Moscow","name":"Moskau","id":"Europe/Moscow"},{"value":"Europe/Oslo","name":"Oslo","id":"Europe/Oslo"},{"value":"Europe/Paris","name":"Paris","id":"Europe/Paris"},{"value":"Europe/Podgorica","name":"Podgorica","id":"Europe/Podgorica"},{"value":"Europe/Prague","name":"Prag","id":"Europe/Prague"},{"value":"Europe/Riga","name":"Riga","id":"Europe/Riga"},{"value":"Europe/Rome","name":"Rom","id":"Europe/Rome"},{"value":"Europe/Samara","name":"Samara","id":"Europe/Samara"},{"value":"Europe/San_Marino","name":"San Marino","id":"Europe/San_Marino"},{"value":"Europe/Sarajevo","name":"Sarajevo","id":"Europe/Sarajevo"},{"value":"Europe/Saratov","name":"Saratow","id":"Europe/Saratov"},{"value":"Europe/Simferopol","name":"Simferopol","id":"Europe/Simferopol"},{"value":"Europe/Skopje","name":"Skopje","id":"Europe/Skopje"},{"value":"Europe/Sofia","name":"Sofia","id":"Europe/Sofia"},{"value":"Europe/Stockholm","name":"Stockholm","id":"Europe/Stockholm"},{"value":"Europe/Tallinn","name":"Tallinn","id":"Europe/Tallinn"},{"value":"Europe/Tirane","name":"Tirana","id":"Europe/Tirane"},{"value":"Europe/Ulyanovsk","name":"Uljanowsk","id":"Europe/Ulyanovsk"},{"value":"Europe/Uzhgorod","name":"Uschgorod","id":"Europe/Uzhgorod"},{"value":"Europe/Vaduz","name":"Vaduz","id":"Europe/Vaduz"},{"value":"Europe/Vatican","name":"Vatikan","id":"Europe/Vatican"},{"value":"Europe/Vienna","name":"Wien","id":"Europe/Vienna"},{"value":"Europe/Vilnius","name":"Vilnius","id":"Europe/Vilnius"},{"value":"Europe/Volgograd","name":"Wolgograd","id":"Europe/Volgograd"},{"value":"Europe/Warsaw","name":"Warschau","id":"Europe/Warsaw"},{"value":"Europe/Zagreb","name":"Zagreb","id":"Europe/Zagreb"},{"value":"Europe/Zaporozhye","name":"Saporischja","id":"Europe/Zaporozhye"},{"value":"Europe/Zurich","name":"Zürich","id":"Europe/Zurich"},{"value":"Indian/Antananarivo","name":"Antananarivo","id":"Indian/Antananarivo"},{"value":"Indian/Chagos","name":"Chagos","id":"Indian/Chagos"},{"value":"Indian/Christmas","name":"Weihnachtsinsel","id":"Indian/Christmas"},{"value":"Indian/Cocos","name":"Cocos","id":"Indian/Cocos"},{"value":"Indian/Comoro","name":"Komoren","id":"Indian/Comoro"},{"value":"Indian/Kerguelen","name":"Kerguelen","id":"Indian/Kerguelen"},{"value":"Indian/Mahe","name":"Mahe","id":"Indian/Mahe"},{"value":"Indian/Maldives","name":"Malediven","id":"Indian/Maldives"},{"value":"Indian/Mauritius","name":"Mauritius","id":"Indian/Mauritius"},{"value":"Indian/Mayotte","name":"Mayotte","id":"Indian/Mayotte"},{"value":"Indian/Reunion","name":"Réunion","id":"Indian/Reunion"},{"value":"Pacific/Apia","name":"Apia","id":"Pacific/Apia"},{"value":"Pacific/Auckland","name":"Auckland","id":"Pacific/Auckland"},{"value":"Pacific/Bougainville","name":"Bougainville","id":"Pacific/Bougainville"},{"value":"Pacific/Chatham","name":"Chatham","id":"Pacific/Chatham"},{"value":"Pacific/Easter","name":"Osterinsel","id":"Pacific/Easter"},{"value":"Pacific/Efate","name":"Efate","id":"Pacific/Efate"},{"value":"Pacific/Enderbury","name":"Enderbury","id":"Pacific/Enderbury"},{"value":"Pacific/Fakaofo","name":"Fakaofo","id":"Pacific/Fakaofo"},{"value":"Pacific/Fiji","name":"Fidschi","id":"Pacific/Fiji"},{"value":"Pacific/Funafuti","name":"Funafuti","id":"Pacific/Funafuti"},{"value":"Pacific/Galapagos","name":"Galapagos","id":"Pacific/Galapagos"},{"value":"Pacific/Gambier","name":"Gambier","id":"Pacific/Gambier"},{"value":"Pacific/Guadalcanal","name":"Guadalcanal","id":"Pacific/Guadalcanal"},{"value":"Pacific/Guam","name":"Guam","id":"Pacific/Guam"},{"value":"Pacific/Honolulu","name":"Honolulu","id":"Pacific/Honolulu"},{"value":"Pacific/Johnston","name":"Johnston","id":"Pacific/Johnston"},{"value":"Pacific/Kiritimati","name":"Kiritimati","id":"Pacific/Kiritimati"},{"value":"Pacific/Kosrae","name":"Kosrae","id":"Pacific/Kosrae"},{"value":"Pacific/Kwajalein","name":"Kwajalein","id":"Pacific/Kwajalein"},{"value":"Pacific/Majuro","name":"Majuro","id":"Pacific/Majuro"},{"value":"Pacific/Marquesas","name":"Marquesas","id":"Pacific/Marquesas"},{"value":"Pacific/Midway","name":"Midway","id":"Pacific/Midway"},{"value":"Pacific/Nauru","name":"Nauru","id":"Pacific/Nauru"},{"value":"Pacific/Niue","name":"Niue","id":"Pacific/Niue"},{"value":"Pacific/Norfolk","name":"Norfolk","id":"Pacific/Norfolk"},{"value":"Pacific/Noumea","name":"Noumea","id":"Pacific/Noumea"},{"value":"Pacific/Pago_Pago","name":"Pago Pago","id":"Pacific/Pago_Pago"},{"value":"Pacific/Palau","name":"Palau","id":"Pacific/Palau"},{"value":"Pacific/Pitcairn","name":"Pitcairn","id":"Pacific/Pitcairn"},{"value":"Pacific/Ponape","name":"Pohnpei","id":"Pacific/Ponape"},{"value":"Pacific/Port_Moresby","name":"Port Moresby","id":"Pacific/Port_Moresby"},{"value":"Pacific/Rarotonga","name":"Rarotonga","id":"Pacific/Rarotonga"},{"value":"Pacific/Saipan","name":"Saipan","id":"Pacific/Saipan"},{"value":"Pacific/Tahiti","name":"Tahiti","id":"Pacific/Tahiti"},{"value":"Pacific/Tarawa","name":"Tarawa","id":"Pacific/Tarawa"},{"value":"Pacific/Tongatapu","name":"Tongatapu","id":"Pacific/Tongatapu"},{"value":"Pacific/Truk","name":"Chuuk","id":"Pacific/Truk"},{"value":"Pacific/Wake","name":"Wake","id":"Pacific/Wake"},{"value":"Pacific/Wallis","name":"Wallis","id":"Pacific/Wallis"}];
};

return moment;
})));

moment.fn.shortDateNoYear = function(){ return this.format('D MMM'); };
moment.fn.shortDate = function(){ return this.format('D MMM, YYYY'); };
moment.fn.longDate = function(){ return this.format('MMMM D, YYYY h:mma'); };
moment.fn.relativeAge = function(opts){ return Discourse.Formatter.relativeAge(this.toDate(), opts)};
